// src/i18n/index.js
// Use dynamic imports to avoid MIME type issues with JSON files
const messages_en = {
  "aboutEmployerScore.backToRankings": "Back to Best Employers",
  "aboutEmployerScore.breadcrumb.current": "Employer score",
  "aboutEmployerScore.breadcrumb.parent": "Best Employers",
  "aboutEmployerScore.compositeScopeNote": "For now, the headline score uses only pay bands, flexibility, hiring stability, and growth — because benefits depth and listing-level transparency signals are not yet connected to the scoring pipeline. Weights below are renormalized to 100% across those four pillars.",
  "aboutEmployerScore.intro": "The JobCrawls Employer Score is a single 0–100 number derived from patterns we can measure consistently across job listings. It is meant to highlight employers who communicate clearly, structure compensation fairly, and advertise flexible, candidate-friendly roles — not to replace your own interviews and diligence.",
  "aboutEmployerScore.limits.changes": "Weights and signals may evolve as we improve detection; we aim to keep the methodology directionally stable.",
  "aboutEmployerScore.limits.listings": "Scores reflect what employers publish in listings we index — not internal HR policies we cannot see.",
  "aboutEmployerScore.limits.notEndorsement": "A higher score is not an endorsement, guarantee of quality, or legal/financial advice.",
  "aboutEmployerScore.limits.title": "Important limitations",
  "aboutEmployerScore.pillar.flex.body": "Remote and hybrid options are scored from how consistently employers advertise flexible work models across their open roles.",
  "aboutEmployerScore.pillar.flex.title": "Flexibility (remote / hybrid)",
  "aboutEmployerScore.pillar.growth.body": "When listings include seniority structure and career progression cues, we interpret that as stronger internal growth paths.",
  "aboutEmployerScore.pillar.growth.title": "Growth signals",
  "aboutEmployerScore.pillar.pay.body": "When we have enough listings with structured salary ranges, we score how competitive the typical band is. Listing-level salary transparency will fold into this pillar once that signal is wired end-to-end.",
  "aboutEmployerScore.pillar.pay.title": "Pay (posted salary bands)",
  "aboutEmployerScore.pillar.stability.body": "We look at hiring continuity over time — employers that maintain steady, non-spiky hiring patterns score higher than those with chaotic posting behavior.",
  "aboutEmployerScore.pillar.stability.title": "Hiring stability",
  "aboutEmployerScore.pillars.title": "What goes into the score",
  "aboutEmployerScore.title": "How the Employer Score works",
  "auth.signInPrompt.closeLabel": "Close",
  "auth.signInPrompt.description": "Create a free account to save jobs, sync progress, and pick up your search on any device.",
  "auth.signInPrompt.descriptionCreateAlert": "Create a free account and we'll email you when new jobs like this appear.",
  "auth.signInPrompt.primaryAction": "Sign in now",
  "auth.signInPrompt.secondaryAction": "Maybe later",
  "auth.signInPrompt.title": "Sign in to save jobs",
  "auth.signInPrompt.titleCreateAlert": "Sign in to get job alerts",
  "autocomplete.filters": "Filter matches",
  "autocomplete.noMatches": "No filter matches found",
  "autocomplete.scrollHint": "Scroll for more",
  "backoffice.architecture": "Architecture",
  "backoffice.dashboard": "Dashboard",
  "backoffice.dataExplorer.nav": "Data explorer",
  "backoffice.dataExplorer.title": "Data explorer",
  "backoffice.emailAlerts.nav": "Email alerts",
  "backoffice.hub.nav": "All tools",
  "backoffice.hub.open": "Open",
  "backoffice.hub.subtitle": "Choose a tool to open. Access is restricted to authorized accounts.",
  "backoffice.hub.title": "Backoffice",
  "backoffice.jobDataExplorer.nav": "Job data API",
  "backoffice.testing": "Testing",
  "backoffice.userAgents.description": "Single-screen monitoring: map-centered, auto-refreshes last 1m on load. Adjust lookback and filters, then drill into the table.",
  "backoffice.userAgents.hours": "Look back",
  "backoffice.userAgents.mapboxTokenMissing": "Map view requires a Mapbox access token (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.nav": "User agents",
  "backoffice.userAgents.noData": "No user agent entries in this time range.",
  "backoffice.userAgents.run": "Refresh",
  "backoffice.userAgents.title": "Crawl & traffic dashboard",
  "bestCompanies.breadcrumb.current": "Best Employers",
  "bestCompanies.breadcrumb.hub": "Best Employers",
  "bestCompanies.card.cta": "Best employers →",
  "bestCompanies.card.ctaDisabled": "Coming soon",
  "bestCompanies.dimension.backToHub": "← All employer rankings",
  "bestCompanies.dimension.empty": "No companies found for this filter yet. Check back after the next index run.",
  "bestCompanies.dimension.introPrefix": "Ranked by the",
  "bestCompanies.dimension.introSuffix": "— computed from salary transparency, remote flexibility, hiring stability, and benefits in listings aimed at the Finnish job market (including many remote roles). Not reviews.",
  "bestCompanies.dimension.scoreName": "JobCrawls Employer Score",
  "bestCompanies.dimension.title": "Best Employers in {label}",
  "bestCompanies.hub.byCity": "By City",
  "bestCompanies.hub.byIndustry": "By Industry",
  "bestCompanies.hub.clearFilters": "Clear filters",
  "bestCompanies.hub.clearSearch": "Clear search",
  "bestCompanies.hub.eyebrow": "{year} rankings, updated weekly",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# employer matches} other {# employers match}}",
  "bestCompanies.hub.heroLede": "Ranked from live job-listing signals — pay, flexibility, hiring stability, and more. Not employee reviews, surveys, or paid placements.",
  "bestCompanies.hub.lead": "This page is our {year} snapshot of employers hiring through roles aimed at the Finnish job market. Many listings are remote or hybrid, so companies are not necessarily headquartered in Finland.",
  "bestCompanies.hub.loadingMoreMatches": "finding more matches…",
  "bestCompanies.hub.methodLink": "Full methodology: how the Employer Score works",
  "bestCompanies.hub.methodologySummary": "Rankings use the JobCrawls Employer Score: a composite from live job-listing signals—salary transparency, remote and hybrid flexibility, hiring consistency over time, benefits depth, and how clearly requirements are stated. It is not based on employee reviews, surveys, or paid placements.",
  "bestCompanies.hub.methodologyToggle": "How the ranking works",
  "bestCompanies.hub.networkWorthyFilter": "Worth networking with",
  "bestCompanies.hub.noMatches": "No companies match your filters. Try clearing a filter or searching a different name.",
  "bestCompanies.hub.overallTitle": "Top employers in {year}",
  "bestCompanies.hub.remoteFriendlyFilter": "Remote-friendly",
  "bestCompanies.hub.scoreScale": "Scores are on a 0–100 scale. When many employers sit close together (for example in the high 30s to low 40s), the list is still ordered by those signals—#1 reflects the strongest combination in this cohort on the dimensions we measure, and lower ranks are often separated by small margins rather than a huge quality gap.",
  "bestCompanies.hub.searchPlaceholder": "Search companies by name…",
  "bestCompanies.hub.sizeFilter.large": "1,000+ employees",
  "bestCompanies.hub.sizeFilter.medium": "201–1,000 employees",
  "bestCompanies.hub.sizeFilter.micro": "1–50 employees",
  "bestCompanies.hub.sizeFilter.small": "51–200 employees",
  "bestCompanies.hub.sort.name": "Name (A–Z)",
  "bestCompanies.hub.sort.postings": "Most active hiring",
  "bestCompanies.hub.sort.score": "Highest score",
  "bestCompanies.hub.sort.size": "Company size",
  "bestCompanies.hub.sortLabel": "Sort by",
  "bestCompanies.hub.stat.companies": "companies scored",
  "bestCompanies.hub.stat.industries": "industries covered",
  "bestCompanies.hub.stat.medianSalary": "median monthly salary",
  "bestCompanies.hub.stat.medianScore": "median employer score",
  "bestCompanies.hub.stat.networkWorthy": "worth networking with",
  "bestCompanies.hub.title": "Best companies to work for in Finland ({year})",
  "bestCompanies.podium.headcount": "{range} employees",
  "bestCompanies.podium.rankLabel": "Highest-scoring employer",
  "bestCompanies.row.hiringPace": "~{count} new roles/mo",
  "bestCompanies.row.medianPrefix": "Median",
  "bestCompanies.row.networkWorthy": "Worth networking with",
  "bestCompanies.row.perMonth": "{range}/mo",
  "bestCompanies.row.remoteHybridPercent": "{percent}% remote/hybrid",
  "bestCompanies.row.remotePercent": "{percent}% remote",
  "bestCompanies.subscore.benefits": "Benefits",
  "bestCompanies.subscore.flexibility": "Flexibility",
  "bestCompanies.subscore.growth": "Growth",
  "bestCompanies.subscore.pay": "Pay",
  "bestCompanies.subscore.stability": "Stability",
  "bestCompanies.subscore.transparency": "Transparency",
  "breadcrumb.benefits": "Benefits",
  "breadcrumb.company": "Company",
  "breadcrumb.educationLevel": "Education",
  "breadcrumb.industry": "Industry",
  "breadcrumb.isDriversLicenseRequired": "Driver's License",
  "breadcrumb.isOpenApplication": "Open Application",
  "breadcrumb.jobType": "Job Type",
  "breadcrumb.jobs": "Jobs",
  "breadcrumb.language": "Language",
  "breadcrumb.level": "Level",
  "breadcrumb.location": "Location",
  "breadcrumb.navigation": "Breadcrumb navigation",
  "breadcrumb.peopleManagementTier": "Management",
  "breadcrumb.remote": "Remote",
  "breadcrumb.skillsAndTechnologies": "Skills/Tech",
  "checklist.field.addTrigger": "Add checklist",
  "checklist.field.placeholder": "Add a task and press Enter…",
  "checklist.field.progressTrigger": "{done}/{total} done",
  "checklist.field.remove": "Remove task {text}",
  "collectiveAgreements.bindingLegend": "What \"unresolved\" means:",
  "collectiveAgreements.bindingLegendBody": "the Confirmation Board didn't name that agreement in any of the annual reviews we have on file — that's a genuine gap in the record, not a \"no.\"",
  "collectiveAgreements.bindingNo": "Not binding",
  "collectiveAgreements.bindingUnknown": "Unknown",
  "collectiveAgreements.bindingYes": "Binding",
  "collectiveAgreements.breadcrumb.current": "Collective Agreements",
  "collectiveAgreements.decisionNoPrefix": "Decision no.",
  "collectiveAgreements.eyebrow": "Reference · Finlex & Ministry of Social Affairs and Health",
  "collectiveAgreements.filterLabel": "Filter collective agreements by name",
  "collectiveAgreements.filterPlaceholder": "Search by agreement name…",
  "collectiveAgreements.intro": "A työehtosopimus sets the minimum pay and terms for a job — which one applies depends on the employer's industry and the kind of role. We link job ads to our best guess automatically; this is the full source list, so you can check that guess yourself.",
  "collectiveAgreements.noResults": "No agreements match your search.",
  "collectiveAgreements.pdfFi": "PDF (Finnish)",
  "collectiveAgreements.pdfSv": "PDF (Swedish)",
  "collectiveAgreements.resultsCount": "Showing {shown} of {total} agreements — {binding} confirmed generally binding",
  "collectiveAgreements.scopeHeading": "Scope of application",
  "collectiveAgreements.scopeUnavailable": "No scope-of-application text is available for this agreement.",
  "collectiveAgreements.stat.binding": "Confirmed binding",
  "collectiveAgreements.stat.total": "Agreements on file",
  "collectiveAgreements.stat.unresolved": "Status unresolved",
  "collectiveAgreements.title": "Finnish collective agreements",
  "collectiveAgreements.viewOnFinlex": "Finlex",
  "company.follow.cta": "Follow",
  "company.follow.followedToast": "Following — watchlist updated",
  "company.follow.following": "Following",
  "company.follow.unfollow": "Unfollow",
  "company.follow.unfollowedToast": "Unfollowed",
  "company.follow.viewWatchlist": "View →",
  "company.logoAlt": "{company} logo",
  "company.logoAltGeneric": "Employer logo",
  "companyChart.caption.averaging": "averaging {avg} jobs per month",
  "companyChart.caption.hiringDeclining": "{companyName}'s hiring is declining",
  "companyChart.caption.hiringGrowing": "{companyName}'s hiring is growing",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}'s hiring is rapidly declining",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}'s hiring is rapidly growing",
  "companyChart.caption.hiringStable": "{companyName}'s hiring is stable",
  "companyChart.caption.levelDistributionDouble": "{companyName} hires mostly at the {level1} and {level2} levels.",
  "companyChart.caption.levelDistributionSingle": "{companyName} hires mostly at the {level} level.",
  "companyChart.caption.levelDistributionTriple": "{companyName} hires mostly at the {level1}, {level2}, and {level3} levels.",
  "companyChart.caption.locationDistributionDouble": "{companyName} hires mostly in {location1} and {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} hires mostly in {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} hires mostly in {location1}, {location2}, and {location3}.",
  "companyChart.caption.margin": "and a profit margin of {margin}",
  "companyChart.caption.marginOnly": "{companyName} had a profit margin of {margin} in 2024",
  "companyChart.caption.profitable": "{companyName} was profitable in 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} hires mostly hybrid positions.",
  "companyChart.caption.remotenessOnsite": "{companyName} hires mostly onsite positions.",
  "companyChart.caption.remotenessRemote": "{companyName} hires mostly remote positions.",
  "companyChart.caption.revenue": "{companyName} had revenue of {revenue} in 2024",
  "companyChart.caption.revenueWith": "with revenue of {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} hires mostly {role1} and {role2} roles.",
  "companyChart.caption.roleDistributionSingle": "{companyName} hires mostly {role} roles.",
  "companyChart.caption.roleDistributionTriple": "{companyName} hires mostly {role1}, {role2}, and {role3} roles.",
  "companyChart.caption.unprofitable": "{companyName} was unprofitable in 2024",
  "companyChart.caption.workforceRate": "({rate}% of their workforce)",
  "companyChart.financialOverview": "Financial Overview (2024)",
  "companyChart.insufficientData": "Limited data available - trends require at least 3 months of data",
  "companyChart.monthlyHiringTrends": "Monthly Hiring Trends",
  "companyChart.moreCategories": "+{count} more",
  "companyChart.profit": "Profit",
  "companyChart.profitMargin": "Profit Margin",
  "companyChart.revenue": "Revenue",
  "companyChart.trend.declining": "Declining",
  "companyChart.trend.growing": "Growing",
  "companyChart.trend.insufficientData": "Limited Data",
  "companyChart.trend.rapidlyDeclining": "Rapidly Declining",
  "companyChart.trend.rapidlyGrowing": "Rapidly Growing",
  "companyChart.trend.stable": "Stable",
  "companyChart.trendDescription.declining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.growing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyDeclining": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.rapidlyGrowing": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyChart.trendDescription.simpleDeclining": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleGrowing": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.simpleStable": "Hiring {avg} jobs/month on average",
  "companyChart.trendDescription.stable": "Hiring {avg} jobs/month ({rate}% of workforce)",
  "companyHeader.jobCount": "{count, plural, one {# open position} other {# open positions}}",
  "companyHeader.locationCount": "{count, plural, one {# location} other {# locations}}",
  "companyInsight.bodyNoLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. This reflects historical crawl data, not a live count of open vacancies.",
  "companyInsight.bodyWithLocations": "appears in {count, plural, one {# indexed job posting} other {# indexed job postings}} in JobCrawls' Finland dataset since {sinceDate}. In that historical index, the strongest location signals for this employer are {locationList}.",
  "companyInsight.englishRequirement": "{percent}% of those indexed postings mention English as a requirement.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indexed posting} other {# indexed postings}})",
  "companyProfile.companyFacts.benefitsLabel": "Benefits",
  "companyProfile.companyFacts.corporateHistoryLabel": "Ownership",
  "companyProfile.companyFacts.heading": "Good to know",
  "companyProfile.companyFacts.officeLocationsLabel": "Offices",
  "companyProfile.companyFacts.remotePolicyLabel": "Remote work",
  "companyProfile.companyFacts.valuesLabel": "Values",
  "companyProfile.communityInsights.consTitle": "Common complaints",
  "companyProfile.communityInsights.heading": "What people say online",
  "companyProfile.communityInsights.prosTitle": "What people like",
  "companyProfile.communityInsights.sentimentInsufficient": "Not enough data",
  "companyProfile.communityInsights.sentimentMixed": "Mixed",
  "companyProfile.communityInsights.sentimentNegative": "Mostly negative",
  "companyProfile.communityInsights.sentimentPositive": "Mostly positive",
  "companyProfile.communityInsights.sourcesTitle": "Sources",
  "companyProfile.communityInsights.subtitle": "Summarized from public Reddit, Suomi24, and forum discussion",
  "companyProfile.siteSources.sourceLabel": "Source",
  "cookie.consent.accept": "Accept analytics",
  "cookie.consent.analyticsBody": "Helps us spot searches that return no results and pages people get stuck on, so we can fix them. Optional, and never used for ads.",
  "cookie.consent.analyticsTitle": "Analytics",
  "cookie.consent.banner": "We use essential cookies to run JobCrawls. With your OK, we also use privacy-friendly analytics — it helps us spot searches that come up empty and pages people get stuck on, so we can fix them faster. Never for ads. You can change your mind anytime.",
  "cookie.consent.cancel": "Cancel",
  "cookie.consent.manage": "Manage preferences",
  "cookie.consent.modalTitle": "Cookie preferences",
  "cookie.consent.necessaryNote": "Essential cookies (session, preferences, security) are always used so the site works.",
  "cookie.consent.nudge": "You can turn on privacy-friendly analytics anytime — it helps us catch broken searches faster.",
  "cookie.consent.privacyLink": "Privacy Policy",
  "cookie.consent.reject": "Reject non-essential",
  "cookie.consent.save": "Save choices",
  "cookie.consent.title": "Cookies and privacy",
  "dashboard.actions": "Actions",
  "dashboard.addComment": "Add Comment",
  "dashboard.addComment.placeholder": "Add a comment...",
  "dashboard.addCompany.cancel": "Cancel",
  "dashboard.addCompany.close": "Close",
  "dashboard.addCompany.doCrawl": "Enable crawling (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Company name is required.",
  "dashboard.addCompany.fieldAts": "ATS",
  "dashboard.addCompany.fieldCareers": "Careers / jobs page URL",
  "dashboard.addCompany.fieldEnqueue": "Enqueue URL",
  "dashboard.addCompany.fieldLogo": "Logo URL",
  "dashboard.addCompany.fieldName": "Company name",
  "dashboard.addCompany.fieldWebsite": "Website",
  "dashboard.addCompany.hintId": "The company ID in the database is the exact company name (trimmed). If a row with the same name already exists, creation will fail.",
  "dashboard.addCompany.open": "Add company",
  "dashboard.addCompany.placeholderName": "e.g. Acme Oy",
  "dashboard.addCompany.saving": "Creating…",
  "dashboard.addCompany.submit": "Create company",
  "dashboard.addCompany.title": "Add company",
  "dashboard.adding": "Adding...",
  "dashboard.address": "Address",
  "dashboard.all": "All",
  "dashboard.allAts": "All ATS",
  "dashboard.allCompanies": "All Companies",
  "dashboard.allStatus": "All Status",
  "dashboard.ats": "ATS",
  "dashboard.atsSystem": "ATS System",
  "dashboard.businessId": "Business ID",
  "dashboard.cancelEdit": "Cancel",
  "dashboard.careersUrl": "Careers URL",
  "dashboard.charts.closeBackdrop": "Close",
  "dashboard.charts.closeButton": "Close charts",
  "dashboard.charts.modalTitle": "Crawl activity charts",
  "dashboard.charts.toolbarDisabledHint": "Load crawl export data first",
  "dashboard.charts.toolbarHint": "Open crawl activity charts",
  "dashboard.charts.toolbarLabel": "Charts",
  "dashboard.check": "Mark as checked",
  "dashboard.clearDlq": "Clear DLQ",
  "dashboard.clearFilters": "Clear Filters",
  "dashboard.clearLogoFailures": "Clear Logo Failures ({count})",
  "dashboard.comments": "Comments",
  "dashboard.companiesHeader": "Companies ({count} of {total})",
  "dashboard.companyAttributes": "Company attributes",
  "dashboard.companyBasic": "Company Basic",
  "dashboard.companyBasic.short": "Basic Info",
  "dashboard.companyBusiness": "Business Info",
  "dashboard.companyContact": "Contact",
  "dashboard.companyCrawl": "Crawl Settings",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rows per page",
  "dashboard.companyCrawlRecordsShowing": "Showing {from}-{to} of {total}",
  "dashboard.companyFinancial": "Financial",
  "dashboard.companyId": "Company ID",
  "dashboard.companyIndustry": "Industry",
  "dashboard.companyInformation": "Company Information",
  "dashboard.companyLocation": "Location",
  "dashboard.companyModal.close": "Close company window",
  "dashboard.companyModal.closeBackdrop": "Close",
  "dashboard.companyModal.subtitle": "{crawls} crawls · {ok} successful · {jobs} sent to processor",
  "dashboard.companyModal.tabCrawls": "Crawl runs",
  "dashboard.companyModal.tabSettings": "Company & crawl settings",
  "dashboard.companyName": "Company Name",
  "dashboard.companyRegistry": "Registry",
  "dashboard.companyRow.jobs": "jobs",
  "dashboard.companyRow.openBadge": "Open",
  "dashboard.companyRow.paginationWarningShort": "Pagination ⚠ {n}",
  "dashboard.companySocial": "Social Media",
  "dashboard.companyUrl": "Company URL",
  "dashboard.coordinates": "Coordinates",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Logs",
  "dashboard.crawlActions.flatActionsColumnHint": "Live · HTML",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ menu",
  "dashboard.crawlActions.flatTraceColumnHint": "Modal",
  "dashboard.crawlActions.legendHtml": "Eye — HTML: snapshot from S3 as crawled (plus live extracted JSON when the row has a URL).",
  "dashboard.crawlActions.legendLive": "Arrow out — Live site: open the public job page on JobCrawls (detail rows with an object ID only).",
  "dashboard.crawlActions.legendLogs": "⋯ — CloudWatch: jump to crawler, processor, enrich, Algolia, etc. (filters use this crawl id or job URL).",
  "dashboard.crawlActions.legendRecrawlDetail": "Arrows — Recrawl page: enqueue one detail crawl for this URL (not the whole company list).",
  "dashboard.crawlActions.legendTitle": "What the row buttons do",
  "dashboard.crawlActions.legendTrace": "Magnifying glass — Trace: one modal with Raw/Final/Enriched status, DynamoDB & AWS console links.",
  "dashboard.crawlActions.liveJobAria": "Open public job listing on JobCrawls",
  "dashboard.crawlActions.liveJobTooltip": "Open this job’s public listing page on JobCrawls (same URL visitors see when the job is indexed).",
  "dashboard.crawlActions.logsMenuAria": "CloudWatch pipeline logs menu for this crawl",
  "dashboard.crawlActions.logsMenuTooltip": "CloudWatch log links: exact crawl stream when available, then filtered views for crawler (crawlId), processor, enrich, Algolia, maintainer, and processor by URL.",
  "dashboard.crawlActions.recrawlDetailAria": "Recrawl this job page (detail crawl only)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Queue a crawl of this job page only (detail). Does not re-run full company list pages — use company “Recrawl” for that.",
  "dashboard.crawlActions.traceAria": "Open full pipeline trace for this job URL",
  "dashboard.crawlActions.traceTooltip": "Open pipeline trace: RawJobs / FinalJobs / Enriched summaries, object IDs, and links to DynamoDB & CloudWatch for this job URL.",
  "dashboard.crawlActions.viewHtmlAria": "View stored HTML snapshot for this crawl",
  "dashboard.crawlActions.viewHtmlTooltip": "Open the HTML snapshot stored for this crawl (S3). Shows rendered or raw markup and live DynamoDB job JSON beside it.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl data loaded ({count} records), but company data hasn't been loaded in this browser yet — so nothing is grouped below. Load companies to see it.",
  "dashboard.crawlDlq": "Crawl DLQ",
  "dashboard.crawlExportWindow": "Loaded crawl records from {from} to {to} (maintainer export window).",
  "dashboard.crawlFailIconTooltip": "This crawl run failed or returned an HTTP error — open CloudWatch / pipeline logs for this crawlId.",
  "dashboard.crawlHistory.hideOlder": "Hide {n} older crawl(s)",
  "dashboard.crawlHistory.hint": "Newest run is in the row above. Each older run has its own crawlId and CloudWatch links.",
  "dashboard.crawlHistory.showOlder": "Show {n} older crawl(s) — time, logs, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Hourly chart of average page time and total crawl minutes",
  "dashboard.crawlHourlyChart.ariaPages": "Hourly chart of listing and job page fetches, saved jobs, listing links, and unsaved job pages",
  "dashboard.crawlHourlyChart.avgSecPhrase": "avg {seconds} s per page that reported timing",
  "dashboard.crawlHourlyChart.axisAvgSec": "Avg s / page",
  "dashboard.crawlHourlyChart.axisExtracted": "Job-related counts / hr",
  "dashboard.crawlHourlyChart.axisPageFetches": "Page fetches / hr",
  "dashboard.crawlHourlyChart.axisTotalMin": "Total min / hr",
  "dashboard.crawlHourlyChart.collapsedEmpty": "No rows in loaded window",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} hours · {fetches} page fetches",
  "dashboard.crawlHourlyChart.durationHms": "{hours}h {minutes}m {seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationMs": "{minutes}m {seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationSecOnly": "{seconds}s total (sum of per-page timings)",
  "dashboard.crawlHourlyChart.durationZero": "0s total",
  "dashboard.crawlHourlyChart.empty": "No crawl rows in the loaded window — refresh crawl data after a maintainer export.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Explanation & window totals",
  "dashboard.crawlHourlyChart.hoverAllFetches": "All page fetches",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} failed)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Avg page time (timed rows)",
  "dashboard.crawlHourlyChart.hoverAvgSecValue": "{seconds} s (n = {n})",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "From single job pages (postings seen)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Single job pages we did not save",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Found on other page types",
  "dashboard.crawlHourlyChart.hoverHourWindow": "{start} – {end}",
  "dashboard.crawlHourlyChart.hoverJobPages": "Job (detail) pages",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} failed",
  "dashboard.crawlHourlyChart.hoverJobsFound": "“Found” total (everything added up)",
  "dashboard.crawlHourlyChart.hoverListPages": "List pages",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} failed",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "From listing pages (job links counted)",
  "dashboard.crawlHourlyChart.hoverNoTimingSamples": "—",
  "dashboard.crawlHourlyChart.hoverPipeline": "Saved to pipeline",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, other {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Total reported crawl time",
  "dashboard.crawlHourlyChart.noTiming": "no per-page duration recorded in this export",
  "dashboard.crawlHourlyChart.panelDuration": "Crawl duration",
  "dashboard.crawlHourlyChart.panelPages": "Fetches and job counts by hour",
  "dashboard.crawlHourlyChart.plainGuide1": "“Found” is often huge because every job link on a careers listing page is counted. Those links are only “we queued this URL” — not a saved job yet.",
  "dashboard.crawlHourlyChart.plainGuide2": "“Extracted” means we actually saved that job to raw storage from a single job page. Listing rows never add to extracted (by design).",
  "dashboard.crawlHourlyChart.plainGuide3": "On the chart, use the checkboxes: the dashed purple line = links counted on list pages; the dashed brown line = job pages we visited but did not save; the solid gold line = saved to the pipeline. Hover the graph for one hour’s numbers.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "In plain terms",
  "dashboard.crawlHourlyChart.subtitle": "Top chart: pages we fetched and job counts per hour. Bottom chart: how long crawls took. Time axis matches your exported crawl window (often about a week).",
  "dashboard.crawlHourlyChart.title": "Crawl activity by hour (local time)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Job pages visited but not saved",
  "dashboard.crawlHourlyChart.totalExtracted": "Jobs saved to raw (“extracted”)",
  "dashboard.crawlHourlyChart.totalFoundRaw": "“Found” (all rows added up)",
  "dashboard.crawlHourlyChart.totalJobPages": "Single job pages crawled",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} succeeded, {fail} failed)",
  "dashboard.crawlHourlyChart.totalListLinks": "Of that, links counted on listing pages",
  "dashboard.crawlHourlyChart.totalListPages": "Listing pages crawled",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} succeeded, {fail} failed)",
  "dashboard.crawlHourlyChart.totalTiming": "Crawler-reported time",
  "dashboard.crawlHourlyChart.totalsTitle": "Totals for the time range above",
  "dashboard.crawlKey": "Crawl Key",
  "dashboard.crawlMetricsExplainer.crawls": "Crawls — one log row each time we open a listing page or a single job page.",
  "dashboard.crawlMetricsExplainer.extracted": "Extracted — jobs we actually saved from a job page. Listing pages don’t add here.",
  "dashboard.crawlMetricsExplainer.found": "Found — mostly “how many job links we counted on listing pages,” plus what we saw on job pages. Big numbers here are normal.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "For a fuller picture, use the hourly chart below: it labels the purple, brown, and gold lines to match this story.",
  "dashboard.crawlMetricsExplainer.successFailed": "Success / failed — did that page load and finish without a crawl error?",
  "dashboard.crawlMetricsExplainer.title": "What these numbers mean",
  "dashboard.crawlMetricsExplainer.triggerAria": "What these crawl summary numbers mean",
  "dashboard.crawlOkIconTooltip": "This crawl run succeeded (HTTP OK, no crawler failure).",
  "dashboard.crawlOutliersFilter.all": "All crawl rows",
  "dashboard.crawlOutliersFilter.any": "Crawled but not sent",
  "dashboard.crawlOutliersFilter.hint": "Uses IndexedDB export fields only. List-page rows are hidden when this is not “All”. Combine with flat “Job / list pages” tabs.",
  "dashboard.crawlOutliersFilter.label": "Pipeline / index outliers (detail crawls)",
  "dashboard.crawlOutliersFilter.notSent": "Crawled OK but jobsExtracted = 0 (not skipped)",
  "dashboard.crawlRecords": "Crawl Records",
  "dashboard.crawlStatistics": "Crawl Statistics",
  "dashboard.crawlType": "Crawl Type",
  "dashboard.crawlingInformation": "Crawling Information",
  "dashboard.deleteComment": "Delete comment",
  "dashboard.deleteCompany": "Delete",
  "dashboard.deleteCompany.confirm": "Delete \"{name}\" from the Companies table (DynamoDB)? This cannot be undone. Local dashboard rows for this company will be removed.",
  "dashboard.deleteCompany.done": "Company \"{name}\" was deleted.",
  "dashboard.deleteCompany.failed": "Failed to delete company: {message}",
  "dashboard.deleteCompany.modalTooltip": "Remove this company from the Companies table (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Delete company from DynamoDB and remove from local dashboard",
  "dashboard.deleteCompany.virtualBlocked": "The Työmarkkinatori aggregate row is not a Companies table record. It cannot be deleted here.",
  "dashboard.detailPages": "Detail Pages",
  "dashboard.details": "Details",
  "dashboard.dlqEmpty": "DLQ is empty - no failed messages",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {message} other {messages}} in DLQ",
  "dashboard.dlqViewer": "Dead Letter Queue Viewer",
  "dashboard.duration": "Duration",
  "dashboard.editCompany": "Edit",
  "dashboard.enqueueUrlPattern": "Enqueue URL Pattern",
  "dashboard.error": "Error",
  "dashboard.failed": "Failed",
  "dashboard.failedToLoadCompanySettings": "Failed to load company settings: {error}",
  "dashboard.filterByField": "Filter by Field",
  "dashboard.filterValue": "Filter value... (use __NOT_EMPTY__ for non-empty)",
  "dashboard.flatView.noCrawlRows": "No crawl rows to show in flat view. Load crawl export data first.",
  "dashboard.flatViews.colActions": "Actions",
  "dashboard.flatViews.colActionsTooltip": "Live listing on the site, HTML snapshot from S3 when available.",
  "dashboard.flatViews.colCompany": "Company",
  "dashboard.flatViews.colCompanyTooltip": "Company name stored on the crawl record.",
  "dashboard.flatViews.colDuration": "Duration",
  "dashboard.flatViews.colDurationTooltip": "Time spent fetching and processing this crawl request.",
  "dashboard.flatViews.colHttpTooltip": "HTTP response status for this request (e.g. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Found / sent",
  "dashboard.flatViews.colMetricsTooltip": "List: jobs enqueued. Detail: sent to processor or not. Other page types: raw counts. Hover a cell for more detail.",
  "dashboard.flatViews.colOkTooltip": "Green: crawl succeeded. Red: failed or bad HTTP. If there are multiple runs for the same URL, hover the time column for per-run status.",
  "dashboard.flatViews.colPage": "Page",
  "dashboard.flatViews.colPageTooltip": "Page type (list vs detail) and badges: TMT, Skipped, Y-tunnus hints, etc.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Links to CloudWatch log streams for crawler, processor, and related stages.",
  "dashboard.flatViews.colTime": "Time",
  "dashboard.flatViews.colTimeTooltip": "When this crawl run started. If the same URL was crawled more than once, the newest run is shown in this row.",
  "dashboard.flatViews.colTrace": "Pipeline logs",
  "dashboard.flatViews.colTraceFull": "Trace",
  "dashboard.flatViews.colTraceFullTooltip": "Open the full job pipeline trace (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "URL fetched by the crawler.",
  "dashboard.flatViews.colYtunnus": "Y-tunnus (TMT)",
  "dashboard.flatViews.colYtunnusTooltip": "Työmarkkinatori only: whether a Finnish business ID (Y-tunnus) was extracted from HTML and matched to your company database.",
  "dashboard.flatViews.crawlRunCount": "{n} crawls",
  "dashboard.flatViews.failure.algolia": "Algolia errors (metadata)",
  "dashboard.flatViews.failure.all": "All outcomes",
  "dashboard.flatViews.failure.cookie": "Cookie / overlay",
  "dashboard.flatViews.failure.nav": "Navigation / timeout",
  "dashboard.flatViews.failure.net": "Network",
  "dashboard.flatViews.failure.ok": "Crawl OK",
  "dashboard.flatViews.failure.other": "Other crawl failure",
  "dashboard.flatViews.failureFilterLabel": "Crawl outcome",
  "dashboard.flatViews.first": "First",
  "dashboard.flatViews.hint": "Sort, Source, Outliers, and Crawl outcome apply only to this flat table. Rows group repeat crawls of the same URL (newest first; crawl count on the time column). Outliers use job-detail rows only (Algolia errors in metadata, or crawl OK but jobsExtracted 0 and not skipped). Crawl outcome uses IndexedDB export fields (not live Dynamo). Use Trace for a row to load Raw/Final/Enriched + AWS console links. Row set also uses the same Filters (Työmarkkinatori, TMT Y-tunnus) as above.",
  "dashboard.flatViews.jobPages": "All job pages",
  "dashboard.flatViews.last": "Last",
  "dashboard.flatViews.listPages": "All list pages",
  "dashboard.flatViews.next": "Next",
  "dashboard.flatViews.pageJumpLabel": "Go to page",
  "dashboard.flatViews.pageOf": "Page {p} of {t} ({n} rows)",
  "dashboard.flatViews.prev": "Prev",
  "dashboard.flatViews.sort.companyAsc": "Company · A–Z",
  "dashboard.flatViews.sort.companyDesc": "Company · Z–A",
  "dashboard.flatViews.sort.failedFirst": "OK · failures first",
  "dashboard.flatViews.sort.jobsFoundAsc": "Jobs found · low → high",
  "dashboard.flatViews.sort.jobsFoundDesc": "Jobs found · high → low",
  "dashboard.flatViews.sort.successFirst": "OK · successes first",
  "dashboard.flatViews.sort.timeAsc": "Time · oldest first",
  "dashboard.flatViews.sort.timeDesc": "Time · newest first",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Z",
  "dashboard.flatViews.sort.urlDesc": "URL · Z–A",
  "dashboard.flatViews.sortLabel": "Sort",
  "dashboard.flatViews.source.all": "All crawls",
  "dashboard.flatViews.source.nonTmt": "Exclude Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Työmarkkinatori only",
  "dashboard.flatViews.sourceLabel": "Source",
  "dashboard.flatViews.title": "Flat crawl views",
  "dashboard.flatViews.yt.legacy": "Older row: no Y-tunnus metadata (re-crawl to classify)",
  "dashboard.flatViews.yt.na": "Not a Työmarkkinatori detail row",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus extracted but not found in CompaniesTable",
  "dashboard.flatViews.yt.none": "No Y-tunnus extracted from page HTML",
  "dashboard.flatViews.yt.ok": "Y-tunnus extracted and company matched",
  "dashboard.greenSuccess": "Green (Success)",
  "dashboard.groupBy": "Group By",
  "dashboard.groupCrawlCount": "Crawl Count",
  "dashboard.groupJobsCount": "Jobs Count",
  "dashboard.groupLogoFailed": "Logo Status",
  "dashboard.groupMetrics": "Metrics",
  "dashboard.groupNone": "None",
  "dashboard.groupPaginationIssue": "Pagination Issues",
  "dashboard.groupStatus": "Status (Red/Yellow/Green)",
  "dashboard.groupStatusIssues": "Status & Issues",
  "dashboard.groupSuccessRate": "Success Rate",
  "dashboard.hasAnyFailedCrawl": "Any failed crawl (in window)",
  "dashboard.hasComments": "Has Comments",
  "dashboard.hasCrawlData.label": "Crawl Data",
  "dashboard.hasCrawlData.option": "Has Data",
  "dashboard.heroImage": "Hero Image",
  "dashboard.howToRunCrawl": "How to Run a Crawl",
  "dashboard.htmlModal.liveExtractedHint": "Same object ID as search index. Long text fields are truncated for display.",
  "dashboard.htmlModal.liveExtractedTitle": "Live extracted job (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Loading FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "This crawl row has no URL — cannot resolve live job records.",
  "dashboard.httpStatusCellTooltip": "HTTP response status for this request (e.g. 200 = OK, 404 = not found).",
  "dashboard.industry": "Industry",
  "dashboard.isChecked": "Checked",
  "dashboard.isSaved": "Saved",
  "dashboard.issuesOnly": "Issues Only",
  "dashboard.itemsPerPage": "Items per page",
  "dashboard.jobLookup.activeHint": "Showing detail crawls for job ID: {id}",
  "dashboard.jobLookup.clear": "Clear export filter",
  "dashboard.jobLookup.find": "Find in export",
  "dashboard.jobLookup.noMatchInExport": "No detail crawl in the loaded window has this job ID. Reload crawl data or widen the export window.",
  "dashboard.jobLookup.parseError": "Could not find a job ID. Paste a full JobCrawls job page URL (…/en/job/…/company/…) or the object ID from the address bar.",
  "dashboard.jobLookup.placeholder": "Paste job page URL or object ID…",
  "dashboard.jobLookup.resolvingIds": "Matching job IDs to crawls…",
  "dashboard.jobSearch.matchExportLabel": "Match in loaded crawl export",
  "dashboard.jobSearch.sectionHint": "Find rows in the loaded export, or trace pipeline state from a job URL.",
  "dashboard.jobSearch.sectionTitle": "Job search",
  "dashboard.jobTrace.blurb": "Paste the exact job listing URL as stored in RawJobs. The dashboard loads RawJobs, FinalJobs, and EnrichedFinalJobs, infers how far the job got, and links to DynamoDB tables and CloudWatch log filters.",
  "dashboard.jobTrace.close": "Close",
  "dashboard.jobTrace.dynamo": "DynamoDB (console)",
  "dashboard.jobTrace.failureCode": "Code: {code}",
  "dashboard.jobTrace.load": "Get all information",
  "dashboard.jobTrace.loading": "Loading trace…",
  "dashboard.jobTrace.logs": "CloudWatch (filter)",
  "dashboard.jobTrace.modalTitle": "Pipeline trace",
  "dashboard.jobTrace.noAwsLinks": "Console links unavailable (pipeline log env incomplete).",
  "dashboard.jobTrace.noLogContext": "Pipeline log env vars missing on API — Dynamo links still work; set PIPELINE_LOG_GROUP_* on Dashboard Lambda for CloudWatch deep links in the API response.",
  "dashboard.jobTrace.rawJson": "Item summaries (JSON)",
  "dashboard.jobTrace.title": "Pipeline trace (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Job URL",
  "dashboard.jobTrace.visual": "Pipeline progress",
  "dashboard.jobsEnqueued": "{count} jobs enqueued",
  "dashboard.jobsEnqueuedCellTooltip": "List crawl: job URLs discovered on this page and enqueued for detail crawls. “List pages” counts extra listing URLs (e.g. pagination) also enqueued.",
  "dashboard.jobsExtracted": "Jobs Extracted",
  "dashboard.jobsFound": "Jobs Found",
  "dashboard.layout.company": "By company",
  "dashboard.layout.flat": "Flat crawls",
  "dashboard.layout.label": "Layout",
  "dashboard.listPages": "List Pages",
  "dashboard.listPagesEnqueued": "{count} list pages",
  "dashboard.liveJobLink": "Live job",
  "dashboard.loadAllCompanies": "Load all companies (86k)",
  "dashboard.loadCompaniesButton": "Load Companies",
  "dashboard.loadedCompanies": "Loaded: {current} of {total} companies",
  "dashboard.loadedCompaniesUnknown": "Loaded: {current} companies",
  "dashboard.loadingAllCompanies": "Loading all companies — slower initial load",
  "dashboard.loadingBatch": "Processing batch {current} of approximately {total}",
  "dashboard.loadingCompanies": "Loading Company Data",
  "dashboard.loadingCompaniesWithUrls": "Loading only companies with website URLs — faster",
  "dashboard.loadingNote": "This may take a few minutes. Please keep this page open.",
  "dashboard.logoFailed": "Logo Failed",
  "dashboard.logoFailedBadgeTitle": "Logo failed to load in the dashboard — use Logo Lambda logs below for ProcessCompanyLogos output",
  "dashboard.logoOk": "Logo OK",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos failed on {failedAt}: {error}",
  "dashboard.logoProcessingFailedUnknownDate": "an unknown date",
  "dashboard.logoUrlFailedLabel": "Failed",
  "dashboard.map": "Map",
  "dashboard.menu.overview": "Overview",
  "dashboard.menu.overview.metricsHelpDesc": "Hover the (i) icon for what each count means.",
  "dashboard.menu.overview.metricsHelpTitle": "Metric definitions",
  "dashboard.menu.overview.noExport": "Load crawl export data (Tools) to see summary counts.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer snapshot vs crawl window.",
  "dashboard.menu.overview.summaryDesc": "Counts from the crawl JSON loaded in this browser.",
  "dashboard.menu.overview.summaryTitle": "Export summary",
  "dashboard.menu.refine": "Refine",
  "dashboard.metricsFoundExtractedTooltip": "Jobs found vs jobs extracted for this page type (not a standard list/detail row).",
  "dashboard.mostRecent": "Most Recent",
  "dashboard.next": "Next",
  "dashboard.noCrawlData.message": "No crawl data available yet. Expand the \"How to Run a Crawl\" section above for instructions on running a crawl and exporting the data.",
  "dashboard.noCrawlData.option": "No Data",
  "dashboard.noCrawlData.withServerDetail": "No crawl export available: {detail}. If you are on localhost, ensure AWS credentials can read the crawl-data bucket and that Maintainer has written crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "No Field Filter",
  "dashboard.noIssues": "No Issues",
  "dashboard.noLogoUrl": "No logo URL",
  "dashboard.notSent": "Not sent",
  "dashboard.notSentTooltip": "No job payload was extracted (jobsExtracted is 0). Not the same as “Skipped”: Skipped means the crawler intentionally did not re-run because the job already existed in RawJobs.",
  "dashboard.pageInfo": "Page {current} of {total}",
  "dashboard.pageType": "Page Type",
  "dashboard.pageType.detailTooltip": "Detail page: a single job posting URL. The crawler extracts structured data and may send it to the processor.",
  "dashboard.pageType.genericTooltip": "Crawler page type: {pageType}.",
  "dashboard.pageType.listTooltip": "List page: discovers job links on a listing or search page and enqueues them for detail crawls.",
  "dashboard.pagination.allRows": "All",
  "dashboard.pagination.first": "First",
  "dashboard.pagination.last": "Last",
  "dashboard.pagination.navGroup": "Page navigation",
  "dashboard.pagination.pageJumpAria": "Page number, 1 to {total}",
  "dashboard.pagination.pageJumpLabel": "Go to page",
  "dashboard.paginationIssueDescription": "Exactly {count} jobs sent - may indicate incomplete pagination.",
  "dashboard.pipelineHealth.active": "Active",
  "dashboard.pipelineHealth.activeFinland": "Active + Finland",
  "dashboard.pipelineHealth.activeNotFinland": "Active, not Finland",
  "dashboard.pipelineHealth.crawlCompare.body": "Jobs extracted on Työmarkkinatori crawl rows (sum of jobsExtracted): {count}. Compare to “Active Työmarkk. (URL)” above — large gaps often mean stale lastSeen (inactive), processor queue backlog, or URL/companyId mismatches.",
  "dashboard.pipelineHealth.crawlCompare.title": "Crawl export (this window)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot from Maintainer scan: {when}",
  "dashboard.pipelineHealth.inactive": "Inactive",
  "dashboard.pipelineHealth.missingStats": "No snapshot yet. After the next successful Maintainer run (with CRAWL_DATA_BUCKET set), counts appear here. Refresh crawl data after Maintainer.",
  "dashboard.pipelineHealth.title": "Pipeline health (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs rows",
  "dashboard.pipelineHealth.tyoFlag": "Active Työmarkk. (flag)",
  "dashboard.pipelineHealth.tyoUrl": "Active Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + not Finland",
  "dashboard.pipelineLogs.algolia": "Algolia",
  "dashboard.pipelineLogs.allGroups": "Lambda log groups",
  "dashboard.pipelineLogs.aria": "CloudWatch log links along the crawl → processor → enrich → Algolia → maintainer path",
  "dashboard.pipelineLogs.crawlSearch": "Crawl (crawlId)",
  "dashboard.pipelineLogs.crawlStream": "Crawl stream",
  "dashboard.pipelineLogs.enrich": "Enrich",
  "dashboard.pipelineLogs.maintainer": "Maintainer",
  "dashboard.pipelineLogs.noObjectId": "ObjectID links on detail rows only",
  "dashboard.pipelineLogs.processor": "Processor",
  "dashboard.pipelineLogs.processorUrl": "Processor (URL)",
  "dashboard.pipelineLogs.region": "{r}",
  "dashboard.pipelineLogs.unconfigured": "Set PIPELINE_LOG_GROUP_* on Dashboard / API Lambda for log links",
  "dashboard.potentialPaginationIssue": "Potential Pagination Issue",
  "dashboard.previous": "Previous",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda logs",
  "dashboard.processCompanyLogoLogs.tooltip": "Open CloudWatch log group for ProcessCompanyLogos (filtered to this company id in log text)",
  "dashboard.processDlq": "Process DLQ",
  "dashboard.quickFilterUncrawled": "Uncrawled · top score",
  "dashboard.quickFilterUncrawled.tooltip": "Show companies where doCrawl is not TRUE, sorted by score descending — useful for manually processing the most important uncrawled companies",
  "dashboard.recordCount": "{count} {count, plural, one {record} other {records}}",
  "dashboard.recrawl": "Recrawl",
  "dashboard.recrawlDetailTriggered": "Detail recrawl queued for {companyName}",
  "dashboard.recrawlTriggered": "Recrawl triggered for {companyName}",
  "dashboard.recrawling": "Recrawling…",
  "dashboard.redLastCrawlFailed": "Red — last crawl failed",
  "dashboard.refine.quickOptionsTitle": "Quick options",
  "dashboard.refine.section.companyList": "Company list",
  "dashboard.refine.section.companyListDesc": "Narrow which companies appear in the list.",
  "dashboard.refine.section.fieldFilterDesc": "Match a single company field (and optional value).",
  "dashboard.refine.section.pipelineIndex": "Pipeline & index",
  "dashboard.refine.section.pipelineIndexDesc": "Detail-crawl signals from the loaded export.",
  "dashboard.refine.section.tyomarkkinatori": "Työmarkkinatori",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Filter Työmarkkinatori-tagged rows and Y-tunnus metadata.",
  "dashboard.refreshCompanies": "Refresh Companies",
  "dashboard.refreshCrawlData": "Refresh Crawl Data",
  "dashboard.refreshCrawlData.title": "Refresh crawl data from S3",
  "dashboard.refreshing": "Refreshing...",
  "dashboard.registryInformation": "Registry Information",
  "dashboard.result": "Result",
  "dashboard.runMaintainer": "Run Maintainer",
  "dashboard.running": "Running...",
  "dashboard.save": "Save",
  "dashboard.saveError": "Error",
  "dashboard.saved": "Saved",
  "dashboard.saving": "Saving…",
  "dashboard.scanningDatabase": "Scanning database and loading companies...",
  "dashboard.searchCompanies": "Search companies...",
  "dashboard.sentForProcessing": "✓ Sent for processing",
  "dashboard.sentForProcessingTooltip": "Structured job data was extracted (jobsExtracted ≥ 1) and sent to the processing pipeline (SQS / processor).",
  "dashboard.sentToProcessor": "Sent to Processor",
  "dashboard.showing": "Showing {filtered} of {total} companies",
  "dashboard.skipped": "Skipped",
  "dashboard.skippedCrawlTooltip": "Skipped: the crawler did not re-fetch this URL because the job was already stored in RawJobs (duplicate prevention). A crawl row is still recorded for visibility.",
  "dashboard.socialMedia": "Social Media",
  "dashboard.sortAndGroup.sectionHint": "Change list order and optional grouping.",
  "dashboard.sortAndGroup.sectionTitle": "Sort & group",
  "dashboard.sortAscending": "Ascending",
  "dashboard.sortBasic": "Basic",
  "dashboard.sortBy": "Sort By",
  "dashboard.sortCrawls": "Crawls",
  "dashboard.sortDescending": "Descending",
  "dashboard.sortDetailPages": "Detail Pages",
  "dashboard.sortDirection": "Sort {direction}",
  "dashboard.sortFailed": "Failed Crawls",
  "dashboard.sortJobs": "Jobs",
  "dashboard.sortJobsExtracted": "Total Jobs Extracted",
  "dashboard.sortJobsFound": "Total Jobs Found",
  "dashboard.sortJobsSent": "Jobs Sent to Processor",
  "dashboard.sortLastCrawl": "Last Crawl Date",
  "dashboard.sortListPages": "List Pages",
  "dashboard.sortMostRecentJobs": "Most Recent Jobs Found",
  "dashboard.sortName": "Company Name",
  "dashboard.sortPages": "Pages",
  "dashboard.sortStatus": "Status",
  "dashboard.sortSuccessRate": "Success Rate",
  "dashboard.sortSuccessful": "Successful Crawls",
  "dashboard.status": "Status",
  "dashboard.successRate": "Success Rate",
  "dashboard.successful": "Successful",
  "dashboard.summary.extractedLabel": "Jobs extracted",
  "dashboard.summary.failedLabel": "Failed",
  "dashboard.summary.foundLabel": "Jobs found",
  "dashboard.summary.successLabel": "Successful",
  "dashboard.summary.totalCrawls": "Total crawls",
  "dashboard.summary.uniqueUrls": "Unique URLs",
  "dashboard.syncingCompanySettings": "Syncing company settings...",
  "dashboard.time": "Time",
  "dashboard.title": "Crawl Dashboard",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori detail: no Y-tunnus extracted from HTML",
  "dashboard.tmtBadge.noYtunnusShort": "No Y-tunnus",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus extracted but no matching company in CompaniesTable",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / no co.",
  "dashboard.tmtBadge.yTunnusUnknown": "Older crawl row: Y-tunnus metadata not recorded yet (re-crawl to classify)",
  "dashboard.tmtSourceTooltip": "This job was crawled from Työmarkkinatori (TE Services / Finnish public employment listings).",
  "dashboard.tmtYtunnusFilter.all": "Any",
  "dashboard.tmtYtunnusFilter.label": "TMT Y-tunnus",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnus not in Companies",
  "dashboard.tmtYtunnusFilter.noExtract": "No Y-tunnus extracted",
  "dashboard.toolsModal.actionsHeading": "Actions",
  "dashboard.toolsModal.closeBackdrop": "Close",
  "dashboard.toolsModal.closeButton": "Close",
  "dashboard.toolsModal.openButton": "Tools & config",
  "dashboard.toolsModal.openButtonSr": "Open maintainer, refresh, DLQ, and crawl instructions",
  "dashboard.toolsModal.title": "Tools & config",
  "dashboard.totalCrawls": "Total Crawls",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "All crawl rows",
  "dashboard.tyomarkkinatoriCrawlFilter.label": "Työmarkkinatori",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Non-TMT rows only",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "TMT rows only",
  "dashboard.uncheck": "Uncheck",
  "dashboard.unsave": "Remove from saved",
  "dashboard.url": "URL",
  "dashboard.viewAttributes": "View Attributes",
  "dashboard.viewJobs": "View",
  "dashboard.viewMessageBody": "View Message Body",
  "dashboard.viewOnGoogleMaps": "View on Google Maps",
  "dashboard.yellowNoJobs": "Yellow (No Jobs)",
  "employerScoreCard.dimension.flexibility": "flexibility",
  "employerScoreCard.dimension.growth": "growth",
  "employerScoreCard.dimension.pay": "pay",
  "employerScoreCard.dimension.stability": "stability",
  "employerScoreCard.disclaimer": "Computed from job data signals — not reviews",
  "employerScoreCard.howWeCalculate": "How we calculate this",
  "employerScoreCard.methodology": "Score is based on salary competitiveness from posted bands (where we have enough listings), remote and hybrid flexibility, hiring stability over time, and growth signals from role mix and hiring volume trends. Benefits and ad-level transparency are omitted from the headline number until those feeds are wired into scoring.",
  "employerScoreCard.strongestAt": "Strongest at {dimension}",
  "employerScoreCard.subscore.benefits": "Benefits",
  "employerScoreCard.subscore.flexibility": "Flexibility",
  "employerScoreCard.subscore.growth": "Growth",
  "employerScoreCard.subscore.pay": "Pay",
  "employerScoreCard.subscore.stability": "Stability",
  "employerScoreCard.subscore.transparency": "Transparency",
  "employerScoreCard.title": "JobCrawls Employer Score",
  "employerScoreCard.trackedOnlyHeading": "Also tracked, not yet weighted in",
  "engagement.nav.feedback": "Feedback",
  "engagement.nav.signIn": "Sign in",
  "facets.benefits": "Benefit",
  "facets.company": "Company",
  "facets.companyIndustry": "Industry",
  "facets.education": "Education",
  "facets.field": "Field",
  "facets.jobType": "Job type",
  "facets.language": "Language",
  "facets.location": "Location",
  "facets.management": "Leadership",
  "facets.remoteness": "Work setup",
  "facets.role": "Role",
  "facets.roleLevel": "Role level",
  "facets.skills": "Skill",
  "feedback.button.label": "Give us feedback",
  "feedback.cancel": "Cancel",
  "feedback.error": "Failed to submit feedback. Please try again.",
  "feedback.label": "Your Feedback",
  "feedback.modal.close": "Close",
  "feedback.modal.description": "We'd love to hear your thoughts. Share your feedback to help us improve.",
  "feedback.modal.title": "Send Feedback",
  "feedback.page.anonymous": "Anonymous",
  "feedback.page.delete": "Delete feedback",
  "feedback.page.deleteConfirm": "Are you sure you want to delete this feedback?",
  "feedback.page.deleteError": "Failed to delete feedback. Please try again.",
  "feedback.page.description": "View and manage user feedback",
  "feedback.page.listTitle": "All Feedback",
  "feedback.page.noFeedback": "No feedback yet",
  "feedback.page.refresh": "Refresh",
  "feedback.page.submitTitle": "Submit Feedback",
  "feedback.page.title": "Feedback",
  "feedback.page.viewMetadata": "View metadata",
  "feedback.placeholder": "Tell us what we should change or add...",
  "feedback.postSubmit.signInBody": "Create a free account so we can reply if we have questions about your feedback.",
  "feedback.postSubmit.signInButton": "Sign in or create account",
  "feedback.postSubmit.signInTitle": "Want us to follow up?",
  "feedback.submit": "Submit",
  "feedback.submitting": "Submitting...",
  "feedback.success": "Thank you! Your feedback has been submitted.",
  "filters.allFilters.navigation": "All filter options",
  "filters.connector.and": "AND",
  "filters.connector.or": "OR",
  "filters.navigation": "Filter options",
  "filters.top.clearAll": "Clear all filters",
  "footer.aboutJobcrawls": "About JobCrawls",
  "footer.accessibilityStatementLink": "Accessibility statement",
  "footer.aiTranslationDisclaimer": "Note: Some content on this website contains machine-translations using AI and may contain errors.",
  "footer.allLocations": "All locations",
  "footer.bestEmployers": "Best employers",
  "footer.brandDescription": "JobCrawls is a job search engine for Finland. We index openings directly from thousands of employer career pages daily, in English, Finnish, and Swedish — with transparent salary data and no sponsored rankings.",
  "footer.browseAllPages": "Browse all pages",
  "footer.businessIdLabel": "Business ID",
  "footer.colCompany": "Company",
  "footer.colEmployersAndDevelopers": "Employers & developers",
  "footer.colFindJobs": "Find jobs",
  "footer.colJobSeekers": "Job seekers",
  "footer.collectiveAgreementsLink": "Collective agreements",
  "footer.connectorPrivacy": "Connector privacy",
  "footer.contact": "Contact",
  "footer.cookieSettings": "Cookie settings",
  "footer.copyright": "© 2026 {company}",
  "footer.editorialStandards": "Editorial standards",
  "footer.forDevelopers": "For Developers",
  "footer.forEmployersLink": "For employers",
  "footer.guidesAndArticles": "Guides & articles",
  "footer.howCrawlerWorks": "How our crawler works",
  "footer.jobsInEspoo": "Jobs in Espoo",
  "footer.jobsInHelsinki": "Jobs in Helsinki",
  "footer.jobsInOulu": "Jobs in Oulu",
  "footer.jobsInTampere": "Jobs in Tampere",
  "footer.jobsInTurku": "Jobs in Turku",
  "footer.openJobsInFinland": "Open jobs in Finland",
  "footer.partnerships": "Media partnerships",
  "footer.privacy": "Privacy Policy",
  "footer.remoteJobs": "Remote jobs",
  "footer.salariesByRole": "Salaries by role",
  "footer.signIn": "Sign in",
  "footer.sitemap": "Site Map",
  "footer.terms": "Terms of Service",
  "hit.applicationDeadline": "Deadline: {date}",
  "hit.applied": "Applied",
  "hit.companyInsights.cue": "Company insights",
  "hit.companyLinkTitle": "Open company profile — data and insights for {company}",
  "hit.companyProfile.aria": "View company profile, hiring data, and insights for {company}",
  "hit.driversLicenseRequired": "Driver's Licence Required",
  "hit.hidden": "Hidden",
  "hit.hide.button": "Hide",
  "hit.hide.menu": "Hide",
  "hit.jobTitle": "Job",
  "hit.jobTypeLinkAria": "Search for {jobType} jobs",
  "hit.jobTypeLinkTitle": "Search for {jobType} jobs",
  "hit.linkCopied": "Link copied to clipboard!",
  "hit.locationLinkAria": "Search for jobs in {location}",
  "hit.locationLinkTitle": "Search for jobs in {location}",
  "hit.locationNotAvailable": "Location not available",
  "hit.markAsApplied.menu": "Mark as Applied",
  "hit.markAsState": "Mark as {state}",
  "hit.moreLocations": "+{count} more",
  "hit.moreOptions": "More options",
  "hit.openApplication": "Open Application",
  "hit.postedDate": "Posted: {date}",
  "hit.postedDate.detail": "Posted: {date}",
  "hit.remotenessLinkAria": "Search for {remoteness} jobs",
  "hit.remotenessLinkTitle": "Search for {remoteness} jobs",
  "hit.removeApplied": "Remove from applied",
  "hit.roleLevelLinkAria": "Search for {roleLevel} jobs",
  "hit.roleLevelLinkLabel": "{roleLevel} jobs",
  "hit.roleLevelLinkTitle": "Search for {roleLevel} jobs",
  "hit.salaryNotSpecified": "Salary not specified",
  "hit.salaryNotSpecified.card": "Salary not specified",
  "hit.save": "Save",
  "hit.save.detail": "Save",
  "hit.saved": "Saved",
  "hit.saved.detail": "Saved",
  "hit.seeAd": "Details",
  "hit.share": "Share",
  "hit.share.detail": "Share",
  "hit.shareError": "Something went wrong while trying to share this job.",
  "hit.summerJob": "Summer Job",
  "hit.toast.applied": "Marked as applied",
  "hit.toast.hidden": "Job hidden",
  "hit.toast.saved": "Job saved",
  "hit.toast.savedWithCount": "Saved — {count, plural, one {# job} other {# jobs}} in My Jobs",
  "hit.toast.shared": "Link copied to clipboard",
  "hit.toast.unapplied": "Removed from applied",
  "hit.toast.unhidden": "Job unhidden",
  "hit.toast.unsaved": "Job removed from saved",
  "hit.toast.viewMyJobs": "View →",
  "hit.toast.viewed": "Marked as viewed",
  "hit.tooltip.details": "View full job details and description",
  "hit.tooltip.filterByCompany": "Filter jobs by this company",
  "hit.tooltip.filterByJobType": "Filter jobs by type: {jobType}",
  "hit.tooltip.filterByLanguages": "Filter jobs by required languages: {languages}",
  "hit.tooltip.filterByLevel": "Filter jobs by level: {level}",
  "hit.tooltip.filterByLocation": "Filter jobs in: {locations}",
  "hit.tooltip.filterByRemoteness": "Filter jobs by remoteness: {remoteness}",
  "hit.tooltip.moreOptions": "More options",
  "hit.tooltip.save": "Save this job to compare with others",
  "hit.tooltip.saved": "Remove from saved jobs",
  "hit.tooltip.share": "Share this job",
  "hit.unhide": "Unhide job",
  "hitGroup.openRoles": "{count, plural, one {# open role} other {# open roles}}",
  "hitGroup.viewCompanyProfile": "View company profile",
  "hitV2.estMonthly": "Est. Monthly",
  "hitV2.monthly": "Monthly",
  "hitV2.viewJob": "View job",
  "hub.bottomNav.alerts": "Alerts",
  "hub.bottomNav.ariaLabel": "Hub navigation",
  "hub.bottomNav.profile": "Profile",
  "hub.guestSyncNote": "Saved on this device — {signIn} to sync across devices",
  "hub.guestSyncNote.signIn": "sign in",
  "hub.nav.myJobs": "My Jobs",
  "hub.nav.myJobs.count": "{savedCount} saved · {activeCount} active",
  "hub.nav.profile": "Profile & CV",
  "hub.nav.searchesAlerts": "Searches & Alerts",
  "hub.nav.searchesAlerts.newCount": "{count} new",
  "hub.nav.watchlist": "Watchlist",
  "hub.title": "My Jobs",
  "instantsearch.searchBoxLink.placeholder": "Search for jobs",
  "instantsearch.searchbox.placeholder": "Search jobs, language, or city",
  "job.copyCompanyName": "Copy company name",
  "jobAlerts.confirm.confirm": "Confirm",
  "jobAlerts.confirm.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.confirm.explanation": "Confirm your email address to start receiving job alert emails from JobCrawls.",
  "jobAlerts.confirm.heading": "Confirm your job alerts",
  "jobAlerts.confirm.invalidLink": "This confirmation link is invalid or has expired. Turn alerts on again from your saved searches to get a new one.",
  "jobAlerts.confirm.successBody": "You're all set — we'll email you when new jobs match your saved searches.",
  "jobAlerts.confirm.successHeading": "Your email is confirmed",
  "jobAlerts.confirm.working": "Confirming…",
  "jobAlerts.newMatches.errorBody": "We couldn't load your new matches. Please try again in a moment.",
  "jobAlerts.newMatches.viewAllInSection": "View all {count} new matches",
  "jobAlerts.panel.activeStatus": "Alerts are on — enable them per search below.",
  "jobAlerts.panel.consentCopy.v1": "Get an email when new jobs match the saved searches you enable alerts for — weekly on Monday mornings by default, or daily if you prefer. Sent to {email}. You can withdraw anytime here or via the unsubscribe link in every email. No other emails, ever.",
  "jobAlerts.panel.disable": "Turn off email alerts",
  "jobAlerts.panel.enable": "Enable email alerts",
  "jobAlerts.panel.error": "Saving failed. Please try again.",
  "jobAlerts.panel.frequencyDaily": "Daily",
  "jobAlerts.panel.frequencyLegend": "How often",
  "jobAlerts.panel.frequencyWeekly": "Weekly (Monday morning)",
  "jobAlerts.panel.heading": "Email alerts",
  "jobAlerts.panel.languageLegend": "Email language",
  "jobAlerts.panel.noEmail": "Your account has no email address, so alerts are unavailable.",
  "jobAlerts.panel.pendingStatus": "Check your inbox: confirm your email address to activate alerts.",
  "jobAlerts.panel.privacyLink": "Privacy policy",
  "jobAlerts.panel.sectionHeading": "Email digest",
  "jobAlerts.panel.seeNewMatches": "See new matches now",
  "jobAlerts.panel.update": "Save changes",
  "jobAlerts.signInPrompt": "Never miss a new match — {signIn} to see live updates and turn on email alerts for your searches.",
  "jobAlerts.toggle.failed": "Couldn't save — try again",
  "jobAlerts.toggle.label": "Email me new matches",
  "jobAlerts.toggle.needsSubscription": "Enable email alerts above first",
  "jobAlerts.unsubscribe.confirm": "Unsubscribe",
  "jobAlerts.unsubscribe.errorBody": "Something went wrong. Please try again in a moment.",
  "jobAlerts.unsubscribe.explanation": "This stops all job alert emails from JobCrawls to your address. Your saved searches stay untouched.",
  "jobAlerts.unsubscribe.heading": "Unsubscribe from job alerts",
  "jobAlerts.unsubscribe.invalidLink": "This unsubscribe link is invalid or incomplete. Use the link from a recent alert email, or manage alerts from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successBody": "You will no longer receive job alert emails. You can re-enable alerts anytime from your saved searches when signed in.",
  "jobAlerts.unsubscribe.successHeading": "You are unsubscribed",
  "jobAlerts.unsubscribe.working": "Unsubscribing…",
  "jobChart.popover.categoriesShown": "Categories shown",
  "jobChart.popover.companyContext": "Based on {companyName} listings in our data.",
  "jobChart.popover.count": "Job postings",
  "jobChart.popover.monthKey": "Period",
  "jobChart.popover.share": "Share of chart",
  "jobChart.popover.totalInRing": "Total in this ring",
  "jobChart.segmentHint": "Tap or hover a segment for details.",
  "jobDetail.similarJobs.algoliaListTitle": "Similar jobs",
  "jobDetail.similarJobs.description": "Discover more opportunities that match your interests and skills",
  "jobDetail.similarJobs.seeAll": "See all",
  "jobDetail.similarJobs.sourceNote": "From JobCrawls search: same role title and primary location as this listing (this job excluded). Up to 8 results.",
  "jobDetail.similarJobs.title": "Related Opportunities",
  "jobDetailPage.404.backHome": "Back to Home",
  "jobDetailPage.404.description": "Sorry, we couldn't find this job. It may have been removed or the link is incorrect.",
  "jobDetailPage.404.heading": "This page is not found",
  "jobDetailPage.aboutCompany": "About",
  "jobDetailPage.applicationDeadline": "Application deadline",
  "jobDetailPage.applied": "Applied ✓",
  "jobDetailPage.applyNavigation": "Apply to job",
  "jobDetailPage.applyNow": "Apply on Company Website",
  "jobDetailPage.availableLanguages": "Available in:",
  "jobDetailPage.benefits": "Benefits",
  "jobDetailPage.benefitsAndPerks": "Benefits & Perks",
  "jobDetailPage.businessId": "Business ID",
  "jobDetailPage.byRemoteness": "By Remoteness",
  "jobDetailPage.chartsDataRange": "Data shown is based on historical job postings from our database.",
  "jobDetailPage.collapseCompensation": "Collapse compensation details",
  "jobDetailPage.companiesHiringInLocation": "Companies Hiring in {location}",
  "jobDetailPage.companyCollapsedBody": "Expand to view trend charts, location distribution, language demand, and map details.",
  "jobDetailPage.companyDistributionDescription": "Showing top {count} companies by number of job postings",
  "jobDetailPage.companyInfoFromTradeRegister": "Includes details from the Finnish Trade Register.",
  "jobDetailPage.compensation": "Compensation",
  "jobDetailPage.contact": "Contact:",
  "jobDetailPage.coverLetter.basedOn": "Based on: {entries}",
  "jobDetailPage.coverLetter.copied": "Copied!",
  "jobDetailPage.coverLetter.copy": "Copy text",
  "jobDetailPage.coverLetter.download": "Download cover letter",
  "jobDetailPage.coverLetter.editHint": "Edit the text below before copying or downloading — it's yours to adjust.",
  "jobDetailPage.coverLetter.failed": "Could not draft your cover letter. Try again later.",
  "jobDetailPage.coverLetter.generateCta": "Draft my cover letter",
  "jobDetailPage.coverLetter.intro": "Draft a cover letter using your profile and this job — you can edit it before downloading.",
  "jobDetailPage.coverLetter.loading": "Drafting your cover letter…",
  "jobDetailPage.coverLetter.networkError": "Network error. Check your connection.",
  "jobDetailPage.coverLetter.notConfigured": "Cover letter drafting is not enabled for this environment.",
  "jobDetailPage.coverLetter.overclaimWarning": "We couldn't find \"{skill}\" in your profile — make sure this is true.",
  "jobDetailPage.coverLetter.quotaExceeded": "You've hit today's cover letter limit — it resets tomorrow.",
  "jobDetailPage.coverLetter.sourceCompany": "Company info",
  "jobDetailPage.coverLetter.sourceSkills": "Skills",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {One part} other {# parts}} of this letter wasn't tied to anything specific in your profile — please check {count, plural, one {it's} other {they're}} accurate.",
  "jobDetailPage.description": "Job Description",
  "jobDetailPage.estimatedExpiry": "Estimated expiry",
  "jobDetailPage.estimatedNetSalary.explanation": "Estimated {year} take-home pay after Finnish income tax, pension, and unemployment insurance contributions. Assumes the national average municipal tax rate ({rate}%), no church tax, and standard deductions only — your actual net pay depends on your municipality, church membership, age, and family situation.",
  "jobDetailPage.expandCompanyData": "Expand company information to view trends, distributions, and map",
  "jobDetailPage.expandCompensation": "Expand compensation details",
  "jobDetailPage.experience": "Experience",
  "jobDetailPage.expired.backToSearch": "Back to search results",
  "jobDetailPage.expired.banner": "This listing may be too old or no longer active. {link}",
  "jobDetailPage.headcount": "Headcount",
  "jobDetailPage.hideCharts": "Hide Charts",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.hiringSnapshotSeo.caption": "Current open roles at {company} on JobCrawls",
  "jobDetailPage.hiringSnapshotSeo.location": "Location",
  "jobDetailPage.jobType": "Job Type",
  "jobDetailPage.languageNavigation": "Available languages",
  "jobDetailPage.languageRequirements": "Language Requirements",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {today} one {#d ago} other {#d ago}}",
  "jobDetailPage.lastSeenDetail": "Last seen in crawl: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Listing",
  "jobDetailPage.loadingMap": "Loading map...",
  "jobDetailPage.location": "Location",
  "jobDetailPage.locationAndRemotenessDistribution": "Location & Remoteness Distribution",
  "jobDetailPage.locationDistribution": "Location Distribution",
  "jobDetailPage.mapError": "Unable to load map",
  "jobDetailPage.matchBreakdown.collapse": "Collapse match breakdown",
  "jobDetailPage.matchBreakdown.expand": "Expand match breakdown",
  "jobDetailPage.matchBreakdown.title": "How this job matches your profile",
  "jobDetailPage.minimumYearsOfExperience": "{years} {years, plural, one {year} other {years}}",
  "jobDetailPage.noItems": "No items to show.",
  "jobDetailPage.noLocation": "No location",
  "jobDetailPage.noRemoteness": "Not specified",
  "jobDetailPage.officialRegisterName": "Registered name",
  "jobDetailPage.originalLanguage": "Original",
  "jobDetailPage.peopleManagementTier": "Management Tier",
  "jobDetailPage.period.day": "day",
  "jobDetailPage.period.hour": "hour",
  "jobDetailPage.period.month": "month",
  "jobDetailPage.period.year": "year",
  "jobDetailPage.perks": "Perks",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Posted today} one {Posted 1 day ago} other {Posted # days ago}}",
  "jobDetailPage.recruitmentProcess": "Recruitment Process",
  "jobDetailPage.remoteness": "Remoteness",
  "jobDetailPage.remotenessDistribution": "Remoteness Distribution",
  "jobDetailPage.remotenessDistribution.short": "Remoteness",
  "jobDetailPage.requiredLanguages": "Required Languages",
  "jobDetailPage.requirements": "Requirements",
  "jobDetailPage.responsibilities": "Responsibilities",
  "jobDetailPage.roleAndRoleLevelDistribution": "Role & Role Level Distribution",
  "jobDetailPage.roleDistribution": "Role Distribution",
  "jobDetailPage.roleLevel": "Role Level",
  "jobDetailPage.roleLevelDistribution": "Role Level Distribution",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Current role-level mix at {company} on JobCrawls",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Role level",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Active listings",
  "jobDetailPage.roleSnapshotSeo.caption": "Current role mix at {company} on JobCrawls",
  "jobDetailPage.roleSnapshotSeo.role": "Role type",
  "jobDetailPage.salaryProvenance.employerQuote": "Pay range is taken from wording in the job ad.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "This pay range is in our data but is not shown as a clear quote in the ad — treat it as unverified.",
  "jobDetailPage.salarySourceBadge.estimated": "Estimated",
  "jobDetailPage.salarySourceBadge.fromListing": "Listed",
  "jobDetailPage.salarySourceBadge.unverified": "Unverified",
  "jobDetailPage.salaryStatistics": "Salary Statistics",
  "jobDetailPage.section.company": "Company Information",
  "jobDetailPage.section.jobDetails": "Job Details",
  "jobDetailPage.seeLocation": "See Location",
  "jobDetailPage.seeOriginal": "See original",
  "jobDetailPage.showCharts": "Show Charts",
  "jobDetailPage.showCompanyContact": "Show Company Contact",
  "jobDetailPage.showContact": "Show Contact Email",
  "jobDetailPage.showConverted": "Show EUR/month",
  "jobDetailPage.showingItemsAboveThreshold": "Showing only items above {percentage}%",
  "jobDetailPage.skillsAndTechnologies": "Skills & Technologies",
  "jobDetailPage.specialisations": "Specialisations",
  "jobDetailPage.tailorCv.disclaimer": "Only your existing experience was reworded and reordered to highlight what this job cares about — nothing was invented. Review it below before downloading.",
  "jobDetailPage.tailorCv.download": "Download tailored CV",
  "jobDetailPage.tailorCv.emptyProfile": "Fill in your profile first — we need your work experience or skills to tailor a CV.",
  "jobDetailPage.tailorCv.failed": "Could not tailor your CV. Try again later.",
  "jobDetailPage.tailorCv.goToProfile": "Go to your profile",
  "jobDetailPage.tailorCv.loading": "Rewording your existing experience for this job…",
  "jobDetailPage.tailorCv.networkError": "Network error. Check your connection.",
  "jobDetailPage.tailorCv.notConfigured": "CV tailoring is not enabled for this environment.",
  "jobDetailPage.tailorCv.quotaExceeded": "You've hit today's tailoring limit — it resets tomorrow.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Cover letter",
  "jobDetailPage.tailorCv.tabCv": "CV",
  "jobDetailPage.tailorCv.title": "Tailor my CV for this job",
  "jobDetailPage.tailorCvCta": "Tailor my CV for this job",
  "jobDetailPage.tradeRegisterWebsite": "Trade register website",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> is Finland's official public employment service portal, operated by the Ministry of Economic Affairs and Employment (TEM). It lists job openings from across the Finnish public sector, municipalities, and employers who use the government's recruitment infrastructure.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Source: <link>Job Market Finland customer information system</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "We include Työmarkkinatori listings so that JobCrawls covers the full breadth of the Finnish job market — including roles that only appear through official government channels and would otherwise be missed.",
  "jobDetailPage.vacationWeeks": "Vacation: {weeks} weeks",
  "jobDetailPage.viewBenefits": "View benefits",
  "jobDetailPage.visa": "Visa",
  "jobDetailPage.visaSponsor": "✓ Sponsorship available",
  "jobDetailPage.watchCompanyVideo": "Watch Company Video",
  "jobDetailPageV2.aboutRole": "About the role",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Browse all Finnish collective agreements",
  "jobDetailPageV2.collectiveAgreement.explicit": "Employer states this job follows the {agreementName} collective agreement.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Best guess: {agreementName} collective agreement — inferred from this employer's industry and the role, could be a different one.",
  "jobDetailPageV2.daysAgo": "{days, plural, one {# day ago} other {# days ago}}",
  "jobDetailPageV2.deadline": "Deadline {date}",
  "jobDetailPageV2.estimatedExpiry": "Est. expiry {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {year} other {years}} experience",
  "jobDetailPageV2.financialOverview": "Financial overview",
  "jobDetailPageV2.lastSeen": "Last seen {date}",
  "jobDetailPageV2.location": "Location",
  "jobDetailPageV2.location.collapse": "Collapse location map",
  "jobDetailPageV2.location.expand": "Expand location map",
  "jobDetailPageV2.mostHiredRoles": "Most-hired roles",
  "jobDetailPageV2.openRoles": "{count} open roles",
  "jobDetailPageV2.otherLocations": "+{count} other locations",
  "jobDetailPageV2.postedOn": "Posted {date}",
  "jobDetailPageV2.profit": "Profit",
  "jobDetailPageV2.profitMargin": "Profit margin",
  "jobDetailPageV2.revenue": "Revenue",
  "jobDetailPageV2.roleLevelMix": "Role-level mix",
  "jobDetailPageV2.salaryCompares": "How this salary compares",
  "jobDetailPageV2.salaryCompares.collapse": "Collapse salary comparison",
  "jobDetailPageV2.salaryCompares.expand": "Expand salary comparison",
  "jobDetailPageV2.tldr": "At a glance",
  "jobDetailPageV2.topLocations": "Top locations:",
  "jobDetailPageV2.viewCompany": "View company",
  "layoutErrorFallback.body": "Please try reloading the page. If the problem continues, we have been notified.",
  "layoutErrorFallback.home": "Go to home",
  "layoutErrorFallback.reload": "Reload page",
  "layoutErrorFallback.title": "Something went wrong",
  "locationHub.activeJobs": "Jobs",
  "locationHub.avgSalary": "Salary",
  "locationHub.hero.description": "Explore major Finnish cities with real-time job counts, salary insights, and market data. Discover your next opportunity in Finland's thriving tech ecosystem.",
  "locationHub.hero.subtitle": "Curated city guides and job searches across Finland",
  "locationHub.hero.title": "Finland Job Market",
  "locationHub.hero.title.breadcrumb": "Explore Jobs by Location",
  "locationHub.languages": "Languages",
  "locationHub.metropolitan.seo": "The Helsinki Metropolitan area, including Espoo and Vantaa, is Finland's primary economic engine, offering the highest density of English-speaking and remote roles with excellent transport connectivity (HSL).",
  "locationHub.overview.description": "Explore Finland's leading technology and innovation centers with real-time job market data, salary insights, and industry trends.",
  "locationHub.overview.title": "Major Tech Hubs",
  "locationHub.popularRoles.heading": "Popular Roles",
  "locationHub.quickJump.overview": "Overview",
  "locationHub.resourcesLink": "Explore Job Market Insights & Career Tips",
  "locationHub.structuredData.collectionPage.description": "Discover job opportunities in major Finnish cities with salary insights and market data",
  "locationHub.structuredData.collectionPage.name": "Finland Locations Hub",
  "locationHub.structuredData.itemList.description": "Explore job opportunities across major cities in Finland",
  "locationHub.structuredData.itemList.name": "Finland Job Locations",
  "locationHub.table.activeJobs": "Active Jobs",
  "locationHub.table.avgSalary": "Avg Salary",
  "locationHub.table.city": "City",
  "locationHub.table.specialty": "Specialty",
  "locationHub.workModel": "Work Model",
  "map.cappedResultsNotice": "Showing {shown} of {total} — zoom in further to narrow down",
  "map.densityZoomPrompt": "Zoom in to see individual jobs and company logos",
  "map.densityZoomPrompt.button": "Zoom in",
  "map.jobs": "jobs",
  "map.jobsInView": "Jobs in view",
  "map.loading": "Loading map...",
  "map.noJobs": "No jobs in this area",
  "map.noJobsInView": "No jobs in this area",
  "map.noLocationsForPins": "No location coordinates for map pins in this view.",
  "map.resetView": "Reset map to show all of Finland",
  "map.tokenMissing": "Map view requires Mapbox access token",
  "marketHeader.language.english": "English",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% English",
  "marketHeader.language.label": "Language Demand",
  "marketHeader.language.mixed": "Mixed",
  "marketHeader.languageSeo.caption": "Language demand in {location}",
  "marketHeader.languageSeo.language": "Language category",
  "marketHeader.languageSeo.share": "Share of listings",
  "marketHeader.nearbyMarkets": "Nearby markets",
  "marketHeader.qa.languageQuestion": "What languages are required in {location}?",
  "marketHeader.qa.remoteAnswer": "Yes, {answer}",
  "marketHeader.qa.remoteQuestion": "Is {location} remote-friendly?",
  "marketHeader.qa.salaryQuestion": "What is the average salary in {location}?",
  "marketHeader.rail.marketDetails": "Market details",
  "marketHeader.rail.samplesUpdatedDaily": "{count} open jobs · updated daily",
  "marketHeader.removeLocation": "Remove location",
  "marketHeader.salary.finlandComparison": "Finland avg: {finlandAvg}",
  "marketHeader.salary.label": "Salary Trends",
  "marketHeader.salary.range": "Salary range",
  "marketHeader.salary.rangePercentile": "25th-75th percentile range",
  "marketHeader.salaryPercentileSeo.caption": "Advertised salary distribution in {location}, Finland — full-time roles",
  "marketHeader.salaryPercentileSeo.p25": "25th percentile",
  "marketHeader.salaryPercentileSeo.p50": "Median (50th percentile)",
  "marketHeader.salaryPercentileSeo.p75": "75th percentile",
  "marketHeader.salaryPercentileSeo.percentile": "Percentile",
  "marketHeader.salaryPercentileSeo.salary": "Monthly salary (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Based on {count} job postings with explicit salary data in {location}, Finland.",
  "marketHeader.title": "Open jobs in {location}",
  "marketHeader.toggle": "Toggle market header",
  "marketHeader.updated": "Updated:",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% remote/hybrid",
  "marketHeader.workModel.label": "Work Model",
  "marketHeader.workModel.noData": "Flexible",
  "marketHeader.workModelSeo.caption": "Work model distribution in {location}",
  "marketHeader.workModelSeo.model": "Work model",
  "marketHeader.workModelSeo.share": "Share of listings",
  "marketingConsent.checkbox.label": "Also send me job market emails and tips from JobCrawls (optional, unsubscribe anytime).",
  "matchDonut.ariaLabel": "Match score: {score}%",
  "matchDonut.breakdown.benefits": "Benefits",
  "matchDonut.breakdown.languages": "Languages",
  "matchDonut.breakdown.remoteness": "Remoteness",
  "matchDonut.breakdown.salary": "Salary",
  "matchDonut.breakdown.title": "Match Score Breakdown",
  "matchDonut.breakdown.vacation": "Vacation",
  "matchDonut.loginPrompt.createAccount": "Create account",
  "matchDonut.loginPrompt.description": "Create a profile and add your current job details to see how well jobs match your preferences",
  "matchDonut.loginPrompt.title": "Login to see your match score",
  "matchDonut.loginPromptAria": "Log in to see your match score",
  "matchDonut.profilePrompt.description": "Add your current job details and preferences on your profile to see how well jobs match.",
  "matchDonut.profilePrompt.goToProfile": "Go to profile",
  "matchDonut.profilePrompt.title": "Complete your profile to see your match score",
  "matchDonut.profilePromptAria": "Complete your profile to see your match score",
  "matchDonut.searchBreakdown.employer": "Employer & industry",
  "matchDonut.searchBreakdown.keywords": "Search keywords",
  "matchDonut.searchBreakdown.location": "Location",
  "matchDonut.searchBreakdown.remoteness": "Remoteness",
  "matchDonut.searchBreakdown.roleFit": "Role & field",
  "matchDonut.searchInference.bullet.company": "You’ve shown interest in employers like {company} — we factor that into the score.",
  "matchDonut.searchInference.bullet.keywords": "Your searches included terms like \"{terms}\" — we compared them to this job’s title and role.",
  "matchDonut.searchInference.bullet.locations": "You’ve searched in areas such as {locations} — this listing’s location is compared to that.",
  "matchDonut.searchInference.bullet.remoteness": "You often use remoteness filters ({values}) — this job is scored against those preferences.",
  "matchDonut.searchInference.bullet.roles": "Your searches include role filters such as {hints} — similar signals are compared to this job.",
  "matchDonut.searchInference.intro": "We don’t have your profile yet, so this score estimates fit using filters and keywords from searches you’ve run on JobCrawls (recent activity counts more).",
  "matchDonut.searchInference.title": "Match from your recent searches",
  "modal.close": "Close",
  "navigation.home": "Home",
  "navigation.home.breadcrumb": "Home",
  "navigation.language": "Language",
  "navigation.language.label": "Language",
  "navigation.locations": "Locations",
  "navigation.locations.menu": "Locations Hub",
  "navigation.menu": "Menu",
  "navigation.menu.heading": "Menu",
  "navigation.menu.open": "Open menu",
  "navigation.search": "Search Jobs",
  "navigation.search.menu": "Find Jobs",
  "navigation.search.reset": "Reset search",
  "notes.field.add": "Add note",
  "notes.field.placeholder": "Add a private note…",
  "numberSelector.any": "Any",
  "pagination.ariaLabel": "Job search results pagination",
  "pagination.first": "First",
  "pagination.keyboardShortcuts": "Keyboard shortcuts",
  "pagination.last": "Last",
  "pagination.next": "Next",
  "pagination.previous": "Previous",
  "profile.aiApply": "Apply",
  "profile.aiLoading": "Thinking…",
  "profile.aiSuggest": "Suggest with AI",
  "profile.aiSuggestionsDisclaimer": "These are AI-drafted starting points based only on your job titles and degrees — not verified facts about you. Read each one and edit it to match what's actually true before applying.",
  "profile.aiSuggestionsEmpty": "Your profile looks complete. Add more experience or leave some fields empty and try again.",
  "profile.aiSuggestionsTitle": "AI suggestions",
  "profile.applicationKits.link": "Application Kits",
  "profile.benefits.label": "Current benefits (for matching)",
  "profile.benefitsWeight": "Benefits Weight: {weight}%",
  "profile.closePreview": "Close preview",
  "profile.closeSuggestions": "Close",
  "profile.completion.allDone": "Your profile is ready to generate great CVs.",
  "profile.completion.fix": "Fix",
  "profile.completion.itemBasic": "Add your title or most recent role",
  "profile.completion.itemCurrentRole": "Add your current role details (for matching)",
  "profile.completion.itemEducation": "Add your education",
  "profile.completion.itemExperience": "Add your work experience",
  "profile.completion.itemSkills": "Add at least 3 skills",
  "profile.completion.label": "profile complete",
  "profile.currentJob.label": "Current role (for matching)",
  "profile.currentSalary.label": "Current salary, monthly (for matching)",
  "profile.currentSalary.placeholder": "e.g. 3500",
  "profile.currentSalary.privacyShort": "Private. Used only for your match score.",
  "profile.currentSalary.unit": "€/mo",
  "profile.currentSalary.workPercent": "work %",
  "profile.currentWorkModel.label": "Current work model (for matching)",
  "profile.cvDownloadFailed": "Failed to download your CV. Please try again.",
  "profile.cvImport.notConfigured": "CV import is not enabled for this environment.",
  "profile.cvUploadError": "Please upload a PDF file",
  "profile.cvUploadFailed": "Failed to upload CV. Please try again.",
  "profile.cvUploadSizeError": "File size must be less than 5MB",
  "profile.cvUploading": "Importing…",
  "profile.desiredBenefits": "Desired benefits",
  "profile.desiredIndustries": "Company Industries",
  "profile.desiredJob": "What you're looking for",
  "profile.desiredJobDescription": "Tell us what you're looking for. These preferences take priority over your current role when we score how well a job matches you.",
  "profile.desiredJobTypes": "Job Types",
  "profile.desiredLocations": "Locations",
  "profile.desiredRemoteness": "Remoteness Options",
  "profile.desiredRoleLevels": "Role Levels",
  "profile.desiredSalaryMin": "Minimum salary, monthly",
  "profile.desiredTitles": "Job Titles",
  "profile.desiredVacationWeeks": "Minimum vacation weeks",
  "profile.downloadCV": "Download my CV",
  "profile.europass.additionalInfo": "Additional information",
  "profile.europass.basedOn": "Based on Europass CV structure (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Education and training",
  "profile.europass.noEducation": "No education added.",
  "profile.europass.noSkills": "No skills added.",
  "profile.europass.noWorkExperience": "No work experience added.",
  "profile.europass.personalSkills": "Personal skills",
  "profile.europass.workExperience": "Work experience",
  "profile.exportCV": "Export CV",
  "profile.jobType": "Job Type",
  "profile.jobTypeWeight": "Job Type Weight: {weight}%",
  "profile.languageSwitcher.hint": "Import, Upload, and Suggest with AI fill in whichever language tab is selected. Each version is independent — nothing is auto-translated.",
  "profile.languages.label": "Languages (professional level)",
  "profile.languagesWeight": "Languages Weight: {weight}%",
  "profile.linkedInImport.button": "Import from LinkedIn",
  "profile.linkedInImport.failed": "Could not import profile. Try again later.",
  "profile.linkedInImport.hint": "Paste your public profile URL (linkedin.com/in/…), then import. Data is fetched via Proxycurl (third-party) and may not include everything on your page. It fills in the form below, not your saved profile — read it over and fix anything before you save.",
  "profile.linkedInImport.invalidProfileUrl": "Use your personal profile link (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Enter a valid LinkedIn URL.",
  "profile.linkedInImport.loading": "Importing…",
  "profile.linkedInImport.networkError": "Network error. Check your connection.",
  "profile.linkedInImport.notConfigured": "LinkedIn import is not enabled for this environment.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/your-profile/",
  "profile.linkedInImport.sectionTitle": "LinkedIn profile",
  "profile.loading": "Loading...",
  "profile.locationWeight": "Location Weight: {weight}%",
  "profile.locations": "Locations",
  "profile.matchPreferences": "Match Preferences",
  "profile.matchPreferencesDescription": "Adjust the importance of different factors when calculating your job match score. The total must equal 100%.",
  "profile.prefillFromSearches.banner": "We filled in some fields from your recent job searches. Review them and adjust anything that looks off.",
  "profile.prefillFromSearches.dismiss": "Dismiss",
  "profile.preview": "Preview",
  "profile.previewEuropass": "CV preview (Europass format)",
  "profile.profilePhoto.errorCompressedTooLarge": "Image is still too large after compression. Try a smaller original.",
  "profile.profilePhoto.errorProcess": "Could not process this image. Try another file.",
  "profile.profilePhoto.errorTooLarge": "Image is too large (max 5 MB).",
  "profile.profilePhoto.errorType": "Use a JPEG, PNG, WebP, or GIF image.",
  "profile.profilePhoto.remove": "Remove uploaded photo",
  "profile.profilePhoto.uploadAria": "Upload or change profile photo",
  "profile.quickActions.title": "Your CV",
  "profile.remotenessWeight": "Remoteness Weight: {weight}%",
  "profile.roleLevel": "Role Level",
  "profile.roleLevelWeight": "Role Level Weight: {weight}%",
  "profile.salaryWeight": "Salary Weight: {weight}%",
  "profile.selectJobType": "Select job type",
  "profile.selectLocations": "Select locations",
  "profile.selectMultipleIndustries": "Select one or more industries",
  "profile.selectMultipleJobTypes": "Select one or more job types",
  "profile.selectMultipleLocations": "Select one or more locations",
  "profile.selectMultipleRemoteness": "Select one or more remoteness options",
  "profile.selectMultipleRoleLevels": "Select one or more role levels",
  "profile.selectMultipleTitles": "Select one or more job titles",
  "profile.selectRoleLevel": "Select your role level",
  "profile.title": "Job Title",
  "profile.titlePlaceholder": "e.g., Software Engineer",
  "profile.titleWeight": "Title Weight: {weight}%",
  "profile.totalWeight": "Total",
  "profile.uploadCV": "Upload CV to prefill",
  "profile.uploadCV.disclaimer": "AI-extracted from your PDF — it fills in the form below, not your saved profile. Read it over and fix anything before you save.",
  "profile.vacationWeeks.label": "Vacation weeks per year",
  "profile.vacationWeeks.unit": "weeks/year",
  "profile.vacationWeight": "Vacation Weight: {weight}%",
  "recentSearches.delete": "Remove",
  "recentSearches.noSearches": "You haven't saved any searches yet.",
  "salary.period.day": "/day",
  "salary.period.hour": "/hr",
  "salary.period.month": "/mo",
  "salary.period.year": "/yr",
  "salaryChart.allRolesInLocation": "All roles in {location}",
  "salaryChart.analysisTitle": "Salary analysis",
  "salaryChart.companyLocation": "Company in {location}",
  "salaryChart.estimatedFromMarket": "Estimated from market data (no pay in ad)",
  "salaryChart.fromJobAd": "From job ad",
  "salaryChart.fromJobAdWithLevel": "From job ad ({roleLevel})",
  "salaryChart.locationAverage": "In {location}: {title}",
  "salaryChart.marketAverage": "Market Average: {title}",
  "salaryChart.marketAverageRoleLevel": "Market Average: {roleLevel} Level",
  "salaryChart.payInDataNotInAd": "Pay in our data — not quoted in ad",
  "salaryChart.payInDataNotInAdWithLevel": "Pay in our data — not quoted in ad ({roleLevel})",
  "salaryChart.popover.average": "Average band",
  "salaryChart.popover.benchmarkEstimateNote": "Not from employer — modelled from benchmarks",
  "salaryChart.popover.dimension": "Dimension",
  "salaryChart.popover.extractedNoQuoteNote": "Numeric pay without quoted text in ad",
  "salaryChart.popover.fromAdText": "Grounded in job-ad salary wording",
  "salaryChart.popover.max": "Maximum",
  "salaryChart.popover.median": "Median band",
  "salaryChart.popover.min": "Minimum",
  "salaryChart.popover.monthlyNote": "All amounts are shown as EUR per month for comparison on this chart.",
  "salaryChart.popover.p25": "25th percentile",
  "salaryChart.popover.p75": "75th percentile",
  "salaryChart.popover.p90": "90th percentile",
  "salaryChart.popover.sample": "Sample size",
  "salaryChart.popover.seeFullSalaryPage": "See the full salary page for {title} →",
  "salaryChart.rangeAria": "Salary range from {min} to {max} per month, median near {median}",
  "salaryChart.salaryContext": "Salary Context: {title}",
  "salaryChart.segmentHint": "Hover or tap a row for full statistics (EUR / month on this chart).",
  "salaryChart.seoTable.caption": "Monthly salary comparison for {title}",
  "salaryChart.seoTable.lowerBound": "Lower bound (25th percentile)",
  "salaryChart.seoTable.market": "Market",
  "salaryChart.seoTable.median": "Median",
  "salaryChart.seoTable.upperBound": "Upper bound (75th percentile)",
  "salaryChart.thisRole": "this role",
  "salaryChart.thisRoleLevel": "this role level",
  "salaryDisplayToggle.label": "Show original currency",
  "salaryIndexPage.allRolesHeading": "Browse all roles",
  "salaryIndexPage.empty": "No salary data is available right now — check back soon.",
  "salaryIndexPage.eyebrow": "{count} roles tracked",
  "salaryIndexPage.heading": "Salary Data by Role in Finland",
  "salaryIndexPage.intro": "Real salary data from Finnish job listings, broken down by role. Pick a role to see median pay, ranges, and city-by-city comparisons.",
  "salaryIndexPage.postingsSuffix": "postings",
  "salaryIndexPage.stat.postings": "postings analyzed",
  "salaryIndexPage.stat.roles": "roles tracked",
  "salaryIndexPage.stat.topRole": "most-analyzed role",
  "salaryIndexPage.topRolesHeading": "Most in-demand roles",
  "salaryIndexPage.topRolesSub": "Ranked by number of postings behind the salary estimate — more postings, more reliable numbers.",
  "salaryInsight.above": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> above {benchmark}.",
  "salaryInsight.below": "This role's salary of <strong>{salary}</strong> is <strong>{percent}%</strong> below {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "the Finland-wide median in our salary data",
  "salaryInsight.benchmark.finlandWithRole": "the Finland-wide median for {role} roles",
  "salaryInsight.benchmark.locationOnly": "the median salary in {location}",
  "salaryInsight.benchmark.locationWithRole": "the median for {role} roles in {location}",
  "salaryRolePage.alsoKnownAs": "Also listed under: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Salary Data",
  "salaryRolePage.cityTable.footnote": "Bar shows P25–P75 band. Vertical line = median. All values in EUR/month.",
  "salaryRolePage.cityTable.title": "{roleTitle} Salary by City",
  "salaryRolePage.ctaBanner": "Looking for {roleTitle} roles? {link}",
  "salaryRolePage.ctaBanner.link": "Browse open positions on JobCrawls →",
  "salaryRolePage.disclaimer": "Salary data is derived from published job listings and may not represent total compensation. Figures are in EUR/month and may include employer estimates where stated salary ranges are not publicly disclosed.",
  "salaryRolePage.examplePostings.inactive": "(listing no longer active)",
  "salaryRolePage.examplePostings.title": "Based on postings like these",
  "salaryRolePage.heading": "{roleTitle} Salary in Finland",
  "salaryRolePage.hero.perMonthNational": "/ month, national median",
  "salaryRolePage.hero.sampleEyebrow": "Based on {count} postings",
  "salaryRolePage.hiringCompanies.browseAll": "Browse best employers in Finland →",
  "salaryRolePage.hiringCompanies.empty": "Browse all ranked employers to find one hiring for this kind of role.",
  "salaryRolePage.hiringCompanies.sub": "From our employer rankings — some may be worth reaching out to directly even without an open listing.",
  "salaryRolePage.hiringCompanies.title": "Companies hiring {roleTitle}s",
  "salaryRolePage.intro": "Based on job listing data from Finnish employers. Updated regularly.",
  "salaryRolePage.overallPanel.footnote": "Monthly EUR · P25–P75 band with median marker · based on {count} job listings",
  "salaryRolePage.overallPanel.title": "{roleTitle} — Finland Average",
  "salaryRolePage.rangeBar.hint": "Tap or hover for details.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Based on # job listing} other {Based on # job listings}}",
  "salaryRolePage.remotePanel.title": "{roleTitle} — Remote Work in Finland",
  "salaryRolePage.seeOpenJobs": "See open {roleTitle} jobs →",
  "salaryRolePage.stat.average": "Average",
  "salaryRolePage.stat.median": "Median",
  "salaryRolePage.stat.middle50": "Middle 50%",
  "salaryRolePage.stat.p25": "P25",
  "salaryRolePage.stat.p75": "P75",
  "salaryRolePage.stat.p90": "P90",
  "salaryRolePage.stat.range": "Full range",
  "salaryRolePage.stat.sampleSize": "Sample size",
  "salaryRolePage.trend.down": "▼ {percent}% vs last month",
  "salaryRolePage.trend.flat": "No change vs last month",
  "salaryRolePage.trend.up": "▲ {percent}% vs last month",
  "salaryStats.aboveMarket": "This salary is above the market median",
  "salaryStats.accuracy.exact": "Based on similar roles at this company",
  "salaryStats.accuracy.general": "Based on market data",
  "salaryStats.accuracy.location": "Based on salaries in {location}",
  "salaryStats.atMarket": "This salary is competitive with the market median",
  "salaryStats.average": "Average",
  "salaryStats.belowMarket": "This salary is below the market median",
  "salaryStats.jobSalary": "This job",
  "salaryStats.marketRange": "Market range: {min} - {max} (median: {median})",
  "salaryStats.median": "Median",
  "salaryStats.noJobSalary": "No salary range provided for this job. Chart shows market distribution.",
  "salaryStats.noValidValues": "Salary statistics are available ({sampleSize} {samples}) but all values are zero. This may indicate the data needs to be regenerated.",
  "salaryStats.perDay": "per day",
  "salaryStats.perHour": "per hour",
  "salaryStats.perMonth": "per month",
  "salaryStats.perYear": "per year",
  "salaryStats.percentiles": "25th-75th percentile",
  "salaryStats.samples": "samples",
  "salaryStats.smallSampleWarning": "Note: Based on a small sample size ({sampleSize} {samples}). Results may not be representative.",
  "savedSearches.card.continue": "Continue",
  "savedSearches.emptyHint": "Run a search with keywords or filters on the jobs page — it will show up here automatically. You can also pin one with “Save search”.",
  "savedSearches.newMatchesBadge": "{count} new",
  "savedSearches.openSearchAria": "Open search: {title}",
  "savedSearches.rename.action": "Name this search",
  "savedSearches.rename.placeholder": "e.g. Backend jobs in Helsinki",
  "savedSearches.rename.save": "Save",
  "savedSearches.summary.filtered": "Filtered search",
  "savedSearches.summary.location": "Location: {values}",
  "savedSearches.summary.page": "Page {page}",
  "savedSearches.summary.sortDate": "Sort: newest",
  "savedSearches.summary.sortSalary": "Sort: salary",
  "savedSearches.summary.worldwide": "All countries",
  "search.activityStrip.cta": "Manage applications",
  "search.activityStrip.teaser": "Browse, save, and apply to jobs to see your funnel here.",
  "search.activityStrip.title": "Your job search activity",
  "search.bestCompaniesStrip.hubCta": "Best employers for Finland roles →",
  "search.bestCompaniesStrip.label": "Top employers",
  "search.controls.navigation": "Search controls and filters",
  "search.jobCount": "{count, number} jobs",
  "search.noResults": "No jobs found.",
  "search.noresults.browseAll": "Browse All Jobs",
  "search.noresults.clearAllParameters": "Clear all search parameters",
  "search.noresults.clearSearch": "Clear Search",
  "search.noresults.description": "Try adjusting your search or filters to find more opportunities.",
  "search.noresults.filtersLabel": "Filters:",
  "search.noresults.goToFirstPage": "Go to page 1",
  "search.noresults.industries": "Industries",
  "search.noresults.jobRoles": "Job Roles",
  "search.noresults.locations": "Locations",
  "search.noresults.pageLabel": "Page:",
  "search.noresults.popularCategories": "Popular Categories",
  "search.noresults.queryLabel": "Query:",
  "search.noresults.removeQuery": "Remove",
  "search.noresults.searchParameters": "Your Search Parameters",
  "search.noresults.searchTips": "Search Tips",
  "search.noresults.tip1": "Try using broader search terms or remove some filters",
  "search.noresults.tip2": "Check your spelling or try alternative keywords",
  "search.noresults.tip3": "Browse popular categories above to discover new opportunities",
  "search.noresults.title": "No results found",
  "search.noresults.trySearches": "Try these searches:",
  "search.refinements.allFilters": "All Filters",
  "search.refinements.allFilters.aria": "All Filters",
  "search.refinements.benefits": "Benefits",
  "search.refinements.benefits.label": "Benefits",
  "search.refinements.benefits.modal": "Benefits",
  "search.refinements.company": "Company",
  "search.refinements.company.heading": "Company",
  "search.refinements.company.label": "Company",
  "search.refinements.company.modal": "Company",
  "search.refinements.company.openProfileAria": "Open company profile for {company}{count, plural, =0 {} other { — {count} open roles on JobCrawls}}",
  "search.refinements.company.searchPlaceholder": "Search companies...",
  "search.refinements.company.section": "Company",
  "search.refinements.dialog.label": "Search filters",
  "search.refinements.educationLevel.detail": "Education Level",
  "search.refinements.educationLevel.heading": "Education Level",
  "search.refinements.educationLevel.label": "Education Level",
  "search.refinements.educationLevel.modal": "Education Level",
  "search.refinements.excludeApplied.checkbox": "Exclude Applied Jobs",
  "search.refinements.excludeApplied.label": "Exclude Applied Jobs",
  "search.refinements.excludeConsultingCompany.filter": "Hide Consulting Company Postings",
  "search.refinements.excludeConsultingCompany.toggle": "Hide Consulting Company Postings",
  "search.refinements.excludeJobs": "Exclude Jobs",
  "search.refinements.excludeRecruitmentCompany.filter": "Hide Recruitment Agency Postings",
  "search.refinements.excludeRecruitmentCompany.toggle": "Hide Recruitment Agency Postings",
  "search.refinements.excludeSaved.checkbox": "Exclude Saved Jobs",
  "search.refinements.excludeSaved.label": "Exclude Saved Jobs",
  "search.refinements.excludeViewed.checkbox": "Exclude Viewed Jobs",
  "search.refinements.excludeViewed.label": "Exclude Viewed Jobs",
  "search.refinements.field": "Field",
  "search.refinements.field.label": "Field",
  "search.refinements.field.modal": "Field",
  "search.refinements.headcount": "Company Headcount (max)",
  "search.refinements.headcount.max": "Max Headcount",
  "search.refinements.industry": "Industry",
  "search.refinements.industry.heading": "Industry",
  "search.refinements.industry.label": "Industry",
  "search.refinements.industry.modal": "Industry",
  "search.refinements.isDriversLicenseRequired.filter": "Driver's Licence Required",
  "search.refinements.isDriversLicenseRequired.toggle": "Driver's Licence Required",
  "search.refinements.isOpenApplication.filter": "Open Application",
  "search.refinements.isOpenApplication.toggle": "Open Application",
  "search.refinements.job": "Job",
  "search.refinements.job.modal": "Job Filters",
  "search.refinements.job.section": "Job",
  "search.refinements.jobTitle": "Job Title",
  "search.refinements.jobType": "Job Type",
  "search.refinements.jobType.label": "Job Type",
  "search.refinements.jobType.modal": "Job Type",
  "search.refinements.languages": "Languages",
  "search.refinements.languages.label": "Languages",
  "search.refinements.languages.modal": "Languages",
  "search.refinements.lastSeen.aria": "Date posted",
  "search.refinements.location": "Location",
  "search.refinements.location.finland": "Finland",
  "search.refinements.location.modal": "Location",
  "search.refinements.location.remote": "Remote",
  "search.refinements.location.searchPlaceholder": "Search locations...",
  "search.refinements.location.section": "Location",
  "search.refinements.peopleManagementTier": "People Management Tier",
  "search.refinements.peopleManagementTier.label": "People Management Tier",
  "search.refinements.peopleManagementTier.modal": "People Management Tier",
  "search.refinements.remoteness.heading": "Remoteness",
  "search.refinements.remoteness.label": "Remoteness",
  "search.refinements.remoteness.modal": "Remoteness",
  "search.refinements.roleLevel": "Role Level",
  "search.refinements.roleLevel.label": "Role Level",
  "search.refinements.roleLevel.modal": "Role Level",
  "search.refinements.salary": "Salary",
  "search.refinements.salary.heading": "Salary",
  "search.refinements.salary.label": "Salary",
  "search.refinements.salary.min": "Minimum Salary",
  "search.refinements.salary.modal": "Salary",
  "search.refinements.salary.section": "Salary",
  "search.refinements.search.placeholder": "Search...",
  "search.refinements.showJobsInFinlandOnly": "Show jobs in Finland only",
  "search.refinements.showLess": "Show less",
  "search.refinements.showMore": "Show more",
  "search.refinements.skillsAndTechnologies": "Skills & Technologies",
  "search.refinements.skillsAndTechnologies.label": "Skills & Technologies",
  "search.refinements.skillsAndTechnologies.modal": "Skills & Technologies",
  "search.refinements.vacationWeeks": "Vacation Weeks",
  "search.refinements.vacationWeeks.heading": "Vacation Weeks",
  "search.refinements.vacationWeeks.label": "Vacation Weeks",
  "search.refinements.vacationWeeks.modal": "Vacation Weeks",
  "search.results.title": "Job Search Results",
  "search.signInCta.benefit1": "Save jobs to review later",
  "search.signInCta.benefit2": "Track every application in one board",
  "search.signInCta.benefit3": "Get alerted the moment new roles match",
  "search.signInCta.button": "Create free account",
  "search.signInCta.secondaryText": "Already have an account? Sign in",
  "search.signInCta.title": "Never lose track of a job again",
  "search.topRolesStrip.hubCta": "Salary data for Finland roles →",
  "search.topRolesStrip.label": "In-demand roles",
  "sort.ariaLabel": "Sort results",
  "sort.newest": "Newest",
  "sort.relevance": "Relevance",
  "sort.salary": "Salary",
  "srpAlertCta.bannerText": "Want to hear about new jobs like this?",
  "srpAlertCta.continueButton": "Continue with email",
  "srpAlertCta.ctaButton": "Get email alerts",
  "srpAlertCta.dismissLabel": "Dismiss",
  "srpAlertCta.errorText": "Something went wrong — we couldn't turn on alerts. Please try again.",
  "srpAlertCta.manageLink": "Manage alerts",
  "srpAlertCta.pendingText": "Almost there — check your inbox to confirm your email and activate alerts.",
  "srpAlertCta.successText": "You're set — we'll email you about jobs like this.",
  "srpAlertCta.unauthConsentCopy": "We'll email you when new jobs matching this search appear. Create a free account to turn it on — no other emails unless you say so.",
  "stats.appliedJobs": "{count} applied jobs",
  "stats.finlandJobsSubtitle": "Jobs available in Finnish or remotely to Finnish residents",
  "stats.newThisWeekInline": "· {count, number} new this week",
  "stats.savedJobs": "{count} saved jobs",
  "stats.viewedJobs": "{count} viewed jobs",
  "tags.field.addTrigger": "Add tag",
  "tags.field.placeholder": "Tag and press Enter…",
  "tags.field.remove": "Remove tag {tag}",
  "tools.applicationKits.cvBadge": "CV ready",
  "tools.applicationKits.deleteKit": "Delete",
  "tools.applicationKits.downloadCv": "Download CV",
  "tools.applicationKits.downloadLetter": "Download letter",
  "tools.applicationKits.emptyBody": "Tailor a CV or draft a cover letter from any job page — it'll be saved here automatically.",
  "tools.applicationKits.emptyTitle": "No application kits yet",
  "tools.applicationKits.kitReadyBadge": "Application kit ready",
  "tools.applicationKits.lead": "Your tailored CVs and cover letters, saved per job — reopen, review, or download anytime.",
  "tools.applicationKits.letterBadge": "Letter ready",
  "tools.applicationKits.openJob": "Open job page",
  "tools.applicationKits.title": "Application Kits",
  "tools.applicationKits.updatedOn": "Updated {date}",
  "tools.applicationState.applied": "Applied",
  "tools.applicationState.hidden": "Hidden",
  "tools.applicationState.label": "State:",
  "tools.applicationState.updated": "State updated to {state}",
  "tools.empty.browseJobs": "Browse jobs →",
  "tools.externalApplication.add": "Add to applied",
  "tools.externalApplication.adding": "Adding…",
  "tools.externalApplication.closeModal": "Close",
  "tools.externalApplication.error.disallowedScheme": "Only http and https links are allowed.",
  "tools.externalApplication.error.empty": "Enter a link to the job or application page.",
  "tools.externalApplication.error.invalid": "That does not look like a valid URL.",
  "tools.externalApplication.error.syncFailed": "Could not save. Check your connection or try signing in.",
  "tools.externalApplication.error.tooLong": "That link is too long.",
  "tools.externalApplication.lead": "Paste a link to a job you applied to on another site. It appears with your other applications on this page.",
  "tools.externalApplication.title": "Track an application elsewhere",
  "tools.externalApplication.titleLabel": "Title (optional)",
  "tools.externalApplication.urlLabel": "Job link",
  "tools.externalApplication.urlPlaceholder": "https://…",
  "tools.history.emptyHidden": "You haven't hidden any jobs.",
  "tools.history.emptyViewed": "You have not viewed any jobs yet.",
  "tools.history.hiddenTab": "Hidden ({count})",
  "tools.history.resetViewed": "Reset viewed jobs",
  "tools.history.viewedTab": "Viewed ({count})",
  "tools.historySummary.counts": "Viewed {viewedCount} · Hidden {hiddenCount}",
  "tools.historySummary.heading": "History",
  "tools.historySummary.openDrawer": "Open drawer",
  "tools.jobFlowSankey.activityChartHeading": "Activity",
  "tools.jobFlowSankey.applied": "Applied",
  "tools.jobFlowSankey.browsed": "Browsed",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% reached interview · {offerRate}% got an offer",
  "tools.jobFlowSankey.emptyState": "Not enough data to display your activity yet. View, save, or apply to jobs to see your journey visualized!",
  "tools.jobFlowSankey.hideActivityChart": "Hide activity chart",
  "tools.jobFlowSankey.hired": "Hired",
  "tools.jobFlowSankey.interviewing": "Interviewing",
  "tools.jobFlowSankey.offer": "Offer",
  "tools.jobFlowSankey.rejected": "Rejected",
  "tools.jobFlowSankey.saved": "Saved",
  "tools.jobFlowSankey.showActivityChart": "Show activity chart",
  "tools.jobFlowSankey.summary": "Browsed {browsed} → Viewed {viewed} → Saved {saved} → Applied {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "You applied or tracked these as submitted applications.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Roles you opened from search — the start of your funnel.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Marked hired — great outcome.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "Currently in the interview process.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Offer stage — negotiation or decision time.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Marked closed or not moving forward.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Saved for later — easy to come back and apply.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "You opened these listings but have not saved them yet.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# job} other {# jobs}} on this path",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct}% of flow leaving {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct}% of flow into {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} from browse without save · {external} from elsewhere",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Includes applications not counted in browse (e.g. off-site).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# job} other {# jobs}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct}% of your applications",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct}% of listings you browsed",
  "tools.jobFlowSankey.viewed": "Viewed",
  "tools.kanban.addExternalApplication": "Add off-site application",
  "tools.kanban.cancelSelectMode": "Cancel",
  "tools.kanban.chip.appliedAgo": "Applied {relativeAge}",
  "tools.kanban.column.applied": "Applied",
  "tools.kanban.column.collapse": "Collapse {column} column",
  "tools.kanban.column.expand": "Expand {column} column",
  "tools.kanban.column.hired": "Hired",
  "tools.kanban.column.interviewing": "Interviewing",
  "tools.kanban.column.offer": "Offer",
  "tools.kanban.column.rejected": "Rejected",
  "tools.kanban.column.saved": "Saved",
  "tools.kanban.companyFilterAll": "All companies",
  "tools.kanban.companyFilterLabel": "Filter by company",
  "tools.kanban.confirmRemove.appliedBody": "“{jobTitle}” will leave your application board. You can apply again from search later.",
  "tools.kanban.confirmRemove.appliedTitle": "Remove from applications?",
  "tools.kanban.confirmRemove.cancel": "Cancel",
  "tools.kanban.confirmRemove.close": "Close",
  "tools.kanban.confirmRemove.confirm": "Remove",
  "tools.kanban.confirmRemove.savedBody": "“{jobTitle}” will be removed from saved jobs.",
  "tools.kanban.confirmRemove.savedTitle": "Remove from saved?",
  "tools.kanban.confirmRemove.working": "Removing…",
  "tools.kanban.deadlineChip": "Closes in {days, plural, one {# day} other {# days}}",
  "tools.kanban.dragHandle": "Drag to move to another column or position",
  "tools.kanban.emptyBoard": "No saved or applied jobs yet. Add an off-site application with the button above, or save and apply to jobs from search.",
  "tools.kanban.emptyColumn": "None yet",
  "tools.kanban.groupMixedHeading": "{count} applications",
  "tools.kanban.groupMixedSavedHeading": "{count} saved",
  "tools.kanban.hideInactive": "Hide no longer active jobs",
  "tools.kanban.keepLooking": "Keep looking →",
  "tools.kanban.mobile.cancel": "Cancel",
  "tools.kanban.mobile.close": "Close",
  "tools.kanban.mobile.companyFilterAll": "All companies",
  "tools.kanban.mobile.companyFilterLabel": "Filter by company",
  "tools.kanban.mobile.emptyTab": "No applications in {stage}.",
  "tools.kanban.mobile.move": "Move",
  "tools.kanban.mobile.moveTo": "Move to",
  "tools.kanban.mobile.searchPlaceholder": "Search company or role",
  "tools.kanban.mobile.searchToggle": "Search applications",
  "tools.kanban.mobile.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.mobile.sortDateAsc": "Oldest first",
  "tools.kanban.mobile.sortDateDesc": "Newest first",
  "tools.kanban.mobile.sortLabel": "Sort by",
  "tools.kanban.mobile.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.mobile.tabAll": "All",
  "tools.kanban.mobile.viewJob": "View job posting",
  "tools.kanban.moveSelectedTo": "Move to…",
  "tools.kanban.removeFailed": "Could not update. Try again.",
  "tools.kanban.removeIcon.applied": "Remove from applications",
  "tools.kanban.removeIcon.saved": "Remove from saved jobs",
  "tools.kanban.removeSelected": "Remove",
  "tools.kanban.savedJob.expired": "No longer active",
  "tools.kanban.savedJob.findSimilar": "Find similar →",
  "tools.kanban.searchLabel": "Search",
  "tools.kanban.searchPlaceholder": "Search company or role",
  "tools.kanban.selectCard": "Select {title}",
  "tools.kanban.selectMode": "Select",
  "tools.kanban.selectedCount": "{count, plural, one {# selected} other {# selected}}",
  "tools.kanban.sortCompanyAsc": "Company (A–Z)",
  "tools.kanban.sortDateAsc": "Oldest first",
  "tools.kanban.sortDateDesc": "Newest first",
  "tools.kanban.sortLabel": "Sort by",
  "tools.kanban.sortTitleAsc": "Job title (A–Z)",
  "tools.kanban.staleChip": "Follow up? {days, plural, one {# day} other {# days}} since applying",
  "tools.kanban.title": "Applications by stage",
  "tools.savedJobs.tailorCvAction": "Tailor CV",
  "tooltip.allFilters": "Open all filters to refine your job search by location, salary, work type, and more",
  "tooltip.view.list": "Switch to list view to see jobs in a compact list format",
  "tooltip.view.map": "Switch to map view to see job locations on a map",
  "usermenu.account": "Account",
  "usermenu.blog": "Resources & Blog",
  "usermenu.blog.link": "Resources",
  "usermenu.installPwa": "Install App",
  "usermenu.login": "Login",
  "usermenu.logout": "Log Out",
  "usermenu.myJobs.withCount": "My Jobs ({count})",
  "usermenu.profile": "My Profile",
  "usermenu.profileCv.avatarGuestInitials": "You",
  "usermenu.profileCv.caption": "Curriculum vitae",
  "usermenu.profileCv.placeholderEmail": "you@example.com",
  "usermenu.profileCv.placeholderHint": "Sign in to save jobs, track applications, and keep your CV on JobCrawls.",
  "usermenu.profileCv.placeholderName": "Your name",
  "usermenu.profileCv.region": "Your profile summary",
  "usermenu.profileCv.regionGuest": "Preview profile — sign in to fill in your details",
  "usermenu.profileCv.session": "Session",
  "usermenu.profileCv.signInSection": "Get started",
  "usermenu.theme": "Theme",
  "view.list": "List view",
  "view.map": "Map view",
  "watchlist.company.dataUnavailable": "Company data isn't available right now.",
  "watchlist.company.employerScore": "employer score",
  "watchlist.company.hiringTrend.declining": "Declining",
  "watchlist.company.hiringTrend.growing": "Growing",
  "watchlist.company.hiringTrend.stable": "Stable",
  "watchlist.company.openRoles": "open roles",
  "watchlist.empty.body": "Follow a company from its profile page to track new roles, employer score, and hiring trend here.",
  "watchlist.empty.browse": "Browse top companies →",
  "watchlist.empty.title": "You aren't following any companies yet.",
  "watchlist.filter.all": "All",
  "watchlist.filter.noMatches": "No followed companies have this tag yet.",
  "watchlist.relationshipTag.inConversation": "In conversation",
  "watchlist.relationshipTag.interested": "Interested",
  "watchlist.relationshipTag.reachedOut": "Reached out",
  "translation.test": "Translation Test: English"
};

const messages_sv = {
  ...messages_en, // Use English as fallback
  "aboutEmployerScore.backToRankings": "Tillbaka till Best Employers",
  "aboutEmployerScore.breadcrumb.current": "Arbetsgivarens poäng",
  "aboutEmployerScore.breadcrumb.parent": "Bästa arbetsgivare",
  "aboutEmployerScore.compositeScopeNote": "För tillfället baseras huvudpoängen endast på löneintervall, flexibilitet, anställningsstabilitet och tillväxt – eftersom förmåners omfattning och transparensignaler på annonsnivå ännu inte är anslutna till poängsättningssystemet. Vikterna nedan har omräknats till 100 % fördelat på dessa fyra pelare.",
  "aboutEmployerScore.intro": "JobCrawls Employer Score är ett enda tal mellan 0–100 som härleds från mönster vi konsekvent kan mäta i platsannonser. Syftet är att lyfta fram arbetsgivare som kommunicerar tydligt, strukturerar ersättningar rättvist och annonserar flexibla, kandidarvänliga roller – inte att ersätta dina egna intervjuer och undersökningar.",
  "aboutEmployerScore.limits.changes": "Vikter och signaler kan komma att ändras i takt med att vi förbättrar detekteringen; vårt mål är att hålla metodiken riktningsmässigt stabil.",
  "aboutEmployerScore.limits.listings": "Poängen återspeglar vad arbetsgivare publicerar i de annonser vi indexerar – inte interna HR-policyer som vi inte har insyn i.",
  "aboutEmployerScore.limits.notEndorsement": "En högre poäng är inte en rekommendation, en kvalitetsgaranti eller juridisk/finansiell rådgivning.",
  "aboutEmployerScore.limits.title": "Viktiga begränsningar",
  "aboutEmployerScore.pillar.flex.body": "Alternativ för distans- och hybridarbete poängsätts utifrån hur konsekvent arbetsgivare annonserar flexibla arbetsmodeller i sina öppna roller.",
  "aboutEmployerScore.pillar.flex.title": "Flexibilitet (distans / hybrid)",
  "aboutEmployerScore.pillar.growth.body": "När platsannonser inkluderar senioritetsstruktur och tecken på karriärutveckling, tolkar vi det som starkare interna tillväxtvägar.",
  "aboutEmployerScore.pillar.growth.title": "Tillväxtsignaler",
  "aboutEmployerScore.pillar.pay.body": "När vi har tillräckligt många annonser med strukturerade löneintervall, bedömer vi hur konkurrenskraftigt det typiska spannet är. Lönetransparens på annonsnivå kommer att inkluderas i denna pelare så snart den signalen är implementerad fullt ut.",
  "aboutEmployerScore.pillar.pay.title": "Lön (publicerade löneintervall)",
  "aboutEmployerScore.pillar.stability.body": "Vi tittar på kontinuiteten i rekryteringen över tid – arbetsgivare som upprätthåller jämna, stabila rekryteringsmönster får högre poäng än those med ett kaotiskt publiceringsbeteende.",
  "aboutEmployerScore.pillar.stability.title": "Rekryteringsstabilitet",
  "aboutEmployerScore.pillars.title": "Vad som ingår i poängen",
  "aboutEmployerScore.title": "Hur Employer Score fungerar",
  "auth.signInPrompt.closeLabel": "Stäng",
  "auth.signInPrompt.description": "Skapa ett gratis konto för att spara jobb, synkronisera dina framsteg och fortsätta ditt sökande på vilken enhet som helst.",
  "auth.signInPrompt.descriptionCreateAlert": "Skapa ett gratis konto så mejlar vi dig när nya liknande jobb dyker upp.",
  "auth.signInPrompt.primaryAction": "Logga in nu",
  "auth.signInPrompt.secondaryAction": "Kanske senare",
  "auth.signInPrompt.title": "Logga in för att spara jobb",
  "auth.signInPrompt.titleCreateAlert": "Logga in för att få jobbaviseringar",
  "autocomplete.filters": "Matchande filter",
  "autocomplete.noMatches": "Inga matchande filter hittades",
  "autocomplete.scrollHint": "Scrolla för fler",
  "backoffice.architecture": "Arkitektur",
  "backoffice.dashboard": "Instrumentpanel",
  "backoffice.dataExplorer.nav": "Datautforskare",
  "backoffice.dataExplorer.title": "Datautforskare",
  "backoffice.emailAlerts.nav": "E-postaviseringar",
  "backoffice.hub.nav": "Alla verktyg",
  "backoffice.hub.open": "Öppna",
  "backoffice.hub.subtitle": "Välj ett verktyg att öppna. Åtkomst är begränsad till behöriga konton.",
  "backoffice.jobDataExplorer.nav": "Jobbdata-API",
  "backoffice.testing": "Testning",
  "backoffice.userAgents.description": "Övervakning på en enda skärm: kartcentrerad, uppdaterar automatiskt senaste minuten vid laddning. Justera tidsintervall och filter, fördjupa dig sedan i tabellen.",
  "backoffice.userAgents.hours": "Titta tillbaka",
  "backoffice.userAgents.mapboxTokenMissing": "Kartvyn kräver en Mapbox-åtkomsttoken (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.noData": "Inga poster för user agents under detta tidsintervall.",
  "backoffice.userAgents.run": "Uppdatera",
  "backoffice.userAgents.title": "Instrumentpanel för crawlning och trafik",
  "bestCompanies.breadcrumb.current": "Bästa arbetsgivare",
  "bestCompanies.breadcrumb.hub": "Bästa arbetsgivare",
  "bestCompanies.card.cta": "Bästa arbetsgivare →",
  "bestCompanies.card.ctaDisabled": "Kommer snart",
  "bestCompanies.dimension.backToHub": "← Alla arbetsgivarrankningar",
  "bestCompanies.dimension.empty": "Inga företag hittades för detta filter än. Återkom efter nästa indexkörning.",
  "bestCompanies.dimension.introPrefix": "Rankade efter",
  "bestCompanies.dimension.introSuffix": "— beräknat utifrån lönetransparens, distansflexibilitet, anställningsstabilitet och förmåner i annonser riktade till den finska arbetsmarknaden (inklusive många distansroller). Inte recensioner.",
  "bestCompanies.dimension.title": "Bästa arbetsgivare inom {label}",
  "bestCompanies.hub.byCity": "Efter stad",
  "bestCompanies.hub.byIndustry": "Efter bransch",
  "bestCompanies.hub.clearFilters": "Rensa filter",
  "bestCompanies.hub.clearSearch": "Rensa sökning",
  "bestCompanies.hub.eyebrow": "{year} års ranking, uppdateras veckovis",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# matchande arbetsgivare} other {# matchande arbetsgivare}}",
  "bestCompanies.hub.heroLede": "Rankad utifrån signaler från aktuella jobbannonser – lön, flexibilitet, anställningsstabilitet och mer. Inte baserat på medarbetarrecensioner, enkäter eller betalda placeringar.",
  "bestCompanies.hub.lead": "Denna sida är vår ögonblicksbild för {year} av arbetsgivare som rekryterar via roller riktade till den finska arbetsmarknaden. Många annonser är distans- eller hybridroller, så företagen har inte nödvändigtvis sitt huvudkontor i Finland.",
  "bestCompanies.hub.loadingMoreMatches": "letar efter fler matchningar…",
  "bestCompanies.hub.methodLink": "Fullständig metodik: så fungerar Employer Score",
  "bestCompanies.hub.methodologySummary": "Rankningarna använder JobCrawls Employer Score: ett sammansatt index baserat på signaler från aktuella jobbannonser – lönetransparens, flexibilitet för distans- och hybridarbete, stabilitet i rekryteringen över tid, omfattning av förmåner och hur tydligt kraven är formulerade. Det baseras inte på anställdas recensioner, enkäter eller betalda placeringar.",
  "bestCompanies.hub.methodologyToggle": "Så fungerar rankningen",
  "bestCompanies.hub.networkWorthyFilter": "Värt att nätverka med",
  "bestCompanies.hub.noMatches": "Inga företag matchar dina filter. Prova att rensa ett filter eller sök på ett annat namn.",
  "bestCompanies.hub.overallTitle": "Topparbetsgivare {year} (alla annonser på den finska marknaden)",
  "bestCompanies.hub.remoteFriendlyFilter": "Distansvänliga",
  "bestCompanies.hub.scoreScale": "Poängen anges på en skala från 0–100. När många arbetsgivare ligger nära varandra (till exempel i det övre 30-talet till det lägre 40-talet), är listan fortfarande sorterad efter dessa signaler – plats #1 återspeglar den starkaste kombinationen i denna grupp utifrån de dimensioner vi mäter, och lägre placeringar skiljs ofta åt av små marginaler snarare än ett stort kvalitetsgap.",
  "bestCompanies.hub.searchPlaceholder": "Sök företag efter namn…",
  "bestCompanies.hub.sizeFilter.large": "1 000+ anställda",
  "bestCompanies.hub.sizeFilter.medium": "201–1 000 anställda",
  "bestCompanies.hub.sizeFilter.micro": "1–50 anställda",
  "bestCompanies.hub.sizeFilter.small": "51–200 anställda",
  "bestCompanies.hub.sort.name": "Namn (A–Ö)",
  "bestCompanies.hub.sort.postings": "Mest aktiva rekryteringar",
  "bestCompanies.hub.sort.score": "Högsta poäng",
  "bestCompanies.hub.sort.size": "Företagsstorlek",
  "bestCompanies.hub.sortLabel": "Sortera efter",
  "bestCompanies.hub.stat.companies": "bedömda företag",
  "bestCompanies.hub.stat.industries": "omfattade branscher",
  "bestCompanies.hub.stat.medianSalary": "medianmånadslön",
  "bestCompanies.hub.stat.medianScore": "medianpoäng för arbetsgivare",
  "bestCompanies.hub.stat.networkWorthy": "värda att nätverka med",
  "bestCompanies.hub.title": "Bästa företagen att jobba på i Finland ({year})",
  "bestCompanies.podium.headcount": "{range} anställda",
  "bestCompanies.podium.rankLabel": "Arbetsgivare med högst poäng",
  "bestCompanies.row.hiringPace": "~{count} nya roller/mån",
  "bestCompanies.row.networkWorthy": "Värt att nätverka med",
  "bestCompanies.row.perMonth": "{range}/mån",
  "bestCompanies.row.remoteHybridPercent": "{percent}% distans/hybrid",
  "bestCompanies.row.remotePercent": "{percent}% distans",
  "bestCompanies.subscore.benefits": "Förmåner",
  "bestCompanies.subscore.flexibility": "Flexibilitet",
  "bestCompanies.subscore.growth": "Tillväxt",
  "bestCompanies.subscore.pay": "Lön",
  "bestCompanies.subscore.stability": "Stabilitet",
  "bestCompanies.subscore.transparency": "Transparens",
  "breadcrumb.benefits": "Förmåner",
  "breadcrumb.company": "Företag",
  "breadcrumb.educationLevel": "Utbildning",
  "breadcrumb.industry": "Bransch",
  "breadcrumb.isDriversLicenseRequired": "Körkort",
  "breadcrumb.isOpenApplication": "Öppen ansökan",
  "breadcrumb.jobType": "Anställningsform",
  "breadcrumb.jobs": "Jobb",
  "breadcrumb.language": "Språk",
  "breadcrumb.level": "Nivå",
  "breadcrumb.location": "Plats",
  "breadcrumb.navigation": "Brödsmulemeny",
  "breadcrumb.peopleManagementTier": "Ledning",
  "breadcrumb.remote": "Distans",
  "breadcrumb.skillsAndTechnologies": "Kompetens/Teknik",
  "checklist.field.addTrigger": "Lägg till checklista",
  "checklist.field.placeholder": "Lägg till en uppgift och tryck på Enter…",
  "checklist.field.progressTrigger": "{done}/{total} klara",
  "checklist.field.remove": "Ta bort uppgiften {text}",
  "collectiveAgreements.bindingLegend": "Vad \"olöst\" betyder:",
  "collectiveAgreements.bindingLegendBody": "bekräftelsenämnden nämnde inte det avtalet i någon av de årliga genomgångarna som vi har i våra arkiv – det är en faktisk lucka i underlaget, inte ett \"nej\".",
  "collectiveAgreements.bindingNo": "Ej bindande",
  "collectiveAgreements.bindingUnknown": "Okänt",
  "collectiveAgreements.bindingYes": "Bindande",
  "collectiveAgreements.breadcrumb.current": "Kollektivavtal",
  "collectiveAgreements.decisionNoPrefix": "Beslut nr",
  "collectiveAgreements.eyebrow": "Referens · Finlex & Social- och hälsovårdsministeriet",
  "collectiveAgreements.filterLabel": "Filtrera kollektivavtal efter namn",
  "collectiveAgreements.filterPlaceholder": "Sök på avtalsnamn…",
  "collectiveAgreements.intro": "Ett työehtosopimus fastställer minimilön och villkor för ett jobb – vilket avtal som gäller beror på arbetsgivarens bransch och typ av roll. Vi länkar jobbannonser till vår bästa gissning automatiskt; detta är den fullständiga källistan så att du själv kan kontrollera den gissningen.",
  "collectiveAgreements.noResults": "Inga avtal matchar din sökning.",
  "collectiveAgreements.pdfFi": "PDF (finska)",
  "collectiveAgreements.pdfSv": "PDF (svenska)",
  "collectiveAgreements.resultsCount": "Visar {shown} av {total} avtal — {binding} bekräftade som allmänt bindande",
  "collectiveAgreements.scopeHeading": "Tillämpningsområde",
  "collectiveAgreements.scopeUnavailable": "Ingen text om tillämpningsområde är tillgänglig för detta avtal.",
  "collectiveAgreements.stat.binding": "Bekräftat bindande",
  "collectiveAgreements.stat.total": "Arkiverade avtal",
  "collectiveAgreements.stat.unresolved": "Status ej fastställd",
  "collectiveAgreements.title": "Finska kollektivavtal",
  "company.follow.cta": "Följ",
  "company.follow.followedToast": "Följer — bevakningslistan uppdaterad",
  "company.follow.following": "Följer",
  "company.follow.unfollow": "Sluta följa",
  "company.follow.unfollowedToast": "Slutade följa",
  "company.follow.viewWatchlist": "Visa →",
  "company.logoAlt": "{company}-logotyp",
  "company.logoAltGeneric": "Arbetsgivarens logotyp",
  "companyChart.caption.averaging": "i genomsnitt {avg} jobb per månad",
  "companyChart.caption.hiringDeclining": "{companyName}s rekrytering minskar",
  "companyChart.caption.hiringGrowing": "{companyName}s rekrytering växer",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}s rekrytering minskar kraftigt",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}s rekrytering växer kraftigt",
  "companyChart.caption.hiringStable": "{companyName}s rekrytering är stabil",
  "companyChart.caption.levelDistributionDouble": "{companyName} rekryterar främst på nivåerna {level1} och {level2}.",
  "companyChart.caption.levelDistributionSingle": "{companyName} anställer främst på {level}-nivå.",
  "companyChart.caption.levelDistributionTriple": "{companyName} anställer främst på nivåerna {level1}, {level2} och {level3}.",
  "companyChart.caption.locationDistributionDouble": "{companyName} anställer främst i {location1} och {location2}.",
  "companyChart.caption.locationDistributionSingle": "{companyName} anställer främst i {location}.",
  "companyChart.caption.locationDistributionTriple": "{companyName} anställer främst i {location1}, {location2} och {location3}.",
  "companyChart.caption.margin": "och en vinstmarginal på {margin}",
  "companyChart.caption.marginOnly": "{companyName} hade en vinstmarginal på {margin} under 2024",
  "companyChart.caption.profitable": "{companyName} gick med vinst under 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} anställer främst till hybridtjänster.",
  "companyChart.caption.remotenessOnsite": "{companyName} anställer främst till tjänster på plats.",
  "companyChart.caption.remotenessRemote": "{companyName} anställer främst till distanspositioner.",
  "companyChart.caption.revenue": "{companyName} hade en omsättning på {revenue} under 2024",
  "companyChart.caption.revenueWith": "med en omsättning på {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} anställer främst roller som {role1} och {role2}.",
  "companyChart.caption.roleDistributionSingle": "{companyName} anställer främst roller som {role}.",
  "companyChart.caption.roleDistributionTriple": "{companyName} anställer främst roller som {role1}, {role2} och {role3}.",
  "companyChart.caption.unprofitable": "{companyName} var olönsamma under 2024",
  "companyChart.caption.workforceRate": "({rate}% av sin arbetsstyrka)",
  "companyChart.financialOverview": "Ekonomisk översikt (2024)",
  "companyChart.insufficientData": "Begränsad data tillgänglig – trender kräver minst 3 månaders data",
  "companyChart.monthlyHiringTrends": "Månatliga rekryteringstrender",
  "companyChart.moreCategories": "+{count} till",
  "companyChart.profit": "Vinst",
  "companyChart.profitMargin": "Vinstmarginal",
  "companyChart.revenue": "Intäkter",
  "companyChart.trend.declining": "Nedåtgående",
  "companyChart.trend.growing": "Uppåtgående",
  "companyChart.trend.insufficientData": "Begränsad data",
  "companyChart.trend.rapidlyDeclining": "Snabbt nedåtgående",
  "companyChart.trend.rapidlyGrowing": "Snabbt uppåtgående",
  "companyChart.trend.stable": "Stabil",
  "companyChart.trendDescription.declining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.growing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyDeclining": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.rapidlyGrowing": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyChart.trendDescription.simpleDeclining": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleGrowing": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.simpleStable": "Anställer i genomsnitt {avg} jobb/månad",
  "companyChart.trendDescription.stable": "Anställer {avg} jobb/månad ({rate}% av arbetsstyrkan)",
  "companyHeader.jobCount": "{count, plural, one {# ledig tjänst} other {# lediga tjänster}}",
  "companyHeader.locationCount": "{count, plural, one {# plats} other {# platser}}",
  "companyInsight.bodyNoLocations": "förekommer i {count, plural, one {# indexerad jobbannons} other {# indexerade jobbannonser}} i JobCrawls dataset för Finland sedan {sinceDate}. Detta återspeglar historiska crawl-data, inte ett aktuellt antal lediga tjänster.",
  "companyInsight.bodyWithLocations": "förekommer i {count, plural, one {# indexerad jobbannons} other {# indexerade jobbannonser}} i JobCrawls dataset för Finland sedan {sinceDate}. I det historiska indexet är de starkaste platssignalerna för denna arbetsgivare {locationList}.",
  "companyInsight.englishRequirement": "{percent}% av dessa indexerade annonser nämner engelska som ett krav.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indexerad annons} other {# indexerade annonser}})",
  "companyProfile.companyFacts.benefitsLabel": "Förmåner",
  "companyProfile.companyFacts.corporateHistoryLabel": "Ägande",
  "companyProfile.companyFacts.heading": "Bra att veta",
  "companyProfile.companyFacts.officeLocationsLabel": "Kontor",
  "companyProfile.companyFacts.remotePolicyLabel": "Distansarbete",
  "companyProfile.companyFacts.valuesLabel": "Värderingar",
  "companyProfile.communityInsights.consTitle": "Vanliga klagomål",
  "companyProfile.communityInsights.heading": "Vad folk säger online",
  "companyProfile.communityInsights.prosTitle": "Vad folk gillar",
  "companyProfile.communityInsights.sentimentInsufficient": "Otillräckligt med data",
  "companyProfile.communityInsights.sentimentMixed": "Blandat",
  "companyProfile.communityInsights.sentimentNegative": "Övervägande negativt",
  "companyProfile.communityInsights.sentimentPositive": "Övervägande positivt",
  "companyProfile.communityInsights.sourcesTitle": "Källor",
  "companyProfile.communityInsights.subtitle": "Sammanställt från offentliga diskussioner på Reddit, Suomi24 och forum",
  "companyProfile.siteSources.sourceLabel": "Källa",
  "cookie.consent.accept": "Acceptera analys",
  "cookie.consent.analyticsBody": "Hjälper oss att hitta sökningar som inte ger några resultat och sidor där användare fastnar, så att vi kan åtgärda dem. Valfritt, och används aldrig för annonser.",
  "cookie.consent.analyticsTitle": "Analys",
  "cookie.consent.banner": "Vi använder nödvändiga cookies för att driva JobCrawls. Med ditt godkännande använder vi även integritetsvänlig analys – det hjälper oss att hitta sökningar som är tomma och sidor där användare fastnar, så att vi kan åtgärda dem snabbare. Aldrig för annonser. Du kan ändra dig när som helst.",
  "cookie.consent.cancel": "Avbryt",
  "cookie.consent.manage": "Hantera inställningar",
  "cookie.consent.modalTitle": "Cookie-inställningar",
  "cookie.consent.necessaryNote": "Nödvändiga cookies (session, inställningar, säkerhet) används alltid för att webbplatsen ska fungera.",
  "cookie.consent.nudge": "Du kan aktivera integritetsvänlig analys när som helst – det hjälper oss att hitta trasiga sökningar snabbare.",
  "cookie.consent.privacyLink": "Integritetspolicy",
  "cookie.consent.reject": "Neka icke-nödvändiga",
  "cookie.consent.save": "Spara val",
  "cookie.consent.title": "Cookies och integritet",
  "dashboard.actions": "Åtgärder",
  "dashboard.addComment": "Lägg till kommentar",
  "dashboard.addComment.placeholder": "Lägg till en kommentar...",
  "dashboard.addCompany.cancel": "Avbryt",
  "dashboard.addCompany.close": "Stäng",
  "dashboard.addCompany.doCrawl": "Aktivera crawling (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Företagsnamn krävs.",
  "dashboard.addCompany.fieldCareers": "URL till karriär-/jobbsida",
  "dashboard.addCompany.fieldEnqueue": "Köläggnings-URL",
  "dashboard.addCompany.fieldLogo": "Logotyp-URL",
  "dashboard.addCompany.fieldName": "Företagsnamn",
  "dashboard.addCompany.fieldWebsite": "Webbplats",
  "dashboard.addCompany.hintId": "Företags-ID i databasen är det exakta företagsnamnet (trimmat). Om en rad med samma namn redan finns kommer skapandet att misslyckas.",
  "dashboard.addCompany.open": "Lägg till företag",
  "dashboard.addCompany.placeholderName": "t.ex. Acme Oy",
  "dashboard.addCompany.saving": "Skapar…",
  "dashboard.addCompany.submit": "Skapa företag",
  "dashboard.addCompany.title": "Lägg till företag",
  "dashboard.adding": "Lägger till...",
  "dashboard.address": "Adress",
  "dashboard.all": "Alla",
  "dashboard.allAts": "Alla ATS",
  "dashboard.allCompanies": "Alla företag",
  "dashboard.allStatus": "Alla statusar",
  "dashboard.atsSystem": "ATS-system",
  "dashboard.businessId": "Organisationsnummer",
  "dashboard.cancelEdit": "Avbryt",
  "dashboard.careersUrl": "URL till karriärsida",
  "dashboard.charts.closeBackdrop": "Stäng",
  "dashboard.charts.closeButton": "Stäng diagram",
  "dashboard.charts.modalTitle": "Diagram över crawl-aktivitet",
  "dashboard.charts.toolbarDisabledHint": "Ladda först exportdata från crawl",
  "dashboard.charts.toolbarHint": "Öppna diagram över crawl-aktivitet",
  "dashboard.charts.toolbarLabel": "Diagram",
  "dashboard.check": "Markera som granskad",
  "dashboard.clearDlq": "Töm DLQ",
  "dashboard.clearFilters": "Rensa filter",
  "dashboard.clearLogoFailures": "Rensa loggmisslyckanden ({count})",
  "dashboard.comments": "Kommentarer",
  "dashboard.companiesHeader": "Företag ({count} av {total})",
  "dashboard.companyAttributes": "Företagsattribut",
  "dashboard.companyBasic": "Företagsgrundläggande",
  "dashboard.companyBasic.short": "Grundläggande info",
  "dashboard.companyBusiness": "Företagsinformation",
  "dashboard.companyContact": "Kontakt",
  "dashboard.companyCrawl": "Inställningar för crawlning",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rader per sida",
  "dashboard.companyCrawlRecordsShowing": "Visar {from}-{to} av {total}",
  "dashboard.companyFinancial": "Ekonomi",
  "dashboard.companyId": "Företags-ID",
  "dashboard.companyIndustry": "Bransch",
  "dashboard.companyInformation": "Företagsinformation",
  "dashboard.companyLocation": "Plats",
  "dashboard.companyModal.close": "Stäng företagsfönster",
  "dashboard.companyModal.closeBackdrop": "Stäng",
  "dashboard.companyModal.subtitle": "{crawls} crawls · {ok} lyckade · {jobs} skickade till processor",
  "dashboard.companyModal.tabCrawls": "Crawl-körningar",
  "dashboard.companyModal.tabSettings": "Företags- och crawl-inställningar",
  "dashboard.companyName": "Företagsnamn",
  "dashboard.companyRegistry": "Register",
  "dashboard.companyRow.jobs": "jobb",
  "dashboard.companyRow.openBadge": "Öppen",
  "dashboard.companyRow.paginationWarningShort": "Pagineringsvarning ⚠ {n}",
  "dashboard.companySocial": "Sociala medier",
  "dashboard.companyUrl": "Företags-URL",
  "dashboard.coordinates": "Koordinater",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Loggar",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ meny",
  "dashboard.crawlActions.legendHtml": "Öga — HTML: ögonblicksbild från S3 så som den crawlades (plus live-extraherad JSON när raden har en URL).",
  "dashboard.crawlActions.legendLive": "Pil ut — Live-sida: öppna den publika jobb-sidan på JobCrawls (detalj-rader med endast ett objekt-ID).",
  "dashboard.crawlActions.legendLogs": "⋯ — CloudWatch: hoppa till crawler, processor, enrich, Algolia, etc. (filter använder detta crawl-id eller jobb-URL).",
  "dashboard.crawlActions.legendRecrawlDetail": "Pilar — Recrawl-sida: lägg till en detalj-crawl för denna URL i kön (inte hela företagslistan).",
  "dashboard.crawlActions.legendTitle": "Vad radknapparna gör",
  "dashboard.crawlActions.legendTrace": "Förstoringsglas — Trace: en modal med status för Raw/Final/Enriched, samt länkar till DynamoDB och AWS-konsolen.",
  "dashboard.crawlActions.liveJobAria": "Öppna offentlig jobbannons på JobCrawls",
  "dashboard.crawlActions.liveJobTooltip": "Öppna den offentliga annonssidan för detta jobb på JobCrawls (samma URL som besökare ser när jobbet är indexerat).",
  "dashboard.crawlActions.logsMenuAria": "Meny för CloudWatch-pipelineloggar för denna crawl",
  "dashboard.crawlActions.logsMenuTooltip": "Länkar till CloudWatch-loggar: exakt crawl-ström när tillgängligt, därefter filtrerade vyer för crawler (crawlId), processor, enrich, Algolia, maintainer och processor per URL.",
  "dashboard.crawlActions.recrawlDetailAria": "Recrawla denna jobbsida (endast detalj-crawl)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Köa en crawl av endast denna jobbsida (detalj). Kör inte om hela företagets listningssidor — använd företagets ”Recrawl” för det.",
  "dashboard.crawlActions.traceAria": "Öppna fullständig pipeline-trace för denna jobb-URL",
  "dashboard.crawlActions.traceTooltip": "Öppna pipeline-trace: sammanfattningar för RawJobs / FinalJobs / Enriched, objekt-ID:n samt länkar till DynamoDB och CloudWatch för denna jobb-URL.",
  "dashboard.crawlActions.viewHtmlAria": "Visa lagrad HTML-snapshot för denna crawl",
  "dashboard.crawlActions.viewHtmlTooltip": "Öppna HTML-snapshoten som lagrats för denna crawl (S3). Visar renderad eller rå markup och live DynamoDB job-JSON bredvid.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl-data har laddats ({count} poster), men företagsdata har inte laddats i den här webbläsaren än — därför visas inga grupper nedan. Ladda företag för att se dem.",
  "dashboard.crawlExportWindow": "Laddade crawl-poster från {from} till {to} (maintainer export window).",
  "dashboard.crawlFailIconTooltip": "Denna crawl-körning misslyckades eller returnerade ett HTTP-fel — öppna CloudWatch / pipeline-loggar för detta crawlId.",
  "dashboard.crawlHistory.hideOlder": "Dölj {n} äldre crawl(s)",
  "dashboard.crawlHistory.hint": "Den senaste körningen finns i raden ovan. Varje äldre körning har sitt eget crawlId och CloudWatch-länkar.",
  "dashboard.crawlHistory.showOlder": "Visa {n} äldre crawl(s) — tid, loggar, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Timvis diagram över genomsnittlig sidtid och totala crawl-minuter",
  "dashboard.crawlHourlyChart.ariaPages": "Timvis diagram över hämtningar av listnings- och jobbsidor, sparade jobb, listningslänkar och osparade jobbsidor",
  "dashboard.crawlHourlyChart.avgSecPhrase": "snitt {seconds} s per sida som rapporterade tidtagning",
  "dashboard.crawlHourlyChart.axisAvgSec": "Genomsnitt s / sida",
  "dashboard.crawlHourlyChart.axisExtracted": "Jobbrelaterade antal / h",
  "dashboard.crawlHourlyChart.axisPageFetches": "Sidhämtningar / h",
  "dashboard.crawlHourlyChart.axisTotalMin": "Totalt min / h",
  "dashboard.crawlHourlyChart.collapsedEmpty": "Inga rader i det laddade fönstret",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} timmar · {fetches} sidhämtningar",
  "dashboard.crawlHourlyChart.durationHms": "Totalt {hours}t {minutes}m {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationMs": "Totalt {minutes}m {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationSecOnly": "Totalt {seconds}s (summa av tider per sida)",
  "dashboard.crawlHourlyChart.durationZero": "0s totalt",
  "dashboard.crawlHourlyChart.empty": "Inga crawl-rader i det laddade fönstret — uppdatera crawl-data efter en maintainer-export.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Förklaring & fönstertotaler",
  "dashboard.crawlHourlyChart.hoverAllFetches": "Alla sidhämtningar",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} misslyckade)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Genomsnittlig sidtid (tidtagna rader)",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "Från enskilda jobb-sidor (sedda annonser)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Enskilda jobb-sidor som vi inte sparade",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Hittades på andra sidtyper",
  "dashboard.crawlHourlyChart.hoverJobPages": "Jobbsidor (detaljer)",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} misslyckades",
  "dashboard.crawlHourlyChart.hoverJobsFound": "Totalt \"hittade\" (summan av allt)",
  "dashboard.crawlHourlyChart.hoverListPages": "Listningssidor",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} misslyckades",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "Från listningssidor (jobblänkar räknade)",
  "dashboard.crawlHourlyChart.hoverPipeline": "Sparade i pipeline",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, övriga {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Total rapporterad tid för crawlning",
  "dashboard.crawlHourlyChart.noTiming": "ingen varaktighet per sida registrerad i denna export",
  "dashboard.crawlHourlyChart.panelDuration": "Crawl-varaktighet",
  "dashboard.crawlHourlyChart.panelPages": "Hämtningar och antal jobb per timme",
  "dashboard.crawlHourlyChart.plainGuide1": "”Hittade” är ofta ett högt tal eftersom varje jobblänk på en listningssida räknas. Dessa länkar betyder bara ”vi har lagt till denna URL i kön” – inte att ett jobb har sparats ännu.",
  "dashboard.crawlHourlyChart.plainGuide2": "”Extraherade” innebär att vi faktiskt har sparat det jobbet till rålagring från en enskild jobbsida. Rader i listningar räknas aldrig som extraherade (enligt design).",
  "dashboard.crawlHourlyChart.plainGuide3": "Använd kryssrutorna i diagrammet: den lila streckade linjen = länkar räknade på listningssidor; den bruna streckade linjen = jobbsidor vi besökte men inte sparade; den solida guldfärgade linjen = sparade till pipelinen. Håll muspekaren över grafen för att se siffrorna för en specifik timme.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "Enkelt förklarat",
  "dashboard.crawlHourlyChart.subtitle": "Övre diagrammet: sidor vi hämtade och antal jobb per timme. Nedre diagrammet: hur lång tid crawlningen tog. Tidsaxeln matchar ditt exporterade crawl-fönster (ofta cirka en vecka).",
  "dashboard.crawlHourlyChart.title": "Crawl-aktivitet per timme (lokal tid)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Jobbsidor besökta men ej sparade",
  "dashboard.crawlHourlyChart.totalExtracted": "Jobb sparade som rådata (\"extraherade\")",
  "dashboard.crawlHourlyChart.totalFoundRaw": "\"Hittade\" (alla rader summerade)",
  "dashboard.crawlHourlyChart.totalJobPages": "Enskilda jobbsidor crawlade",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} lyckades, {fail} misslyckades)",
  "dashboard.crawlHourlyChart.totalListLinks": "Av dessa, länkar räknade på listningssidor",
  "dashboard.crawlHourlyChart.totalListPages": "Listningssidor crawlade",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} lyckades, {fail} misslyckades)",
  "dashboard.crawlHourlyChart.totalTiming": "Tid rapporterad av crawler",
  "dashboard.crawlHourlyChart.totalsTitle": "Totalt för tidsintervallet ovan",
  "dashboard.crawlKey": "Crawl-nyckel",
  "dashboard.crawlMetricsExplainer.crawls": "Crawlningar — en loggrad varje gång vi öppnar en listningssida eller en enskild jobbannons.",
  "dashboard.crawlMetricsExplainer.extracted": "Extraherade — jobb som vi faktiskt sparat från en jobbsida. Listningssidor räknas inte här.",
  "dashboard.crawlMetricsExplainer.found": "Hittade — främst ”hur många jobblänkar vi räknade på listningssidorna”, plus det vi såg på jobbsidorna. Höga siffror här är normalt.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "För en mer komplett bild, använd det timvisa diagrammet nedan: där är de lila, bruna och guldfärgade linjerna märkta för att matcha denna förklaring.",
  "dashboard.crawlMetricsExplainer.successFailed": "Lyckad / misslyckad — laddades sidan och slutfördes utan ett crawlningsfel?",
  "dashboard.crawlMetricsExplainer.title": "Vad dessa siffror betyder",
  "dashboard.crawlMetricsExplainer.triggerAria": "Vad dessa siffror i crawl-sammanfattningen betyder",
  "dashboard.crawlOkIconTooltip": "Denna crawlning lyckades (HTTP OK, inget crawler-fel).",
  "dashboard.crawlOutliersFilter.all": "Alla crawl-rader",
  "dashboard.crawlOutliersFilter.any": "Crawlad men ej skickad",
  "dashboard.crawlOutliersFilter.hint": "Använder endast exportfält från IndexedDB. Rader på list-sidan döljs när detta inte är inställt på ”Alla”. Kombinera med platta flikar för ”Jobb / list-sidor”.",
  "dashboard.crawlOutliersFilter.label": "Pipeline / index-avvikelser (detalj-crawls)",
  "dashboard.crawlOutliersFilter.notSent": "Crawlad OK men jobsExtracted = 0 (ej hoppad över)",
  "dashboard.crawlRecords": "Crawl-poster",
  "dashboard.crawlStatistics": "Crawl-statistik",
  "dashboard.crawlType": "Crawl-typ",
  "dashboard.crawlingInformation": "Crawlingsinformation",
  "dashboard.deleteComment": "Ta bort kommentar",
  "dashboard.deleteCompany": "Ta bort",
  "dashboard.deleteCompany.confirm": "Ta bort \"{name}\" från tabellen Companies (DynamoDB)? Detta kan inte ångras. Lokala rader i instrumentpanelen för detta företag kommer att tas bort.",
  "dashboard.deleteCompany.done": "Företaget \"{name}\" raderades.",
  "dashboard.deleteCompany.failed": "Misslyckades med att radera företaget: {message}",
  "dashboard.deleteCompany.modalTooltip": "Ta bort det här företaget från tabellen Företag (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Radera företaget från DynamoDB och ta bort från den lokala instrumentpanelen",
  "dashboard.deleteCompany.virtualBlocked": "Den aggregerade raden för Työmarkkinatori är inte ett post i tabellen Företag. Den kan inte raderas här.",
  "dashboard.detailPages": "Detaljsidor",
  "dashboard.details": "Detaljer",
  "dashboard.dlqEmpty": "DLQ är tom - inga misslyckade meddelanden",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {meddelande} other {meddelanden}} i DLQ",
  "dashboard.duration": "Varaktighet",
  "dashboard.editCompany": "Redigera",
  "dashboard.enqueueUrlPattern": "Mönster för köläggning av URL:er",
  "dashboard.error": "Fel",
  "dashboard.failed": "Misslyckade",
  "dashboard.failedToLoadCompanySettings": "Kunde inte ladda företagsinställningar: {error}",
  "dashboard.filterByField": "Filtrera efter fält",
  "dashboard.filterValue": "Filtervärde... (använd __NOT_EMPTY__ för icke-tomma)",
  "dashboard.flatView.noCrawlRows": "Inga crawl-rader att visa i platt vy. Ladda först in data från crawl-exporten.",
  "dashboard.flatViews.colActions": "Åtgärder",
  "dashboard.flatViews.colActionsTooltip": "Live-listning på webbplatsen, HTML-snapshot från S3 när tillgängligt.",
  "dashboard.flatViews.colCompany": "Företag",
  "dashboard.flatViews.colCompanyTooltip": "Företagsnamn lagrat i crawl-posten.",
  "dashboard.flatViews.colDuration": "Varaktighet",
  "dashboard.flatViews.colDurationTooltip": "Tid som lagts på att hämta och behandla denna crawl-förfrågan.",
  "dashboard.flatViews.colHttpTooltip": "HTTP-svarsstatus för denna förfrågan (t.ex. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Hittade / skickade",
  "dashboard.flatViews.colMetricsTooltip": "Lista: jobb i kö. Detaljer: skickat till processor eller ej. Andra sidtyper: råa antal. Håll muspekaren över en cell för mer detaljer.",
  "dashboard.flatViews.colOkTooltip": "Grön: crawl lyckades. Röd: misslyckades eller felaktig HTTP. Om det finns flera körningar för samma URL, håll muspekaren över tidskolumnen för status per körning.",
  "dashboard.flatViews.colPage": "Sida",
  "dashboard.flatViews.colPageTooltip": "Sidtyp (lista vs detalj) och märken: TMT, Hoppad, Y-tunnus-tips, etc.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Länkar till CloudWatch-loggströmmar för crawler, processor och relaterade steg.",
  "dashboard.flatViews.colTime": "Tid",
  "dashboard.flatViews.colTimeTooltip": "När denna crawl-körning startade. Om samma URL crawlades mer än en gång visas den senaste körningen i denna rad.",
  "dashboard.flatViews.colTrace": "Pipeline-loggar",
  "dashboard.flatViews.colTraceFull": "Spårning",
  "dashboard.flatViews.colTraceFullTooltip": "Öppna hela jobbpipeline-tracen (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "URL som hämtats av crawlern.",
  "dashboard.flatViews.colYtunnus": "Y-nummer (TMT)",
  "dashboard.flatViews.colYtunnusTooltip": "Endast Työmarkkinatori: om ett finskt företagskennande (Y-tunnus) extraherades från HTML och matchades mot din företagsdatabas.",
  "dashboard.flatViews.crawlRunCount": "{n} crawlningar",
  "dashboard.flatViews.failure.algolia": "Algolia-fel (metadata)",
  "dashboard.flatViews.failure.all": "Alla utfall",
  "dashboard.flatViews.failure.cookie": "Kaka / overlay",
  "dashboard.flatViews.failure.nav": "Navigering / timeout",
  "dashboard.flatViews.failure.net": "Nätverk",
  "dashboard.flatViews.failure.other": "Annat crawl-fel",
  "dashboard.flatViews.failureFilterLabel": "Crawl-utfall",
  "dashboard.flatViews.first": "Första",
  "dashboard.flatViews.hint": "Sortering, Källa, Avvikelser och Crawl-resultat gäller endast för denna platta tabell. Rader grupperar upprepade crawls av samma URL (nyaste först; antal crawls i tidskolumnen). Avvikelser använder endast rader för jobbdetaljer (Algolia-fel i metadata, eller crawl OK men jobsExtracted 0 och ej hoppad över). Crawl-resultat använder IndexedDB-exportfält (inte live Dynamo). Använd Trace för en rad för att ladda Raw/Final/Enriched + AWS-konsolens länkar. Raduppsättningen använder även samma filter (Työmarkkinatori, TMT Y-tunnus) som ovan.",
  "dashboard.flatViews.jobPages": "Alla jobbsidor",
  "dashboard.flatViews.last": "Sista",
  "dashboard.flatViews.listPages": "Alla listsidor",
  "dashboard.flatViews.next": "Nästa",
  "dashboard.flatViews.pageJumpLabel": "Gå till sida",
  "dashboard.flatViews.pageOf": "Sida {p} av {t} ({n} rader)",
  "dashboard.flatViews.prev": "Föregående",
  "dashboard.flatViews.sort.companyAsc": "Företag · A–Ö",
  "dashboard.flatViews.sort.companyDesc": "Företag · Ö–A",
  "dashboard.flatViews.sort.failedFirst": "OK · misslyckade först",
  "dashboard.flatViews.sort.jobsFoundAsc": "Hittade jobb · låg → hög",
  "dashboard.flatViews.sort.jobsFoundDesc": "Hittade jobb · hög → låg",
  "dashboard.flatViews.sort.successFirst": "OK · lyckade först",
  "dashboard.flatViews.sort.timeAsc": "Tid · äldsta först",
  "dashboard.flatViews.sort.timeDesc": "Tid · nyaste först",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Ö",
  "dashboard.flatViews.sort.urlDesc": "URL · Ö–A",
  "dashboard.flatViews.sortLabel": "Sortera",
  "dashboard.flatViews.source.all": "Alla crawlningar",
  "dashboard.flatViews.source.nonTmt": "Exkludera Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Endast Työmarkkinatori",
  "dashboard.flatViews.sourceLabel": "Källa",
  "dashboard.flatViews.title": "Platta crawl-vyer",
  "dashboard.flatViews.yt.legacy": "Äldre rad: ingen Y-tunnus-metadata (crawl om för att klassificera)",
  "dashboard.flatViews.yt.na": "Inte en Työmarkkinatori-detaljrad",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus extraherad men hittades inte i CompaniesTable",
  "dashboard.flatViews.yt.none": "Ingen Y-tunnus extraherad från sidans HTML",
  "dashboard.flatViews.yt.ok": "Y-tunnus extraherad och företag matchat",
  "dashboard.greenSuccess": "Grön (Lyckad)",
  "dashboard.groupBy": "Gruppera efter",
  "dashboard.groupCrawlCount": "Antal crawlningar",
  "dashboard.groupJobsCount": "Antal jobb",
  "dashboard.groupLogoFailed": "Logostatus",
  "dashboard.groupMetrics": "Mätvärden",
  "dashboard.groupNone": "Ingen",
  "dashboard.groupPaginationIssue": "Pagineringsproblem",
  "dashboard.groupStatus": "Status (Röd/Gul/Grön)",
  "dashboard.groupStatusIssues": "Status & Problem",
  "dashboard.groupSuccessRate": "Framgångsgrad",
  "dashboard.hasAnyFailedCrawl": "Någon misslyckad crawl (inom tidsfönstret)",
  "dashboard.hasComments": "Har kommentarer",
  "dashboard.hasCrawlData.label": "Crawl-data",
  "dashboard.hasCrawlData.option": "Har data",
  "dashboard.heroImage": "Hero-bild",
  "dashboard.howToRunCrawl": "Så här kör du en crawl",
  "dashboard.htmlModal.liveExtractedHint": "Samma objekt-ID som sökindexet. Långa textfält är trunkerade i vyn.",
  "dashboard.htmlModal.liveExtractedTitle": "Live-extraherat jobb (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Laddar FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "Denna crawl-rad saknar URL – kan inte hämta live-jobbposter.",
  "dashboard.httpStatusCellTooltip": "HTTP-svarstatus för denna begäran (t.ex. 200 = OK, 404 = inte hittad).",
  "dashboard.industry": "Bransch",
  "dashboard.isChecked": "Granskade",
  "dashboard.isSaved": "Sparade",
  "dashboard.issuesOnly": "Endast problem",
  "dashboard.itemsPerPage": "Objekt per sida",
  "dashboard.jobLookup.activeHint": "Visar detaljerade crawlningar för jobb-ID: {id}",
  "dashboard.jobLookup.clear": "Rensa exportfilter",
  "dashboard.jobLookup.find": "Sök i export",
  "dashboard.jobLookup.noMatchInExport": "Ingen detaljerad crawlning i det laddade fönstret har detta jobb-ID. Ladda om crawl-data eller utöka exportfönstret.",
  "dashboard.jobLookup.parseError": "Kunde inte hitta något jobb-ID. Klistra in en fullständig URL till JobCrawls jobb-sida (…/en/job/…/company/…) eller objekt-ID från adressfältet.",
  "dashboard.jobLookup.placeholder": "Klistra in URL till jobbsida eller objekt-ID…",
  "dashboard.jobLookup.resolvingIds": "Matchar jobb-ID:n med crawls…",
  "dashboard.jobSearch.matchExportLabel": "Matcha i laddad crawl-export",
  "dashboard.jobSearch.sectionHint": "Hitta rader i den laddade exporten, eller spåra pipelinens status från en jobb-URL.",
  "dashboard.jobSearch.sectionTitle": "Jobbsökning",
  "dashboard.jobTrace.blurb": "Klistra in den exakta URL:en till jobbannonsen så som den är lagrad i RawJobs. Instrumentpanelen laddar RawJobs, FinalJobs och EnrichedFinalJobs, drar slutsatser om hur långt jobbet kommit och länkar till DynamoDB-tabeller och CloudWatch-loggfilter.",
  "dashboard.jobTrace.close": "Stäng",
  "dashboard.jobTrace.dynamo": "DynamoDB (konsol)",
  "dashboard.jobTrace.failureCode": "Kod: {code}",
  "dashboard.jobTrace.load": "Hämta all information",
  "dashboard.jobTrace.loading": "Laddar spårning…",
  "dashboard.jobTrace.modalTitle": "Pipeline-spårning",
  "dashboard.jobTrace.noAwsLinks": "Konsollänkarna är inte tillgängliga (pipeline log env är ofullständig).",
  "dashboard.jobTrace.noLogContext": "Pipeline log env-variabler saknas i API:et — Dynamo-länkar fungerar fortfarande; ställ in PIPELINE_LOG_GROUP_* på Dashboard Lambda för CloudWatch-djup länkar i API-svaret.",
  "dashboard.jobTrace.rawJson": "Objektsammanfattningar (JSON)",
  "dashboard.jobTrace.title": "Pipeline-spårning (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Jobb-URL",
  "dashboard.jobTrace.visual": "Pipeline-förlopp",
  "dashboard.jobsEnqueued": "{count} jobb i kön",
  "dashboard.jobsEnqueuedCellTooltip": "Listcrawl: jobb-URL:er som upptäckts på denna sida och lagts i kön för detaljcrawlning. ”Listpages” räknar även extra listnings-URL:er (t.ex. paginering) som lagts i kön.",
  "dashboard.jobsExtracted": "Extraherade jobb",
  "dashboard.jobsFound": "Hittade jobb",
  "dashboard.layout.company": "Per företag",
  "dashboard.layout.flat": "Platta crawls",
  "dashboard.listPages": "Listningssidor",
  "dashboard.listPagesEnqueued": "{count} listningssidor",
  "dashboard.liveJobLink": "Live-jobb",
  "dashboard.loadAllCompanies": "Ladda alla företag (86k)",
  "dashboard.loadCompaniesButton": "Ladda företag",
  "dashboard.loadedCompanies": "Laddade: {current} av {total} företag",
  "dashboard.loadedCompaniesUnknown": "Laddade: {current} företag",
  "dashboard.loadingAllCompanies": "Laddar alla företag — långsammare initial laddning",
  "dashboard.loadingBatch": "Bearbetar batch {current} av ungefär {total}",
  "dashboard.loadingCompanies": "Laddar företagsdata",
  "dashboard.loadingCompaniesWithUrls": "Laddar endast företag med webbadresser — snabbare",
  "dashboard.loadingNote": "Detta kan ta några minuter. Vänligen håll kvar denna sida öppen.",
  "dashboard.logoFailed": "Logotyp misslyckades",
  "dashboard.logoFailedBadgeTitle": "Logotypen kunde inte laddas i instrumentpanelen — använd Logo Lambda-loggarna nedan för ProcessCompanyLogos-utdata",
  "dashboard.logoOk": "Logotyp OK",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos misslyckades ({failedAt}): {error}",
  "dashboard.logoProcessingFailedUnknownDate": "okänt datum",
  "dashboard.logoUrlFailedLabel": "Misslyckades",
  "dashboard.map": "Karta",
  "dashboard.menu.overview": "Översikt",
  "dashboard.menu.overview.metricsHelpDesc": "Håll muspekaren över (i)-ikonen för att se vad varje antal betyder.",
  "dashboard.menu.overview.metricsHelpTitle": "Definitioner av mätvärden",
  "dashboard.menu.overview.noExport": "Ladda data från crawl-export (Verktyg) för att se sammanfattande antal.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer-ögonblicksbild jämfört med crawl-fönster.",
  "dashboard.menu.overview.summaryDesc": "Antal från den crawl-JSON som laddats i denna webbläsare.",
  "dashboard.menu.overview.summaryTitle": "Exportsammanfattning",
  "dashboard.menu.refine": "Förfina",
  "dashboard.metricsFoundExtractedTooltip": "Hittade jobb jämfört med extraherade jobb för denna sidtyp (inte en standardrad för lista/detaljer).",
  "dashboard.mostRecent": "Senaste",
  "dashboard.next": "Nästa",
  "dashboard.noCrawlData.message": "Inga crawl-data tillgängliga än. Expandera avsnittet \"Hur man kör en crawl\" ovan för instruktioner om hur du kör en crawl och exporterar data.",
  "dashboard.noCrawlData.option": "Inga data",
  "dashboard.noCrawlData.withServerDetail": "Ingen crawl-export tillgänglig: {detail}. Om du kör på localhost, se till att AWS-uppgifterna kan läsa crawl-data-bucketen och att Maintainer har skrivit crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "Inget fältfilter",
  "dashboard.noIssues": "Inga problem",
  "dashboard.noLogoUrl": "Ingen logotyp-URL",
  "dashboard.notSent": "Ej skickad",
  "dashboard.notSentTooltip": "Ingen jobbinformation extraherades (jobsExtracted är 0). Detta är inte samma sak som ”Hoppades över”: Hoppades över innebär att crawlern avsiktligt inte kördes igen eftersom jobbet redan fanns i RawJobs.",
  "dashboard.pageInfo": "Sida {current} av {total}",
  "dashboard.pageType": "Sidtyp",
  "dashboard.pageType.detailTooltip": "Detaljsida: en enskild URL för en jobbannons. Crawlern extraherar strukturerad data och kan skicka den till processorn.",
  "dashboard.pageType.genericTooltip": "Crawler-sidtyp: {pageType}.",
  "dashboard.pageType.listTooltip": "Listningssida: hittar jobblänkar på en listnings- eller söksida och lägger till dem i kön för detalj-crawling.",
  "dashboard.pagination.allRows": "Alla",
  "dashboard.pagination.first": "Första",
  "dashboard.pagination.last": "Sista",
  "dashboard.pagination.navGroup": "Sidnavigering",
  "dashboard.pagination.pageJumpAria": "Sidnummer, 1 till {total}",
  "dashboard.pagination.pageJumpLabel": "Gå till sida",
  "dashboard.paginationIssueDescription": "Exakt {count} jobb skickades – kan tyda på ofullständig paginering.",
  "dashboard.pipelineHealth.active": "Aktiv",
  "dashboard.pipelineHealth.activeFinland": "Aktiv + Finland",
  "dashboard.pipelineHealth.activeNotFinland": "Aktiv, ej Finland",
  "dashboard.pipelineHealth.crawlCompare.body": "Jobb extraherade i rader från Työmarkkinatori-crawl (summa av jobsExtracted): {count}. Jämför med ”Active Työmarkk. (URL)” ovan – stora skillnader beror ofta på föråldrad lastSeen (inaktiv), köbildning i processorn eller felaktiga URL/companyId.",
  "dashboard.pipelineHealth.crawlCompare.title": "Crawl-export (detta fönster)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot från Maintainer-skanning: {when}",
  "dashboard.pipelineHealth.inactive": "Inaktiv",
  "dashboard.pipelineHealth.missingStats": "Ingen snapshot ännu. Efter nästa lyckade Maintainer-körning (med CRAWL_DATA_BUCKET inställd) visas siffrorna här. Uppdatera crawl-data efter Maintainer.",
  "dashboard.pipelineHealth.title": "Pipeline-hälsa (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs-rader",
  "dashboard.pipelineHealth.tyoFlag": "Active Työmarkk. (flagga)",
  "dashboard.pipelineHealth.tyoUrl": "Aktiv Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + inte Finland",
  "dashboard.pipelineLogs.allGroups": "Lambda-loggrupper",
  "dashboard.pipelineLogs.aria": "CloudWatch-logglänkar längs sökvägen crawl → processor → enrich → Algolia → maintainer",
  "dashboard.pipelineLogs.crawlStream": "Crawl-ström",
  "dashboard.pipelineLogs.enrich": "Berika",
  "dashboard.pipelineLogs.maintainer": "Underhållare",
  "dashboard.pipelineLogs.noObjectId": "ObjectID-länkar endast på detaljraderna",
  "dashboard.pipelineLogs.unconfigured": "Ange PIPELINE_LOG_GROUP_* på Dashboard / API Lambda för logglänkar",
  "dashboard.potentialPaginationIssue": "Potentiellt problem med paginering",
  "dashboard.previous": "Föregående",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda-loggar",
  "dashboard.processCompanyLogoLogs.tooltip": "Öppna CloudWatch-loggrupp för ProcessCompanyLogos (filtrerad på detta företags-id i logtexten)",
  "dashboard.processDlq": "Processa DLQ",
  "dashboard.quickFilterUncrawled": "Ej crawlade · högsta poäng",
  "dashboard.quickFilterUncrawled.tooltip": "Visa företag där doCrawl inte är TRUE, sorterat efter poäng i fallande ordning — användbart för att manuellt processa de viktigaste ej crawlade företagen",
  "dashboard.recordCount": "{count} {count, plural, one {post} other {poster}}",
  "dashboard.recrawl": "Crawla om",
  "dashboard.recrawlDetailTriggered": "Detalj-omcrawlning köad för {companyName}",
  "dashboard.recrawlTriggered": "Omcrawlning startad för {companyName}",
  "dashboard.recrawling": "Krälar om…",
  "dashboard.redLastCrawlFailed": "Röd – senaste krälningen misslyckades",
  "dashboard.refine.quickOptionsTitle": "Snabbalternativ",
  "dashboard.refine.section.companyList": "Företagslista",
  "dashboard.refine.section.companyListDesc": "Begränsa vilka företag som visas i listan.",
  "dashboard.refine.section.fieldFilterDesc": "Matcha ett enskilt företagsfält (och ett valfritt värde).",
  "dashboard.refine.section.pipelineIndexDesc": "Detaljerade kräl-signaler från den laddade exporten.",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Filtrera rader taggade med Työmarkkinatori och Y-tunnus-metadata.",
  "dashboard.refreshCompanies": "Uppdatera företag",
  "dashboard.refreshCrawlData": "Uppdatera crawl-data",
  "dashboard.refreshCrawlData.title": "Uppdatera crawl-data från S3",
  "dashboard.refreshing": "Uppdaterar...",
  "dashboard.registryInformation": "Registerinformation",
  "dashboard.result": "Resultat",
  "dashboard.runMaintainer": "Kör underhåll",
  "dashboard.running": "Körs...",
  "dashboard.save": "Spara",
  "dashboard.saveError": "Fel",
  "dashboard.saved": "Sparad",
  "dashboard.saving": "Sparar…",
  "dashboard.scanningDatabase": "Söker igenom databasen och laddar företag...",
  "dashboard.searchCompanies": "Sök företag...",
  "dashboard.sentForProcessing": "✓ Skickat för bearbetning",
  "dashboard.sentForProcessingTooltip": "Strukturerad jobbdata extraherades (jobsExtracted ≥ 1) och skickades till bearbetningsflödet (SQS / processor).",
  "dashboard.sentToProcessor": "Skickat till processor",
  "dashboard.showing": "Visar {filtered} av {total} företag",
  "dashboard.skipped": "Hoppades över",
  "dashboard.skippedCrawlTooltip": "Hoppades över: crawlern hämtade inte denna URL igen eftersom jobbet redan fanns lagrat i RawJobs (för att förhindra dubbletter). En crawl-rad registreras ändå för synlighets skull.",
  "dashboard.socialMedia": "Sociala medier",
  "dashboard.sortAndGroup.sectionHint": "Ändra listordning och valfri gruppering.",
  "dashboard.sortAndGroup.sectionTitle": "Sortera & gruppera",
  "dashboard.sortAscending": "Stigande",
  "dashboard.sortBasic": "Grundläggande",
  "dashboard.sortBy": "Sortera efter",
  "dashboard.sortCrawls": "Sökningar",
  "dashboard.sortDescending": "Fallande",
  "dashboard.sortDetailPages": "Detaljsidor",
  "dashboard.sortDirection": "Sortera {direction}",
  "dashboard.sortFailed": "Misslyckade crawlningar",
  "dashboard.sortJobs": "Jobb",
  "dashboard.sortJobsExtracted": "Totalt extraherade jobb",
  "dashboard.sortJobsFound": "Totalt hittade jobb",
  "dashboard.sortJobsSent": "Jobb skickade till processor",
  "dashboard.sortLastCrawl": "Datum för senaste crawlning",
  "dashboard.sortListPages": "Listningssidor",
  "dashboard.sortMostRecentJobs": "Senast hittade jobb",
  "dashboard.sortName": "Företagsnamn",
  "dashboard.sortPages": "Sidor",
  "dashboard.sortSuccessRate": "Framgångsgrad",
  "dashboard.sortSuccessful": "Lyckade crawlningar",
  "dashboard.successRate": "Framgångsgrad",
  "dashboard.successful": "Lyckade",
  "dashboard.summary.extractedLabel": "Extraherade jobb",
  "dashboard.summary.failedLabel": "Misslyckade",
  "dashboard.summary.foundLabel": "Hittade jobb",
  "dashboard.summary.successLabel": "Lyckade",
  "dashboard.summary.totalCrawls": "Totalt antal crawlningar",
  "dashboard.summary.uniqueUrls": "Unika URL:er",
  "dashboard.syncingCompanySettings": "Synkroniserar företagsinställningar...",
  "dashboard.time": "Tid",
  "dashboard.title": "Crawl-instrumentpanel",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori-detalj: inget Y-tunnus extraherades från HTML",
  "dashboard.tmtBadge.noYtunnusShort": "Inget Y-tunnus",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus extraherades men inget matchande företag hittades i CompaniesTable",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / inget fört.",
  "dashboard.tmtBadge.yTunnusUnknown": "Äldre crawl-rad: Y-tunnus-metadata har inte registrerats ännu (crawl om för att klassificera)",
  "dashboard.tmtSourceTooltip": "Det här jobbet hämtades från Työmarkkinatori (TE-tjänsterna / finska offentliga arbetsförmedlingslistor).",
  "dashboard.tmtYtunnusFilter.all": "Vilken som helst",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnus saknas i Companies",
  "dashboard.tmtYtunnusFilter.noExtract": "Ingen Y-tunnus extraherad",
  "dashboard.toolsModal.actionsHeading": "Åtgärder",
  "dashboard.toolsModal.closeBackdrop": "Stäng",
  "dashboard.toolsModal.closeButton": "Stäng",
  "dashboard.toolsModal.openButton": "Verktyg & konfig",
  "dashboard.toolsModal.openButtonSr": "Öppna underhåll, uppdatering, DLQ och instruktioner för hämtning",
  "dashboard.toolsModal.title": "Verktyg och konfiguration",
  "dashboard.totalCrawls": "Totalt antal crawlningar",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "Alla crawl-rader",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Endast rader utan TMT",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "Endast TMT-rader",
  "dashboard.uncheck": "Avmarkera",
  "dashboard.unsave": "Ta bort från sparade",
  "dashboard.viewAttributes": "Visa attribut",
  "dashboard.viewJobs": "Visa",
  "dashboard.viewMessageBody": "Visa meddelandetext",
  "dashboard.viewOnGoogleMaps": "Visa på Google Maps",
  "dashboard.yellowNoJobs": "Gul (Inga jobb)",
  "employerScoreCard.dimension.flexibility": "flexibilitet",
  "employerScoreCard.dimension.growth": "tillväxt",
  "employerScoreCard.dimension.pay": "lön",
  "employerScoreCard.dimension.stability": "stabilitet",
  "employerScoreCard.disclaimer": "Beräknat utifrån jobbdata – inte recensioner",
  "employerScoreCard.howWeCalculate": "Hur vi beräknar detta",
  "employerScoreCard.methodology": "Poängen baseras på lönekonkurrenskraft från publicerade löneintervall (där vi har tillräckligt många annonser), flexibilitet gällande distans- och hybridarbete, anställningsstabilitet över tid samt tillväxtsignaler från rollfördelning och trender i rekryteringsvolym. Förmåner och transparens på annonsnivå är exkluderade från huvudpoängen tills dessa flöden är integrerade i beräkningen.",
  "employerScoreCard.strongestAt": "Starkast inom {dimension}",
  "employerScoreCard.subscore.benefits": "Förmåner",
  "employerScoreCard.subscore.flexibility": "Flexibilitet",
  "employerScoreCard.subscore.growth": "Tillväxt",
  "employerScoreCard.subscore.pay": "Lön",
  "employerScoreCard.subscore.stability": "Stabilitet",
  "employerScoreCard.subscore.transparency": "Transparens",
  "employerScoreCard.trackedOnlyHeading": "Mäts även, men vägs ännu inte in",
  "engagement.nav.signIn": "Logga in",
  "facets.benefits": "Förmån",
  "facets.company": "Företag",
  "facets.companyIndustry": "Bransch",
  "facets.education": "Utbildningsnivå",
  "facets.field": "Område",
  "facets.jobType": "Anställningsform",
  "facets.language": "Språk",
  "facets.location": "Plats",
  "facets.management": "Ledarskap",
  "facets.remoteness": "Arbetsupplägg",
  "facets.role": "Roll",
  "facets.roleLevel": "Rollnivå",
  "facets.skills": "Kompetens",
  "feedback.button.label": "Lämna feedback",
  "feedback.cancel": "Avbryt",
  "feedback.error": "Kunde inte skicka feedback. Försök igen.",
  "feedback.label": "Din feedback",
  "feedback.modal.close": "Stäng",
  "feedback.modal.description": "Vi vill gärna höra dina tankar. Dela med dig av din feedback för att hjälpa oss att bli bättre.",
  "feedback.modal.title": "Skicka feedback",
  "feedback.page.anonymous": "Anonym",
  "feedback.page.delete": "Ta bort feedback",
  "feedback.page.deleteConfirm": "Är du säker på att du vill ta bort den här feedbacken?",
  "feedback.page.deleteError": "Kunde inte ta bort feedbacken. Försök igen.",
  "feedback.page.description": "Visa och hantera användarfeedback",
  "feedback.page.listTitle": "All feedback",
  "feedback.page.noFeedback": "Ingen feedback än",
  "feedback.page.refresh": "Uppdatera",
  "feedback.page.submitTitle": "Skicka feedback",
  "feedback.page.viewMetadata": "Visa metadata",
  "feedback.placeholder": "Berätta för oss vad vi bör ändra eller lägga till...",
  "feedback.postSubmit.signInBody": "Skapa ett gratis konto så att vi kan svara om vi har frågor om din feedback.",
  "feedback.postSubmit.signInButton": "Logga in eller skapa konto",
  "feedback.postSubmit.signInTitle": "Vill du att vi följer upp?",
  "feedback.submit": "Skicka",
  "feedback.submitting": "Skickar...",
  "feedback.success": "Tack! Din feedback har skickats.",
  "filters.allFilters.navigation": "Alla filteralternativ",
  "filters.connector.and": "OCH",
  "filters.connector.or": "ELLER",
  "filters.navigation": "Filteralternativ",
  "filters.top.clearAll": "Rensa alla filter",
  "footer.aboutJobcrawls": "Om JobCrawls",
  "footer.accessibilityStatementLink": "Tillgänglighetsutlåtande",
  "footer.aiTranslationDisclaimer": "Obs: En del av innehållet på denna webbplats är maskinöversatt med AI och kan innehålla fel.",
  "footer.allLocations": "Alla platser",
  "footer.bestEmployers": "Bästa arbetsgivare",
  "footer.brandDescription": "JobCrawls är en jobbsökmotor för Finland. Vi indexerar lediga jobb direkt från tusentals arbetsgivares karriärsidor varje dag – på engelska, finska och svenska – med transparent lönedata och inga sponsrade rankningar.",
  "footer.browseAllPages": "Bläddra bland alla sidor",
  "footer.businessIdLabel": "Organisationsnummer",
  "footer.colCompany": "Företag",
  "footer.colEmployersAndDevelopers": "Arbetsgivare och utvecklare",
  "footer.colFindJobs": "Hitta jobb",
  "footer.colJobSeekers": "Arbetssökande",
  "footer.collectiveAgreementsLink": "Kollektivavtal",
  "footer.connectorPrivacy": "Connectors integritetspolicy",
  "footer.contact": "Kontakt",
  "footer.cookieSettings": "Cookie-inställningar",
  "footer.editorialStandards": "Redaktionella riktlinjer",
  "footer.forDevelopers": "För utvecklare",
  "footer.forEmployersLink": "För arbetsgivare",
  "footer.guidesAndArticles": "Guider och artiklar",
  "footer.howCrawlerWorks": "Hur vår crawler fungerar",
  "footer.jobsInEspoo": "Jobb i Esbo",
  "footer.jobsInHelsinki": "Jobb i Helsingfors",
  "footer.jobsInOulu": "Jobb i Uleåborg",
  "footer.jobsInTampere": "Jobb i Tammerfors",
  "footer.jobsInTurku": "Jobb i Åbo",
  "footer.openJobsInFinland": "Lediga jobb i Finland",
  "footer.partnerships": "Mediepartnerskap",
  "footer.privacy": "Integritetspolicy",
  "footer.remoteJobs": "Distansjobb",
  "footer.salariesByRole": "Löner per yrke",
  "footer.signIn": "Logga in",
  "footer.sitemap": "Webbplatskarta",
  "footer.terms": "Användarvillkor",
  "hit.applicationDeadline": "Sista ansökningsdag: {date}",
  "hit.applied": "Ansökt",
  "hit.companyInsights.cue": "Företagsinsikter",
  "hit.companyLinkTitle": "Öppna företagsprofil — data och insikter för {company}",
  "hit.companyProfile.aria": "Visa företagsprofil, rekryteringsdata och insikter för {company}",
  "hit.driversLicenseRequired": "Körkort krävs",
  "hit.hidden": "Dold",
  "hit.hide.button": "Dölj",
  "hit.hide.menu": "Dölj",
  "hit.jobTitle": "Jobb",
  "hit.jobTypeLinkAria": "Sök efter {jobType}-jobb",
  "hit.jobTypeLinkTitle": "Sök efter {jobType}-jobb",
  "hit.linkCopied": "Länken kopierades till urklipp!",
  "hit.locationLinkAria": "Sök efter jobb i {location}",
  "hit.locationLinkTitle": "Sök efter jobb i {location}",
  "hit.locationNotAvailable": "Plats saknas",
  "hit.markAsApplied.menu": "Markera som ansökt",
  "hit.markAsState": "Markera som {state}",
  "hit.moreLocations": "+{count} till",
  "hit.moreOptions": "Fler alternativ",
  "hit.openApplication": "Öppen ansökan",
  "hit.postedDate": "Publicerad: {date}",
  "hit.postedDate.detail": "Publicerad: {date}",
  "hit.remotenessLinkAria": "Sök efter {remoteness}-jobb",
  "hit.remotenessLinkTitle": "Sök efter {remoteness}-jobb",
  "hit.removeApplied": "Ta bort från ansökta",
  "hit.roleLevelLinkAria": "Sök efter {roleLevel}-jobb",
  "hit.roleLevelLinkLabel": "{roleLevel}-jobb",
  "hit.roleLevelLinkTitle": "Sök efter {roleLevel}-jobb",
  "hit.salaryNotSpecified": "Lön ej angiven",
  "hit.salaryNotSpecified.card": "Lön ej angiven",
  "hit.save": "Spara",
  "hit.save.detail": "Spara",
  "hit.saved": "Sparad",
  "hit.saved.detail": "Sparad",
  "hit.seeAd": "Detaljer",
  "hit.share": "Dela",
  "hit.share.detail": "Dela",
  "hit.shareError": "Något gick fel när det försöktes dela det här jobbet.",
  "hit.summerJob": "Sommarjobb",
  "hit.toast.applied": "Markerad som ansökt",
  "hit.toast.hidden": "Jobbet är dolt",
  "hit.toast.saved": "Jobbet är sparat",
  "hit.toast.savedWithCount": "Sparat — {count, plural, one {# jobb} other {# jobb}} i Mina jobb",
  "hit.toast.shared": "Länk kopierad till urklipp",
  "hit.toast.unapplied": "Tagen bort från ansökta",
  "hit.toast.unhidden": "Jobbet är synligt igen",
  "hit.toast.unsaved": "Jobbet togs bort från sparade",
  "hit.toast.viewMyJobs": "Visa →",
  "hit.toast.viewed": "Markerad som läst",
  "hit.tooltip.details": "Visa fullständiga jobbdetaljer och beskrivning",
  "hit.tooltip.filterByCompany": "Filtrera jobb efter det här företaget",
  "hit.tooltip.filterByJobType": "Filtrera jobb efter typ: {jobType}",
  "hit.tooltip.filterByLanguages": "Filtrera jobb efter krävda språk: {languages}",
  "hit.tooltip.filterByLevel": "Filtrera jobb efter nivå: {level}",
  "hit.tooltip.filterByLocation": "Filtrera jobb i: {locations}",
  "hit.tooltip.filterByRemoteness": "Filtrera jobb efter arbetsform: {remoteness}",
  "hit.tooltip.moreOptions": "Fler alternativ",
  "hit.tooltip.save": "Spara det här jobbet för att jämföra med andra",
  "hit.tooltip.saved": "Ta bort från sparade jobb",
  "hit.tooltip.share": "Dela det här jobbet",
  "hit.unhide": "Visa jobb igen",
  "hitGroup.openRoles": "{count, plural, one {# ledig tjänst} other {# lediga tjänster}}",
  "hitGroup.viewCompanyProfile": "Visa företagsprofil",
  "hitV2.estMonthly": "Beräknad månadslön",
  "hitV2.monthly": "Månadslön",
  "hitV2.viewJob": "Visa jobb",
  "hub.bottomNav.alerts": "Bevakningar",
  "hub.bottomNav.ariaLabel": "Verktygsnavigering",
  "hub.bottomNav.profile": "Profil",
  "hub.guestSyncNote": "Sparat på den här enheten — {signIn} för att synka mellan enheter",
  "hub.guestSyncNote.signIn": "logga in",
  "hub.nav.myJobs": "Mina jobb",
  "hub.nav.myJobs.count": "{savedCount} sparade · {activeCount} aktiva",
  "hub.nav.profile": "Profil och CV",
  "hub.nav.searchesAlerts": "Sökningar och bevakningar",
  "hub.nav.searchesAlerts.newCount": "{count} nya",
  "hub.nav.watchlist": "Bevakade",
  "hub.title": "Mina jobb",
  "instantsearch.searchBoxLink.placeholder": "Sök jobb",
  "instantsearch.searchbox.placeholder": "Sök jobb, språk eller stad",
  "job.copyCompanyName": "Kopiera företagsnamn",
  "jobAlerts.confirm.confirm": "Bekräfta",
  "jobAlerts.confirm.errorBody": "Något gick fel. Försök igen om en liten stund.",
  "jobAlerts.confirm.explanation": "Bekräfta din e-postadress för att börja få jobbaviseringar från JobCrawls.",
  "jobAlerts.confirm.heading": "Bekräfta din jobbevakning",
  "jobAlerts.confirm.invalidLink": "Denna bekräftelselänk är ogiltig eller har gått ut. Aktivera aviseringar igen via dina sparade sökningar för att få en ny länk.",
  "jobAlerts.confirm.successBody": "Klart – vi skickar e-post till dig när nya jobb matchar dina sparade sökningar.",
  "jobAlerts.confirm.successHeading": "Din e-postadress är bekräftad",
  "jobAlerts.confirm.working": "Bekräftar…",
  "jobAlerts.newMatches.errorBody": "Vi kunde inte ladda dina nya matchningar. Försök igen om en liten stund.",
  "jobAlerts.newMatches.viewAllInSection": "Visa alla {count} nya matchningar",
  "jobAlerts.panel.activeStatus": "Aviseringar är på – aktivera dem per sökning nedan.",
  "jobAlerts.panel.consentCopy.v1": "Få ett e-postmeddelande när nya jobb matchar de sparade sökningar som du aktiverar aviseringar för – som standard varje måndagsmorgon, eller dagligen om du föredrar det. Skickas till {email}. Du kan återkalla ditt samtycke när som helst här eller via avregistreringslänken i varje e-postmeddelande. Inga andra e-postmeddelanden, någonsin.",
  "jobAlerts.panel.disable": "Stäng av e-postaviseringar",
  "jobAlerts.panel.enable": "Aktivera e-postaviseringar",
  "jobAlerts.panel.error": "Kunde inte spara. Försök igen.",
  "jobAlerts.panel.frequencyDaily": "Dagligen",
  "jobAlerts.panel.frequencyLegend": "Hur ofta",
  "jobAlerts.panel.frequencyWeekly": "Veckovis (måndag morgon)",
  "jobAlerts.panel.heading": "E-postaviseringar",
  "jobAlerts.panel.languageLegend": "Språk för e-post",
  "jobAlerts.panel.noEmail": "Ditt konto saknar en e-postadress, så aviseringar är inte tillgängliga.",
  "jobAlerts.panel.pendingStatus": "Kontrollera din inkorg: bekräfta din e-postadress för att aktivera aviseringar.",
  "jobAlerts.panel.privacyLink": "Integritetspolicy",
  "jobAlerts.panel.sectionHeading": "E-postsammanfattning",
  "jobAlerts.panel.seeNewMatches": "Se nya matchningar nu",
  "jobAlerts.panel.update": "Spara ändringar",
  "jobAlerts.signInPrompt": "Missa aldrig en ny matchning — {signIn} för att se uppdateringar i realtid och aktivera e-postaviseringar för dina sökningar.",
  "jobAlerts.toggle.failed": "Kunde inte spara — försök igen",
  "jobAlerts.toggle.label": "Mejla mig nya matchningar",
  "jobAlerts.toggle.needsSubscription": "Aktivera e-postaviseringar ovanför först",
  "jobAlerts.unsubscribe.confirm": "Avregistrera",
  "jobAlerts.unsubscribe.errorBody": "Något gick fel. Försök igen om en liten stund.",
  "jobAlerts.unsubscribe.explanation": "Detta stoppar alla e-postaviseringar om jobb från JobCrawls till din adress. Dina sparade sökningar förblir orörda.",
  "jobAlerts.unsubscribe.heading": "Avregistrera dig från jobbaviseringar",
  "jobAlerts.unsubscribe.invalidLink": "Denna avregistreringslänk är ogiltig eller ofullständig. Använd länken från ett nyligen mottaget aviseringsmejl, eller hantera aviseringar via dina sparade sökningar när du är inloggad.",
  "jobAlerts.unsubscribe.successBody": "Du kommer inte längre att få e-postaviseringar om jobb. Du kan när som helst återaktivera aviseringar via dina sparade sökningar när du är inloggad.",
  "jobAlerts.unsubscribe.successHeading": "Du är nu avregistrerad",
  "jobAlerts.unsubscribe.working": "Avregistrerar…",
  "jobChart.popover.categoriesShown": "Visade kategorier",
  "jobChart.popover.companyContext": "Baserat på {companyName}s annonser i vår data.",
  "jobChart.popover.count": "Jobbannonser",
  "jobChart.popover.share": "Andel av diagrammet",
  "jobChart.popover.totalInRing": "Totalt i denna ring",
  "jobChart.segmentHint": "Tryck på eller hovra över ett segment för detaljer.",
  "jobDetail.similarJobs.algoliaListTitle": "Liknande jobb",
  "jobDetail.similarJobs.description": "Hitta fler möjligheter som matchar dina intressen och färdigheter",
  "jobDetail.similarJobs.seeAll": "Visa alla",
  "jobDetail.similarJobs.sourceNote": "Från JobCrawls sökning: samma rolltitel och primära plats som denna annons (denna tjänst exkluderad). Upp till 8 resultat.",
  "jobDetail.similarJobs.title": "Relaterade möjligheter",
  "jobDetailPage.404.backHome": "Tillbaka till startsidan",
  "jobDetailPage.404.description": "Tyvärr kunde vi inte hitta det här jobbet. Det kan ha tagits bort eller så är länken felaktig.",
  "jobDetailPage.404.heading": "Sidan kunde inte hittas",
  "jobDetailPage.aboutCompany": "Om",
  "jobDetailPage.applicationDeadline": "Sista ansökningsdag",
  "jobDetailPage.applied": "Ansökt ✓",
  "jobDetailPage.applyNavigation": "Sök jobbet",
  "jobDetailPage.applyNow": "Ansök på företagets webbplats",
  "jobDetailPage.availableLanguages": "Tillgänglig på:",
  "jobDetailPage.benefits": "Förmåner",
  "jobDetailPage.benefitsAndPerks": "Förmåner & Perks",
  "jobDetailPage.businessId": "Organisationsnummer",
  "jobDetailPage.byRemoteness": "Efter distansarbete",
  "jobDetailPage.chartsDataRange": "Visad data är baserad på historiska platsannonser från vår databas.",
  "jobDetailPage.collapseCompensation": "Dölj ersättningsdetaljer",
  "jobDetailPage.companiesHiringInLocation": "Företag som anställer i {location}",
  "jobDetailPage.companyCollapsedBody": "Expandera för att se trenddiagram, platsfördelning, språkefterfrågan och kartdetaljer.",
  "jobDetailPage.companyDistributionDescription": "Visar de {count} främsta företagen baserat på antal jobbannonser",
  "jobDetailPage.companyInfoFromTradeRegister": "Innehåller uppgifter från det finska handelsregistret.",
  "jobDetailPage.compensation": "Ersättning",
  "jobDetailPage.contact": "Kontakt:",
  "jobDetailPage.coverLetter.basedOn": "Baserat på: {entries}",
  "jobDetailPage.coverLetter.copied": "Kopierat!",
  "jobDetailPage.coverLetter.copy": "Kopiera text",
  "jobDetailPage.coverLetter.download": "Ladda ner personligt brev",
  "jobDetailPage.coverLetter.editHint": "Redigera texten nedan innan du kopierar eller laddar ner den — den är din att justera.",
  "jobDetailPage.coverLetter.failed": "Kunde inte skapa ditt personliga brev. Försök igen senare.",
  "jobDetailPage.coverLetter.generateCta": "Skapa mitt personliga brev",
  "jobDetailPage.coverLetter.intro": "Skapa ett personligt brev utifrån din profil och det här jobbet — du kan redigera det innan du laddar ner det.",
  "jobDetailPage.coverLetter.loading": "Skapar ditt personliga brev…",
  "jobDetailPage.coverLetter.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "jobDetailPage.coverLetter.notConfigured": "Att skapa personliga brev är inte aktiverat för den här miljön.",
  "jobDetailPage.coverLetter.overclaimWarning": "Vi kunde inte hitta \"{skill}\" i din profil — se till att detta stämmer.",
  "jobDetailPage.coverLetter.quotaExceeded": "Du har nått dagens gräns för personliga brev — den återställs i morgon.",
  "jobDetailPage.coverLetter.sourceCompany": "Företagsinformation",
  "jobDetailPage.coverLetter.sourceSkills": "Kompetenser",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {En del} other {# delar}} av brevet var inte kopplade till något specifikt i din profil — kontrollera att {count, plural, one {den stämmer} other {de stämmer}}.",
  "jobDetailPage.description": "Jobbeskrivning",
  "jobDetailPage.estimatedExpiry": "Beräknat utgångsdatum",
  "jobDetailPage.estimatedNetSalary.explanation": "Beräknad nettoinkomst för {year} efter finsk inkomstskatt samt pensions- och arbetslöshetsförsäkringsavgifter. Förutsätter den nationella genomsnittliga kommunalskatten ({rate}%), ingen kyrkoskatt och endast standardavdrag – din faktiska nettolön beror på din kommun, kyrkmedlemskap, ålder och familjesituation.",
  "jobDetailPage.expandCompanyData": "Expandera företagsinformation för att se trender, fördelningar och karta",
  "jobDetailPage.expandCompensation": "Expandera ersättningsdetaljer",
  "jobDetailPage.experience": "Erfarenhet",
  "jobDetailPage.expired.backToSearch": "Tillbaka till sökresultaten",
  "jobDetailPage.expired.banner": "Denna annons kan vara för gammal eller inte längre aktiv. {link}",
  "jobDetailPage.headcount": "Antal anställda",
  "jobDetailPage.hideCharts": "Dölj diagram",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.hiringSnapshotSeo.caption": "Aktuella lediga tjänster på {company} via JobCrawls",
  "jobDetailPage.hiringSnapshotSeo.location": "Plats",
  "jobDetailPage.jobType": "Anställningsform",
  "jobDetailPage.languageNavigation": "Tillgängliga språk",
  "jobDetailPage.languageRequirements": "Språkkrav",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {idag} one {#d sedan} other {#d sedan}}",
  "jobDetailPage.lastSeenDetail": "Senast sedd vid skanning: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Annons",
  "jobDetailPage.loadingMap": "Laddar karta...",
  "jobDetailPage.location": "Plats",
  "jobDetailPage.locationAndRemotenessDistribution": "Fördelning av plats & distansarbete",
  "jobDetailPage.locationDistribution": "Platsfördelning",
  "jobDetailPage.mapError": "Kunde inte ladda kartan",
  "jobDetailPage.matchBreakdown.collapse": "Dölj matchningsöversikt",
  "jobDetailPage.matchBreakdown.expand": "Expandera matchningsöversikt",
  "jobDetailPage.matchBreakdown.title": "Så här matchar det här jobbet din profil",
  "jobDetailPage.minimumYearsOfExperience": "{years} {years, plural, one {år} other {år}}",
  "jobDetailPage.noItems": "Inga objekt att visa.",
  "jobDetailPage.noLocation": "Ingen plats",
  "jobDetailPage.noRemoteness": "Ej angivet",
  "jobDetailPage.officialRegisterName": "Registrerat namn",
  "jobDetailPage.peopleManagementTier": "Ledningsnivå",
  "jobDetailPage.period.day": "dag",
  "jobDetailPage.period.hour": "timme",
  "jobDetailPage.period.month": "månad",
  "jobDetailPage.period.year": "år",
  "jobDetailPage.perks": "Förmåner",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Publicerad idag} one {Publicerad för 1 dag sedan} other {Publicerad för # dagar sedan}}",
  "jobDetailPage.recruitmentProcess": "Rekryteringsprocess",
  "jobDetailPage.remoteness": "Arbetsform",
  "jobDetailPage.remotenessDistribution": "Fördelning av arbetsform",
  "jobDetailPage.remotenessDistribution.short": "Arbetsform",
  "jobDetailPage.requiredLanguages": "Krav på språkkunskaper",
  "jobDetailPage.requirements": "Krav",
  "jobDetailPage.responsibilities": "Ansvarsområden",
  "jobDetailPage.roleAndRoleLevelDistribution": "Fördelning av roll & rollnivå",
  "jobDetailPage.roleDistribution": "Rollfördelning",
  "jobDetailPage.roleLevel": "Rollnivå",
  "jobDetailPage.roleLevelDistribution": "Fördelning av rollnivåer",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Aktuell fördelning av rollnivåer på {company} via JobCrawls",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Rollnivå",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Aktiva annonser",
  "jobDetailPage.roleSnapshotSeo.caption": "Aktuell rollfördelning på {company} via JobCrawls",
  "jobDetailPage.roleSnapshotSeo.role": "Rolltyp",
  "jobDetailPage.salaryProvenance.employerQuote": "Löneintervallet är hämtat från formuleringen i jobbannonsen.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "Detta löneintervall finns i vår data men visas inte som ett tydligt citat i annonsen – betrakta det som obekräftat.",
  "jobDetailPage.salarySourceBadge.estimated": "Uppskattad",
  "jobDetailPage.salarySourceBadge.fromListing": "Angiven",
  "jobDetailPage.salarySourceBadge.unverified": "Obekräftad",
  "jobDetailPage.salaryStatistics": "Lönestatistik",
  "jobDetailPage.section.company": "Företagsinformation",
  "jobDetailPage.section.jobDetails": "Jobbdetaljer",
  "jobDetailPage.seeLocation": "Visa plats",
  "jobDetailPage.seeOriginal": "Visa original",
  "jobDetailPage.showCharts": "Visa diagram",
  "jobDetailPage.showCompanyContact": "Visa företagskontakt",
  "jobDetailPage.showContact": "Visa kontakt-e-post",
  "jobDetailPage.showConverted": "Visa EUR/månad",
  "jobDetailPage.showingItemsAboveThreshold": "Visar endast objekt över {percentage}%",
  "jobDetailPage.skillsAndTechnologies": "Kompetenser & tekniker",
  "jobDetailPage.specialisations": "Specialiseringar",
  "jobDetailPage.tailorCv.disclaimer": "Endast din befintliga erfarenhet har omformulerats och ordnats om för att lyfta fram det som är relevant för det här jobbet – inget har hittats på. Granska det nedan innan du laddar ner.",
  "jobDetailPage.tailorCv.download": "Ladda ner anpassat CV",
  "jobDetailPage.tailorCv.emptyProfile": "Fyll i din profil först – vi behöver din arbetserfarenhet eller dina kompetenser för att kunna anpassa ett CV.",
  "jobDetailPage.tailorCv.failed": "Kunde inte anpassa ditt CV. Försök igen senare.",
  "jobDetailPage.tailorCv.goToProfile": "Gå till din profil",
  "jobDetailPage.tailorCv.loading": "Omformulerar din befintliga erfarenhet för det här jobbet…",
  "jobDetailPage.tailorCv.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "jobDetailPage.tailorCv.notConfigured": "CV-anpassning är inte aktiverat för den här miljön.",
  "jobDetailPage.tailorCv.quotaExceeded": "Du har nått dagens anpassningsgräns — den återställs i morgon.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Personligt brev",
  "jobDetailPage.tailorCv.title": "Anpassa mitt CV för det här jobbet",
  "jobDetailPage.tailorCvCta": "Anpassa mitt CV för det här jobbet",
  "jobDetailPage.tradeRegisterWebsite": "Handelsregistrets webbplats",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> är Finlands officiella portal för offentliga arbetsförmedlingstjänster, som drivs av närings- och sysselsättningsministeriet (TEM). Den listar lediga jobb från hela den finländska offentliga sektorn, kommuner och arbetsgivare som använder regeringens rekryteringsinfrastruktur.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Källa: <link>Job Market Finlands kundinformationssystem</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "Vi inkluderar annonser från Työmarkkinatori så att JobCrawls täcker hela bredden av den finländska arbetsmarknaden – inklusive roller som endast visas via officiella statliga kanaler och som annars skulle missas.",
  "jobDetailPage.vacationWeeks": "Semester: {weeks} veckor",
  "jobDetailPage.viewBenefits": "Visa förmåner",
  "jobDetailPage.visa": "Visum",
  "jobDetailPage.visaSponsor": "✓ Sponsring tillgänglig",
  "jobDetailPage.watchCompanyVideo": "Se företagsvideo",
  "jobDetailPageV2.aboutRole": "Om rollen",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Bläddra bland alla finska kollektivavtal",
  "jobDetailPageV2.collectiveAgreement.explicit": "Arbetsgivaren anger att denna tjänst följer kollektivavtalet {agreementName}.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Bästa gissning: kollektivavtalet {agreementName} — utlett från arbetsgivarens bransch och rollen, det kan vara ett annat.",
  "jobDetailPageV2.daysAgo": "{days, plural, one {för # dag sedan} other {för # dagar sedan}}",
  "jobDetailPageV2.deadline": "Sista ansökningsdag {date}",
  "jobDetailPageV2.estimatedExpiry": "Beräknat utgångsdatum {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {års} other {års}} erfarenhet",
  "jobDetailPageV2.financialOverview": "Ekonomisk översikt",
  "jobDetailPageV2.lastSeen": "Senast sedd {date}",
  "jobDetailPageV2.location": "Plats",
  "jobDetailPageV2.location.collapse": "Dölj platskarta",
  "jobDetailPageV2.location.expand": "Expandera platskarta",
  "jobDetailPageV2.mostHiredRoles": "Vanligaste rollerna",
  "jobDetailPageV2.openRoles": "{count} lediga tjänster",
  "jobDetailPageV2.otherLocations": "+{count} andra platser",
  "jobDetailPageV2.postedOn": "Publicerad {date}",
  "jobDetailPageV2.profit": "Vinst",
  "jobDetailPageV2.profitMargin": "Vinstmarginal",
  "jobDetailPageV2.revenue": "Intäkter",
  "jobDetailPageV2.roleLevelMix": "Fördelning av senioritetsnivåer",
  "jobDetailPageV2.salaryCompares": "Hur denna lön står sig i jämförelse",
  "jobDetailPageV2.salaryCompares.collapse": "Dölj lönejämförelse",
  "jobDetailPageV2.salaryCompares.expand": "Expandera lönejämförelse",
  "jobDetailPageV2.tldr": "I korthet",
  "jobDetailPageV2.topLocations": "Topporter:",
  "jobDetailPageV2.viewCompany": "Visa företag",
  "layoutErrorFallback.body": "Vänligen försök ladda om sidan. Om problemet kvarstår har vi blivit meddelade.",
  "layoutErrorFallback.home": "Gå till startsidan",
  "layoutErrorFallback.reload": "Ladda om sidan",
  "layoutErrorFallback.title": "Något gick fel",
  "locationHub.activeJobs": "Jobb",
  "locationHub.avgSalary": "Lön",
  "locationHub.hero.description": "Utforska stora finska städer med aktuellt antal lediga jobb, löneinsikter och marknadsdata. Hitta din nästa möjlighet i Finlands blomstrande tech-ekosystem.",
  "locationHub.hero.subtitle": "Kurerade stadsguider och jobbsökningar över hela Finland",
  "locationHub.hero.title": "Arbetsmarknaden i Finland",
  "locationHub.hero.title.breadcrumb": "Utforska jobb efter plats",
  "locationHub.languages": "Språk",
  "locationHub.metropolitan.seo": "Helsingforsregionen, inklusive Espoo och Vanda, är Finlands främsta ekonomiska motor och erbjuder den högsta tätheten av engelskspråkiga och distansbaserade roller med utmärkta transportförbindelser (HSL).",
  "locationHub.overview.description": "Utforska Finlands ledande teknik- och innovationscenter med arbetsmarknadsdata i realtid, löneinsikter och branschtrender.",
  "locationHub.overview.title": "Större tekniknav",
  "locationHub.popularRoles.heading": "Populära yrken",
  "locationHub.quickJump.overview": "Översikt",
  "locationHub.resourcesLink": "Utforska arbetsmarknadsinsikter och karriärtips",
  "locationHub.structuredData.collectionPage.description": "Upptäck jobbmöjligheter i stora finska städer med löneinsikter och marknadsdata",
  "locationHub.structuredData.itemList.description": "Utforska jobbmöjligheter i stora städer över hela Finland",
  "locationHub.structuredData.itemList.name": "Jobbplatser i Finland",
  "locationHub.table.activeJobs": "Aktiva jobb",
  "locationHub.table.avgSalary": "Genomsnittslön",
  "locationHub.table.city": "Stad",
  "locationHub.table.specialty": "Specialisering",
  "locationHub.workModel": "Arbetsmodell",
  "map.cappedResultsNotice": "Visar {shown} av {total} — zooma in för att begränsa sökningen",
  "map.densityZoomPrompt": "Zooma in för att se enskilda jobb och företagslogotyper",
  "map.densityZoomPrompt.button": "Zooma in",
  "map.jobs": "jobb",
  "map.jobsInView": "Jobb i vyn",
  "map.loading": "Laddar karta...",
  "map.noJobs": "Inga jobb i det här området",
  "map.noJobsInView": "Inga jobb i det här området",
  "map.noLocationsForPins": "Inga platskoordinater för kartnålar i den här vyn.",
  "map.resetView": "Återställ kartan för att visa hela Finland",
  "map.tokenMissing": "Kartvyn kräver en Mapbox-åtkomsttoken",
  "marketHeader.language.english": "Engelska",
  "marketHeader.language.finlandComparison": "Finland: {finlandEnglish}% engelska",
  "marketHeader.language.label": "Språkefterfrågan",
  "marketHeader.language.mixed": "Blandat",
  "marketHeader.languageSeo.caption": "Språkefterfrågan i {location}",
  "marketHeader.languageSeo.language": "Språkkategori",
  "marketHeader.languageSeo.share": "Andel annonser",
  "marketHeader.nearbyMarkets": "Närliggande områden",
  "marketHeader.qa.languageQuestion": "Vilka språk krävs i {location}?",
  "marketHeader.qa.remoteAnswer": "Ja, {answer}",
  "marketHeader.qa.remoteQuestion": "Är {location} anpassat för distansarbete?",
  "marketHeader.qa.salaryQuestion": "Vad är genomsnittslönen i {location}?",
  "marketHeader.rail.marketDetails": "Marknadsinformation",
  "marketHeader.rail.samplesUpdatedDaily": "{count} lediga jobb · uppdateras dagligen",
  "marketHeader.removeLocation": "Ta bort plats",
  "marketHeader.salary.finlandComparison": "Finland snitt: {finlandAvg}",
  "marketHeader.salary.label": "Lönetrender",
  "marketHeader.salary.range": "Löneintervall",
  "marketHeader.salary.rangePercentile": "Intervall för 25:e till 75:e percentilen",
  "marketHeader.salaryPercentileSeo.caption": "Annonserad lönefördelning i {location}, Finland — heltidsroller",
  "marketHeader.salaryPercentileSeo.p25": "25:e percentilen",
  "marketHeader.salaryPercentileSeo.p50": "Median (50:e percentilen)",
  "marketHeader.salaryPercentileSeo.p75": "75:e percentilen",
  "marketHeader.salaryPercentileSeo.percentile": "Percentil",
  "marketHeader.salaryPercentileSeo.salary": "Månadslön (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Baserat på {count} platsannonser med uttrycklig löneinformation i {location}, Finland.",
  "marketHeader.title": "Lediga jobb i {location}",
  "marketHeader.toggle": "Växla marknadshuvud",
  "marketHeader.updated": "Uppdaterad:",
  "marketHeader.workModel.finlandComparison": "Finland: {finlandRemote}% distans/hybrid",
  "marketHeader.workModel.label": "Arbetsmodell",
  "marketHeader.workModel.noData": "Flexibel",
  "marketHeader.workModelSeo.caption": "Fördelning av arbetsmodeller i {location}",
  "marketHeader.workModelSeo.model": "Arbetsmodell",
  "marketHeader.workModelSeo.share": "Andel annonser",
  "marketingConsent.checkbox.label": "Skicka även e-post om arbetsmarknaden och tips från JobCrawls till mig (valfritt, avregistrera dig när som helst).",
  "matchDonut.ariaLabel": "Matchningspoäng: {score}%",
  "matchDonut.breakdown.benefits": "Förmåner",
  "matchDonut.breakdown.languages": "Språk",
  "matchDonut.breakdown.remoteness": "Distansarbete",
  "matchDonut.breakdown.salary": "Lön",
  "matchDonut.breakdown.title": "Specifikation av matchningspoäng",
  "matchDonut.breakdown.vacation": "Semester",
  "matchDonut.loginPrompt.createAccount": "Skapa konto",
  "matchDonut.loginPrompt.description": "Skapa en profil och lägg till detaljer om ditt nuvarande jobb för att se hur väl jobb matchar dina preferenser",
  "matchDonut.loginPrompt.title": "Logga in för att se din matchningspoäng",
  "matchDonut.loginPromptAria": "Logga in för att se din matchningspoäng",
  "matchDonut.profilePrompt.description": "Lägg till detaljer om ditt nuvarande jobb och dina preferenser i din profil för att se hur väl jobben matchar.",
  "matchDonut.profilePrompt.goToProfile": "Gå till profil",
  "matchDonut.profilePrompt.title": "Komplettera din profil för att se din matchningspoäng",
  "matchDonut.profilePromptAria": "Komplettera din profil för att se din matchningspoäng",
  "matchDonut.searchBreakdown.employer": "Arbetsgivare & bransch",
  "matchDonut.searchBreakdown.keywords": "Sökord",
  "matchDonut.searchBreakdown.location": "Plats",
  "matchDonut.searchBreakdown.remoteness": "Distansarbete",
  "matchDonut.searchBreakdown.roleFit": "Roll & område",
  "matchDonut.searchInference.bullet.company": "Du har visat intresse för arbetsgivare som {company} – det räknar vi in i poängen.",
  "matchDonut.searchInference.bullet.keywords": "Dina sökningar innehöll termer som \"{terms}\" – vi har jämfört dem med det här jobbets titel och roll.",
  "matchDonut.searchInference.bullet.locations": "Du har sökt i områden som {locations} – platsen för den här annonsen jämförs med detta.",
  "matchDonut.searchInference.bullet.remoteness": "Du använder ofta filter för distansarbete ({values}) – det här jobbet poängsätts utifrån dessa preferenser.",
  "matchDonut.searchInference.bullet.roles": "Dina sökningar innehåller rollfilter som {hints} – liknande signaler jämförs med det här jobbet.",
  "matchDonut.searchInference.intro": "Vi har inte din profil än, så den här poängen uppskattar matchningen med hjälp av filter och sökord från sökningar du gjort på JobCrawls (senaste aktiviteten väger tyngre).",
  "matchDonut.searchInference.title": "Matchning baserat på dina senaste sökningar",
  "modal.close": "Stäng",
  "navigation.home": "Hem",
  "navigation.home.breadcrumb": "Hem",
  "navigation.language": "Språk",
  "navigation.language.label": "Språk",
  "navigation.locations": "Platser",
  "navigation.locations.menu": "Platser",
  "navigation.menu": "Meny",
  "navigation.menu.heading": "Meny",
  "navigation.menu.open": "Öppna meny",
  "navigation.search": "Sök jobb",
  "navigation.search.menu": "Hitta jobb",
  "navigation.search.reset": "Återställ sökning",
  "notes.field.add": "Lägg till anteckning",
  "notes.field.placeholder": "Lägg till en privat anteckning…",
  "numberSelector.any": "Vilken som helst",
  "pagination.ariaLabel": "Sidnumrering för sökresultat av jobb",
  "pagination.first": "Första",
  "pagination.keyboardShortcuts": "Kortkommandon",
  "pagination.last": "Sista",
  "pagination.next": "Nästa",
  "pagination.previous": "Föregående",
  "profile.aiApply": "Använd",
  "profile.aiLoading": "Tänker…",
  "profile.aiSuggest": "Föreslå med AI",
  "profile.aiSuggestionsDisclaimer": "Det här är AI-genererade utgångspunkter baserade enbart på dina jobbtitlar och examina — inte verifierade fakta om dig. Läs igenom varje förslag och redigera det så att det stämmer innan du använder det.",
  "profile.aiSuggestionsEmpty": "Din profil ser komplett ut. Lägg till mer erfarenhet eller lämna några fält tomma och försök igen.",
  "profile.aiSuggestionsTitle": "AI-förslag",
  "profile.applicationKits.link": "Ansökningskit",
  "profile.benefits.label": "Nuvarande förmåner (för matchning)",
  "profile.benefitsWeight": "Viktning av förmåner: {weight}%",
  "profile.closePreview": "Stäng förhandsgranskning",
  "profile.closeSuggestions": "Stäng",
  "profile.completion.allDone": "Din profil är redo att generera fantastiska CV:n.",
  "profile.completion.fix": "Åtgärda",
  "profile.completion.itemBasic": "Lägg till din titel eller senaste roll",
  "profile.completion.itemCurrentRole": "Lägg till detaljer om din nuvarande roll (för matchning)",
  "profile.completion.itemEducation": "Lägg till din utbildning",
  "profile.completion.itemExperience": "Lägg till din arbetserfarenhet",
  "profile.completion.itemSkills": "Lägg till minst 3 kompetenser",
  "profile.completion.label": "profilen är klar",
  "profile.currentJob.label": "Nuvarande roll (för matchning)",
  "profile.currentSalary.label": "Nuvarande månadslön (för matchning)",
  "profile.currentSalary.placeholder": "t.ex. 3500",
  "profile.currentSalary.privacyShort": "Privat. Används endast för din matchningspoäng.",
  "profile.currentSalary.unit": "€/mån",
  "profile.currentSalary.workPercent": "arbetstid %",
  "profile.currentWorkModel.label": "Nuvarande arbetsmodell (för matchning)",
  "profile.cvDownloadFailed": "Kunde inte ladda ner ditt CV. Försök igen.",
  "profile.cvImport.notConfigured": "CV-import är inte aktiverat för denna miljö.",
  "profile.cvUploadError": "Vänligen ladda upp en PDF-fil",
  "profile.cvUploadFailed": "Kunde inte ladda upp CV. Försök igen.",
  "profile.cvUploadSizeError": "Filstorleken måste vara mindre än 5 MB",
  "profile.cvUploading": "Importerar…",
  "profile.desiredBenefits": "Önskade förmåner",
  "profile.desiredIndustries": "Branscher",
  "profile.desiredJob": "Vad du letar efter",
  "profile.desiredJobDescription": "Berätta vad du letar efter. Dessa preferenser prioriteras framför din nuvarande roll när vi beräknar hur väl ett jobb matchar dig.",
  "profile.desiredJobTypes": "Anställningsformer",
  "profile.desiredLocations": "Platser",
  "profile.desiredRemoteness": "Alternativ för distansarbete",
  "profile.desiredRoleLevels": "Nivåer",
  "profile.desiredSalaryMin": "Lägsta månadslön",
  "profile.desiredTitles": "Jobbtitlar",
  "profile.desiredVacationWeeks": "Minsta antal semesterveckor",
  "profile.downloadCV": "Ladda ner mitt CV",
  "profile.europass.additionalInfo": "Ytterligare information",
  "profile.europass.basedOn": "Baserat på Europass CV-struktur (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Utbildning och kurser",
  "profile.europass.noEducation": "Ingen utbildning tillagd.",
  "profile.europass.noSkills": "Inga färdigheter tillagda.",
  "profile.europass.noWorkExperience": "Ingen arbetslivserfarenhet tillagd.",
  "profile.europass.personalSkills": "Personliga färdigheter",
  "profile.europass.workExperience": "Arbetslivserfarenhet",
  "profile.exportCV": "Exportera CV",
  "profile.jobType": "Anställningsform",
  "profile.jobTypeWeight": "Viktning av anställningsform: {weight}%",
  "profile.languageSwitcher.hint": "Import, uppladdning och AI-förslag fylls i i den språkflik som är vald. Varje version är oberoende – inget översätts automatiskt.",
  "profile.languages.label": "Språk (professionell nivå)",
  "profile.languagesWeight": "Viktning av språk: {weight}%",
  "profile.linkedInImport.button": "Importera från LinkedIn",
  "profile.linkedInImport.failed": "Kunde inte importera profilen. Försök igen senare.",
  "profile.linkedInImport.hint": "Klistra in din publika profil-URL (linkedin.com/in/…) och importera. Uppgifterna hämtas via Proxycurl (tredje part) och kanske inte innehåller allt som finns på din sida. De fyller i formuläret nedan, inte din sparade profil — läs igenom och rätta till innan du sparar.",
  "profile.linkedInImport.invalidProfileUrl": "Använd länken till din personliga profil (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Ange en giltig LinkedIn-URL.",
  "profile.linkedInImport.loading": "Importerar…",
  "profile.linkedInImport.networkError": "Nätverksfel. Kontrollera din anslutning.",
  "profile.linkedInImport.notConfigured": "LinkedIn-import är inte aktiverat för den här miljön.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/din-profil/",
  "profile.linkedInImport.sectionTitle": "LinkedIn-profil",
  "profile.loading": "Laddar...",
  "profile.locationWeight": "Platsvikt: {weight}%",
  "profile.locations": "Platser",
  "profile.matchPreferences": "Matchningsinställningar",
  "profile.matchPreferencesDescription": "Justera vikten av olika faktorer när din matchningspoäng för jobb beräknas. Summan måste vara 100 %.",
  "profile.prefillFromSearches.banner": "Vi har fyllt i några fält baserat på dina senaste jobbsökningar. Se över dem och ändra det som ser fel ut.",
  "profile.prefillFromSearches.dismiss": "Stäng",
  "profile.preview": "Förhandsgranska",
  "profile.previewEuropass": "Förhandsgranskning av CV (Europass-format)",
  "profile.profilePhoto.errorCompressedTooLarge": "Bilden är fortfarande för stor efter komprimering. Prova med en mindre originalbild.",
  "profile.profilePhoto.errorProcess": "Kunde inte behandla den här bilden. Prova med en annan fil.",
  "profile.profilePhoto.errorTooLarge": "Bilden är för stor (max 5 MB).",
  "profile.profilePhoto.errorType": "Använd en bild i formatet JPEG, PNG, WebP eller GIF.",
  "profile.profilePhoto.remove": "Ta bort uppladdad bild",
  "profile.profilePhoto.uploadAria": "Ladda upp eller ändra profilbild",
  "profile.quickActions.title": "Ditt CV",
  "profile.remotenessWeight": "Viktning av avstånd: {weight}%",
  "profile.roleLevel": "Rollnivå",
  "profile.roleLevelWeight": "Viktning av rollnivå: {weight}%",
  "profile.salaryWeight": "Viktning av lön: {weight}%",
  "profile.selectJobType": "Välj anställningsform",
  "profile.selectLocations": "Välj platser",
  "profile.selectMultipleIndustries": "Välj en eller flera branscher",
  "profile.selectMultipleJobTypes": "Välj en eller flera anställningsformer",
  "profile.selectMultipleLocations": "Välj en eller flera platser",
  "profile.selectMultipleRemoteness": "Välj ett eller flera alternativ för distansarbete",
  "profile.selectMultipleRoleLevels": "Välj en eller flera rollnivåer",
  "profile.selectMultipleTitles": "Välj en eller flera jobbtitlar",
  "profile.selectRoleLevel": "Välj din rollnivå",
  "profile.title": "Jobbtitel",
  "profile.titlePlaceholder": "t.ex. Programvarutekniker",
  "profile.titleWeight": "Titelvikt: {weight}%",
  "profile.totalWeight": "Totalt",
  "profile.uploadCV": "Ladda upp CV för att förifylla",
  "profile.uploadCV.disclaimer": "AI-extraherat från din PDF — det fyller i formuläret nedan, inte din sparade profil. Läs igenom det och rätta till innan du sparar.",
  "profile.vacationWeeks.label": "Semesterveckor per år",
  "profile.vacationWeeks.unit": "veckor/år",
  "profile.vacationWeight": "Semestervikt: {weight}%",
  "recentSearches.delete": "Ta bort",
  "recentSearches.noSearches": "Du har inte sparat några sökningar än.",
  "salary.period.day": "/dag",
  "salary.period.hour": "/tim",
  "salary.period.month": "/mån",
  "salary.period.year": "/år",
  "salaryChart.allRolesInLocation": "Alla roller i {location}",
  "salaryChart.analysisTitle": "Löneanalys",
  "salaryChart.companyLocation": "Företag i {location}",
  "salaryChart.estimatedFromMarket": "Uppskattat utifrån marknadsdata (ingen lön i annonsen)",
  "salaryChart.fromJobAd": "Från jobbannons",
  "salaryChart.fromJobAdWithLevel": "Från jobbannons ({roleLevel})",
  "salaryChart.locationAverage": "I {location}: {title}",
  "salaryChart.marketAverage": "Marknadssnitt: {title}",
  "salaryChart.marketAverageRoleLevel": "Marknadsgenomsnitt: {roleLevel}-nivå",
  "salaryChart.payInDataNotInAd": "Lön i vår data — anges ej i annonsen",
  "salaryChart.payInDataNotInAdWithLevel": "Lön i vår data — anges ej i annonsen ({roleLevel})",
  "salaryChart.popover.average": "Genomsnittligt intervall",
  "salaryChart.popover.benchmarkEstimateNote": "Ej från arbetsgivaren — modellerat utifrån benchmarks",
  "salaryChart.popover.extractedNoQuoteNote": "Numerisk lön utan tillhörande text i annonsen",
  "salaryChart.popover.fromAdText": "Baserat på löneprecisering i jobbannonsen",
  "salaryChart.popover.max": "Maximalt",
  "salaryChart.popover.median": "Medianintervall",
  "salaryChart.popover.min": "Minimalt",
  "salaryChart.popover.monthlyNote": "Alla belopp visas som EUR per månad för jämförelse i detta diagram.",
  "salaryChart.popover.p25": "25:e percentilen",
  "salaryChart.popover.p75": "75:e percentilen",
  "salaryChart.popover.p90": "90:e percentilen",
  "salaryChart.popover.sample": "Urvalsstorlek",
  "salaryChart.popover.seeFullSalaryPage": "Se hela lönesidan för {title} →",
  "salaryChart.rangeAria": "Löneintervall från {min} till {max} per månad, median nära {median}",
  "salaryChart.salaryContext": "Lönekontext: {title}",
  "salaryChart.segmentHint": "Håll muspekaren över eller tryck på en rad för fullständig statistik (EUR / månad i detta diagram).",
  "salaryChart.seoTable.caption": "Månadslönjämförelse för {title}",
  "salaryChart.seoTable.lowerBound": "Nedre gräns (25:e percentilen)",
  "salaryChart.seoTable.market": "\\n\\n---\\n\\n\n\nMarknad",
  "salaryChart.seoTable.median": "\\n\\n---\\n\\n\n\nMedian",
  "salaryChart.seoTable.upperBound": "\\n\\n---\\n\\n\n\nÖvre gräns (75:e percentilen)",
  "salaryChart.thisRole": "\\n\\n---\\n\\n\n\ndenna roll",
  "salaryChart.thisRoleLevel": "\\n\\n---\\n\\n\n\ndenna rollnivå",
  "salaryDisplayToggle.label": "Visa ursprunglig valuta",
  "salaryIndexPage.allRolesHeading": "Bläddra bland alla roller",
  "salaryIndexPage.empty": "Ingen lönedata är tillgänglig just nu — kom tillbaka snart.",
  "salaryIndexPage.eyebrow": "{count} roller spåras",
  "salaryIndexPage.heading": "Lönedata per yrke i Finland",
  "salaryIndexPage.intro": "Verklig lönedata från finländska jobbannonser, uppdelad per yrke. Välj ett yrke för att se medianlön, intervall och jämförelser mellan städer.",
  "salaryIndexPage.postingsSuffix": "annonser",
  "salaryIndexPage.stat.postings": "analyserade annonser",
  "salaryIndexPage.stat.roles": "spårade roller",
  "salaryIndexPage.stat.topRole": "mest analyserade roll",
  "salaryIndexPage.topRolesHeading": "Mest eftertraktade roller",
  "salaryIndexPage.topRolesSub": "Rankade efter antal annonser bakom löneuppskattningen — fler annonser, mer tillförlitliga siffror.",
  "salaryInsight.above": "\\n\\n---\\n\\n\n\nLönen för denna roll, <strong>{salary}</strong>, ligger <strong>{percent}%</strong> över {benchmark}.",
  "salaryInsight.below": "\\n\\n---\\n\\n\n\nLönen för denna roll, <strong>{salary}</strong>, ligger <strong>{percent}%</strong> under {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "\\n\\n---\\n\\n\n\nmedianen för hela Finland i vår lönedata",
  "salaryInsight.benchmark.finlandWithRole": "\\n\\n---\\n\\n\n\nmedianen för hela Finland för roller som {role}",
  "salaryInsight.benchmark.locationOnly": "medianlönen i {location}",
  "salaryInsight.benchmark.locationWithRole": "medianen för {role}-roller i {location}",
  "salaryRolePage.alsoKnownAs": "Listas även som: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Lönedata",
  "salaryRolePage.cityTable.footnote": "Stapeln visar P25–P75-intervallet. Den vertikala linjen = median. Alla värden i EUR/månad.",
  "salaryRolePage.cityTable.title": "{roleTitle}: lön per stad",
  "salaryRolePage.ctaBanner": "Letar du efter {roleTitle}-jobb? {link}",
  "salaryRolePage.ctaBanner.link": "Bläddra bland lediga jobb på JobCrawls →",
  "salaryRolePage.disclaimer": "Lönedata är hämtad från publicerade jobbannonser och representerar inte nödvändigtvis den totala ersättningen. Beloppen anges i EUR/månad och kan innehålla arbetsgivarens uppskattningar när det angivna löneintervallet inte offentliggjorts.",
  "salaryRolePage.examplePostings.inactive": "(annonsen är inte längre aktiv)",
  "salaryRolePage.examplePostings.title": "Baserat på dessa annonser",
  "salaryRolePage.heading": "{roleTitle}: lön i Finland",
  "salaryRolePage.hero.perMonthNational": "/ månad, nationellt medianvärde",
  "salaryRolePage.hero.sampleEyebrow": "Baserat på {count} annonser",
  "salaryRolePage.hiringCompanies.browseAll": "Bläddra bland bästa arbetsgivare i Finland →",
  "salaryRolePage.hiringCompanies.empty": "Bläddra bland alla rankade arbetsgivare för att hitta någon som anställer för den här typen av roll.",
  "salaryRolePage.hiringCompanies.sub": "Från våra arbetsgivarrankningar — vissa kan vara värda att kontakta direkt även utan en öppen annons.",
  "salaryRolePage.hiringCompanies.title": "Företag som anställer {roleTitle}s",
  "salaryRolePage.intro": "Baserat på jobbannonser från finländska arbetsgivare. Uppdateras regelbundet.",
  "salaryRolePage.overallPanel.footnote": "EUR per månad · P25–P75-intervall med medianmarkör · baserat på {count} platsannonser",
  "salaryRolePage.overallPanel.title": "{roleTitle} — Finlands genomsnitt",
  "salaryRolePage.rangeBar.hint": "Klicka eller hovra för detaljer.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Baserat på # platsannons} other {Baserat på # platsannonser}}",
  "salaryRolePage.remotePanel.title": "{roleTitle} — distansarbete i Finland",
  "salaryRolePage.seeOpenJobs": "Se lediga {roleTitle}-jobb →",
  "salaryRolePage.stat.average": "Genomsnitt",
  "salaryRolePage.stat.middle50": "Mittersta 50 %",
  "salaryRolePage.stat.range": "Hela intervallet",
  "salaryRolePage.stat.sampleSize": "Urvalsstorlek",
  "salaryRolePage.trend.down": "▼ {percent} % jämfört med förra månaden",
  "salaryRolePage.trend.flat": "Ingen förändring jämfört med förra månaden",
  "salaryRolePage.trend.up": "▲ {percent} % jämfört med förra månaden",
  "salaryStats.aboveMarket": "Denna lön ligger över marknadens median",
  "salaryStats.accuracy.exact": "Baserat på liknande roller på detta företag",
  "salaryStats.accuracy.general": "Baserat på marknadsdata",
  "salaryStats.accuracy.location": "Baserat på löner i {location}",
  "salaryStats.atMarket": "Denna lön är konkurrenskraftig i förhållande till marknadens median",
  "salaryStats.average": "Genomsnitt",
  "salaryStats.belowMarket": "Denna lön ligger under marknadens median",
  "salaryStats.jobSalary": "Detta jobb",
  "salaryStats.marketRange": "Marknadsintervall: {min} - {max} (median: {median})",
  "salaryStats.noJobSalary": "Inget löneintervall angivet för det här jobbet. Diagrammet visar marknadsfördelningen.",
  "salaryStats.noValidValues": "Lönestatistik finns tillgänglig ({sampleSize} {samples}), men alla värden är noll. Detta kan tyda på att datan behöver genereras om.",
  "salaryStats.perDay": "per dag",
  "salaryStats.perHour": "per timme",
  "salaryStats.perMonth": "per månad",
  "salaryStats.perYear": "per år",
  "salaryStats.percentiles": "25:e-75:e percentilen",
  "salaryStats.samples": "prover",
  "salaryStats.smallSampleWarning": "Obs: Baserat på ett litet urval ({sampleSize} {samples}). Resultaten är eventuellt inte representativa.",
  "savedSearches.card.continue": "Fortsätt",
  "savedSearches.emptyHint": "Gör en sökning med sökord eller filter på jobbsidan – den kommer att visas här automatiskt. Du kan också fästa en med ”Spara sökning”.",
  "savedSearches.newMatchesBadge": "{count} nya",
  "savedSearches.openSearchAria": "Öppna sökning: {title}",
  "savedSearches.rename.action": "Namnge denna sökning",
  "savedSearches.rename.placeholder": "t.ex. Backend-jobb i Helsingfors",
  "savedSearches.rename.save": "Spara",
  "savedSearches.summary.filtered": "Filtrerad sökning",
  "savedSearches.summary.location": "Plats: {values}",
  "savedSearches.summary.page": "Sida {page}",
  "savedSearches.summary.sortDate": "Sortera: nyaste",
  "savedSearches.summary.sortSalary": "Sortera: lön",
  "savedSearches.summary.worldwide": "Alla länder",
  "search.activityStrip.cta": "Hantera ansökningar",
  "search.activityStrip.teaser": "Bläddra, spara och sök jobb för att se din tratt här.",
  "search.activityStrip.title": "Din aktivitet i jobbsökningen",
  "search.bestCompaniesStrip.hubCta": "Bästa arbetsgivarna för roller i Finland →",
  "search.bestCompaniesStrip.label": "Topparbetsgivare",
  "search.controls.navigation": "Sökinställningar och filter",
  "search.jobCount": "{count, number} jobb",
  "search.noResults": "Inga jobb hittades.",
  "search.noresults.browseAll": "Bläddra bland alla jobb",
  "search.noresults.clearAllParameters": "Rensa alla sökparametrar",
  "search.noresults.clearSearch": "Rensa sökning",
  "search.noresults.description": "Prova att justera din sökning eller dina filter för att hitta fler möjligheter.",
  "search.noresults.filtersLabel": "Filter:",
  "search.noresults.goToFirstPage": "Gå till sida 1",
  "search.noresults.industries": "Branscher",
  "search.noresults.jobRoles": "Jobbroller",
  "search.noresults.locations": "Platser",
  "search.noresults.pageLabel": "Sida:",
  "search.noresults.popularCategories": "Populära kategorier",
  "search.noresults.queryLabel": "Sökord:",
  "search.noresults.removeQuery": "Ta bort",
  "search.noresults.searchParameters": "Dina sökparametrar",
  "search.noresults.searchTips": "Söktips",
  "search.noresults.tip1": "Prova att använda bredare söktermer eller ta bort några filter",
  "search.noresults.tip2": "Kontrollera stavningen eller prova alternativa sökord",
  "search.noresults.tip3": "Bläddra bland populära kategorier ovan för att upptäcka nya möjligheter",
  "search.noresults.title": "Inga resultat hittades",
  "search.noresults.trySearches": "Prova dessa sökningar:",
  "search.refinements.allFilters": "Alla filter",
  "search.refinements.allFilters.aria": "Alla filter",
  "search.refinements.benefits": "Förmåner",
  "search.refinements.benefits.label": "Förmåner",
  "search.refinements.benefits.modal": "Förmåner",
  "search.refinements.company": "Företag",
  "search.refinements.company.heading": "Företag",
  "search.refinements.company.label": "Företag",
  "search.refinements.company.modal": "Företag",
  "search.refinements.company.openProfileAria": "Öppna företagsprofil för {company}{count, plural, =0 {} other { — {count} lediga tjänster på JobCrawls}}",
  "search.refinements.company.searchPlaceholder": "Sök företag...",
  "search.refinements.company.section": "Företag",
  "search.refinements.dialog.label": "Sökfilter",
  "search.refinements.educationLevel.detail": "Utbildningsnivå",
  "search.refinements.educationLevel.heading": "Utbildningsnivå",
  "search.refinements.educationLevel.label": "Utbildningsnivå",
  "search.refinements.educationLevel.modal": "Utbildningsnivå",
  "search.refinements.excludeApplied.checkbox": "Exkludera ansökta jobb",
  "search.refinements.excludeApplied.label": "Exkludera sökta jobb",
  "search.refinements.excludeConsultingCompany.filter": "Exkludera konsultföretags jobb",
  "search.refinements.excludeConsultingCompany.toggle": "Exkludera konsultföretags jobb",
  "search.refinements.excludeJobs": "Exkludera jobb",
  "search.refinements.excludeRecruitmentCompany.filter": "Exkludera rekryteringsbyråers jobb",
  "search.refinements.excludeRecruitmentCompany.toggle": "Exkludera rekryteringsbyråers jobb",
  "search.refinements.excludeSaved.checkbox": "Exkludera sparade jobb",
  "search.refinements.excludeSaved.label": "Exkludera sparade jobb",
  "search.refinements.excludeViewed.checkbox": "Exkludera visade jobb",
  "search.refinements.excludeViewed.label": "Exkludera visade jobb",
  "search.refinements.field": "Område",
  "search.refinements.field.label": "Område",
  "search.refinements.field.modal": "Område",
  "search.refinements.headcount": "Antal anställda (max)",
  "search.refinements.headcount.max": "Max antal anställda",
  "search.refinements.industry": "Bransch",
  "search.refinements.industry.heading": "Bransch",
  "search.refinements.industry.label": "Bransch",
  "search.refinements.industry.modal": "Bransch",
  "search.refinements.isDriversLicenseRequired.filter": "Körkort krävs",
  "search.refinements.isDriversLicenseRequired.toggle": "Körkort krävs",
  "search.refinements.isOpenApplication.filter": "Öppen ansökan",
  "search.refinements.isOpenApplication.toggle": "Öppen ansökan",
  "search.refinements.job": "Jobb",
  "search.refinements.job.modal": "Jobfilter",
  "search.refinements.job.section": "Jobb",
  "search.refinements.jobTitle": "Jobbtitel",
  "search.refinements.jobType": "Anställningsform",
  "search.refinements.jobType.label": "Anställningsform",
  "search.refinements.jobType.modal": "Anställningsform",
  "search.refinements.languages": "Språk",
  "search.refinements.languages.label": "Språk",
  "search.refinements.languages.modal": "Språk",
  "search.refinements.lastSeen.aria": "Publiceringsdatum",
  "search.refinements.location": "Plats",
  "search.refinements.location.modal": "Plats",
  "search.refinements.location.remote": "Distans",
  "search.refinements.location.searchPlaceholder": "Sök platser...",
  "search.refinements.location.section": "Plats",
  "search.refinements.peopleManagementTier": "Ledningsnivå",
  "search.refinements.peopleManagementTier.label": "Ledningsnivå",
  "search.refinements.peopleManagementTier.modal": "Ledningsnivå",
  "search.refinements.remoteness.heading": "Arbetsform",
  "search.refinements.remoteness.label": "Arbetsform",
  "search.refinements.remoteness.modal": "Arbetsform",
  "search.refinements.roleLevel": "Rollnivå",
  "search.refinements.roleLevel.label": "Rollnivå",
  "search.refinements.roleLevel.modal": "Rollnivå",
  "search.refinements.salary": "Lön",
  "search.refinements.salary.heading": "Lön",
  "search.refinements.salary.label": "Lön",
  "search.refinements.salary.min": "Minsta lön",
  "search.refinements.salary.modal": "Lön",
  "search.refinements.salary.section": "Lön",
  "search.refinements.search.placeholder": "Sök...",
  "search.refinements.showJobsInFinlandOnly": "Visa endast jobb i Finland",
  "search.refinements.showLess": "Visa färre",
  "search.refinements.showMore": "Visa fler",
  "search.refinements.skillsAndTechnologies": "Kompetenser & tekniker",
  "search.refinements.skillsAndTechnologies.label": "Kompetenser & tekniker",
  "search.refinements.skillsAndTechnologies.modal": "Kompetenser & tekniker",
  "search.refinements.vacationWeeks": "Semesterveckor",
  "search.refinements.vacationWeeks.heading": "Semesterveckor",
  "search.refinements.vacationWeeks.label": "Semesterveckor",
  "search.refinements.vacationWeeks.modal": "Semesterveckor",
  "search.results.title": "Sökresultat för jobb",
  "search.signInCta.benefit1": "Spara jobb och granska dem senare",
  "search.signInCta.benefit2": "Följ alla dina ansökningar på en tavla",
  "search.signInCta.benefit3": "Få en avisering så snart ett nytt jobb matchar",
  "search.signInCta.button": "Skapa ett gratis konto",
  "search.signInCta.secondaryText": "Har du redan ett konto? Logga in",
  "search.signInCta.title": "Håll koll på ditt jobbsök",
  "search.topRolesStrip.hubCta": "Lönedata för roller i Finland →",
  "search.topRolesStrip.label": "Eftertraktade roller",
  "sort.ariaLabel": "Sortera resultat",
  "sort.newest": "Nyaste",
  "sort.relevance": "Relevans",
  "sort.salary": "Lön",
  "srpAlertCta.bannerText": "Vill du få veta när liknande jobb dyker upp?",
  "srpAlertCta.continueButton": "Fortsätt med e-post",
  "srpAlertCta.ctaButton": "Få e-postaviseringar",
  "srpAlertCta.dismissLabel": "Stäng",
  "srpAlertCta.errorText": "Något gick fel — vi kunde inte aktivera aviseringar. Försök igen.",
  "srpAlertCta.manageLink": "Hantera aviseringar",
  "srpAlertCta.pendingText": "Nästan klart — kontrollera din inkorg och bekräfta din e-postadress för att aktivera aviseringar.",
  "srpAlertCta.successText": "Klart – vi skickar e-post till dig om liknande jobb.",
  "srpAlertCta.unauthConsentCopy": "Vi skickar ett e-postmeddelande när nya jobb som matchar den här sökningen dyker upp. Skapa ett gratis konto för att aktivera detta – inga andra mejl om du inte vill ha det.",
  "stats.appliedJobs": "{count} sökta jobb",
  "stats.finlandJobsSubtitle": "Jobb på finska eller på distans för personer bosatta i Finland",
  "stats.newThisWeekInline": "· {count, number} nya denna vecka",
  "stats.savedJobs": "{count} sparade jobb",
  "stats.viewedJobs": "{count} visade jobb",
  "tags.field.addTrigger": "Lägg till tagg",
  "tags.field.placeholder": "Skriv tagg och tryck Enter…",
  "tags.field.remove": "Ta bort taggen {tag}",
  "tools.applicationKits.cvBadge": "CV klart",
  "tools.applicationKits.deleteKit": "Ta bort",
  "tools.applicationKits.downloadCv": "Ladda ner CV",
  "tools.applicationKits.downloadLetter": "Ladda ner brev",
  "tools.applicationKits.emptyBody": "Anpassa ett CV eller skriv ett personligt brev från vilken jobbsida som helst — det sparas här automatiskt.",
  "tools.applicationKits.emptyTitle": "Inga ansökningspaket än",
  "tools.applicationKits.kitReadyBadge": "Ansökningspaket klart",
  "tools.applicationKits.lead": "Dina anpassade CV:n och personliga brev, sparade per jobb — öppna igen, granska eller ladda ner när som helst.",
  "tools.applicationKits.letterBadge": "Brev klart",
  "tools.applicationKits.openJob": "Öppna jobbsidan",
  "tools.applicationKits.title": "Ansökningspaket",
  "tools.applicationKits.updatedOn": "Uppdaterad {date}",
  "tools.applicationState.applied": "Ansökt",
  "tools.applicationState.hidden": "Dold",
  "tools.applicationState.label": "Status:",
  "tools.applicationState.updated": "Status uppdaterad till {state}",
  "tools.empty.browseJobs": "Bläddra bland jobb →",
  "tools.externalApplication.add": "Lägg till som ansökt",
  "tools.externalApplication.adding": "Lägger till…",
  "tools.externalApplication.closeModal": "Stäng",
  "tools.externalApplication.error.disallowedScheme": "Endast http- och https-länkar är tillåtna.",
  "tools.externalApplication.error.empty": "Ange en länk till jobb- eller ansökningssidan.",
  "tools.externalApplication.error.invalid": "Det där ser inte ut som en giltig URL.",
  "tools.externalApplication.error.syncFailed": "Kunde inte spara. Kontrollera din anslutning eller försök logga in.",
  "tools.externalApplication.error.tooLong": "Den länken är för lång.",
  "tools.externalApplication.lead": "Klistra in en länk till ett jobb du har ansökt till på en annan sida. Den visas tillsammans med dina andra ansökningar på den här sidan.",
  "tools.externalApplication.title": "Håll koll på en ansökan på annan sida",
  "tools.externalApplication.titleLabel": "Titel (valfritt)",
  "tools.externalApplication.urlLabel": "Jobblänk",
  "tools.history.emptyHidden": "Du har inte dolt några jobb.",
  "tools.history.emptyViewed": "Du har inte visat några jobb ännu.",
  "tools.history.hiddenTab": "Dolda ({count})",
  "tools.history.resetViewed": "Återställ visade jobb",
  "tools.history.viewedTab": "Visade ({count})",
  "tools.historySummary.counts": "Visade {viewedCount} · Dolda {hiddenCount}",
  "tools.historySummary.heading": "Historik",
  "tools.historySummary.openDrawer": "Visa",
  "tools.jobFlowSankey.activityChartHeading": "Aktivitet",
  "tools.jobFlowSankey.applied": "Ansökt",
  "tools.jobFlowSankey.browsed": "Tittat på",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% nådde intervju · {offerRate}% fick ett erbjudande",
  "tools.jobFlowSankey.emptyState": "Inte tillräckligt med data för att visa din aktivitet än. Titta på, spara eller sök jobb för att se din resa visualiserad!",
  "tools.jobFlowSankey.hideActivityChart": "Dölj aktivitetsdiagram",
  "tools.jobFlowSankey.hired": "Anställd",
  "tools.jobFlowSankey.interviewing": "Intervjuar",
  "tools.jobFlowSankey.offer": "Erbjudande",
  "tools.jobFlowSankey.rejected": "Avslag",
  "tools.jobFlowSankey.saved": "Sparade",
  "tools.jobFlowSankey.showActivityChart": "Visa aktivitetsdiagram",
  "tools.jobFlowSankey.summary": "Tittat på {browsed} → Visade {viewed} → Sparade {saved} → Ansökt {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "Du har ansökt om eller spårat dessa som inskickade ansökningar.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Roller som du öppnat via sökningen – början av din tratt.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Markerad som anställd – ett fantastiskt resultat.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "För närvarande i intervjuprocessen.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Erbjudandestadiet – dags för förhandling eller beslut.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Markerad som stängd eller går inte vidare.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Sparad till senare – enkelt att komma tillbaka till och ansöka.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "Du har öppnat dessa annonser men har inte sparat dem än.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# jobb} other {# jobb}} på denna väg",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct}% av flödet som lämnar {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct}% av flödet in till {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} direkt från sök utan att spara · {external} från andra källor",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Inkluderar ansökningar som inte räknats i sök (t.ex. externa sidor).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# jobb} other {# jobb}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct}% av dina ansökningar",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct}% av annonserna du tittat på",
  "tools.jobFlowSankey.viewed": "Visade",
  "tools.kanban.addExternalApplication": "Lägg till extern ansökan",
  "tools.kanban.cancelSelectMode": "Avbryt",
  "tools.kanban.chip.appliedAgo": "Ansökt {relativeAge}",
  "tools.kanban.column.applied": "Ansökt",
  "tools.kanban.column.collapse": "Fäll ihop kolumnen {column}",
  "tools.kanban.column.expand": "Expandera kolumnen {column}",
  "tools.kanban.column.hired": "Anställd",
  "tools.kanban.column.interviewing": "Intervjuer",
  "tools.kanban.column.offer": "Erbjudande",
  "tools.kanban.column.rejected": "Avslag",
  "tools.kanban.column.saved": "Sparade",
  "tools.kanban.companyFilterAll": "Alla företag",
  "tools.kanban.companyFilterLabel": "Filtrera efter företag",
  "tools.kanban.confirmRemove.appliedBody": "”{jobTitle}” kommer att tas bort från din ansökningsöversikt. Du kan ansöka igen via sökningen senare.",
  "tools.kanban.confirmRemove.appliedTitle": "Ta bort från ansökningar?",
  "tools.kanban.confirmRemove.cancel": "Avbryt",
  "tools.kanban.confirmRemove.close": "Stäng",
  "tools.kanban.confirmRemove.confirm": "\\n\\n---\\n\\n\n\nTa bort",
  "tools.kanban.confirmRemove.savedBody": "\\n\\n---\\n\\n\n\n”{jobTitle}” kommer att tas bort från sparade jobb.",
  "tools.kanban.confirmRemove.savedTitle": "\\n\\n---\\n\\n\n\nTa bort från sparade?",
  "tools.kanban.confirmRemove.working": "\\n\\n---\\n\\n\n\nTar bort…",
  "tools.kanban.deadlineChip": "Stänger om {days, plural, one {# dag} other {# dagar}}",
  "tools.kanban.dragHandle": "Dra för att flytta till en annan kolumn eller position",
  "tools.kanban.emptyBoard": "\\n\\n---\\n\\n\n\nInga sparade jobb eller ansökningar än. Lägg till en extern ansökan med knappen ovan, eller spara och sök jobb via sökfunktionen.",
  "tools.kanban.emptyColumn": "\\n\\n---\\n\\n\n\nInga än",
  "tools.kanban.groupMixedHeading": "\\n\\n---\\n\\n\n\n{count} ansökningar",
  "tools.kanban.groupMixedSavedHeading": "\\n\\n---\\n\\n\n\n{count} sparade",
  "tools.kanban.hideInactive": "Dölj jobb som inte längre är aktiva",
  "tools.kanban.keepLooking": "Fortsätt leta →",
  "tools.kanban.mobile.cancel": "\\n\\n---\\n\\n\n\nAvbryt",
  "tools.kanban.mobile.close": "Stäng",
  "tools.kanban.mobile.companyFilterAll": "Alla företag",
  "tools.kanban.mobile.companyFilterLabel": "Filtrera efter företag",
  "tools.kanban.mobile.emptyTab": "Inga ansökningar i {stage}.",
  "tools.kanban.mobile.move": "Flytta",
  "tools.kanban.mobile.moveTo": "Flytta till",
  "tools.kanban.mobile.searchPlaceholder": "Sök företag eller roll",
  "tools.kanban.mobile.searchToggle": "Sök ansökningar",
  "tools.kanban.mobile.sortCompanyAsc": "Företag (A–Ö)",
  "tools.kanban.mobile.sortDateAsc": "Äldst först",
  "tools.kanban.mobile.sortDateDesc": "Nyast först",
  "tools.kanban.mobile.sortLabel": "Sortera efter",
  "tools.kanban.mobile.sortTitleAsc": "Jobbtitel (A–Ö)",
  "tools.kanban.mobile.tabAll": "Alla",
  "tools.kanban.mobile.viewJob": "Visa jobbannons",
  "tools.kanban.moveSelectedTo": "Flytta till…",
  "tools.kanban.removeFailed": "Kunde inte uppdatera. Försök igen.",
  "tools.kanban.removeIcon.applied": "Ta bort från ansökningar",
  "tools.kanban.removeIcon.saved": "Ta bort från sparade jobb",
  "tools.kanban.removeSelected": "Ta bort",
  "tools.kanban.savedJob.expired": "Inte längre aktiv",
  "tools.kanban.savedJob.findSimilar": "Hitta liknande →",
  "tools.kanban.searchLabel": "Sök",
  "tools.kanban.searchPlaceholder": "Sök företag eller roll",
  "tools.kanban.selectCard": "Markera {title}",
  "tools.kanban.selectMode": "Markera",
  "tools.kanban.selectedCount": "{count, plural, one {# markerad} other {# markerade}}",
  "tools.kanban.sortCompanyAsc": "Företag (A–Ö)",
  "tools.kanban.sortDateAsc": "Äldst först",
  "tools.kanban.sortDateDesc": "Nyaste först",
  "tools.kanban.sortLabel": "Sortera efter",
  "tools.kanban.sortTitleAsc": "Jobbtitel (A–Z)",
  "tools.kanban.staleChip": "Följa upp? {days, plural, one {# dag} other {# dagar}} sedan ansökan",
  "tools.kanban.title": "Ansökningar per steg",
  "tools.savedJobs.tailorCvAction": "Anpassa CV",
  "tooltip.allFilters": "Öppna alla filter för att förfina din jobbsökning baserat på plats, lön, anställningsform och mer",
  "tooltip.view.list": "Byt till listvy för att se jobb i ett kompakt listformat",
  "tooltip.view.map": "Byt till kartvy för att se jobbens platser på en karta",
  "usermenu.account": "Konto",
  "usermenu.blog": "Resurser och blogg",
  "usermenu.blog.link": "Resurser",
  "usermenu.installPwa": "Installera app",
  "usermenu.login": "Logga in",
  "usermenu.logout": "Logga ut",
  "usermenu.myJobs.withCount": "Mina jobb ({count})",
  "usermenu.profile": "Min profil",
  "usermenu.profileCv.avatarGuestInitials": "Du",
  "usermenu.profileCv.caption": "CV",
  "usermenu.profileCv.placeholderEmail": "du@exempel.se",
  "usermenu.profileCv.placeholderHint": "Logga in för att spara jobb, följa dina ansökningar och hålla ditt CV sparat på JobCrawls.",
  "usermenu.profileCv.placeholderName": "Ditt namn",
  "usermenu.profileCv.region": "Sammanfattning av din profil",
  "usermenu.profileCv.regionGuest": "Förhandsgranska profil — logga in för att fylla i dina uppgifter",
  "usermenu.profileCv.signInSection": "Kom igång",
  "usermenu.theme": "Tema",
  "view.list": "Listvy",
  "view.map": "Kartvy",
  "watchlist.company.dataUnavailable": "Företagsdata är inte tillgänglig just nu.",
  "watchlist.company.employerScore": "arbetsgivarpoäng",
  "watchlist.company.hiringTrend.declining": "Minskar",
  "watchlist.company.hiringTrend.growing": "Ökar",
  "watchlist.company.hiringTrend.stable": "Stabil",
  "watchlist.company.openRoles": "öppna tjänster",
  "watchlist.empty.body": "Följ ett företag från dess profilsida för att spåra nya tjänster, arbetsgivarpoäng och rekryteringstrend här.",
  "watchlist.empty.browse": "Bläddra bland toppföretag →",
  "watchlist.empty.title": "Du följer inga företag än.",
  "watchlist.filter.all": "Alla",
  "watchlist.filter.noMatches": "Inga företag du följer har den här taggen än.",
  "watchlist.relationshipTag.inConversation": "I samtal",
  "watchlist.relationshipTag.interested": "Intresserad",
  "watchlist.relationshipTag.reachedOut": "Kontaktat",
  "translation.test": "Översättningstest: Svenska"
};

const messages_fi = {
  ...messages_en, // Use English as fallback
  "aboutEmployerScore.backToRankings": "Takaisin Best Employers -keskukseen",
  "aboutEmployerScore.breadcrumb.current": "Työnantajan pistemäärä",
  "aboutEmployerScore.breadcrumb.parent": "Parhaat työnantajat",
  "aboutEmployerScore.compositeScopeNote": "Tällä hetkellä pääpistemäärä perustuu vain palkkahaitareihin, joustavuuteen, rekrytoinnin vakauteen ja kasvuun, koska etuuksien kattavuus ja ilmoitustason läpinäkyvyyssignaalit eivät ole vielä kytketty pisteytysputkeen. Alla olevat painotukset on normalisoitu uudelleen 100 %:iin näiden neljän pilarin välillä.",
  "aboutEmployerScore.intro": "JobCrawls Employer Score on yksi 0–100 välinen luku, joka johdetaan malleista, joita voimme mitata johdonmukaisesti työpaikkailmoituksista. Sen tarkoituksena on nostaa esiin työnantajia, jotka viestivät selkeästi, rakentavat palkitsemisen oikeudenmukaisesti ja mainostavat joustavia, hakijaystävällisiä rooleja – se ei ole tarkoitettu korvaamaan omia haastattelujasi ja taustaselvityksiäsi.",
  "aboutEmployerScore.limits.changes": "Painotukset ja signaalit voivat kehittyä tunnistuksen parantuessa; pyrimme pitämään metodologian suuntauksellisesti vakaana.",
  "aboutEmployerScore.limits.listings": "Pistemäärät heijastavat sitä, mitä työnantajat julkaisevat indeksoimissamme ilmoituksissa – eivät sisäisiä HR-käytäntöjä, joihin meillä ei ole näkyvyyttä.",
  "aboutEmployerScore.limits.notEndorsement": "Korkeampi pistemäärä ei ole suositus, laadun takuu tai oikeudellinen/taloudellinen neuvonta.",
  "aboutEmployerScore.limits.title": "Tärkeitä rajoituksia",
  "aboutEmployerScore.pillar.flex.body": "Etä- ja hybridivaihtoehtoja pisteytetään sen perusteella, kuinka johdonmukaisesti työnantajat mainostavat joustavia työskentelymalleja avoimissa rooleissaan.",
  "aboutEmployerScore.pillar.flex.title": "Joustavuus (etätyö / hybridi)",
  "aboutEmployerScore.pillar.growth.body": "Kun ilmoitukset sisältävät tietoa seniority-rakenteesta ja urakehitysmahdollisuuksista, tulkitsemme tämän merkkinä vahvoista sisäisistä kasvupoluista.",
  "aboutEmployerScore.pillar.growth.title": "Kasvusignaalit",
  "aboutEmployerScore.pillar.pay.body": "Kun meillä on riittävästi ilmoituksia, joissa on jäsennellyt palkkahaitarit, pisteytämme tyypillisen palkkatason kilpailukyvyn. Ilmoituskohtainen palkkavälitiedon avoimuus sisällytetään tähän pilariin, kun kyseinen signaali on toteutettu kokonaisuudessaan.",
  "aboutEmployerScore.pillar.pay.title": "Palkkaus (ilmoitetut palkkahaitarit)",
  "aboutEmployerScore.pillar.stability.body": "Tarkastelemme rekrytoinnin jatkuvuutta ajan myötä – työnantajat, joilla on tasainen ja ennustettava rekrytointitahti, saavat korkeammat pisteet kuin ne, joiden ilmoituskäyttäytyminen on kaoottista.",
  "aboutEmployerScore.pillar.stability.title": "Rekrytoinnin vakaus",
  "aboutEmployerScore.pillars.title": "Mistä pistemäärä koostuu",
  "aboutEmployerScore.title": "Näin työnantajapisteet (Employer Score) toimivat",
  "auth.signInPrompt.closeLabel": "Sulje",
  "auth.signInPrompt.description": "Luo ilmainen tili tallentaaksesi työpaikkoja, synkronoidaksesi edistymisesi ja jatkaaksesi hakuasi millä tahansa laitteella.",
  "auth.signInPrompt.descriptionCreateAlert": "Luo ilmainen tili, niin lähetämme sinulle sähköpostia, kun vastaavia uusia työpaikkoja tulee tarjolle.",
  "auth.signInPrompt.primaryAction": "Kirjaudu sisään nyt",
  "auth.signInPrompt.secondaryAction": "Ehkä myöhemmin",
  "auth.signInPrompt.title": "Kirjaudu sisään tallentaaksesi työpaikkoja",
  "auth.signInPrompt.titleCreateAlert": "Kirjaudu sisään saadaksesi työpaikkailmoituksia",
  "autocomplete.filters": "Suodattimen osumat",
  "autocomplete.noMatches": "Ei suodattimen osumia",
  "autocomplete.scrollHint": "Vieritä nähdäksesi lisää",
  "backoffice.architecture": "Arkkitehtuuri",
  "backoffice.dashboard": "Hallintapaneeli",
  "backoffice.dataExplorer.nav": "Tiedonhaku",
  "backoffice.dataExplorer.title": "Tiedonhaku",
  "backoffice.emailAlerts.nav": "Sähköpostihälytykset",
  "backoffice.hub.nav": "Kaikki työkalut",
  "backoffice.hub.open": "Avaa",
  "backoffice.hub.subtitle": "Valitse avattava työkalu. Pääsy on rajoitettu valtuutetuille tileille.",
  "backoffice.jobDataExplorer.nav": "Työpaikkadata-API",
  "backoffice.testing": "Testaus",
  "backoffice.userAgents.description": "Yhden näytön seuranta: karttapainotteinen, päivittää viimeisen minuutin automaattisesti latauksessa. Säädä tarkastelujaksoa ja suodattimia, ja siirry sitten tarkastelemaan taulukkoa.",
  "backoffice.userAgents.hours": "Tarkastelujakso",
  "backoffice.userAgents.mapboxTokenMissing": "Karttanäkymä vaatii Mapbox-pääsytokenin (PUBLIC_ENV__MAPBOX_ACCESS_TOKEN).",
  "backoffice.userAgents.nav": "Käyttäjäagentit",
  "backoffice.userAgents.noData": "Tällä aikavälillä ei ole käyttäjäagenttimerkintöjä.",
  "backoffice.userAgents.run": "Päivitä",
  "backoffice.userAgents.title": "Kierto- ja liikennepaneeli",
  "bestCompanies.breadcrumb.current": "Parhaat työnantajat",
  "bestCompanies.breadcrumb.hub": "Parhaat työnantajat",
  "bestCompanies.card.cta": "Parhaat työnantajat →",
  "bestCompanies.card.ctaDisabled": "Tulossa pian",
  "bestCompanies.dimension.backToHub": "← Kaikki työnantäjälistaukset",
  "bestCompanies.dimension.empty": "Tällä suodattimella ei löytynyt vielä yrityksiä. Tarkista tilanne seuraavan indeksoinnin jälkeen.",
  "bestCompanies.dimension.introPrefix": "Sijoitukset perustuvat",
  "bestCompanies.dimension.introSuffix": "— laskettu palkkavällyyden, etätyömahdollisuuksien, rekrytoinnin vakauden ja etujen perusteella suomalaisille työmarkkinoille suunnatuissa ilmoituksissa (mukaan lukien monet etätyöpaikat). Ei perustu arvosteluihin.",
  "bestCompanies.dimension.scoreName": "JobCrawls työnantajapisteet",
  "bestCompanies.dimension.title": "Parhaat työnantajat kategoriassa {label}",
  "bestCompanies.hub.byCity": "Kaupungin mukaan",
  "bestCompanies.hub.byIndustry": "Toimialan mukaan",
  "bestCompanies.hub.clearFilters": "Tyhjennä suodattimet",
  "bestCompanies.hub.clearSearch": "Tyhjennä haku",
  "bestCompanies.hub.eyebrow": "{year} sijoitukset, päivitetään viikoittain",
  "bestCompanies.hub.filteredCount": "{count, plural, one {# työnantaja vastaa hakuun} other {# työnantajaa vastaa hakuun}}",
  "bestCompanies.hub.heroLede": "Sijoitukset perustuvat reaaliaikaisiin työpaikkailmoitusten signaaleihin – palkkaukseen, joustavuuteen, rekrytoinnin vakauteen ja muuhun. Ei työntekijöiden arvosteluja, kyselyitä tai maksettuja sijoituksia.",
  "bestCompanies.hub.lead": "Tämä sivu on {year} tilannekatsaus työnantajista, jotka rekrytoivat suomalaisille työmarkkinoille suunnatuilla rooleilla. Monet ilmoitukset ovat etä- tai hybridityöpaikkoja, joten yritysten pääkonttori ei välttämättä sijaitse Suomessa.",
  "bestCompanies.hub.loadingMoreMatches": "etsitään lisää osumia…",
  "bestCompanies.hub.methodLink": "Koko metodologia: näin Employer Score toimii",
  "bestCompanies.hub.methodologySummary": "Sijoitukset perustuvat JobCrawls Employer Scoreen: koosteeseen reaaliaikaisista työpaikkailmoitusten signaaleista – palkkoiden läpinäkyvyydestä, etä- ja hybridityön joustavuudesta, rekrytoinnin jatkuvuudesta, etujen kattavuudesta sekä vaatimusten selkeydestä. Se ei perustu työntekijöiden arvosteluihin, kyselyihin tai maksettuihin sijoituksiin.",
  "bestCompanies.hub.methodologyToggle": "Näin sijoitus toimii",
  "bestCompanies.hub.networkWorthyFilter": "Verkostoitumisen arvoinen",
  "bestCompanies.hub.noMatches": "Yksikään yritys ei vastaa suodattimiasi. Kokeile tyhjentää suodatin tai hakea eri nimellä.",
  "bestCompanies.hub.overallTitle": "Vuoden {year} parhaat työnantajat",
  "bestCompanies.hub.remoteFriendlyFilter": "Etätyöystävällinen",
  "bestCompanies.hub.scoreScale": "Pisteet ovat asteikolla 0–100. Kun monet työnantajat sijoittuvat lähelle toisiaan (esimerkiksi 30-luvun lopun ja 40-luvun alun välille), lista on silti järjestetty näiden signaalien perusteella – sija #1 heijastaa vahvinta yhdistelmää tässä ryhmässä mittaamillamme osa-alueilla, ja alempia sijoja erottavat usein pienet marginaalit suuren laatueron sijaan.",
  "bestCompanies.hub.searchPlaceholder": "Hae yrityksiä nimellä…",
  "bestCompanies.hub.sizeFilter.large": "Yli 1 000 työntekijää",
  "bestCompanies.hub.sizeFilter.medium": "201–1 000 työntekijää",
  "bestCompanies.hub.sizeFilter.micro": "1–50 työntekijää",
  "bestCompanies.hub.sizeFilter.small": "51–200 työntekijää",
  "bestCompanies.hub.sort.name": "Nimi (A–Z)",
  "bestCompanies.hub.sort.postings": "Aktiivisimmat rekrytoijat",
  "bestCompanies.hub.sort.score": "Korkein pistemäärä",
  "bestCompanies.hub.sort.size": "Yrityksen koko",
  "bestCompanies.hub.sortLabel": "Lajittele",
  "bestCompanies.hub.stat.companies": "arvioituja yrityksiä",
  "bestCompanies.hub.stat.industries": "katetut toimialat",
  "bestCompanies.hub.stat.medianSalary": "mediaanikuukausipalkka",
  "bestCompanies.hub.stat.medianScore": "mediaani työnantajapisteistä",
  "bestCompanies.hub.stat.networkWorthy": "verkostoitumisen arvoisia",
  "bestCompanies.hub.title": "Suomen parhaat työpaikat ({year})",
  "bestCompanies.podium.headcount": "{range} työntekijää",
  "bestCompanies.podium.rankLabel": "Korkeimmat pisteet saanut työnantaja",
  "bestCompanies.row.hiringPace": "~{count} uutta roolia/kk",
  "bestCompanies.row.medianPrefix": "Mediaani",
  "bestCompanies.row.networkWorthy": "Verkostoitumisen arvoinen",
  "bestCompanies.row.perMonth": "{range}/kk",
  "bestCompanies.row.remoteHybridPercent": "{percent}% etä/hybridi",
  "bestCompanies.row.remotePercent": "{percent}% etätyö",
  "bestCompanies.subscore.benefits": "Edut",
  "bestCompanies.subscore.flexibility": "Joustavuus",
  "bestCompanies.subscore.growth": "Kasvu",
  "bestCompanies.subscore.pay": "Palkkaus",
  "bestCompanies.subscore.stability": "Vakaus",
  "bestCompanies.subscore.transparency": "Läpinäkyvyys",
  "breadcrumb.benefits": "Edut",
  "breadcrumb.company": "Yritys",
  "breadcrumb.educationLevel": "Koulutus",
  "breadcrumb.industry": "Ala",
  "breadcrumb.isDriversLicenseRequired": "Ajokortti",
  "breadcrumb.isOpenApplication": "Avoin hakemus",
  "breadcrumb.jobType": "Työsuhteen tyyppi",
  "breadcrumb.jobs": "Työpaikat",
  "breadcrumb.language": "Kieli",
  "breadcrumb.level": "Taso",
  "breadcrumb.location": "Sijainti",
  "breadcrumb.navigation": "Murupolku-navigointi",
  "breadcrumb.peopleManagementTier": "Johtaminen",
  "breadcrumb.remote": "Etätyö",
  "breadcrumb.skillsAndTechnologies": "Taidot/Teknologiat",
  "checklist.field.addTrigger": "Lisää tarkistuslista",
  "checklist.field.placeholder": "Lisää tehtävä ja paina Enteriä…",
  "checklist.field.progressTrigger": "{done}/{total} valmis",
  "checklist.field.remove": "Poista tehtävä {text}",
  "collectiveAgreements.bindingLegend": "Mitä \"ratkaisematon\" tarkoittaa:",
  "collectiveAgreements.bindingLegendBody": "Vahvistuslautakunta ei maininnut kyseistä sopimusta missään arkistoiduista vuosikatsauksistamme – kyseessä on siis todellinen puute tiedoissa, ei \"ei\".",
  "collectiveAgreements.bindingNo": "Ei yleissitova",
  "collectiveAgreements.bindingUnknown": "Tuntematon",
  "collectiveAgreements.bindingYes": "Yleissitova",
  "collectiveAgreements.breadcrumb.current": "Työehtosopimukset",
  "collectiveAgreements.decisionNoPrefix": "Päätösnro",
  "collectiveAgreements.eyebrow": "Lähde · Finlex & Sosiaali- ja terveysministeriö",
  "collectiveAgreements.filterLabel": "Suodata työehtosopimuksia nimen perusteella",
  "collectiveAgreements.filterPlaceholder": "Hae sopimuksen nimellä…",
  "collectiveAgreements.intro": "Työehtosopimus määrittää työn vähimmäispalkan ja ehdot – se, mikä sopimus on voimassa, riippuu työnantajan toimialasta ja tehtävästä. Linkitämme työpaikkailmoitukset automaattisesti parhaan arvauksen perusteella; tässä on koko lähdeluettelo, jotta voit tarkistaa arvauksen itse.",
  "collectiveAgreements.noResults": "Haku ei tuottanut tuloksia.",
  "collectiveAgreements.pdfFi": "PDF (suomi)",
  "collectiveAgreements.pdfSv": "PDF (ruotsi)",
  "collectiveAgreements.resultsCount": "Näytetään {shown} / {total} sopimusta — {binding} vahvistettu yleissitovaksi",
  "collectiveAgreements.scopeHeading": "Soveltamisala",
  "collectiveAgreements.scopeUnavailable": "Tälle sopimukselle ei ole saatavilla soveltamisala-tekstiä.",
  "collectiveAgreements.stat.binding": "Vahvistettu sitova",
  "collectiveAgreements.stat.total": "Arkistoidut sopimukset",
  "collectiveAgreements.stat.unresolved": "Tilaan määrittelemätön",
  "collectiveAgreements.title": "Suomalaiset työehtosopimukset",
  "company.follow.cta": "Seuraa",
  "company.follow.followedToast": "Seurataan — seurantalista päivitetty",
  "company.follow.following": "Seurataan",
  "company.follow.unfollow": "Lopeta seuranta",
  "company.follow.unfollowedToast": "Seuranta lopetettu",
  "company.follow.viewWatchlist": "Näytä →",
  "company.logoAlt": "{company}-logo",
  "company.logoAltGeneric": "Työnantajan logo",
  "companyChart.caption.averaging": "keskiarvona {avg} työpaikkaa kuukaudessa",
  "companyChart.caption.hiringDeclining": "{companyName}:n rekrytointi on laskussa",
  "companyChart.caption.hiringGrowing": "{companyName}:n rekrytointi on kasvussa",
  "companyChart.caption.hiringRapidlyDeclining": "{companyName}:n rekrytointi laskee nopeasti",
  "companyChart.caption.hiringRapidlyGrowing": "{companyName}:n rekrytointi kasvaa nopeasti",
  "companyChart.caption.hiringStable": "{companyName}:n rekrytointi on vakaata",
  "companyChart.caption.levelDistributionDouble": "{companyName} rekrytoi pääasiassa tasoille {level1} ja {level2}.",
  "companyChart.caption.levelDistributionSingle": "{companyName} palkkaa pääasiassa {level}-tasolle.",
  "companyChart.caption.levelDistributionTriple": "{companyName} palkkaa pääasiassa {level1}-, {level2}- ja {level3}-tasoille.",
  "companyChart.caption.locationDistributionDouble": "{companyName} palkkaa pääasiassa {location1}:ssa ja {location2}:ssa.",
  "companyChart.caption.locationDistributionSingle": "{companyName} palkkaa pääasiassa {location}:ssa.",
  "companyChart.caption.locationDistributionTriple": "{companyName} palkkaa pääasiassa {location1}:ssa, {location2}:ssa ja {location3}:ssa.",
  "companyChart.caption.margin": "ja {margin} voittomarginaalilla",
  "companyChart.caption.marginOnly": "{companyName}:n voittomarginaali oli vuonna 2024 {margin}",
  "companyChart.caption.profitable": "{companyName} oli kannattava vuonna 2024",
  "companyChart.caption.remotenessHybrid": "{companyName} palkkaa pääasiassa hybridi-rooleihin.",
  "companyChart.caption.remotenessOnsite": "{companyName} palkkaa pääasiassa paikan päällä työskenneltäviin rooleihin.",
  "companyChart.caption.remotenessRemote": "{companyName} palkkaa pääasiassa etätyöntekijöitä.",
  "companyChart.caption.revenue": "{companyName}:n liikevaihto oli vuonna 2024 {revenue}",
  "companyChart.caption.revenueWith": "liikevaihdolla {revenue}",
  "companyChart.caption.roleDistributionDouble": "{companyName} palkkaa pääasiassa {role1}- ja {role2}-rooleihin.",
  "companyChart.caption.roleDistributionSingle": "{companyName} palkkaa pääasiassa {role}-rooleihin.",
  "companyChart.caption.roleDistributionTriple": "{companyName} palkkaa pääasiassa {role1}-, {role2}- ja {role3}-rooleihin.",
  "companyChart.caption.unprofitable": "{companyName} oli tappiollinen vuonna 2024",
  "companyChart.caption.workforceRate": "({rate}% heidän henkilöstöstään)",
  "companyChart.financialOverview": "Taloudellinen yleiskatsaus (2024)",
  "companyChart.insufficientData": "Rajoitetusti tietoja saatavilla – trendien laskeminen edellyttää vähintään 3 kuukauden tietoja",
  "companyChart.monthlyHiringTrends": "Kuukausittaiset rekrytointitrendit",
  "companyChart.moreCategories": "+{count} lisää",
  "companyChart.profit": "Voitto",
  "companyChart.profitMargin": "Voittomarginaali",
  "companyChart.revenue": "Liikevaihto",
  "companyChart.trend.declining": "Laskeva",
  "companyChart.trend.growing": "Kasvava",
  "companyChart.trend.insufficientData": "Rajoitettu määrä tietoa",
  "companyChart.trend.rapidlyDeclining": "Nopeasti laskeva",
  "companyChart.trend.rapidlyGrowing": "Nopeasti kasvava",
  "companyChart.trend.stable": "Vakaa",
  "companyChart.trendDescription.declining": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.growing": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.rapidlyDeclining": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.rapidlyGrowing": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyChart.trendDescription.simpleDeclining": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleGrowing": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.simpleStable": "Rekrytointeja keskimäärin {avg} työpaikkaa/kk",
  "companyChart.trendDescription.stable": "Rekrytointeja {avg} työpaikkaa/kk ({rate} % työvoimasta)",
  "companyHeader.jobCount": "{count, plural, one {# avoinna oleva tehtävä} other {# avointa tehtävää}}",
  "companyHeader.locationCount": "{count, plural, one {# toimipiste} other {# toimipistettä}}",
  "companyInsight.bodyNoLocations": "esiintyy {count, plural, one {# indeksoidussa työpaikkailmoituksessa} other {# indeksoidussa työpaikkailmoituksessa}} JobCrawls'in Suomen tietojoukossa {sinceDate} lähtien. Tämä heijastaa historiallista hakudataa, ei reaaliaikaista avoimien työpaikkojen määrää.",
  "companyInsight.bodyWithLocations": "esiintyy {count, plural, one {# indeksoidussa työpaikkailmoituksessa} other {# indeksoidussa työpaikkailmoituksessa}} JobCrawls'in Suomen tietojoukossa {sinceDate} lähtien. Tässä historiallisessa indeksissä tämän työnantajan vahvimmat sijaintisignaalit ovat {locationList}.",
  "companyInsight.englishRequirement": "{percent} % näistä indeksoiduista ilmoituksista mainitsee englannin kielen vaatimuksena.",
  "companyInsight.locationSegment": "{location} ({count, plural, one {# indeksoitu ilmoitus} other {# indeksoitua ilmoitusta}})",
  "companyProfile.companyFacts.benefitsLabel": "Edut",
  "companyProfile.companyFacts.corporateHistoryLabel": "Omistus",
  "companyProfile.companyFacts.heading": "Hyvä tietää",
  "companyProfile.companyFacts.officeLocationsLabel": "Toimipisteet",
  "companyProfile.companyFacts.remotePolicyLabel": "Etätyö",
  "companyProfile.companyFacts.valuesLabel": "Arvot",
  "companyProfile.communityInsights.consTitle": "Yleisimmät valitukset",
  "companyProfile.communityInsights.heading": "Mitä verkossa sanotaan",
  "companyProfile.communityInsights.prosTitle": "Mistä pidetään",
  "companyProfile.communityInsights.sentimentInsufficient": "Ei tarpeeksi tietoa",
  "companyProfile.communityInsights.sentimentMixed": "Sekalainen",
  "companyProfile.communityInsights.sentimentNegative": "Pääosin negatiivinen",
  "companyProfile.communityInsights.sentimentPositive": "Pääosin positiivinen",
  "companyProfile.communityInsights.sourcesTitle": "Lähteet",
  "companyProfile.communityInsights.subtitle": "Tiivistelmä julkisista Reddit-, Suomi24- ja foorumikeskusteluista",
  "companyProfile.siteSources.sourceLabel": "Lähde",
  "cookie.consent.accept": "Hyväksy analytiikka",
  "cookie.consent.analyticsBody": "Auttaa meitä löytämään haut, jotka eivät tuota tuloksia, sekä sivut, joilla käyttäjät jäävät jumiin, jotta voimme korjata ne. Valinnainen, eikä tietoja käytetä koskaan mainontaan.",
  "cookie.consent.analyticsTitle": "Analytiikka",
  "cookie.consent.banner": "Käytämme välttämättömiä evästeitä JobCrawls-palvelun pyörittämiseen. Suostumuksellasi käytämme myös yksityisyydensuojattuun analytiikkaan perustuvia työkaluja – ne auttavat meitä löytämään tuloksettomat haut ja sivut, joilla käyttäjät jäävät jumiin, jotta voimme korjata ne nopeammin. Ei koskaan mainontaan. Voit muuttaa valintaasi milloin tahansa.",
  "cookie.consent.cancel": "Peruuta",
  "cookie.consent.manage": "Hallitse asetuksia",
  "cookie.consent.modalTitle": "Evästeasetukset",
  "cookie.consent.necessaryNote": "Välttämättömiä evästeitä (istunto, asetukset, tietoturva) käytetään aina, jotta sivusto toimii.",
  "cookie.consent.nudge": "Voit ottaa yksityisyydensuojatun analytiikan käyttöön milloin tahansa – se auttaa meitä havaitsemaan toimimattomat haut nopeammin.",
  "cookie.consent.privacyLink": "Tietosuojaseloste",
  "cookie.consent.reject": "Hylkää ei-välttämättömät",
  "cookie.consent.save": "Tallenna valinnat",
  "cookie.consent.title": "Evästeet ja tietosuoja",
  "dashboard.actions": "Toiminnot",
  "dashboard.addComment": "Lisää kommentti",
  "dashboard.addComment.placeholder": "Lisää kommentti...",
  "dashboard.addCompany.cancel": "Peruuta",
  "dashboard.addCompany.close": "Sulje",
  "dashboard.addCompany.doCrawl": "Ota haku käyttöön (doCrawl = TRUE)",
  "dashboard.addCompany.errorName": "Yrityksen nimi on pakollinen.",
  "dashboard.addCompany.fieldCareers": "Urasivun URL-osoite",
  "dashboard.addCompany.fieldEnqueue": "Jonotus-URL",
  "dashboard.addCompany.fieldLogo": "Logon URL-osoite",
  "dashboard.addCompany.fieldName": "Yrityksen nimi",
  "dashboard.addCompany.fieldWebsite": "Verkkosivusto",
  "dashboard.addCompany.hintId": "Tietokannan yritystunnus on yrityksen tarkka nimi (ilman tyhjiä välejä reunoilla). Jos rivi, jolla on sama nimi, on jo olemassa, luominen epäonnistuu.",
  "dashboard.addCompany.open": "Lisää yritys",
  "dashboard.addCompany.placeholderName": "esim. Acme Oy",
  "dashboard.addCompany.saving": "Luodaan…",
  "dashboard.addCompany.submit": "Luo yritys",
  "dashboard.addCompany.title": "Lisää yritys",
  "dashboard.adding": "Lisätään...",
  "dashboard.address": "Osoite",
  "dashboard.all": "Kaikki",
  "dashboard.allAts": "Kaikki ATS:t",
  "dashboard.allCompanies": "Kaikki yritykset",
  "dashboard.allStatus": "Kaikki tilat",
  "dashboard.atsSystem": "ATS-järjestelmä",
  "dashboard.businessId": "Y-tunnus",
  "dashboard.cancelEdit": "Peruuta",
  "dashboard.careersUrl": "Urasivun URL",
  "dashboard.charts.closeBackdrop": "Sulje",
  "dashboard.charts.closeButton": "Sulje kaaviot",
  "dashboard.charts.modalTitle": "Käyntien aktiivisuuskaaviot",
  "dashboard.charts.toolbarDisabledHint": "Lataa ensin käyntien vientitiedot",
  "dashboard.charts.toolbarHint": "Avaa käyntien aktiivisuuskaaviot",
  "dashboard.charts.toolbarLabel": "Kaaviot",
  "dashboard.check": "Merkitse tarkistetuksi",
  "dashboard.clearDlq": "Tyhjennä DLQ",
  "dashboard.clearFilters": "Tyhjennä suodattimet",
  "dashboard.clearLogoFailures": "Tyhjennä logovirheet ({count})",
  "dashboard.comments": "Kommentit",
  "dashboard.companiesHeader": "Yritykset ({count} / {total})",
  "dashboard.companyAttributes": "Yrityksen attribuutit",
  "dashboard.companyBasic": "Yrityksen perustiedot",
  "dashboard.companyBasic.short": "Perustiedot",
  "dashboard.companyBusiness": "Liiketoimintatiedot",
  "dashboard.companyContact": "Yhteystiedot",
  "dashboard.companyCrawl": "Hakuasetukset",
  "dashboard.companyCrawlRecordsPerPageLabel": "Rivejä sivulla",
  "dashboard.companyCrawlRecordsShowing": "Näytetään {from}-{to} / {total}",
  "dashboard.companyFinancial": "Talous",
  "dashboard.companyId": "Yrityksen ID",
  "dashboard.companyIndustry": "Toimiala",
  "dashboard.companyInformation": "Yritystiedot",
  "dashboard.companyLocation": "Sijainti",
  "dashboard.companyModal.close": "Sulje yritysikkuna",
  "dashboard.companyModal.closeBackdrop": "Sulje",
  "dashboard.companyModal.subtitle": "{crawls} hakuja · {ok} onnistunutta · {jobs} lähetetty prosessoijalle",
  "dashboard.companyModal.tabCrawls": "Hakuajot",
  "dashboard.companyModal.tabSettings": "Yrityksen ja haun asetukset",
  "dashboard.companyName": "Yrityksen nimi",
  "dashboard.companyRegistry": "Rekisteri",
  "dashboard.companyRow.jobs": "työt",
  "dashboard.companyRow.openBadge": "Avoinna",
  "dashboard.companyRow.paginationWarningShort": "Sivutus ⚠ {n}",
  "dashboard.companySocial": "Sosiaali media",
  "dashboard.companyUrl": "Yrityksen URL",
  "dashboard.coordinates": "Koordinaatit",
  "dashboard.crawlActions.companyColumnHint": "HTML · Live · Trace · Lokit",
  "dashboard.crawlActions.flatLogsColumnHint": "⋯ valikko",
  "dashboard.crawlActions.flatTraceColumnHint": "Modaali",
  "dashboard.crawlActions.legendHtml": "Silmä — HTML: S3-snapshottivarmuuskopio haetussa muodossa (sekä live-uutettu JSON, jos rivillä on URL-osoite).",
  "dashboard.crawlActions.legendLive": "Nuoli ulos — Live-sivusto: avaa julkinen työpaikkasivu JobCrawlsissa (vain objektitunnuksen omaavat yksityiskohtaiset rivit).",
  "dashboard.crawlActions.legendLogs": "⋯ — CloudWatch: siirry crawleriin, prosessoriin, enrichiin, Algoliaan jne. (suodattimet käyttävät tätä crawl-id:tä tai työpaikan URL-osoitetta).",
  "dashboard.crawlActions.legendRecrawlDetail": "Nuolet — Hae sivu uudelleen: lisää yksi yksityiskohtainen haku jonoon tälle URL-osoitteelle (ei koko yritysluetteloa).",
  "dashboard.crawlActions.legendTitle": "Mitä rivin painikkeet tekevät",
  "dashboard.crawlActions.legendTrace": "Suurennuslasi — Trace: yksi modaali, jossa on Raw/Final/Enriched-tilat sekä linkit DynamoDB:hen ja AWS-konsoliin.",
  "dashboard.crawlActions.liveJobAria": "Avaa julkinen työpaikkailmoitus JobCrawls-palvelussa",
  "dashboard.crawlActions.liveJobTooltip": "Avaa tämän työpaikan julkinen ilmoitussivu JobCrawls-palvelussa (sama URL, jonka vierailijat näkevät, kun työpaikka on indeksoitu).",
  "dashboard.crawlActions.logsMenuAria": "CloudWatch-putkilokien valikko tälle hakuprosessille",
  "dashboard.crawlActions.logsMenuTooltip": "CloudWatch-lokilinkit: tarkka haku-striimi (kun saatavilla), sekä suodatetut näkymät hakuohjelmalle (crawlId), prosessorille, rikastukselle, Algolialle, ylläpitäjälle ja prosessorille URL-osoitteen mukaan.",
  "dashboard.crawlActions.recrawlDetailAria": "Hae tämä työpaikkasivu uudelleen (vain yksityiskohtainen haku)",
  "dashboard.crawlActions.recrawlDetailTooltip": "Lisää jonoon vain tämän työpaikkasivun haku (yksityiskohdat). Ei aja koko yritysluettelosivujen hakua uudelleen — käytä sitä varten yrityksen ”Recrawl”-toimintoa.",
  "dashboard.crawlActions.traceAria": "Avaa koko putken trace tälle työpaikan URL-osoitteelle",
  "dashboard.crawlActions.traceTooltip": "Avaa putken trace: RawJobs / FinalJobs / Enriched -yhteenvedot, objektitunnukset sekä linkit DynamoDB:hen ja CloudWatchiin tälle työpaikan URL-osoitteelle.",
  "dashboard.crawlActions.viewHtmlAria": "Näytä tämän haun tallennettu HTML-snapshot",
  "dashboard.crawlActions.viewHtmlTooltip": "Avaa tälle hakuun tallennettu HTML-snapshot (S3). Näyttää renderöidyn tai raa'an merkinnän sekä sen vieressä live DynamoDB -työn JSON-tiedon.",
  "dashboard.crawlDataLoadedNoCompanies": "Crawl-data on ladattu ({count} tietuetta), mutta yritystietoja ei ole vielä ladattu tähän selaimeen — siksi alla ei näy ryhmiä. Lataa yritykset nähdäksesi ne.",
  "dashboard.crawlDlq": "Haku DLQ",
  "dashboard.crawlExportWindow": "Ladattuja hakuennätyksiä väliltä {from} – {to} (ylläpitäjän vienti-ikkuna).",
  "dashboard.crawlFailIconTooltip": "Tämä hakukerta epäonnistui tai palautti HTTP-virheen – avaa CloudWatch- / pipeline-lokit tälle crawlId:lle.",
  "dashboard.crawlHistory.hideOlder": "Piilota {n} vanhempaa hakua",
  "dashboard.crawlHistory.hint": "Uusin suoritus on yläpuolella olevalla rivillä. Jokaisella vanhemmalla suorituksella on oma crawlId:nsä ja CloudWatch-linkkinsä.",
  "dashboard.crawlHistory.showOlder": "Näytä {n} vanhempaa hakua — aika, lokit, HTML",
  "dashboard.crawlHourlyChart.ariaDuration": "Tuntikohtainen kaavio sivujen keskimääräisestä ajasta ja kokonaisvaltaisista hakuminuuteista",
  "dashboard.crawlHourlyChart.ariaPages": "Tuntikohtainen kaavio listaus- ja työsivujen hauista, tallennetuista työistä, listauslinkeistä ja tallentamattomista työsivuista",
  "dashboard.crawlHourlyChart.avgSecPhrase": "keskiarvo {seconds} s per sivu, josta raportoitiin ajoitus",
  "dashboard.crawlHourlyChart.axisAvgSec": "Keski-s / sivu",
  "dashboard.crawlHourlyChart.axisExtracted": "Työhön liittyvät määrät / h",
  "dashboard.crawlHourlyChart.axisPageFetches": "Sivuhaudonnot / h",
  "dashboard.crawlHourlyChart.axisTotalMin": "Yhteensä min / h",
  "dashboard.crawlHourlyChart.collapsedEmpty": "Ei rivejä ladatussa aikavälissä",
  "dashboard.crawlHourlyChart.collapsedSummary": "{hours} tuntia · {fetches} sivuhautonta",
  "dashboard.crawlHourlyChart.durationHms": "Yhteensä {hours}t {minutes}m {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationMs": "Yhteensä {minutes}m {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationSecOnly": "Yhteensä {seconds}s (sivukohtaisten aikojen summa)",
  "dashboard.crawlHourlyChart.durationZero": "Yhteensä 0s",
  "dashboard.crawlHourlyChart.empty": "Ladatussa aikavälissä ei ole crawl-rivejä – päivitä crawl-tiedot maintainer-viennin jälkeen.",
  "dashboard.crawlHourlyChart.helpCollapsibleLabel": "Selitykset ja aikavälin kokonaismäärät",
  "dashboard.crawlHourlyChart.hoverAllFetches": "Kaikki sivun haut",
  "dashboard.crawlHourlyChart.hoverAllFetchesValue": "{total} ({ok} ok / {fail} epäonnistunutta)",
  "dashboard.crawlHourlyChart.hoverAvgPageTime": "Sivun keskimääräinen aika (ajastetut rivit)",
  "dashboard.crawlHourlyChart.hoverDetailJobsCounted": "Yksittäisiltä työpaikkasivuilta (nähdyt ilmoitukset)",
  "dashboard.crawlHourlyChart.hoverDetailNotSaved": "Yksittäiset työpaikkasivut, joita emme tallentaneet",
  "dashboard.crawlHourlyChart.hoverFoundOtherPages": "Löytyi muilta sivutyypeiltä",
  "dashboard.crawlHourlyChart.hoverJobPages": "Työpaikkasivut (yksityiskohdat)",
  "dashboard.crawlHourlyChart.hoverJobPagesValue": "{ok} ok / {fail} epäonnistui",
  "dashboard.crawlHourlyChart.hoverJobsFound": "”Löytyneiden” kokonaismäärä (kaikki laskettuna yhteen)",
  "dashboard.crawlHourlyChart.hoverListPages": "Listasivut",
  "dashboard.crawlHourlyChart.hoverListPagesValue": "{ok} ok / {fail} epäonnistui",
  "dashboard.crawlHourlyChart.hoverListUrlsEnqueued": "Listasivuilta (laskettu työpaikkalinkit)",
  "dashboard.crawlHourlyChart.hoverPipeline": "Tallennettu putkeen",
  "dashboard.crawlHourlyChart.hoverPipelineBreakdown": "{total} (Työmarkkinatori {tm}, muut {other})",
  "dashboard.crawlHourlyChart.hoverTotalReportedTime": "Ilmoitettu kokonaiskestoaika hakuun",
  "dashboard.crawlHourlyChart.noTiming": "tässä viennissä ei ole tallennettu sivukohtaisia kestoja",
  "dashboard.crawlHourlyChart.panelDuration": "Haku- eli crawl-kesto",
  "dashboard.crawlHourlyChart.panelPages": "Haudut ja työpaikkojen määrät tunneittain",
  "dashboard.crawlHourlyChart.plainGuide1": "”Löytyneet” (Found) on usein suuri luku, koska jokainen työpaikkalinkki listausivulla lasketaan mukaan. Nämä linkit tarkoittavat vain sitä, että ”jonotimme tämän URL-osoitteen” – ne eivät ole vielä tallennettuja työpaikkoja.",
  "dashboard.crawlHourlyChart.plainGuide2": "”Poimitut” (Extracted) tarkoittaa, että tallensimme kyseisen työpaikan raakamuotoiseen tallennustilaan yksittäiseltä työpaikkasivulta. Listausrivit eivät koskaan kasvata poimittujen määrää (tämä on tietoinen valinta).",
  "dashboard.crawlHourlyChart.plainGuide3": "Käytä kaaviossa valintaruutuja: katkoviivainen violetti viiva = listasivuilla lasketut linkit; katkoviivainen ruskea viiva = vierailtavat työpaikkasivut, joita ei tallennettu; yhtenäinen kultainen viiva = putkeen tallennetut. Vie hiiri kaavion päälle nähdäksesi yhden tunnin lukemat.",
  "dashboard.crawlHourlyChart.plainGuideTitle": "Yksinkertaisesti selitettynä",
  "dashboard.crawlHourlyChart.subtitle": "Ylempi kaavio: haetut sivut ja työpaikkojen määrät tunnissa. Alempi kaavio: haun kesto. Aika-akseli vastaa viennin hakuikkunaa (usein noin viikko).",
  "dashboard.crawlHourlyChart.title": "Hakuaktiivisuus tunneittain (paikallinen aika)",
  "dashboard.crawlHourlyChart.totalDetailSkipped": "Vierailut työpaikkasivuilla, joita ei tallennettu",
  "dashboard.crawlHourlyChart.totalExtracted": "Työt tallennettu raakamuotoon (”extracted”)",
  "dashboard.crawlHourlyChart.totalFoundRaw": "”Löytyi” (kaikki rivit laskettuna yhteen)",
  "dashboard.crawlHourlyChart.totalJobPages": "Käydyt yksittäiset työpaikkasivut",
  "dashboard.crawlHourlyChart.totalJobPagesValue": "{total} ({ok} onnistui, {fail} epäonnistui)",
  "dashboard.crawlHourlyChart.totalListLinks": "Näistä listausivuilla laskettujen linkkien määrä",
  "dashboard.crawlHourlyChart.totalListPages": "Käydyt listausivut",
  "dashboard.crawlHourlyChart.totalListPagesValue": "{total} ({ok} onnistui, {fail} epäonnistui)",
  "dashboard.crawlHourlyChart.totalTiming": "Crawlerin raportoima aika",
  "dashboard.crawlHourlyChart.totalsTitle": "Yhteensä yllä olevalla aikavälillä",
  "dashboard.crawlKey": "Crawl-avain",
  "dashboard.crawlMetricsExplainer.crawls": "Hakuja — yksi lokirivi joka kerta, kun avaamme listaus- tai yksittäisen työpaikkasivun.",
  "dashboard.crawlMetricsExplainer.extracted": "Poimittu — työpaikat, jotka tallensimme varsinaisesti työpaikkasivulta. Listaus-sivut eivät vaikuta tähän.",
  "dashboard.crawlMetricsExplainer.found": "Löytynyt — pääasiassa ”kuinka monta työpaikkalinkkiä laskimme listaus-sivuilla”, plus mitä näimme työpaikkasivuilla. Suuret luvut tässä ovat normaaleja.",
  "dashboard.crawlMetricsExplainer.foundVsExtracted": "Saadaksesi kokonaiskuvan, käytä alla olevaa tuntikohtaista kaaviota: siinä purppura, ruskea ja kultainen viiva on nimetty vastaamaan tätä kuvausta.",
  "dashboard.crawlMetricsExplainer.successFailed": "Onnistunut / epäonnistunut — latautuiko sivu ja valmistuiko se ilman hakuvirhettä?",
  "dashboard.crawlMetricsExplainer.title": "Mitä nämä luvut tarkoittavat",
  "dashboard.crawlMetricsExplainer.triggerAria": "Mitä nämä haun yhteenvetoluvut tarkoittavat",
  "dashboard.crawlOkIconTooltip": "Tämä haku onnistui (HTTP OK, ei hakuohjelmiston virhettä).",
  "dashboard.crawlOutliersFilter.all": "Kaikki hakurivit",
  "dashboard.crawlOutliersFilter.any": "Haettu, mutta ei lähetetty",
  "dashboard.crawlOutliersFilter.hint": "Käyttää vain IndexedDB-vienti-kenttiä. Listasivun rivit piilotetaan, kun tämä ei ole ”Kaikki”. Yhdistä tasaisiin ”Job / list pages” -välilehtiin.",
  "dashboard.crawlOutliersFilter.label": "Pipeline- / indeksipoikkeamat (yksityiskohtaiset haku)",
  "dashboard.crawlOutliersFilter.notSent": "Haku onnistui, mutta jobsExtracted = 0 (ei ohitettu)",
  "dashboard.crawlRecords": "Hakuennätykset",
  "dashboard.crawlStatistics": "Hakutilastot",
  "dashboard.crawlType": "Hakutyyppi",
  "dashboard.crawlingInformation": "Hakutiedot",
  "dashboard.deleteComment": "Poista kommentti",
  "dashboard.deleteCompany": "Poista",
  "dashboard.deleteCompany.confirm": "Poistetaanko \"{name}\" Companies-taulukosta (DynamoDB)? Tätä toimintoa ei voi peruuttaa. Tähän yritykseen liittyvät paikallisen hallintapaneelin rivit poistetaan.",
  "dashboard.deleteCompany.done": "Yritys \"{name}\" poistettiin.",
  "dashboard.deleteCompany.failed": "Yrityksen poistaminen epäonnistui: {message}",
  "dashboard.deleteCompany.modalTooltip": "Poista tämä yritys Yritykset-taulukosta (DynamoDB)",
  "dashboard.deleteCompany.rowTooltip": "Poista yritys DynamoDB:stä ja poista paikallisesta hallintapaneelista",
  "dashboard.deleteCompany.virtualBlocked": "Työmarkkinatorin kooste-rivi ei ole Yritykset-taulukon tietue. Sitä ei voi poistaa tästä.",
  "dashboard.detailPages": "Yksityiskohtasivut",
  "dashboard.details": "Tiedot",
  "dashboard.dlqEmpty": "DLQ on tyhjä - ei epäonnistuneita viestejä",
  "dashboard.dlqMessageCount": "{count} {count, plural, one {viesti} other {viestiä}} DLQ:ssa",
  "dashboard.dlqViewer": "Dead Letter Queue -katselu",
  "dashboard.duration": "Kesto",
  "dashboard.editCompany": "Muokkaa",
  "dashboard.enqueueUrlPattern": "Jonotus-URL-malli",
  "dashboard.error": "Virhe",
  "dashboard.failed": "Epäonnistuneet",
  "dashboard.failedToLoadCompanySettings": "Yrityksen asetusten lataaminen epäonnistui: {error}",
  "dashboard.filterByField": "Suodata kentän mukaan",
  "dashboard.filterValue": "Suodatinarvo... (käytä __NOT_EMPTY__ tyhjien poistamiseen)",
  "dashboard.flatView.noCrawlRows": "Ei näytettäviä rivejä tasanäkymässä. Lataa ensin crawl-vienti-tiedot.",
  "dashboard.flatViews.colActions": "Toiminnot",
  "dashboard.flatViews.colActionsTooltip": "Sivuston live-listaus, S3-HTML-tilannekuva kun saatavilla.",
  "dashboard.flatViews.colCompany": "Yritys",
  "dashboard.flatViews.colCompanyTooltip": "Crawl-tietueeseen tallennettu yrityksen nimi.",
  "dashboard.flatViews.colDuration": "Kesto",
  "dashboard.flatViews.colDurationTooltip": "Tähän crawl-pyyntöön käytetty haku- ja käsittelyaika.",
  "dashboard.flatViews.colHttpTooltip": "Tämän pyynnön HTTP-vastaustila (esim. 200 = OK).",
  "dashboard.flatViews.colMetrics": "Löytyi / lähetetty",
  "dashboard.flatViews.colMetricsTooltip": "Lista: jonotetut työpaikat. Yksityiskohdat: lähetetty prosessoijalle vai ei. Muut sivutyypit: raakamäärät. Vie hiiri solun päälle nähdäksesi lisätietoja.",
  "dashboard.flatViews.colOkTooltip": "Vihreä: crawl onnistui. Punainen: epäonnistui tai virheellinen HTTP. Jos samalle URL-osoitteelle on useita ajoja, vie hiiri aikasarakeen päälle nähdäksesi tilan per ajo.",
  "dashboard.flatViews.colPage": "Sivu",
  "dashboard.flatViews.colPageTooltip": "Sivutyyppi (lista vs. yksityiskohdat) ja tunnisteet: TMT, Ohitettu, Y-tunnus-vihjeet jne.",
  "dashboard.flatViews.colPipelineLogsTooltip": "Linkit CloudWatch-lokivirtoihin crawlerille, prosessorille ja liittyville vaiheille.",
  "dashboard.flatViews.colTime": "Aika",
  "dashboard.flatViews.colTimeTooltip": "Milloin tämä haku alkoi. Jos sama URL on haettu useammin kuin kerran, tässä rivissä näytetään uusin haku.",
  "dashboard.flatViews.colTrace": "Pipeline-lokit",
  "dashboard.flatViews.colTraceFull": "Jälkitys",
  "dashboard.flatViews.colTraceFullTooltip": "Avaa koko työn pipeline-jälkitys (Raw/Final/Enriched, DynamoDB & CloudWatch).",
  "dashboard.flatViews.colUrlTooltip": "Crawlerin noutama URL.",
  "dashboard.flatViews.colYtunnusTooltip": "Vain Työmarkkinatori: onko HTML-koodista poimittu suomalaista Y-tunnusta ja täsmännytkö se yritystietokantaasi.",
  "dashboard.flatViews.crawlRunCount": "{n} hakua",
  "dashboard.flatViews.failure.algolia": "Algolia-virheet (metatiedot)",
  "dashboard.flatViews.failure.all": "Kaikki tulokset",
  "dashboard.flatViews.failure.cookie": "Eväste / peitekerros",
  "dashboard.flatViews.failure.nav": "Navigointi / aikakatkaisu",
  "dashboard.flatViews.failure.net": "Verkko",
  "dashboard.flatViews.failure.ok": "Haku onnistui",
  "dashboard.flatViews.failure.other": "Muu hakuvirhe",
  "dashboard.flatViews.failureFilterLabel": "Hakuun liittyvä tulos",
  "dashboard.flatViews.first": "Ensimmäinen",
  "dashboard.flatViews.hint": "Lajittelu, Lähde, Poikkeamat ja Crawl-tulos koskevat vain tätä taulukkoa. Rivit ryhmittelevät saman URL-osoitteen toistuvat haku-kerrat (uusin ensin; hakukertojen määrä aikasarakeessa). Poikkeamat käyttävät vain työn yksityiskohtien rivejä (Algolia-virheet metatiedoissa tai haku onnistui, mutta jobsExtracted on 0 eikä sitä ohitettu). Crawl-tulos käyttää IndexedDB-vienti-kenttiä (ei live Dynamoa). Käytä Trace-toimintoa rivillä ladataksesi Raw/Final/Enriched-tiedot sekä AWS-konsolin linkit. Rivijoukko käyttää samoja suodattimia (Työmarkkinatori, TMT Y-tunnus) kuin yllä.",
  "dashboard.flatViews.jobPages": "Kaikki työpaikkasivut",
  "dashboard.flatViews.last": "Viimeinen",
  "dashboard.flatViews.listPages": "Kaikki listasivut",
  "dashboard.flatViews.next": "Seuraava",
  "dashboard.flatViews.pageJumpLabel": "Siirry sivulle",
  "dashboard.flatViews.pageOf": "Sivu {p} / {t} ({n} riviä)",
  "dashboard.flatViews.prev": "Edellinen",
  "dashboard.flatViews.sort.companyAsc": "Yritys · A–Ö",
  "dashboard.flatViews.sort.companyDesc": "Yritys · Ö–A",
  "dashboard.flatViews.sort.failedFirst": "OK · epäonnistumiset ensin",
  "dashboard.flatViews.sort.jobsFoundAsc": "Löytyneet työt · pienestä → suureen",
  "dashboard.flatViews.sort.jobsFoundDesc": "Löytyneet työt · suuresta → pieneen",
  "dashboard.flatViews.sort.successFirst": "OK · onnistumiset ensin",
  "dashboard.flatViews.sort.timeAsc": "Aika · vanhimmat ensin",
  "dashboard.flatViews.sort.timeDesc": "Aika · uusimmat ensin",
  "dashboard.flatViews.sort.urlAsc": "URL · A–Ö",
  "dashboard.flatViews.sort.urlDesc": "URL · Ö–A",
  "dashboard.flatViews.sortLabel": "Lajittele",
  "dashboard.flatViews.source.all": "Kaikki crawlaukset",
  "dashboard.flatViews.source.nonTmt": "Poissulje Työmarkkinatori",
  "dashboard.flatViews.source.tmtOnly": "Vain Työmarkkinatori",
  "dashboard.flatViews.sourceLabel": "Lähde",
  "dashboard.flatViews.title": "Flat crawl -näkymät",
  "dashboard.flatViews.yt.legacy": "Vanhempi rivi: ei Y-tunnus-metadataa (uudelleenhaku luokittelua varten)",
  "dashboard.flatViews.yt.na": "Ei Työmarkkinatorin yksityiskohtainen rivi",
  "dashboard.flatViews.yt.nocompany": "Y-tunnus poimittu, mutta ei löytynyt CompaniesTable-taulukosta",
  "dashboard.flatViews.yt.none": "Y-tunnusta ei poimittu sivun HTML-koodista",
  "dashboard.flatViews.yt.ok": "Y-tunnus poimittu ja yritys täsmää",
  "dashboard.greenSuccess": "Vihreä (Onnistunut)",
  "dashboard.groupBy": "Ryhmittele",
  "dashboard.groupCrawlCount": "Haku-kerrat",
  "dashboard.groupJobsCount": "Työpaikkojen määrä",
  "dashboard.groupLogoFailed": "Logon tila",
  "dashboard.groupMetrics": "Mittarit",
  "dashboard.groupNone": "Ei mitään",
  "dashboard.groupPaginationIssue": "Sivutuspulmat",
  "dashboard.groupStatus": "Tila (Punainen/Keltainen/Vihreä)",
  "dashboard.groupStatusIssues": "Tilat ja ongelmat",
  "dashboard.groupSuccessRate": "Onnistumisprosentti",
  "dashboard.hasAnyFailedCrawl": "Mikä tahansa epäonnistunut haku (ikkunassa)",
  "dashboard.hasComments": "Sisältää kommentteja",
  "dashboard.hasCrawlData.label": "Haku-tiedot",
  "dashboard.hasCrawlData.option": "Sisältää tietoja",
  "dashboard.heroImage": "Sankarikuva",
  "dashboard.howToRunCrawl": "Kuinka suorittaa haku",
  "dashboard.htmlModal.liveExtractedHint": "Sama objektitunnus kuin hakuindeksissä. Pitkät tekstikentät on lyhennetty näkymää varten.",
  "dashboard.htmlModal.liveExtractedTitle": "Reaaliaikaisesti louhittu työpaikka (DynamoDB)",
  "dashboard.htmlModal.loadingLive": "Ladataan FinalJobs / Enriched…",
  "dashboard.htmlModal.noJobUrl": "Tällä hakurivillä ei ole URL-osoitetta – reaaliaikaisia työpaikkatiueita ei voida hakea.",
  "dashboard.httpStatusCellTooltip": "Tämän pyynnön HTTP-vastausstatus (esim. 200 = OK, 404 = ei löytynyt).",
  "dashboard.industry": "Toimiala",
  "dashboard.isChecked": "Tarkistettu",
  "dashboard.isSaved": "Tallennettu",
  "dashboard.issuesOnly": "Vain ongelmat",
  "dashboard.itemsPerPage": "Kohteita sivulla",
  "dashboard.jobLookup.activeHint": "Näytetään yksityiskohtaiset haku-tulokset työlle ID: {id}",
  "dashboard.jobLookup.clear": "Tyhjennä vientisuodatin",
  "dashboard.jobLookup.find": "Etsi viennistä",
  "dashboard.jobLookup.noMatchInExport": "Ladatussa ikkunassa ei ole yksityiskohtaista hakua tällä työ-ID:llä. Lataa hakudata uudelleen tai laajenna vienti-ikkunaa.",
  "dashboard.jobLookup.parseError": "Työpaikkatunnusta ei löytynyt. Liitä JobCrawls-työpaikkasivun koko URL-osoite (…/en/job/…/company/…) tai osoitepalkin objektitunnus.",
  "dashboard.jobLookup.placeholder": "Liitä työpaikkasivun URL-osoite tai objektitunnus…",
  "dashboard.jobLookup.resolvingIds": "yhdistetään työpaikkatunnuksia hakuun…",
  "dashboard.jobSearch.matchExportLabel": "Hae ladatusta crawl-viennistä",
  "dashboard.jobSearch.sectionHint": "Etsi rivejä ladatusta viennistä tai seuraa putken tilaa työpaikan URL-osoitteen avulla.",
  "dashboard.jobSearch.sectionTitle": "Työpaikkahaku",
  "dashboard.jobTrace.blurb": "Liitä täsmälleen se työpaikkailmoituksen URL-osoite, joka on tallennettu RawJobs-tietokantaan. Hallintapaneeli lataa RawJobs-, FinalJobs- ja EnrichedFinalJobs-tiedot, päättelee kuinka pitkälle työpaikka eteni ja linkittää DynamoDB-tauluihin sekä CloudWatch-lokisuodattimiin.",
  "dashboard.jobTrace.close": "Sulje",
  "dashboard.jobTrace.dynamo": "DynamoDB (konsoli)",
  "dashboard.jobTrace.failureCode": "Koodi: {code}",
  "dashboard.jobTrace.load": "Hae kaikki tiedot",
  "dashboard.jobTrace.loading": "Ladataan jäljitystä…",
  "dashboard.jobTrace.logs": "CloudWatch (suodatin)",
  "dashboard.jobTrace.modalTitle": "Putken jäljitys",
  "dashboard.jobTrace.noAwsLinks": "Konsolilinkit eivät ole käytettävissä (putken lokiympäristö on puutteellinen).",
  "dashboard.jobTrace.noLogContext": "Putken lokiympäristön muuttujat puuttuvat API:sta — Dynamon linkit toimivat edelleen; määritä PIPELINE_LOG_GROUP_* Dashboard Lambdassa, jotta CloudWatch-syvälinkit näkyvät API-vastauksessa.",
  "dashboard.jobTrace.rawJson": "Kohteiden yhteenvedot (JSON)",
  "dashboard.jobTrace.title": "Putken jäljitys (Dynamo & CloudWatch)",
  "dashboard.jobTrace.urlLabel": "Työn URL",
  "dashboard.jobTrace.visual": "Putken edistyminen",
  "dashboard.jobsEnqueued": "{count} tehtävää jonossa",
  "dashboard.jobsEnqueuedCellTooltip": "Listahaku: tällä sivulla löydetyt ja yksityiskohtaiseen hakuun jonotetut työpaikkojen URL-osoitteet. ”Listasivut” sisältää myös muut jonotetut listaus-URL-osoitteet (esim. sivunumerointi).",
  "dashboard.jobsExtracted": "Poimitut tehtävät",
  "dashboard.jobsFound": "Löydetyt tehtävät",
  "dashboard.layout.company": "Yrityksittäin",
  "dashboard.layout.flat": "Yksittäiset haut",
  "dashboard.layout.label": "Asettelu",
  "dashboard.listPages": "Listasivut",
  "dashboard.listPagesEnqueued": "{count} listasivua",
  "dashboard.liveJobLink": "Live-työpaikka",
  "dashboard.loadAllCompanies": "Lataa kaikki yritykset (86k)",
  "dashboard.loadCompaniesButton": "Lataa yritykset",
  "dashboard.loadedCompanies": "Ladattu: {current} / {total} yritystä",
  "dashboard.loadedCompaniesUnknown": "Ladattu: {current} yritystä",
  "dashboard.loadingAllCompanies": "Ladataan kaikkia yrityksiä — hitaampi alkuvaiheen lataus",
  "dashboard.loadingBatch": "Käsitellään erää {current} noin {total}:sta",
  "dashboard.loadingCompanies": "Ladataan yritystietoja",
  "dashboard.loadingCompaniesWithUrls": "Ladataan vain yritykset, joilla on verkkosivuosoite — nopeampi",
  "dashboard.loadingNote": "Tämä voi kestää muutaman minuutin. Pidä tämä sivu auki.",
  "dashboard.logoFailed": "Logon lataus epäonnistui",
  "dashboard.logoFailedBadgeTitle": "Logon lataaminen hallintapaneeliin epäonnistui — käytä alla olevia Logo Lambda - lokeja ProcessCompanyLogos-tulosten tarkistamiseen",
  "dashboard.logoProcessingFailedBadgeTitle": "ProcessCompanyLogos epäonnistui ({failedAt}): {error}",
  "dashboard.logoProcessingFailedUnknownDate": "tuntematon päivämäärä",
  "dashboard.logoUrlFailedLabel": "Epäonnistui",
  "dashboard.map": "Kartta",
  "dashboard.menu.overview": "Yleiskatsaus",
  "dashboard.menu.overview.metricsHelpDesc": "Vie hiiri (i)-kuvakkeen päälle nähdäksesi, mitä kukin lukema tarkoittaa.",
  "dashboard.menu.overview.metricsHelpTitle": "Mittarien määritelmät",
  "dashboard.menu.overview.noExport": "Lataa crawl-vientiä (Työkalut) nähdäksesi yhteenvetoluvut.",
  "dashboard.menu.overview.pipelineDesc": "Maintainer-snapshot vs. crawl-ikkuna.",
  "dashboard.menu.overview.summaryDesc": "Luvut tässä selaimessa ladatusta crawl-JSON-tiedostosta.",
  "dashboard.menu.overview.summaryTitle": "Viennin yhteenveto",
  "dashboard.menu.refine": "Tarkenna",
  "dashboard.metricsFoundExtractedTooltip": "Löytyneet työt vs. tämän sivutyypin kohdalta poimitut työt (ei vakioitu luettelo/yksityiskohtainen rivi).",
  "dashboard.mostRecent": "Viimeisin",
  "dashboard.next": "Seuraava",
  "dashboard.noCrawlData.message": "Hakuaineistoa ei ole vielä saatavilla. Laajenna yllä oleva \"Kuinka suorittaa haku\" -osio saadaksesi ohjeet haun suorittamiseen ja tietojen vientiin.",
  "dashboard.noCrawlData.option": "Ei tietoja",
  "dashboard.noCrawlData.withServerDetail": "Hakuviestiä ei ole saatavilla: {detail}. Jos käytät localhostia, varmista, että AWS-tunnuksilla on lukuoikeus crawl-data-bucketiin ja että Maintainer on kirjoittanut tiedoston crawl-exports/latest.json.",
  "dashboard.noFieldFilter": "Ei kenttäsuodatinta",
  "dashboard.noIssues": "Ei ongelmia",
  "dashboard.noLogoUrl": "Ei logo-URL-osoitetta",
  "dashboard.notSent": "Ei lähetetty",
  "dashboard.notSentTooltip": "Työpaikkadataa ei louhittu (jobsExtracted on 0). Tämä ei ole sama asia kuin ”Ohitettu”: Ohitettu tarkoittaa, että crawler ei tietoisesti suorittanut ajoa uudelleen, koska työpaikka löytyi jo RawJobs-taulusta.",
  "dashboard.pageInfo": "Sivu {current} / {total}",
  "dashboard.pageType": "Sivutyyppi",
  "dashboard.pageType.detailTooltip": "Yksityiskohtainen sivu: yksittäisen työpaikkailmoituksen URL. Crawler louhii jäsenneltyä dataa ja voi lähettää sen prosessoijalle.",
  "dashboard.pageType.genericTooltip": "Crawlerin sivutyyppi: {pageType}.",
  "dashboard.pageType.listTooltip": "Listasivu: etsii työpaikkalinkkejä listaus- tai hakusivulta ja lisää ne jonoon yksityiskohtaista louhintaa varten.",
  "dashboard.pagination.allRows": "Kaikki",
  "dashboard.pagination.first": "Ensimmäinen",
  "dashboard.pagination.last": "Viimeinen",
  "dashboard.pagination.navGroup": "Sivunavigointi",
  "dashboard.pagination.pageJumpAria": "Sivunumero, 1–{total}",
  "dashboard.pagination.pageJumpLabel": "Siirry sivulle",
  "dashboard.paginationIssueDescription": "Lähetetty tarkalleen {count} työpaikkaa – tämä voi viitata puutteelliseen sivutukseen.",
  "dashboard.pipelineHealth.active": "Aktiivinen",
  "dashboard.pipelineHealth.activeFinland": "Aktiivinen + Suomi",
  "dashboard.pipelineHealth.activeNotFinland": "Aktiivinen, ei Suomi",
  "dashboard.pipelineHealth.crawlCompare.body": "Työmarkkinatori-haun riveiltä poimitut työpaikat (jobsExtracted-summa): {count}. Vertaa yllä olevaan kohtaan ”Active Työmarkk. (URL)” — suuret erot johtuvat usein vanhentuneesta lastSeen-merkinnästä (ei-aktiivinen), prosessointijonon ruuhkasta tai URL/companyId-ristiriidoista.",
  "dashboard.pipelineHealth.crawlCompare.title": "Haku-exportti (tämä ikkuna)",
  "dashboard.pipelineHealth.generatedAt": "Snapshot Maintainer-skannauksesta: {when}",
  "dashboard.pipelineHealth.inactive": "Epäaktiivinen",
  "dashboard.pipelineHealth.missingStats": "Ei vielä snapshotia. Lukumäärät ilmestyvät tähän seuraavan onnistuneen Maintainer-ajon (CRAWL_DATA_BUCKET asetettuna) jälkeen. Päivitä crawl-tiedot Maintainerin jälkeen.",
  "dashboard.pipelineHealth.title": "Pipelinen kunto (FinalJobs)",
  "dashboard.pipelineHealth.totalRows": "FinalJobs-rivit",
  "dashboard.pipelineHealth.tyoFlag": "Aktiivinen Työmarkk. (lippu)",
  "dashboard.pipelineHealth.tyoUrl": "Aktiivinen Työmarkk. (URL)",
  "dashboard.pipelineHealth.tyoUrlBadFinland": "Työmarkk. URL + ei Suomi",
  "dashboard.pipelineLogs.allGroups": "Lambda-lokiryhmät",
  "dashboard.pipelineLogs.aria": "CloudWatch-lokilinkit crawl → processor → enrich → Algolia → maintainer -polun mukaisesti",
  "dashboard.pipelineLogs.crawlSearch": "Haku (crawlId)",
  "dashboard.pipelineLogs.crawlStream": "Hakuvirta",
  "dashboard.pipelineLogs.enrich": "Rikastaminen",
  "dashboard.pipelineLogs.maintainer": "Ylläpitäjä",
  "dashboard.pipelineLogs.noObjectId": "ObjectID-linkit vain yksityiskohtaisilla riveillä",
  "dashboard.pipelineLogs.processor": "Prosessori",
  "dashboard.pipelineLogs.processorUrl": "Prosessori (URL)",
  "dashboard.pipelineLogs.unconfigured": "Aseta PIPELINE_LOG_GROUP_* Dashboard- tai API Lambdaan lokilinkkejä varten",
  "dashboard.potentialPaginationIssue": "Mahdollinen sivutusongelma",
  "dashboard.previous": "Edellinen",
  "dashboard.processCompanyLogoLogs.link": "Logo Lambda -lokit",
  "dashboard.processCompanyLogoLogs.tooltip": "Avaa ProcessCompanyLogos-lokiryhmä CloudWatchista (suodatettuna tämän yrityksen tunnuksen mukaan)",
  "dashboard.processDlq": "Käsittele DLQ",
  "dashboard.quickFilterUncrawled": "Ei haetut · korkein pistemäärä",
  "dashboard.quickFilterUncrawled.tooltip": "Näytä yritykset, joissa doCrawl ei ole TRUE, järjestettynä pistemäärän mukaan laskevasti — hyödyllinen tärkeimpien ei-haettujen yritysten manuaaliseen käsittelyyn",
  "dashboard.recordCount": "{count} {count, plural, one {tietue} other {tietuetta}}",
  "dashboard.recrawl": "Hae uudelleen",
  "dashboard.recrawlDetailTriggered": "Yksityiskohtien uudelleenhaku jonotettu yritykselle {companyName}",
  "dashboard.recrawlTriggered": "Uudelleenhaku käynnistetty yritykselle {companyName}",
  "dashboard.recrawling": "Uudelleenhaku käynnissä…",
  "dashboard.redLastCrawlFailed": "[Punainen] – viimeisin haku epäonnistui",
  "dashboard.refine.quickOptionsTitle": "Pikavalinnat",
  "dashboard.refine.section.companyList": "Yritysluettelo",
  "dashboard.refine.section.companyListDesc": "Rajaa luettelossa näkyviä yrityksiä.",
  "dashboard.refine.section.fieldFilterDesc": "Hae tietyn yrityskentän (ja valinnaisen arvon) perusteella.",
  "dashboard.refine.section.pipelineIndex": "Pipeline & indeksi",
  "dashboard.refine.section.pipelineIndexDesc": "Ladatun viennin yksityiskohtaiset haku-signaalit.",
  "dashboard.refine.section.tyomarkkinatoriDesc": "Suodata Työmarkkinatori-tunnisteiset rivit ja Y-tunnus-metatiedot.",
  "dashboard.refreshCompanies": "Päivitä yritykset",
  "dashboard.refreshCrawlData": "Päivitä hakuaineisto",
  "dashboard.refreshCrawlData.title": "Päivitä hakuaineisto S3-tallennustilasta",
  "dashboard.refreshing": "Päivitetään...",
  "dashboard.registryInformation": "Rekisteritiedot",
  "dashboard.result": "Tulos",
  "dashboard.runMaintainer": "Aja ylläpitotyökalu",
  "dashboard.running": "Ajetaan...",
  "dashboard.save": "Tallenna",
  "dashboard.saveError": "Virhe",
  "dashboard.saved": "Tallennettu",
  "dashboard.saving": "Tallennetaan…",
  "dashboard.scanningDatabase": "Skannataan tietokantaa ja ladataan yrityksiä...",
  "dashboard.searchCompanies": "Hae yrityksiä...",
  "dashboard.sentForProcessing": "✓ Lähetetty käsiteltäväksi",
  "dashboard.sentForProcessingTooltip": "Strukturoidut työpaikkatiedot on uutettu (jobsExtracted ≥ 1) ja lähetetty käsittelyputkeen (SQS / processor).",
  "dashboard.sentToProcessor": "Lähetetty prosessoriin",
  "dashboard.showing": "Näytetään {filtered} / {total} yritystä",
  "dashboard.skipped": "Ohitettu",
  "dashboard.skippedCrawlTooltip": "Ohitettu: crawler ei hakenut tätä URL-osoitetta uudelleen, koska työpaikka oli jo tallennettu RawJobs-tauluun (duplikaattien esto). Crawl-rivi on silti tallennettu näkyvyyden varmistamiseksi.",
  "dashboard.socialMedia": "Sosiaali media",
  "dashboard.sortAndGroup.sectionHint": "Muuta listan järjestystä ja valinnaista ryhmittelyä.",
  "dashboard.sortAndGroup.sectionTitle": "Lajittelu ja ryhmittely",
  "dashboard.sortAscending": "Nouseva",
  "dashboard.sortBasic": "Perus",
  "dashboard.sortBy": "Lajitteluperuste",
  "dashboard.sortCrawls": "Hakuajat",
  "dashboard.sortDescending": "Laskeva",
  "dashboard.sortDetailPages": "Yksityiskohtaiset sivut",
  "dashboard.sortDirection": "Lajittele {direction}",
  "dashboard.sortFailed": "Epäonnistuneet haku-kerrat",
  "dashboard.sortJobs": "Työt",
  "dashboard.sortJobsExtracted": "Kaikki poimitut työt",
  "dashboard.sortJobsFound": "Kaikki löydetyt työt",
  "dashboard.sortJobsSent": "Käsittelyyn lähetetyt työt",
  "dashboard.sortLastCrawl": "Viimeisin haku-päivämäärä",
  "dashboard.sortListPages": "Listasivut",
  "dashboard.sortMostRecentJobs": "Viimeisimmät löydetyt työt",
  "dashboard.sortName": "Yrityksen nimi",
  "dashboard.sortPages": "Sivut",
  "dashboard.sortStatus": "Tila",
  "dashboard.sortSuccessRate": "Onnistumisprosentti",
  "dashboard.sortSuccessful": "Onnistuneet hakuet",
  "dashboard.status": "Tila",
  "dashboard.successRate": "Onnistumisprosentti",
  "dashboard.successful": "Onnistuneet",
  "dashboard.summary.extractedLabel": "Poimitut tehtävät",
  "dashboard.summary.failedLabel": "Epäonnistuneet",
  "dashboard.summary.foundLabel": "Löytyneet tehtävät",
  "dashboard.summary.successLabel": "Onnistuneet",
  "dashboard.summary.totalCrawls": "Kierroksia yhteensä",
  "dashboard.summary.uniqueUrls": "Uniikit URL-osoitteet",
  "dashboard.syncingCompanySettings": "Synkronoidaan yrityksen asetuksia...",
  "dashboard.time": "Aika",
  "dashboard.title": "Kierrosten hallintapaneeli",
  "dashboard.tmtBadge.noYtunnus": "Työmarkkinatori-yksityiskohta: Y-tunnusta ei erotettu HTML-koodista",
  "dashboard.tmtBadge.noYtunnusShort": "Ei Y-tunnusta",
  "dashboard.tmtBadge.yTunnusNoCompany": "Y-tunnus erotettu, mutta vastaavaa yritystä ei löytynyt CompaniesTable-taulukosta",
  "dashboard.tmtBadge.yTunnusNoCompanyShort": "Y-tunnus / ei yritystä",
  "dashboard.tmtBadge.yTunnusUnknown": "Vanhempi kierrosrivi: Y-tunnuksen metadataa ei ole vielä tallennettu (luokittele uudelleen kierroksella)",
  "dashboard.tmtSourceTooltip": "Tämä työpaikka on haettu Työmarkkinatorilta (TE-palvelut / julkiset työpaikkailmoitukset).",
  "dashboard.tmtYtunnusFilter.all": "Kaikki",
  "dashboard.tmtYtunnusFilter.noCompany": "Y-tunnusta ei löydy yrityksistä",
  "dashboard.tmtYtunnusFilter.noExtract": "Y-tunnusta ei voitu hakea",
  "dashboard.toolsModal.actionsHeading": "Toiminnot",
  "dashboard.toolsModal.closeBackdrop": "Sulje",
  "dashboard.toolsModal.closeButton": "Sulje",
  "dashboard.toolsModal.openButton": "Työkalut ja asetukset",
  "dashboard.toolsModal.openButtonSr": "Avaa ylläpitäjän työkalut, päivitykset, DLQ ja hakuohjeet",
  "dashboard.toolsModal.title": "Työkalut ja asetukset",
  "dashboard.totalCrawls": "Kokonaislouhinnat",
  "dashboard.tyomarkkinatoriCrawlFilter.all": "Kaikki louhinnat",
  "dashboard.tyomarkkinatoriCrawlFilter.nonTmt": "Vain muut kuin TMT-rivit",
  "dashboard.tyomarkkinatoriCrawlFilter.tmtOnly": "Vain TMT-rivit",
  "dashboard.uncheck": "Poista valinta",
  "dashboard.unsave": "Poista tallennetuista",
  "dashboard.viewAttributes": "Näytä attribuutit",
  "dashboard.viewJobs": "Näytä",
  "dashboard.viewMessageBody": "Näytä viestin sisältö",
  "dashboard.viewOnGoogleMaps": "Näytä Google Mapsissa",
  "dashboard.yellowNoJobs": "Keltainen (ei työpaikkoja)",
  "employerScoreCard.dimension.flexibility": "joustavuus",
  "employerScoreCard.dimension.growth": "kasvu",
  "employerScoreCard.dimension.pay": "palkkaus",
  "employerScoreCard.dimension.stability": "vakaus",
  "employerScoreCard.disclaimer": "Laskettu työpaikkadatasta – ei arvosteluihin perustuva",
  "employerScoreCard.howWeCalculate": "Näin laskemme tämän",
  "employerScoreCard.methodology": "Pisteet perustuvat julkaistujen palkkahaitarien kilpailukykyyn (siellä, missä meillä on riittävästi ilmoituksia), etä- ja hybridityön joustavuuteen, rekrytoinnin vakauteen ajan myötä sekä kasvusignaaleihin, jotka on johdettu roolien jakautumisesta ja rekrytointivolyymin trendeistä. Edut ja ilmoitustason läpinäkyvyys on jätetty pois pääluvusta, kunnes kyseiset tietovirrat on yhdistetty pisteytykseen.",
  "employerScoreCard.strongestAt": "Vahvin osa-alue: {dimension}",
  "employerScoreCard.subscore.benefits": "Edut",
  "employerScoreCard.subscore.flexibility": "Joustavuus",
  "employerScoreCard.subscore.growth": "Kasvu",
  "employerScoreCard.subscore.pay": "Palkkaus",
  "employerScoreCard.subscore.stability": "Vakaus",
  "employerScoreCard.subscore.transparency": "Läpinäkyvyys",
  "employerScoreCard.title": "JobCrawls-työnantajapisteet",
  "employerScoreCard.trackedOnlyHeading": "Myös seurattu, ei vielä painotettu",
  "engagement.nav.feedback": "Palaute",
  "engagement.nav.signIn": "Kirjaudu sisään",
  "facets.benefits": "Etu",
  "facets.company": "Yritys",
  "facets.companyIndustry": "Toimiala",
  "facets.education": "Koulutus",
  "facets.field": "Ala",
  "facets.jobType": "Työsuhteen tyyppi",
  "facets.language": "Kieli",
  "facets.location": "Sijainti",
  "facets.management": "Johtajuus",
  "facets.remoteness": "Työskentelymalli",
  "facets.role": "Rooli",
  "facets.roleLevel": "Roolitaso",
  "facets.skills": "Taito",
  "feedback.button.label": "Anna palautetta",
  "feedback.cancel": "Peruuta",
  "feedback.error": "Palautteen lähettäminen epäonnistui. Yritä uudelleen.",
  "feedback.label": "Palautteesi",
  "feedback.modal.close": "Sulje",
  "feedback.modal.description": "Haluamme kuulla mielipiteesi. Jaa palautteesi auttaaksesi meitä kehittymään.",
  "feedback.modal.title": "Lähetä palautetta",
  "feedback.page.anonymous": "Anonyymi",
  "feedback.page.delete": "Poista palaute",
  "feedback.page.deleteConfirm": "Oletko varma, että haluat poistaa tämän palautteen?",
  "feedback.page.deleteError": "Palautteen poistaminen epäonnistui. Yritä uudelleen.",
  "feedback.page.description": "Tarkastele ja hallitse käyttäjäpalautteita",
  "feedback.page.listTitle": "Kaikki palautteet",
  "feedback.page.noFeedback": "Ei vielä palautteita",
  "feedback.page.refresh": "Päivitä",
  "feedback.page.submitTitle": "Lähetä palautetta",
  "feedback.page.title": "Palaute",
  "feedback.page.viewMetadata": "Näytä metatiedot",
  "feedback.placeholder": "Kerro meille, mitä meidän pitäisi muuttaa tai lisätä...",
  "feedback.postSubmit.signInBody": "Luo ilmainen tili, jotta voimme vastata, jos meillä on kysyttävää palautteestasi.",
  "feedback.postSubmit.signInButton": "Kirjaudu sisään tai luo tili",
  "feedback.postSubmit.signInTitle": "Haluatko, että otamme yhteyttä?",
  "feedback.submit": "Lähetä",
  "feedback.submitting": "Lähetetään...",
  "feedback.success": "Kiitos! Palautteesi on lähetetty.",
  "filters.allFilters.navigation": "Kaikki suodatinvaihtoehdot",
  "filters.connector.and": "JA",
  "filters.connector.or": "TAI",
  "filters.navigation": "Suodatinvaihtoehdot",
  "filters.top.clearAll": "Tyhjennä kaikki suodattimet",
  "footer.aboutJobcrawls": "Tietoa JobCrawlsista",
  "footer.accessibilityStatementLink": "Saavutettavuusseloste",
  "footer.aiTranslationDisclaimer": "Huomio: Osa tämän sivuston sisällöstä on tekoälyn tekemää konekäännöstä ja saattaa sisältää virheitä.",
  "footer.allLocations": "Kaikki sijainnit",
  "footer.bestEmployers": "Parhaat työnantajat",
  "footer.brandDescription": "JobCrawls on työnhakupalvelu Suomen työmarkkinoille. Indeksoimme avoimia työpaikkoja suoraan tuhansilta työnantajien urasivuilta päivittäin – englanniksi, suomeksi ja ruotsiksi – läpinäkyvin palkkatiedoin ja ilman maksettuja sijoituksia.",
  "footer.browseAllPages": "Selaa kaikkia sivuja",
  "footer.businessIdLabel": "Y-tunnus",
  "footer.colCompany": "Yritys",
  "footer.colEmployersAndDevelopers": "Työnantajat ja kehittäjät",
  "footer.colFindJobs": "Etsi työpaikkoja",
  "footer.colJobSeekers": "Työnhakijat",
  "footer.collectiveAgreementsLink": "Työehtosopimukset",
  "footer.connectorPrivacy": "Connectorin tietosuojakäytäntö",
  "footer.contact": "Ota yhteyttä",
  "footer.cookieSettings": "Evästeasetukset",
  "footer.editorialStandards": "Toimitukselliset periaatteet",
  "footer.forDevelopers": "Kehittäjille",
  "footer.forEmployersLink": "Työnantajille",
  "footer.guidesAndArticles": "Oppaat ja artikkelit",
  "footer.howCrawlerWorks": "Miten indeksointimme toimii",
  "footer.jobsInEspoo": "Työpaikat Espoossa",
  "footer.jobsInHelsinki": "Työpaikat Helsingissä",
  "footer.jobsInOulu": "Työpaikat Oulussa",
  "footer.jobsInTampere": "Työpaikat Tampereella",
  "footer.jobsInTurku": "Työpaikat Turussa",
  "footer.openJobsInFinland": "Avoimet työpaikat Suomessa",
  "footer.partnerships": "Mediayhteistyö",
  "footer.privacy": "Tietosuojaseloste",
  "footer.remoteJobs": "Etätyöt",
  "footer.salariesByRole": "Palkat ammateittain",
  "footer.signIn": "Kirjaudu sisään",
  "footer.sitemap": "Sivukartta",
  "footer.terms": "Käyttöehdot",
  "hit.applicationDeadline": "Haku päättyy: {date}",
  "hit.applied": "Hakiutunut",
  "hit.companyInsights.cue": "Yritystiedot",
  "hit.companyLinkTitle": "Avaa yritysprofiili — tietoja ja analyyseja yrityksestä {company}",
  "hit.companyProfile.aria": "Näytä yritysprofiili, rekrytointitiedot ja analyysit yrityksestä {company}",
  "hit.driversLicenseRequired": "Ajokortti vaaditaan",
  "hit.hidden": "Piilotettu",
  "hit.hide.button": "Piilota",
  "hit.hide.menu": "Piilota",
  "hit.jobTitle": "Työpaikka",
  "hit.jobTypeLinkAria": "Hae {jobType}-työpaikkoja",
  "hit.jobTypeLinkTitle": "Hae {jobType}-työpaikkoja",
  "hit.linkCopied": "Linkki kopioitu leikepöydälle!",
  "hit.locationLinkAria": "Hae työpaikkoja paikasta {location}",
  "hit.locationLinkTitle": "Hae työpaikkoja paikasta {location}",
  "hit.locationNotAvailable": "Sijaintitietoja ei ole saatavilla",
  "hit.markAsApplied.menu": "Merkitse haetuksi",
  "hit.markAsState": "Merkitse tilaksi {state}",
  "hit.moreLocations": "+{count} lisää",
  "hit.moreOptions": "Lisää vaihtoehtoja",
  "hit.openApplication": "Avoin hakemus",
  "hit.postedDate": "Julkaistu: {date}",
  "hit.postedDate.detail": "Julkaistu: {date}",
  "hit.remotenessLinkAria": "Hae {remoteness} työpaikkoja",
  "hit.remotenessLinkTitle": "Hae {remoteness} työpaikkoja",
  "hit.removeApplied": "Poista haetuista",
  "hit.roleLevelLinkAria": "Hae {roleLevel} työpaikkoja",
  "hit.roleLevelLinkLabel": "{roleLevel} työpaikat",
  "hit.roleLevelLinkTitle": "Hae {roleLevel} työpaikkoja",
  "hit.salaryNotSpecified": "Palkka ei määritelty",
  "hit.salaryNotSpecified.card": "Palkkaa ei ole määritelty",
  "hit.save": "Tallenna",
  "hit.save.detail": "Tallenna",
  "hit.saved": "Tallennettu",
  "hit.saved.detail": "Tallennettu",
  "hit.seeAd": "Tiedot",
  "hit.share": "Jaa",
  "hit.share.detail": "Jaa",
  "hit.shareError": "Jotain meni vikaan, kun työpaikkaa yritettiin jakaa.",
  "hit.summerJob": "Kesätyö",
  "hit.toast.applied": "Merkitty haetuksi",
  "hit.toast.hidden": "Työpaikka piilotettu",
  "hit.toast.saved": "Työpaikka tallennettu",
  "hit.toast.savedWithCount": "Tallennettu — {count, plural, one {# työpaikka} other {# työpaikkaa}} kohdassa Omat työpaikat",
  "hit.toast.shared": "Linkki kopioitu leikepöydälle",
  "hit.toast.unapplied": "Poistettu haetuista",
  "hit.toast.unhidden": "Työpaikka palautettu näkyviin",
  "hit.toast.unsaved": "Työpaikka poistettu tallennetuista",
  "hit.toast.viewMyJobs": "Näytä →",
  "hit.toast.viewed": "Merkitty katsotuksi",
  "hit.tooltip.details": "Näytä työpaikan täydelliset tiedot ja kuvaus",
  "hit.tooltip.filterByCompany": "Suodata työpaikat tämän yrityksen mukaan",
  "hit.tooltip.filterByJobType": "Suodata tyypin mukaan: {jobType}",
  "hit.tooltip.filterByLanguages": "Suodata vaadittujen kielten mukaan: {languages}",
  "hit.tooltip.filterByLevel": "Suodata tason mukaan: {level}",
  "hit.tooltip.filterByLocation": "Suodata sijainnin mukaan: {locations}",
  "hit.tooltip.filterByRemoteness": "Suodata etätyömahdollisuuden mukaan: {remoteness}",
  "hit.tooltip.moreOptions": "Lisää vaihtoehtoja",
  "hit.tooltip.save": "Tallenna tämä työpaikka vertailua varten",
  "hit.tooltip.saved": "Poista tallennetuista työpaikoista",
  "hit.tooltip.share": "Jaa tämä työpaikka",
  "hit.unhide": "Näytä työpaikka uudelleen",
  "hitGroup.openRoles": "{count, plural, one {# avoin työpaikka} other {# avointa työpaikkaa}}",
  "hitGroup.viewCompanyProfile": "Näytä yrityksen profiili",
  "hitV2.estMonthly": "Arvioitu kuukausipalkka",
  "hitV2.monthly": "Kuukausipalkka",
  "hitV2.viewJob": "Katso työpaikka",
  "hub.bottomNav.alerts": "Hälytykset",
  "hub.bottomNav.ariaLabel": "Työkalujen navigointi",
  "hub.bottomNav.profile": "Profiili",
  "hub.guestSyncNote": "Tallennettu tälle laitteelle — {signIn} synkronoidaksesi laitteiden välillä",
  "hub.guestSyncNote.signIn": "kirjaudu sisään",
  "hub.nav.myJobs": "Omat työpaikat",
  "hub.nav.myJobs.count": "{savedCount} tallennettua · {activeCount} aktiivista",
  "hub.nav.profile": "Profiili ja CV",
  "hub.nav.searchesAlerts": "Haut ja hälytykset",
  "hub.nav.searchesAlerts.newCount": "{count} uutta",
  "hub.nav.watchlist": "Seurattavat",
  "hub.title": "Omat työpaikat",
  "instantsearch.searchBoxLink.placeholder": "Hae työpaikkoja",
  "instantsearch.searchbox.placeholder": "Hae työpaikkoja, kieltä tai kaupunkia",
  "job.copyCompanyName": "Kopioi yrityksen nimi",
  "jobAlerts.confirm.confirm": "Vahvista",
  "jobAlerts.confirm.errorBody": "Jotain meni vikaan. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.confirm.explanation": "Vahvista sähköpostiosoitteesi aloittaaksesi JobCrawlsin työpaikkailmoitusten vastaanottamisen.",
  "jobAlerts.confirm.heading": "Vahvista työpaikkavahtisi",
  "jobAlerts.confirm.invalidLink": "Tämä vahvistuslinkki on virheellinen tai vanhentunut. Ota ilmoitukset uudelleen käyttöön tallennetuista hauistasi saadaksesi uuden linkin.",
  "jobAlerts.confirm.successBody": "Kaikki valmista – lähetämme sinulle sähköpostia, kun uusia työpaikkoja löytyy tallennettuja hakujasi vastaten.",
  "jobAlerts.confirm.successHeading": "Sähköpostiosoitteesi on vahvistettu",
  "jobAlerts.confirm.working": "Vahvistetaan…",
  "jobAlerts.newMatches.errorBody": "Uusia osumia ei voitu ladata. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.newMatches.viewAllInSection": "Näytä kaikki {count} uutta osumaa",
  "jobAlerts.panel.activeStatus": "Hälytykset ovat käytössä – voit määrittää ne hakuittain alta.",
  "jobAlerts.panel.consentCopy.v1": "Saat sähköpostia, kun tallennetuille hauillesi, joille olet ottanut hälytykset käyttöön, löytyy uusia työpaikkoja – oletusarvoisesti viikoittain maanantaiaamuisin tai päivittäin, jos niin haluat. Viestit lähetetään osoitteeseen {email}. Voit peruuttaa tilauksen milloin tahansa täältä tai jokaisen sähköpostin tilauslinkin kautta. Emme lähetä mitään muita sähköposteja.",
  "jobAlerts.panel.disable": "Kytke sähköpostihälytykset pois päältä",
  "jobAlerts.panel.enable": "Ota sähköpostihälytykset käyttöön",
  "jobAlerts.panel.error": "Tallennus epäonnistui. Yritä uudelleen.",
  "jobAlerts.panel.frequencyDaily": "Päivittäin",
  "jobAlerts.panel.frequencyLegend": "Kuinka usein",
  "jobAlerts.panel.frequencyWeekly": "Viikoittain (maanantaiaamuisin)",
  "jobAlerts.panel.heading": "Sähköposti-ilmoitukset",
  "jobAlerts.panel.languageLegend": "Sähköpostin kieli",
  "jobAlerts.panel.noEmail": "Tililläsi ei ole sähköpostiosoitetta, joten ilmoitukset eivät ole käytettävissä.",
  "jobAlerts.panel.pendingStatus": "Tarkista postilaatikkosi: vahvista sähköpostiosoitteesi aktivoidaksesi ilmoitukset.",
  "jobAlerts.panel.privacyLink": "Tietosuojaseloste",
  "jobAlerts.panel.sectionHeading": "Sähköpostikooste",
  "jobAlerts.panel.seeNewMatches": "Katso uudet osumat nyt",
  "jobAlerts.panel.update": "Tallenna muutokset",
  "jobAlerts.signInPrompt": "Älä missaa yhtään uutta osumaa — {signIn} nähdäksesi reaaliaikaiset päivitykset ja aktivoidaksesi sähköposti-ilmoitukset hauillesi.",
  "jobAlerts.toggle.failed": "Tallennus epäonnistui — yritä uudelleen",
  "jobAlerts.toggle.label": "Lähetä uudet osumat sähköpostitse",
  "jobAlerts.toggle.needsSubscription": "Ota ensin käyttöön sähköposti-ilmoitukset ylhäältä",
  "jobAlerts.unsubscribe.confirm": "Peruuta tilaus",
  "jobAlerts.unsubscribe.errorBody": "Jotain meni vikaan. Yritä uudelleen hetken kuluttua.",
  "jobAlerts.unsubscribe.explanation": "Tämä pysäyttää kaikki JobCrawls-palvelun työpaikkailmoitukset sähköpostiisi. Tallennetut haut pysyvät ennallaan.",
  "jobAlerts.unsubscribe.heading": "Peruuta työpaikkailmoitusten tilaus",
  "jobAlerts.unsubscribe.invalidLink": "Tämä peruutuslinkki on virheellinen tai puutteellinen. Käytä viimeisimmän ilmoitusviestin linkkiä tai hallitse ilmoituksia tallennettujen hakujen kautta kirjautuneena.",
  "jobAlerts.unsubscribe.successBody": "Et saa enää työpaikkailmoituksia sähköpostiisi. Voit ottaa ilmoitukset uudelleen käyttöön milloin tahansa tallennettujen hakujen kautta kirjautuneena.",
  "jobAlerts.unsubscribe.successHeading": "Tilaus peruutettu",
  "jobAlerts.unsubscribe.working": "Peruutetaan tilausta…",
  "jobChart.popover.categoriesShown": "Näytetyt kategoriat",
  "jobChart.popover.companyContext": "Perustuu {companyName}-yrityksen ilmoituksiin tiedoissamme.",
  "jobChart.popover.count": "Työpaikkailmoitukset",
  "jobChart.popover.monthKey": "Jakso",
  "jobChart.popover.share": "Osuus kaaviosta",
  "jobChart.popover.totalInRing": "Yhteensä tässä renkaassa",
  "jobChart.segmentHint": "Napauta tai vie hiiri segmentin päälle nähdäksesi lisätiedot.",
  "jobDetail.similarJobs.algoliaListTitle": "Samankaltaisia työpaikkoja",
  "jobDetail.similarJobs.description": "Löydä lisää kiinnostuksen kohteisiisi ja taitoihisi sopivia mahdollisuuksia",
  "jobDetail.similarJobs.seeAll": "Katso kaikki",
  "jobDetail.similarJobs.sourceNote": "JobCrawls-haun tuloksia: sama tehtävänimike ja ensisijainen sijainti kuin tässä ilmoituksessa (tämä työpaikka on rajattu pois). Enintään 8 tulosta.",
  "jobDetail.similarJobs.title": "Aiheeseen liittyvät mahdollisuudet",
  "jobDetailPage.404.backHome": "Takaisin etusivulle",
  "jobDetailPage.404.description": "Pahoittelut, emme löytäneet tätä työpaikkaa. Se on saatettu poistaa tai linkki on virheellinen.",
  "jobDetailPage.404.heading": "Sivua ei löytynyt",
  "jobDetailPage.aboutCompany": "Tietoa meistä",
  "jobDetailPage.applicationDeadline": "Haku päättyy",
  "jobDetailPage.applied": "Haettu ✓",
  "jobDetailPage.applyNavigation": "Hae työpaikkaa",
  "jobDetailPage.applyNow": "Hae yrityksen verkkosivuilta",
  "jobDetailPage.availableLanguages": "Saatavilla kielillä:",
  "jobDetailPage.benefits": "Edut",
  "jobDetailPage.benefitsAndPerks": "Edut ja etuudet",
  "jobDetailPage.businessId": "Y-tunnus",
  "jobDetailPage.byRemoteness": "Etätyöasteen mukaan",
  "jobDetailPage.chartsDataRange": "Näytetyt tiedot perustuvat tietokantamme historiallisiin työpaikkailmoituksiin.",
  "jobDetailPage.collapseCompensation": "Piilota palkkatiedot",
  "jobDetailPage.companiesHiringInLocation": "Yritykset, jotka rekrytoivat kohteessa {location}",
  "jobDetailPage.companyCollapsedBody": "Laajenna nähdäksesi trendikaaviot, sijaintijakauman, kielikysynnän ja karttatiedot.",
  "jobDetailPage.companyDistributionDescription": "Näytetään {count} yritystä, joilla on eniten työpaikkailmoituksia",
  "jobDetailPage.companyInfoFromTradeRegister": "Sisältää tietoja kaupparekisteristä.",
  "jobDetailPage.compensation": "Palkkaus",
  "jobDetailPage.contact": "Yhteys:",
  "jobDetailPage.coverLetter.basedOn": "Perustuu: {entries}",
  "jobDetailPage.coverLetter.copied": "Kopioitu!",
  "jobDetailPage.coverLetter.copy": "Kopioi teksti",
  "jobDetailPage.coverLetter.download": "Lataa hakemuskirje",
  "jobDetailPage.coverLetter.editHint": "Muokkaa tekstiä alla ennen kopiointia tai lataamista — se on sinun muokattavissasi.",
  "jobDetailPage.coverLetter.failed": "Hakemuskirjettä ei voitu luoda. Yritä myöhemmin uudelleen.",
  "jobDetailPage.coverLetter.generateCta": "Laadi hakemuskirjeeni",
  "jobDetailPage.coverLetter.intro": "Laadi hakemuskirje profiilisi ja tämän työpaikan tietojen perusteella — voit muokata sitä ennen lataamista.",
  "jobDetailPage.coverLetter.loading": "Laaditaan hakemuskirjettäsi…",
  "jobDetailPage.coverLetter.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "jobDetailPage.coverLetter.notConfigured": "Hakemuskirjeen laatiminen ei ole käytössä tässä ympäristössä.",
  "jobDetailPage.coverLetter.overclaimWarning": "Emme löytäneet tekstiä \"{skill}\" profiilistasi — varmista, että tämä pitää paikkansa.",
  "jobDetailPage.coverLetter.quotaExceeded": "Olet saavuttanut tämän päivän hakemuskirjerajan — se nollautuu huomenna.",
  "jobDetailPage.coverLetter.sourceCompany": "Yrityksen tiedot",
  "jobDetailPage.coverLetter.sourceSkills": "Osaaminen",
  "jobDetailPage.coverLetter.ungroundedFlag": "{count, plural, one {Yksi kohta} other {# kohtaa}} tästä kirjeestä ei perustunut mihinkään tiettyyn profiilisi tietoon — tarkista, että {count, plural, one {se pitää} other {ne pitävät}} paikkansa.",
  "jobDetailPage.description": "Työpaikkakuvaus",
  "jobDetailPage.estimatedExpiry": "Arvioitu päättymispäivä",
  "jobDetailPage.estimatedNetSalary.explanation": "Arvioitu {year} nettopalkka Suomen tuloverojen, eläke- ja työttömyysvakuutusmaksujen jälkeen. Laskennassa on käytetty kansallista keskimääräistä kunnallisveroprosenttia ({rate}%), ei kirkollisveroa ja vain vakiovähennyksiä – todellinen nettopalkkasi riippuu kunnastasi, kirkon jäsenyydestä, iästäsi ja perhetilanteestasi.",
  "jobDetailPage.expandCompanyData": "Laajenna yritystiedot nähdäksesi trendit, jakaumat ja kartan",
  "jobDetailPage.expandCompensation": "Laajenna palkkatiedot",
  "jobDetailPage.experience": "Kokemus",
  "jobDetailPage.expired.backToSearch": "Takaisin hakutuloksiin",
  "jobDetailPage.expired.banner": "Tämä ilmoitus voi olla liian vanha tai se ei ole enää aktiivinen. {link}",
  "jobDetailPage.headcount": "Henkilöstömäärä",
  "jobDetailPage.hideCharts": "Piilota kaaviot",
  "jobDetailPage.hiringSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.hiringSnapshotSeo.caption": "Tämänhetkiset avoimet roolit yrityksessä {company} JobCrawls-palvelussa",
  "jobDetailPage.hiringSnapshotSeo.location": "Sijainti",
  "jobDetailPage.jobType": "Työsuhteen tyyppi",
  "jobDetailPage.languageNavigation": "Saatavilla olevat kielet",
  "jobDetailPage.languageRequirements": "Kielivaatimukset",
  "jobDetailPage.lastSeenAgoCompact": "{days, plural, =0 {tänään} one {# pv sitten} other {# pv sitten}}",
  "jobDetailPage.lastSeenDetail": "Viimeksi havaittu haussa: {date}{ago}",
  "jobDetailPage.listingCompanyIndustryLabel": "Ilmoitus",
  "jobDetailPage.loadingMap": "Ladataan karttaa...",
  "jobDetailPage.location": "Sijainti",
  "jobDetailPage.locationAndRemotenessDistribution": "Sijainnin ja etätyön jakautuminen",
  "jobDetailPage.locationDistribution": "Sijaintien jakautuminen",
  "jobDetailPage.mapError": "Karttaa ei voitu ladata",
  "jobDetailPage.matchBreakdown.collapse": "Piilota vastaavuuserittely",
  "jobDetailPage.matchBreakdown.expand": "Laajenna vastaavuuserittely",
  "jobDetailPage.matchBreakdown.title": "Näin tämä työ sopii profiiliisi",
  "jobDetailPage.minimumYearsOfExperience": "{years} {years, plural, one {vuosi} other {vuotta}}",
  "jobDetailPage.noItems": "Ei näytettäviä kohteita.",
  "jobDetailPage.noLocation": "Ei sijaintia",
  "jobDetailPage.noRemoteness": "Ei määritelty",
  "jobDetailPage.officialRegisterName": "Rekisteröity nimi",
  "jobDetailPage.originalLanguage": "Alkuperäinen",
  "jobDetailPage.peopleManagementTier": "Johtotaso",
  "jobDetailPage.period.day": "päivä",
  "jobDetailPage.period.hour": "tunti",
  "jobDetailPage.period.month": "kuukausi",
  "jobDetailPage.period.year": "vuosi",
  "jobDetailPage.perks": "Edut",
  "jobDetailPage.postedAgo": "{days, plural, =0 {Julkaistu tänään} one {Julkaistu 1 päivä sitten} other {Julkaistu # päivää sitten}}",
  "jobDetailPage.recruitmentProcess": "Rekrytointiprosessi",
  "jobDetailPage.remoteness": "Etätyömahdollisuus",
  "jobDetailPage.remotenessDistribution": "Etätyön jakautuminen",
  "jobDetailPage.remotenessDistribution.short": "Etätyö",
  "jobDetailPage.requiredLanguages": "Vaaditut kielet",
  "jobDetailPage.requirements": "Vaatimukset",
  "jobDetailPage.responsibilities": "Vastuualueet",
  "jobDetailPage.roleAndRoleLevelDistribution": "Roolien ja tasojen jakautuminen",
  "jobDetailPage.roleDistribution": "Roolien jakautuminen",
  "jobDetailPage.roleLevel": "Roolitaso",
  "jobDetailPage.roleLevelDistribution": "Roolitasojen jakautuma",
  "jobDetailPage.roleLevelSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.roleLevelSnapshotSeo.caption": "Nykyinen roolitasojen jakauma yrityksessä {company} JobCrawls-palvelussa",
  "jobDetailPage.roleLevelSnapshotSeo.level": "Roolitaso",
  "jobDetailPage.roleSnapshotSeo.activeListings": "Aktiiviset ilmoitukset",
  "jobDetailPage.roleSnapshotSeo.caption": "Nykyinen roolien jakauma yrityksessä {company} JobCrawls-palvelussa",
  "jobDetailPage.roleSnapshotSeo.role": "Roolityyppi",
  "jobDetailPage.salaryProvenance.employerQuote": "\\n\\n---\\n\\n\n\nPalkkahaitari on poimittu työpaikkailmoituksen tekstistä.",
  "jobDetailPage.salaryProvenance.extractedNoQuote": "\\n\\n---\\n\\n\n\nTämä palkkahaitari löytyy tiedoistamme, mutta sitä ei ole mainittu selkeästi ilmoituksessa – pidä sitä varmistamattomana.",
  "jobDetailPage.salarySourceBadge.estimated": "\\n\\n---\\n\\n\n\nArvioitu",
  "jobDetailPage.salarySourceBadge.fromListing": "\\n\\n---\\n\\n\n\nIlmoitettu",
  "jobDetailPage.salarySourceBadge.unverified": "Vahvistamaton",
  "jobDetailPage.salaryStatistics": "Palkkatilastot",
  "jobDetailPage.section.company": "Yritystiedot",
  "jobDetailPage.section.jobDetails": "Työn tiedot",
  "jobDetailPage.seeLocation": "Katso sijainti",
  "jobDetailPage.seeOriginal": "Katso alkuperäinen",
  "jobDetailPage.showCharts": "Näytä kaaviot",
  "jobDetailPage.showCompanyContact": "Näytä yrityksen yhteystiedot",
  "jobDetailPage.showContact": "Näytä yhteysosoite",
  "jobDetailPage.showConverted": "Näytä EUR/kk",
  "jobDetailPage.showingItemsAboveThreshold": "Näytetään vain kohteet, jotka ylittävät {percentage} %",
  "jobDetailPage.skillsAndTechnologies": "Taidot ja teknologiat",
  "jobDetailPage.specialisations": "Erikoistumisalueet",
  "jobDetailPage.tailorCv.disclaimer": "Vain nykyistä kokemustasi on muotoiltu ja järjestelty uudelleen korostamaan tälle työlle olennaisia asioita – mitään ei ole keksitty. Tarkista se alta ennen lataamista.",
  "jobDetailPage.tailorCv.download": "Lataa räätälöity CV",
  "jobDetailPage.tailorCv.emptyProfile": "Täytä ensin profiilisi – tarvitsemme työkokemuksesi tai taitosi CV:n räätälöimiseksi.",
  "jobDetailPage.tailorCv.failed": "CV:n räätälöinti epäonnistui. Yritä myöhemmin uudelleen.",
  "jobDetailPage.tailorCv.goToProfile": "Siirry profiiliisi",
  "jobDetailPage.tailorCv.loading": "Muotoillaan nykyistä kokemustasi tätä työpaikkaa varten…",
  "jobDetailPage.tailorCv.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "jobDetailPage.tailorCv.notConfigured": "CV:n räätälöinti ei ole käytössä tässä ympäristössä.",
  "jobDetailPage.tailorCv.quotaExceeded": "Olet saavuttanut tämän päivän räätälöintirajan — se nollautuu huomenna.",
  "jobDetailPage.tailorCv.tabCoverLetter": "Hakemuskirje",
  "jobDetailPage.tailorCv.title": "Räätälöi CV:ni tätä työpaikkaa varten",
  "jobDetailPage.tailorCvCta": "Räätälöi CV:ni tätä työpaikkaa varten",
  "jobDetailPage.tradeRegisterWebsite": "Kaupparekisterin verkkosivusto",
  "jobDetailPage.tyomarkkinatori.about": "<strong>Työmarkkinatori</strong> on Suomen virallinen julkinen työllisyyspalveluportaali, jota ylläpitää työllisyysministeriö (TEM). Sieltä löytyvät avoimet työpaikat koko Suomen julkiselta sektorilta, kunnilta sekä työnantajilta, jotka käyttävät valtion rekrytointia infrastruktuuria.",
  "jobDetailPage.tyomarkkinatori.dataSourceAttribution": "Lähde: <link>Työmarkkinatorin asiakastietojärjestelmä</link>",
  "jobDetailPage.tyomarkkinatori.whyWeIndex": "Sisällytämme Työmarkkinatorin ilmoitukset, jotta JobCrawls kattaa koko suomalaisen työmarkkinan – mukaan lukien tehtävät, jotka tulevat julki vain virallisten valtion kanavien kautta ja jäisivät muuten huomaamatta.",
  "jobDetailPage.vacationWeeks": "Loma: {weeks} viikkoa",
  "jobDetailPage.viewBenefits": "Näytä edut",
  "jobDetailPage.visa": "Viisumi",
  "jobDetailPage.visaSponsor": "✓ Sponsorointi saatavilla",
  "jobDetailPage.watchCompanyVideo": "Katso yritysvideo",
  "jobDetailPageV2.aboutRole": "Tietoa tehtävästä",
  "jobDetailPageV2.collectiveAgreement.browseAll": "Selaa kaikkia Suomen työehtosopimuksia",
  "jobDetailPageV2.collectiveAgreement.explicit": "Työnantaja ilmoittaa, että tässä työtehtävässä noudatetaan {agreementName} työehtosopimusta.",
  "jobDetailPageV2.collectiveAgreement.inferred": "Paras arvio: {agreementName} työehtosopimus — päätelty työnantajan toimialan ja roolin perusteella, voi olla eri sopimus.",
  "jobDetailPageV2.daysAgo": "{days, plural, one {# päivä sitten} other {# päivää sitten}}",
  "jobDetailPageV2.deadline": "Haku päättyy {date}",
  "jobDetailPageV2.estimatedExpiry": "Arvioitu päättymispäivä {date}",
  "jobDetailPageV2.experienceYears": "{years} {years, plural, one {vuoden} other {vuoden}} kokemus",
  "jobDetailPageV2.financialOverview": "Talouskatsaus",
  "jobDetailPageV2.lastSeen": "Viimeksi nähty {date}",
  "jobDetailPageV2.location": "Sijainti",
  "jobDetailPageV2.location.collapse": "Piilota sijaintikartta",
  "jobDetailPageV2.location.expand": "Laajenna sijaintikartta",
  "jobDetailPageV2.mostHiredRoles": "Yleisimmät rekrytoidut roolit",
  "jobDetailPageV2.openRoles": "{count} avointa tehtävää",
  "jobDetailPageV2.otherLocations": "+{count} muuta sijaintia",
  "jobDetailPageV2.postedOn": "Julkaistu {date}",
  "jobDetailPageV2.profit": "Voitto",
  "jobDetailPageV2.profitMargin": "Voittomarginaali",
  "jobDetailPageV2.revenue": "Liikevaihto",
  "jobDetailPageV2.roleLevelMix": "Roolitasojen jakautuma",
  "jobDetailPageV2.salaryCompares": "Kuinka tämä palkka vertautuu muihin",
  "jobDetailPageV2.salaryCompares.collapse": "Piilota palkkavertailu",
  "jobDetailPageV2.salaryCompares.expand": "Laajenna palkkavertailu",
  "jobDetailPageV2.tldr": "Lyhyesti",
  "jobDetailPageV2.topLocations": "Suosituimmat sijainnit:",
  "jobDetailPageV2.viewCompany": "Näytä yritysprofiili",
  "layoutErrorFallback.body": "Yritä ladata sivu uudelleen. Jos ongelma jatkuu, olemme saaneet siitä tiedon.",
  "layoutErrorFallback.home": "Siirry etusivulle",
  "layoutErrorFallback.reload": "Lataa sivu uudelleen",
  "layoutErrorFallback.title": "Jotain meni vikaan",
  "locationHub.activeJobs": "Työpaikat",
  "locationHub.avgSalary": "Palkka",
  "locationHub.hero.description": "Tutustu Suomen suurimpiin kaupunkeihin reaaliaikaisten työpaikkamäärien, palkkatietojen ja markkinadatat avulla. Löydä seuraava mahdollisuutesi Suomen kukoistavasta teknologiaympäristöstä.",
  "locationHub.hero.subtitle": "Kuratoituja kaupunkioppaita ja työnhakuja ympäri Suomea",
  "locationHub.hero.title": "Suomen työmarkkinat",
  "locationHub.hero.title.breadcrumb": "Selaa työpaikkoja sijainnin mukaan",
  "locationHub.languages": "Kielet",
  "locationHub.metropolitan.seo": "Helsingin pääkaupunkiseutu, mukaan lukien Espoo ja Vantaa, on Suomen ensisijainen talousmoottori, joka tarjoaa suurimman tiheyden englanninkielisiä ja etätyöpaikkoja sekä erinomaiset liikenneyhteydet (HSL).",
  "locationHub.overview.description": "Tutustu Suomen johtaviin teknologia- ja innovaatiokeskuksiin reaaliaikaisen työmarkkinadatan, palkkatietojen ja toimialatrendien avulla.",
  "locationHub.overview.title": "Tärkeimmät teknologia-keskittymät",
  "locationHub.popularRoles.heading": "Suositut ammatit",
  "locationHub.quickJump.overview": "Yleiskatsaus",
  "locationHub.resourcesLink": "Tutustu työmarkkinoiden näkymiin ja uravinkkeihin",
  "locationHub.structuredData.collectionPage.description": "Löydä työmahdollisuuksia Suomen suurimmista kaupungeista palkkatietojen ja markkinadatan avulla",
  "locationHub.structuredData.collectionPage.name": "Suomen toimipisteet",
  "locationHub.structuredData.itemList.description": "Tutustu työmahdollisuuksiin Suomen suurimmissa kaupungeissa",
  "locationHub.structuredData.itemList.name": "Työpaikat Suomessa",
  "locationHub.table.activeJobs": "Aktiiviset työpaikat",
  "locationHub.table.avgSalary": "Keskipalkka",
  "locationHub.table.city": "Kaupunki",
  "locationHub.table.specialty": "Erikoisala",
  "locationHub.workModel": "Työmalli",
  "map.cappedResultsNotice": "Näytetään {shown} / {total} — lähennä karttaa tarkentaaksesi hakua",
  "map.densityZoomPrompt": "Lähennä nähdäksesi yksittäiset työpaikat ja yritysten logot",
  "map.densityZoomPrompt.button": "Lähennä",
  "map.jobs": "työpaikkaa",
  "map.jobsInView": "Näkymän työpaikat",
  "map.loading": "Ladataan karttaa...",
  "map.noJobs": "Tällä alueella ei ole työpaikkoja",
  "map.noJobsInView": "Tällä alueella ei ole työpaikkoja",
  "map.noLocationsForPins": "Tässä näkymässä ei ole sijaintikoordinaatteja karttamerkkejä varten.",
  "map.resetView": "Palauta kartta näyttämään koko Suomi",
  "map.tokenMissing": "Karttanäkymä vaatii Mapbox-pääsytokenin",
  "marketHeader.language.english": "Englanti",
  "marketHeader.language.finlandComparison": "Suomi: {finlandEnglish}% englanti",
  "marketHeader.language.label": "Kielikysyntä",
  "marketHeader.language.mixed": "Sekoitettu",
  "marketHeader.languageSeo.caption": "Kielikysyntä alueella {location}",
  "marketHeader.languageSeo.language": "Kielikategoria",
  "marketHeader.languageSeo.share": "Ilmoitusten osuus",
  "marketHeader.nearbyMarkets": "Lähialueet",
  "marketHeader.qa.languageQuestion": "Mitä kieliä alueella {location} vaaditaan?",
  "marketHeader.qa.remoteAnswer": "Kyllä, {answer}",
  "marketHeader.qa.remoteQuestion": "Onko {location} etätyöystävällinen?",
  "marketHeader.qa.salaryQuestion": "Mikä on keskipalkka {location}-alueella?",
  "marketHeader.rail.marketDetails": "Markkinatiedot",
  "marketHeader.rail.samplesUpdatedDaily": "{count} avointa työpaikkaa · päivitetään päivittäin",
  "marketHeader.removeLocation": "Poista sijainti",
  "marketHeader.salary.finlandComparison": "Suomen keskiarvo: {finlandAvg}",
  "marketHeader.salary.label": "Palkkatrendit",
  "marketHeader.salary.range": "Palkkahaitari",
  "marketHeader.salary.rangePercentile": "25.–75. persentiilin vaihteluväli",
  "marketHeader.salaryPercentileSeo.caption": "Ilmoitettu palkkajakauma kohteessa {location}, Suomi — kokoaikaiset roolit",
  "marketHeader.salaryPercentileSeo.p25": "25. persentiili",
  "marketHeader.salaryPercentileSeo.p50": "Mediaani (50. persentiili)",
  "marketHeader.salaryPercentileSeo.p75": "75. prosentiili",
  "marketHeader.salaryPercentileSeo.percentile": "Prosentiili",
  "marketHeader.salaryPercentileSeo.salary": "Kuukausipalkka (EUR)",
  "marketHeader.salaryPercentileSeo.sampleSize": "Perustuu {count} työpaikkailmoitukseen, joissa on ilmoitettu palkka {location}, Suomi.",
  "marketHeader.title": "Avoimet työpaikat {location}",
  "marketHeader.toggle": "Vaihda markkinanäkymän tila",
  "marketHeader.updated": "Päivitetty:",
  "marketHeader.workModel.finlandComparison": "Suomi: {finlandRemote}% etätyö/hybridi",
  "marketHeader.workModel.label": "Työmalli",
  "marketHeader.workModel.noData": "Joustava",
  "marketHeader.workModelSeo.caption": "Työmallien jakautuminen kohteessa {location}",
  "marketHeader.workModelSeo.model": "Työmalli",
  "marketHeader.workModelSeo.share": "Ilmoitusten osuus",
  "marketingConsent.checkbox.label": "Lähetä minulle myös työmarkkinasähköposteja ja vinkkejä JobCrawlsilta (valinnainen, voit peruuttaa tilauksen milloin vain).",
  "matchDonut.ariaLabel": "Osumapisteet: {score}%",
  "matchDonut.breakdown.benefits": "Edut",
  "matchDonut.breakdown.languages": "Kielet",
  "matchDonut.breakdown.remoteness": "Etätyömahdollisuus",
  "matchDonut.breakdown.salary": "Palkka",
  "matchDonut.breakdown.title": "Osumapisteiden erittely",
  "matchDonut.breakdown.vacation": "Lomat",
  "matchDonut.loginPrompt.createAccount": "Luo tili",
  "matchDonut.loginPrompt.description": "Luo profiili ja lisää nykyisen työsi tiedot nähdäksesi, kuinka hyvin työpaikat vastaavat mieltymyksiäsi",
  "matchDonut.loginPrompt.title": "Kirjaudu sisään nähdäksesi vastaavuuspisteesi",
  "matchDonut.loginPromptAria": "Kirjaudu sisään nähdäksesi vastaavuuspisteesi",
  "matchDonut.profilePrompt.description": "Lisää nykyisen työsi tiedot ja mieltymyksesi profiiliisi nähdäksesi, kuinka hyvin työpaikat vastaavat niitä.",
  "matchDonut.profilePrompt.goToProfile": "Siirry profiiliin",
  "matchDonut.profilePrompt.title": "Täydennä profiilisi nähdäksesi vastaavuuspisteesi",
  "matchDonut.profilePromptAria": "Täydennä profiilisi nähdäksesi vastaavuuspisteesi",
  "matchDonut.searchBreakdown.employer": "Työnantaja ja toimiala",
  "matchDonut.searchBreakdown.keywords": "Hakusanat",
  "matchDonut.searchBreakdown.location": "Sijainti",
  "matchDonut.searchBreakdown.remoteness": "Etätyömahdollisuus",
  "matchDonut.searchBreakdown.roleFit": "Rooli ja ala",
  "matchDonut.searchInference.bullet.company": "Olet osoittanut kiinnostusta työnantajia, kuten {company}, kohtaan – otamme tämän huomioon pisteytyksessä.",
  "matchDonut.searchInference.bullet.keywords": "Hakuissasi on ollut termejä kuten \"{terms}\" – vertasimme niitä tämän työpaikan nimikkeeseen ja rooliin.",
  "matchDonut.searchInference.bullet.locations": "Olet hakenut alueilta kuten {locations} – tämän ilmoituksen sijaintia verrataan näihin.",
  "matchDonut.searchInference.bullet.remoteness": "Käytät usein etätyösuodattimia ({values}) – tämän työpaikan pisteytys perustuu näihin mieltymyksiin.",
  "matchDonut.searchInference.bullet.roles": "Hakuissasi on käytetty roolisuodattimia, kuten {hints} – vastaavia signaaleja verrataan tähän työpaikkaan.",
  "matchDonut.searchInference.intro": "Meillä ei ole vielä profiiliasi, joten tämä pistemäärä arvioi sopivuutta JobCrawlsissa tekemiesi hakujen suodattimien ja avainsanojen perusteella (viimeaikainen toiminta painottuu enemmän).",
  "matchDonut.searchInference.title": "Osuma viimeisimpien hakujesi perusteella",
  "modal.close": "Sulje",
  "navigation.home": "Etusivu",
  "navigation.home.breadcrumb": "Etusivu",
  "navigation.language": "Kieli",
  "navigation.language.label": "Kieli",
  "navigation.locations": "Toimipisteet",
  "navigation.locations.menu": "Toimipisteet",
  "navigation.menu": "Valikko",
  "navigation.menu.heading": "Valikko",
  "navigation.menu.open": "Avaa valikko",
  "navigation.search": "Hae työpaikkoja",
  "navigation.search.menu": "Etsi työpaikkoja",
  "navigation.search.reset": "Nollaa haku",
  "notes.field.add": "Lisää muistiinpano",
  "notes.field.placeholder": "Lisää yksityinen muistiinpano…",
  "numberSelector.any": "Kaikki",
  "pagination.ariaLabel": "Työpaikkahakutulosten sivunavigointi",
  "pagination.first": "Ensimmäinen",
  "pagination.keyboardShortcuts": "Näppäimistön pikanäppäimet",
  "pagination.last": "Viimeinen",
  "pagination.next": "Seuraava",
  "pagination.previous": "Edellinen",
  "profile.aiApply": "Käytä",
  "profile.aiLoading": "Ajatellaan…",
  "profile.aiSuggest": "Ehdotukset tekoälyllä",
  "profile.aiSuggestionsDisclaimer": "Nämä ovat tekoälyn laatimia lähtökohtia, jotka perustuvat vain työnimikkeisiisi ja tutkintoihisi — ei vahvistettuja faktoja sinusta. Lue jokainen ja muokkaa sitä vastaamaan todellisuutta ennen käyttöönottoa.",
  "profile.aiSuggestionsEmpty": "Profiilisi näyttää täydelliseltä. Lisää kokemusta tai jätä joitakin kenttiä tyhjiksi ja yritä uudelleen.",
  "profile.aiSuggestionsTitle": "Tekoälyehdotukset",
  "profile.applicationKits.link": "Hakupaketit",
  "profile.benefits.label": "Nykyiset edut (sovitusta varten)",
  "profile.benefitsWeight": "Etujen painoarvo: {weight}%",
  "profile.closePreview": "Sulje esikatselu",
  "profile.closeSuggestions": "Sulje",
  "profile.completion.allDone": "Profiilisi on valmis loistavien ansioluetteloiden luomiseen.",
  "profile.completion.fix": "Korjaa",
  "profile.completion.itemBasic": "Lisää titteli tai viimeisin roolisi",
  "profile.completion.itemCurrentRole": "Lisää nykyisen roolisi tiedot (osittamiseksi)",
  "profile.completion.itemEducation": "Lisää koulutuksesi",
  "profile.completion.itemExperience": "Lisää työkokemuksesi",
  "profile.completion.itemSkills": "Lisää vähintään 3 taitoa",
  "profile.completion.label": "profiili täytetty",
  "profile.currentJob.label": "Nykyinen rooli (osittamista varten)",
  "profile.currentSalary.label": "Nykyinen kuukausipalkka (osittamista varten)",
  "profile.currentSalary.placeholder": "esim. 3500",
  "profile.currentSalary.privacyShort": "Yksityinen. Käytetään vain yhteensopivuuspisteesi laskemiseen.",
  "profile.currentSalary.unit": "€/kk",
  "profile.currentSalary.workPercent": "työ %",
  "profile.currentWorkModel.label": "Nykyinen työmalli (yhteensopivuutta varten)",
  "profile.cvDownloadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen.",
  "profile.cvImport.notConfigured": "CV:n tuonti ei ole käytössä tässä ympäristössä.",
  "profile.cvUploadError": "Lataa PDF-tiedosto",
  "profile.cvUploadFailed": "CV:n lataaminen epäonnistui. Yritä uudelleen.",
  "profile.cvUploadSizeError": "Tiedoston koon on oltava alle 5 Mt",
  "profile.cvUploading": "Tuodaan…",
  "profile.desiredBenefits": "Toivottuja etuja",
  "profile.desiredIndustries": "Yritysten toimialat",
  "profile.desiredJob": "Mitä etsit",
  "profile.desiredJobDescription": "Kerro meille, mitä etsit. Nämä mieltymykset ohittavat nykyisen roolisi, kun pisteytämme sitä, kuinka hyvin työ sopii sinulle.",
  "profile.desiredJobTypes": "Työsuhteen tyypit",
  "profile.desiredLocations": "Sijainnit",
  "profile.desiredRemoteness": "Etätyömahdollisuudet",
  "profile.desiredRoleLevels": "Roolitasot",
  "profile.desiredSalaryMin": "Vähimmäispalkka, kuukausittain",
  "profile.desiredTitles": "Työnimikkeet",
  "profile.desiredVacationWeeks": "Vähimmäislomaviiikot",
  "profile.downloadCV": "Lataa CV:ni",
  "profile.europass.additionalInfo": "Lisätiedot",
  "profile.europass.basedOn": "Perustuu Europass CV -rakenteeseen (europass.europa.eu)",
  "profile.europass.educationAndTraining": "Koulutus ja tutkinto",
  "profile.europass.noEducation": "Koulutusta ei ole lisätty.",
  "profile.europass.noSkills": "Taitoja ei ole lisätty.",
  "profile.europass.noWorkExperience": "Työkokemusta ei ole lisätty.",
  "profile.europass.personalSkills": "Henkilökohtaiset taidot",
  "profile.europass.workExperience": "Työkokemus",
  "profile.exportCV": "Vie CV",
  "profile.jobType": "Työsuhteen tyyppi",
  "profile.jobTypeWeight": "Työsuhteen tyypin painotus: {weight}%",
  "profile.languageSwitcher.hint": "Tuo, lataa ja ehdota tekoälyllä sillä kielivälilehdellä, joka on valittuna. Jokainen versio on itsenäinen – mitään ei käännetä automaattisesti.",
  "profile.languages.label": "Kielet (ammattitaitoinen taso)",
  "profile.languagesWeight": "Kielten painotus: {weight}%",
  "profile.linkedInImport.button": "Tuo LinkedInistä",
  "profile.linkedInImport.failed": "Profiilia ei voitu tuoda. Yritä myöhemmin uudelleen.",
  "profile.linkedInImport.hint": "Liitä julkisen profiilisi URL-osoite (linkedin.com/in/…), ja tuo tiedot. Tiedot haetaan Proxycurlin (kolmas osapuoli) kautta, eikä niissä välttämättä ole kaikkea sivullasi olevaa tietoa. Tiedot täyttävät alla olevan lomakkeen, eivät tallennettua profiiliasi — tarkista ja korjaa tarvittaessa ennen tallennusta.",
  "profile.linkedInImport.invalidProfileUrl": "Käytä henkilökohtaisen profiilisi linkkiä (linkedin.com/in/…).",
  "profile.linkedInImport.invalidUrl": "Syötä voimassa oleva LinkedIn-URL-osoite.",
  "profile.linkedInImport.loading": "Tuodaan…",
  "profile.linkedInImport.networkError": "Verkkovirhe. Tarkista yhteytesi.",
  "profile.linkedInImport.notConfigured": "LinkedIn-tuonti ei ole käytössä tässä ympäristössä.",
  "profile.linkedInImport.placeholder": "https://www.linkedin.com/in/profiilisi/",
  "profile.linkedInImport.sectionTitle": "LinkedIn-profiili",
  "profile.loading": "Ladataan...",
  "profile.locationWeight": "Sijainnin painotus: {weight} %",
  "profile.locations": "Sijainnit",
  "profile.matchPreferences": "Osumapreferenssit",
  "profile.matchPreferencesDescription": "Säädä eri tekijöiden painoarvoa työpaikkasovivuuden laskennassa. Kokonaissumman on oltava 100 %.",
  "profile.prefillFromSearches.banner": "Täytimme joitakin kenttiä viimeisimpien työhakujesi perusteella. Tarkista tiedot ja korjaa mahdolliset virheet.",
  "profile.prefillFromSearches.dismiss": "Sulje",
  "profile.preview": "Esikatselu",
  "profile.previewEuropass": "CV-esikatselu (Europass-muoto)",
  "profile.profilePhoto.errorCompressedTooLarge": "Kuva on edelleen liian suuri pakkaamisen jälkeen. Kokeile pienempää alkuperäiskuvaa.",
  "profile.profilePhoto.errorProcess": "Kuvaa ei voitu käsitellä. Kokeile toista tiedostoa.",
  "profile.profilePhoto.errorTooLarge": "Kuva on liian suuri (enintään 5 Mt).",
  "profile.profilePhoto.errorType": "Käytä JPEG-, PNG-, WebP- tai GIF-kuvaa.",
  "profile.profilePhoto.remove": "Poista ladattu kuva",
  "profile.profilePhoto.uploadAria": "Lataa tai vaihda profiilikuva",
  "profile.quickActions.title": "CV:si",
  "profile.remotenessWeight": "Etäisyyden painotus: {weight}%",
  "profile.roleLevel": "Roolitaso",
  "profile.roleLevelWeight": "Roolitason painotus: {weight}%",
  "profile.salaryWeight": "Palkan painotus: {weight}%",
  "profile.selectJobType": "Valitse työsuhteen tyyppi",
  "profile.selectLocations": "Valitse sijainnit",
  "profile.selectMultipleIndustries": "Valitse yksi tai useampi toimiala",
  "profile.selectMultipleJobTypes": "Valitse yksi tai useampi työsuhteen tyyppi",
  "profile.selectMultipleLocations": "Valitse yksi tai useampi sijainti",
  "profile.selectMultipleRemoteness": "Valitse yksi tai useampi etätyövaihtoehto",
  "profile.selectMultipleRoleLevels": "Valitse yksi tai useampi rolin taso",
  "profile.selectMultipleTitles": "Valitse yksi tai useampi työnimike",
  "profile.selectRoleLevel": "Valitse rolin tasosi",
  "profile.title": "Työnimike",
  "profile.titlePlaceholder": "esim. ohjelmistokehittäjä",
  "profile.titleWeight": "Nimikkeen painoarvo: {weight}%",
  "profile.totalWeight": "Yhteensä",
  "profile.uploadCV": "Lataa CV esitäyttöä varten",
  "profile.uploadCV.disclaimer": "Tekoäly poimii tiedot PDF-tiedostostasi — ne täyttävät alla olevan lomakkeen, eivät tallennettua profiiliasi. Tarkista tiedot ja korjaa tarvittaessa ennen tallennusta.",
  "profile.vacationWeeks.label": "Lomaviikot vuodessa",
  "profile.vacationWeeks.unit": "viikkoa/vuosi",
  "profile.vacationWeight": "Loman painoarvo: {weight}%",
  "recentSearches.delete": "Poista",
  "recentSearches.noSearches": "Et ole vielä tallentanut yhtään hakua.",
  "salary.period.day": "/pv",
  "salary.period.hour": "/t",
  "salary.period.month": "/kk",
  "salary.period.year": "/v",
  "salaryChart.allRolesInLocation": "Kaikki roolit kohteessa {location}",
  "salaryChart.analysisTitle": "Palkka-analyysi",
  "salaryChart.companyLocation": "Yritys kohteessa {location}",
  "salaryChart.estimatedFromMarket": "Arvioitu markkinatiedon perusteella (ei palkkatietoa ilmoituksessa)",
  "salaryChart.fromJobAd": "Työpaikkailmoituksesta",
  "salaryChart.fromJobAdWithLevel": "Työpaikkailmoituksesta ({roleLevel})",
  "salaryChart.locationAverage": "Kohteessa {location}: {title}",
  "salaryChart.marketAverage": "Markkinoiden keskiarvo: {title}",
  "salaryChart.marketAverageRoleLevel": "Markkinoiden keskiarvo: {roleLevel}-taso",
  "salaryChart.payInDataNotInAd": "Tietojemme mukainen palkka — ei mainittu ilmoituksessa",
  "salaryChart.payInDataNotInAdWithLevel": "Tietojemme mukainen palkka — ei mainittu ilmoituksessa ({roleLevel})",
  "salaryChart.popover.average": "Keskimääräinen palkkahaitari",
  "salaryChart.popover.benchmarkEstimateNote": "Ei työnantajalta — mallinnettu vertailutietojen perusteella",
  "salaryChart.popover.dimension": "Ulottuvuus",
  "salaryChart.popover.extractedNoQuoteNote": "Numeerinen palkka ilman tarkentavaa tekstiä ilmoituksessa",
  "salaryChart.popover.fromAdText": "Perustuu työpaikkailmoituksen palkkaukseen",
  "salaryChart.popover.max": "Enimmäisarvo",
  "salaryChart.popover.median": "Mediaanihaitari",
  "salaryChart.popover.min": "Minimi",
  "salaryChart.popover.monthlyNote": "Kaikki summat on ilmoitettu euroina kuukaudessa vertailun helpottamiseksi tässä kaaviossa.",
  "salaryChart.popover.p25": "25. prosenttipiste",
  "salaryChart.popover.p75": "75. prosenttipiste",
  "salaryChart.popover.p90": "90. prosenttipiste",
  "salaryChart.popover.sample": "Otoskoko",
  "salaryChart.popover.seeFullSalaryPage": "Katso {title}: koko palkkasivu →",
  "salaryChart.rangeAria": "Palkkahaitari {min}:sta {max}:een kuukaudessa, mediaani lähellä arvoa {median}",
  "salaryChart.salaryContext": "Palkkayhteys: {title}",
  "salaryChart.segmentHint": "Vie hiiri rivin päälle tai napauta riviä nähdäksesi täydelliset tilastot (EUR / kk tässä kaaviossa).",
  "salaryChart.seoTable.caption": "Kuukausipalkkavertailu nimikkeelle {title}",
  "salaryChart.seoTable.lowerBound": "Alaraja (25. persentiili)",
  "salaryChart.seoTable.market": "Markkinat",
  "salaryChart.seoTable.median": "Mediaani",
  "salaryChart.seoTable.upperBound": "Yläraja (75. persentiili)",
  "salaryChart.thisRole": "tämä rooli",
  "salaryChart.thisRoleLevel": "tämä roolitaso",
  "salaryDisplayToggle.label": "Näytä alkuperäinen valuutta",
  "salaryIndexPage.allRolesHeading": "Selaa kaikkia rooleja",
  "salaryIndexPage.empty": "Palkkatietoja ei ole juuri nyt saatavilla — käy myöhemmin uudelleen.",
  "salaryIndexPage.eyebrow": "{count} seurattua roolia",
  "salaryIndexPage.heading": "Palkkatiedot ammateittain Suomessa",
  "salaryIndexPage.intro": "Todellista palkkatietoa suomalaisista työpaikkailmoituksista ammateittain eriteltynä. Valitse ammatti nähdäksesi mediaanipalkan, vaihteluvälin ja kaupunkikohtaisen vertailun.",
  "salaryIndexPage.postingsSuffix": "ilmoitusta",
  "salaryIndexPage.stat.postings": "analysoitua ilmoitusta",
  "salaryIndexPage.stat.roles": "seurattu rooli",
  "salaryIndexPage.stat.topRole": "eniten analysoitu rooli",
  "salaryIndexPage.topRolesHeading": "Kysytyimmät roolit",
  "salaryIndexPage.topRolesSub": "Järjestetty palkka-arvion taustalla olevien ilmoitusten määrän mukaan – mitä enemmän ilmoituksia, sitä luotettavampia luvut ovat.",
  "salaryInsight.above": "Tämän roolin palkka <strong>{salary}</strong> on <strong>{percent}%</strong> korkeampi kuin {benchmark}.",
  "salaryInsight.below": "Tämän roolin palkka <strong>{salary}</strong> on <strong>{percent}%</strong> alempi kuin {benchmark}.",
  "salaryInsight.benchmark.finlandOnly": "palkkatietojemme Suomen laajuisen mediaanin",
  "salaryInsight.benchmark.finlandWithRole": "Suomen laajuisen mediaanin {role}-rooleille",
  "salaryInsight.benchmark.locationOnly": "mediaanipalkka paikassa {location}",
  "salaryInsight.benchmark.locationWithRole": "mediaani {role}-tehtäville paikassa {location}",
  "salaryRolePage.alsoKnownAs": "Löytyy myös nimillä: {titles}",
  "salaryRolePage.breadcrumb.salaryData": "Palkkatiedot",
  "salaryRolePage.cityTable.footnote": "Palkki näyttää P25–P75-vaihteluvälin. Pystyviiva = mediaani. Kaikki arvot ovat euroa/kk.",
  "salaryRolePage.cityTable.title": "{roleTitle}: palkka kaupungeittain",
  "salaryRolePage.ctaBanner": "Etsitkö {roleTitle}-työpaikkoja? {link}",
  "salaryRolePage.ctaBanner.link": "Selaa avoimia työpaikkoja JobCrawlsissa →",
  "salaryRolePage.disclaimer": "Palkkatiedot perustuvat julkaistuihin työpaikkailmoituksiin, eivätkä ne välttämättä kuvaa kokonaiskorvausta. Luvut ovat euroa/kk ja voivat sisältää työnantajan arvioita silloin, kun ilmoitettua palkkahaarukkaa ei ole julkisesti kerrottu.",
  "salaryRolePage.examplePostings.inactive": "(ilmoitus ei ole enää voimassa)",
  "salaryRolePage.examplePostings.title": "Perustuu näihin ilmoituksiin",
  "salaryRolePage.heading": "{roleTitle} palkka Suomessa",
  "salaryRolePage.hero.perMonthNational": "/ kk, kansallinen mediaani",
  "salaryRolePage.hero.sampleEyebrow": "Perustuu {count} ilmoitukseen",
  "salaryRolePage.hiringCompanies.browseAll": "Selaa Suomen parhaita työnantajia →",
  "salaryRolePage.hiringCompanies.empty": "Selaa kaikkia sijoituksissa olevia työnantajia löytääksesi yrityksiä, jotka rekrytoivat tähän rooliin.",
  "salaryRolePage.hiringCompanies.sub": "Työnantajien sijoituksistamme — joihinkin kannattaa ottaa yhteyttä suoraan, vaikka avointa työpaikkaa ei olisi ilmoitettu.",
  "salaryRolePage.hiringCompanies.title": "Yritykset, jotka rekrytoivat {roleTitle}-ammattilaisia",
  "salaryRolePage.intro": "Perustuu suomalaisten työnantajien työpaikkailmoituksiin. Päivitetään säännöllisesti.",
  "salaryRolePage.overallPanel.footnote": "EUR/kk · P25–P75-väli mediaanimerkinnällä · perustuu {count} työpaikkailmoitukseen",
  "salaryRolePage.overallPanel.title": "{roleTitle} — Suomen keskiarvo",
  "salaryRolePage.rangeBar.hint": "Napauta tai vie hiiri päälle nähdäksesi tiedot.",
  "salaryRolePage.rangeBar.popoverListings": "{count, plural, one {Perustuu # työpaikkailmoitukseen} other {Perustuu # työpaikkailmoitukseen}}",
  "salaryRolePage.remotePanel.title": "{roleTitle} — etätyö Suomessa",
  "salaryRolePage.seeOpenJobs": "Katso avoimet {roleTitle}-työpaikat →",
  "salaryRolePage.stat.average": "Keskiarvo",
  "salaryRolePage.stat.median": "Mediaani",
  "salaryRolePage.stat.middle50": "Keskimmäinen 50 %",
  "salaryRolePage.stat.range": "Koko vaihteluväli",
  "salaryRolePage.stat.sampleSize": "Otoskoko",
  "salaryRolePage.trend.down": "▼ {percent} % edelliseen kuukauteen verrattuna",
  "salaryRolePage.trend.flat": "Ei muutosta edelliseen kuukauteen verrattuna",
  "salaryRolePage.trend.up": "▲ {percent} % edelliseen kuukauteen verrattuna",
  "salaryStats.aboveMarket": "Tämä palkka on markkinoiden mediaania korkeampi",
  "salaryStats.accuracy.exact": "Perustuu saman yrityksen vastaaviin tehtäviin",
  "salaryStats.accuracy.general": "Perustuu markkinatietoihin",
  "salaryStats.accuracy.location": "Perustuu palkkoihin paikassa {location}",
  "salaryStats.atMarket": "Tämä palkka on kilpailukykyinen suhteessa markkinoiden mediaaniin",
  "salaryStats.average": "Keskiarvo",
  "salaryStats.belowMarket": "Tämä palkka on markkinoiden mediaania alhaisempi",
  "salaryStats.jobSalary": "Tämä työpaikka",
  "salaryStats.marketRange": "Markkina-alue: {min} - {max} (mediaani: {median})",
  "salaryStats.median": "Mediaani",
  "salaryStats.noJobSalary": "Tälle työpaikalle ei ole annettu palkkahaitaria. Kaavio näyttää markkinajakauman.",
  "salaryStats.noValidValues": "Palkkatilastoja on saatavilla ({sampleSize} {samples}), mutta kaikki arvot ovat nollia. Tämä voi tarkoittaa, että tiedot on päivitettävä.",
  "salaryStats.perDay": "päivässä",
  "salaryStats.perHour": "tunnissa",
  "salaryStats.perMonth": "kuukaudessa",
  "salaryStats.perYear": "vuodessa",
  "salaryStats.percentiles": "25.–75. prosentiili",
  "salaryStats.samples": "näytteet",
  "salaryStats.smallSampleWarning": "Huom: Perustuu pieneen otoskokoon ({sampleSize} {samples}). Tulokset eivät välttämättä ole edustavia.",
  "savedSearches.card.continue": "Jatka",
  "savedSearches.emptyHint": "Tee haku avainsanoilla tai suodattimilla työpaikkasivulla – se ilmestyy tänne automaattisesti. Voit myös kiinnittää haun ”Tallenna haku” -toiminnolla.",
  "savedSearches.newMatchesBadge": "{count} uutta",
  "savedSearches.openSearchAria": "Avaa haku: {title}",
  "savedSearches.rename.action": "Nimeä tämä haku",
  "savedSearches.rename.placeholder": "esim. Backend-työt Helsingissä",
  "savedSearches.rename.save": "Tallenna",
  "savedSearches.summary.filtered": "Suodatettu haku",
  "savedSearches.summary.location": "Sijainti: {values}",
  "savedSearches.summary.page": "Sivu {page}",
  "savedSearches.summary.sortDate": "Lajittelu: uusimmat",
  "savedSearches.summary.sortSalary": "Lajittelu: palkka",
  "savedSearches.summary.worldwide": "Kaikki maat",
  "search.activityStrip.cta": "Hallitse hakemuksia",
  "search.activityStrip.teaser": "Selaa, tallenna ja hae työpaikkoja nähdäksesi hakuprosessisi tässä.",
  "search.activityStrip.title": "Työnhakusi aktiivisuus",
  "search.bestCompaniesStrip.hubCta": "Parhaat työnantajat Suomen tehtäviin →",
  "search.bestCompaniesStrip.label": "Huipputyönantajat",
  "search.controls.navigation": "Haun ohjaimet ja suodattimet",
  "search.jobCount": "{count, number} työpaikkaa",
  "search.noResults": "Työpaikkoja ei löytynyt.",
  "search.noresults.browseAll": "Selaa kaikkia työpaikkoja",
  "search.noresults.clearAllParameters": "Tyhjennä kaikki hakuehdot",
  "search.noresults.clearSearch": "Tyhjennä haku",
  "search.noresults.description": "Kokeile muuttaa hakua tai suodattimia löytääksesi lisää mahdollisuuksia.",
  "search.noresults.filtersLabel": "Suodattimet:",
  "search.noresults.goToFirstPage": "Siirry sivulle 1",
  "search.noresults.industries": "Toimialat",
  "search.noresults.jobRoles": "Työtehtävät",
  "search.noresults.locations": "Sijainnit",
  "search.noresults.pageLabel": "Sivu:",
  "search.noresults.popularCategories": "Suositut kategoriat",
  "search.noresults.queryLabel": "Haku:",
  "search.noresults.removeQuery": "Poista",
  "search.noresults.searchParameters": "Hakuehtosi",
  "search.noresults.searchTips": "Hakuohjeita",
  "search.noresults.tip1": "Kokeile laajempia hakutermejä tai poista joitakin suodattimia",
  "search.noresults.tip2": "Tarkista oikeinkirjoitus tai kokeile vaihtoehtoisia avainsanoja",
  "search.noresults.tip3": "Selaa yllä olevia suosittuja kategorioita löytääksesi uusia mahdollisuuksia",
  "search.noresults.title": "Tuloksia ei löytynyt",
  "search.noresults.trySearches": "Kokeile näitä hakuja:",
  "search.refinements.allFilters": "Kaikki suodattimet",
  "search.refinements.allFilters.aria": "Kaikki suodattimet",
  "search.refinements.benefits": "Edut",
  "search.refinements.benefits.label": "Edut",
  "search.refinements.benefits.modal": "Edut",
  "search.refinements.company": "Yritys",
  "search.refinements.company.heading": "Yritys",
  "search.refinements.company.label": "Yritys",
  "search.refinements.company.modal": "Yritys",
  "search.refinements.company.openProfileAria": "Avaa yritysprofiili {company}{count, plural, =0 {} other { — {count} avointa tehtävää JobCrawlsissa}}",
  "search.refinements.company.searchPlaceholder": "Hae yrityksiä...",
  "search.refinements.company.section": "Yritys",
  "search.refinements.dialog.label": "Hakusuodattimet",
  "search.refinements.educationLevel.detail": "Koulutustaso",
  "search.refinements.educationLevel.heading": "Koulutustaso",
  "search.refinements.educationLevel.label": "Koulutustaso",
  "search.refinements.educationLevel.modal": "Koulutustaso",
  "search.refinements.excludeApplied.checkbox": "Poissulje haetut työpaikat",
  "search.refinements.excludeApplied.label": "Poissulje haetut työpaikat",
  "search.refinements.excludeConsultingCompany.filter": "Poissulje konsulttiyritysten ilmoitukset",
  "search.refinements.excludeConsultingCompany.toggle": "Poissulje konsulttiyritysten ilmoitukset",
  "search.refinements.excludeJobs": "Poissulje työpaikat",
  "search.refinements.excludeRecruitmentCompany.filter": "Poissulje rekrytointitoimistojen ilmoitukset",
  "search.refinements.excludeRecruitmentCompany.toggle": "Poissulje rekrytointitoimistojen ilmoitukset",
  "search.refinements.excludeSaved.checkbox": "Poissulje tallennetut työpaikat",
  "search.refinements.excludeSaved.label": "Poissulje tallennetut työpaikat",
  "search.refinements.excludeViewed.checkbox": "Poissulje katsotut työpaikat",
  "search.refinements.excludeViewed.label": "Poissulje katsotut työpaikat",
  "search.refinements.field": "Ala",
  "search.refinements.field.label": "Ala",
  "search.refinements.field.modal": "Ala",
  "search.refinements.headcount": "Yrityksen koko (enintään)",
  "search.refinements.headcount.max": "Enimmäishenkilmämäärä",
  "search.refinements.industry": "Toimiala",
  "search.refinements.industry.heading": "Toimiala",
  "search.refinements.industry.label": "Toimiala",
  "search.refinements.industry.modal": "Toimiala",
  "search.refinements.isDriversLicenseRequired.filter": "Ajokorttivaatimus",
  "search.refinements.isDriversLicenseRequired.toggle": "Ajokorttivaatimus",
  "search.refinements.isOpenApplication.filter": "Avoin hakemus",
  "search.refinements.isOpenApplication.toggle": "Avoin hakemus",
  "search.refinements.job": "Työpaikka",
  "search.refinements.job.modal": "Työpaikkasuodattimet",
  "search.refinements.job.section": "Työpaikka",
  "search.refinements.jobTitle": "Työnimike",
  "search.refinements.jobType": "Työsuhteen tyyppi",
  "search.refinements.jobType.label": "Työsuhteen tyyppi",
  "search.refinements.jobType.modal": "Työsuhteen tyyppi",
  "search.refinements.languages": "Kielet",
  "search.refinements.languages.label": "Kielet",
  "search.refinements.languages.modal": "Kielet",
  "search.refinements.lastSeen.aria": "Julkaisupäivämäärä",
  "search.refinements.location": "Sijainti",
  "search.refinements.location.finland": "Suomi",
  "search.refinements.location.modal": "Sijainti",
  "search.refinements.location.remote": "Etätyö",
  "search.refinements.location.searchPlaceholder": "Hae sijainteja...",
  "search.refinements.location.section": "Sijainti",
  "search.refinements.peopleManagementTier": "Esimenestotaso",
  "search.refinements.peopleManagementTier.label": "Esimenestotaso",
  "search.refinements.peopleManagementTier.modal": "Esimenestotaso",
  "search.refinements.remoteness.heading": "Työmuoto",
  "search.refinements.remoteness.label": "Etätyömahdollisuus",
  "search.refinements.remoteness.modal": "Etätyömahdollisuus",
  "search.refinements.roleLevel": "Roolin taso",
  "search.refinements.roleLevel.label": "Roolin taso",
  "search.refinements.roleLevel.modal": "Roolin taso",
  "search.refinements.salary": "Palkka",
  "search.refinements.salary.heading": "Palkka",
  "search.refinements.salary.label": "Palkka",
  "search.refinements.salary.min": "Minimipalkka",
  "search.refinements.salary.modal": "Palkka",
  "search.refinements.salary.section": "Palkka",
  "search.refinements.search.placeholder": "Hae...",
  "search.refinements.showJobsInFinlandOnly": "Näytä vain Suomessa olevat työpaikat",
  "search.refinements.showLess": "Näytä vähemmän",
  "search.refinements.showMore": "Näytä lisää",
  "search.refinements.skillsAndTechnologies": "Taidot ja teknologiat",
  "search.refinements.skillsAndTechnologies.label": "Taidot ja teknologiat",
  "search.refinements.skillsAndTechnologies.modal": "Taidot ja teknologiat",
  "search.refinements.vacationWeeks": "Lomapäivät",
  "search.refinements.vacationWeeks.heading": "Lomapäivät",
  "search.refinements.vacationWeeks.label": "Lomaviikot",
  "search.refinements.vacationWeeks.modal": "Lomaviikot",
  "search.results.title": "Työnhakutulokset",
  "search.signInCta.benefit1": "Tallenna työpaikkoja myöhempää varten",
  "search.signInCta.benefit2": "Seuraa kaikkia hakemuksiasi yhdellä taululla",
  "search.signInCta.benefit3": "Saat ilmoituksen heti, kun uusi työpaikka sopii sinulle",
  "search.signInCta.button": "Luo ilmainen tili",
  "search.signInCta.secondaryText": "Onko sinulla jo tili? Kirjaudu sisään",
  "search.signInCta.title": "Pidä työnhakusi hallinnassa",
  "search.topRolesStrip.hubCta": "Palkkatietoja Suomen rooleille →",
  "search.topRolesStrip.label": "Kysytyimmät roolit",
  "sort.ariaLabel": "Lajittele tulokset",
  "sort.newest": "Uusimmat",
  "sort.relevance": "Relevanssi",
  "sort.salary": "Palkka",
  "srpAlertCta.bannerText": "Haluatko kuulla vastaavista uusista työpaikoista?",
  "srpAlertCta.continueButton": "Jatka sähköpostilla",
  "srpAlertCta.ctaButton": "Tilaa sähköposti-ilmoitukset",
  "srpAlertCta.dismissLabel": "Sulje",
  "srpAlertCta.errorText": "Jokin meni pieleen — ilmoituksia ei saatu käyttöön. Yritä uudelleen.",
  "srpAlertCta.manageLink": "Hallitse ilmoituksia",
  "srpAlertCta.pendingText": "Melkein valmista — tarkista postilaatikkosi ja vahvista sähköpostiosoitteesi aktivoidaksesi ilmoitukset.",
  "srpAlertCta.successText": "Kaikki valmista – lähetämme sinulle sähköpostia vastaavista työpaikoista.",
  "srpAlertCta.unauthConsentCopy": "Lähetämme sinulle sähköpostia, kun hakuasi vastaavia uusia työpaikkoja tulee tarjolle. Luo ilmainen tili aktivoidaksesi tämän – emme lähetä muita sähköposteja, ellet sitä erikseen pyydä.",
  "stats.appliedJobs": "{count} haettua työpaikkaa",
  "stats.finlandJobsSubtitle": "Työpaikkoja suomeksi tai etänä Suomessa asuville",
  "stats.newThisWeekInline": "· {count, number} uutta tällä viikolla",
  "stats.savedJobs": "{count} tallennettua työpaikkaa",
  "stats.viewedJobs": "{count} katsottua työpaikkaa",
  "tags.field.addTrigger": "Lisää tägi",
  "tags.field.placeholder": "Tägi ja paina Enteriä…",
  "tags.field.remove": "Poista tägi {tag}",
  "tools.applicationKits.cvBadge": "CV valmis",
  "tools.applicationKits.deleteKit": "Poista",
  "tools.applicationKits.downloadCv": "Lataa CV",
  "tools.applicationKits.downloadLetter": "Lataa kirje",
  "tools.applicationKits.emptyBody": "Räätälöi CV tai laadi hakemuskirje miltä tahansa työpaikkasivulta — se tallentuu tänne automaattisesti.",
  "tools.applicationKits.emptyTitle": "Ei vielä hakemuspaketteja",
  "tools.applicationKits.kitReadyBadge": "Hakemuspaketti valmis",
  "tools.applicationKits.lead": "Räätälöidyt CV:t ja hakemuskirjeet työpaikoittain tallennettuna — avaa uudelleen, tarkista tai lataa milloin tahansa.",
  "tools.applicationKits.letterBadge": "Kirje valmis",
  "tools.applicationKits.openJob": "Avaa työpaikkasivu",
  "tools.applicationKits.title": "Hakemuspaketit",
  "tools.applicationKits.updatedOn": "Päivitetty {date}",
  "tools.applicationState.applied": "Haettu",
  "tools.applicationState.hidden": "Piilotettu",
  "tools.applicationState.label": "Tila:",
  "tools.applicationState.updated": "Tila päivitetty muotoon {state}",
  "tools.empty.browseJobs": "Selaa työpaikkoja →",
  "tools.externalApplication.add": "Lisää haettuihin",
  "tools.externalApplication.adding": "Lisätään…",
  "tools.externalApplication.closeModal": "Sulje",
  "tools.externalApplication.error.disallowedScheme": "Vain http- ja https-linkit ovat sallittuja.",
  "tools.externalApplication.error.empty": "Syötä linkki työpaikka- tai hakemusivulle.",
  "tools.externalApplication.error.invalid": "Tämä ei vaikuta olevan voimassa oleva URL-osoite.",
  "tools.externalApplication.error.syncFailed": "Tallennus epäonnistui. Tarkista yhteys tai yritä kirjautua sisään.",
  "tools.externalApplication.error.tooLong": "Linkki on liian pitkä.",
  "tools.externalApplication.lead": "Liitä linkki työpaikkaan, jota haet toisella sivustolla. Se näkyy muiden hakemustesi joukossa tällä sivulla.",
  "tools.externalApplication.title": "Seuraa muualla tehtyä hakemusta",
  "tools.externalApplication.titleLabel": "Nimike (valinnainen)",
  "tools.externalApplication.urlLabel": "Työpaikkalinkki",
  "tools.history.emptyHidden": "Et ole piilottanut yhtään työpaikkaa.",
  "tools.history.emptyViewed": "Et ole vielä katsonut yhtään työpaikkaa.",
  "tools.history.hiddenTab": "Piilotetut ({count})",
  "tools.history.resetViewed": "Nollaa katsotut työpaikat",
  "tools.history.viewedTab": "Katsotut ({count})",
  "tools.historySummary.counts": "Katsotut {viewedCount} · Piilotetut {hiddenCount}",
  "tools.historySummary.heading": "Historia",
  "tools.historySummary.openDrawer": "Näytä",
  "tools.jobFlowSankey.activityChartHeading": "Aktiivisuus",
  "tools.jobFlowSankey.applied": "Haettu",
  "tools.jobFlowSankey.browsed": "Selaillut",
  "tools.jobFlowSankey.conversionSummary": "{interviewRate}% pääsi haastatteluun · {offerRate}% sai tarjouksen",
  "tools.jobFlowSankey.emptyState": "Aktiivisuutesi näyttämiseen ei ole vielä tarpeeksi tietoja. Selaa, tallenna tai hae työpaikkoja nähdäksesi polkusi visualisoituna!",
  "tools.jobFlowSankey.hideActivityChart": "Piilota aktiivisuuskaavio",
  "tools.jobFlowSankey.hired": "Palkattu",
  "tools.jobFlowSankey.interviewing": "Haastatteluvaiheessa",
  "tools.jobFlowSankey.offer": "Tarjous",
  "tools.jobFlowSankey.rejected": "Hylätty",
  "tools.jobFlowSankey.saved": "Tallennetut",
  "tools.jobFlowSankey.showActivityChart": "Näytä aktiviteettikaavio",
  "tools.jobFlowSankey.summary": "Selaillut {browsed} → Katsotut {viewed} → Tallennetut {saved} → Haettu {applied}",
  "tools.jobFlowSankey.tooltip.hint.applied": "Olet hakenut näitä tai seurannut niitä lähetettyinä hakemuksina.",
  "tools.jobFlowSankey.tooltip.hint.browsed": "Hakuista avaamasi roolit – suppilosi alku.",
  "tools.jobFlowSankey.tooltip.hint.hired": "Merkitty palkatuksi – hieno lopputulos.",
  "tools.jobFlowSankey.tooltip.hint.interviewing": "Tällä hetkellä haastatteluprosessissa.",
  "tools.jobFlowSankey.tooltip.hint.offer": "Tarjousvaihe – neuvottelujen tai päätöksen aika.",
  "tools.jobFlowSankey.tooltip.hint.rejected": "Merkitty suljetuksi tai haku ei edennyt.",
  "tools.jobFlowSankey.tooltip.hint.saved": "Tallennettu myöhemmäksi – helppo palata ja hakea.",
  "tools.jobFlowSankey.tooltip.hint.viewed": "Olet avannut nämä ilmoitukset, mutta et ole vielä tallentanut niitä.",
  "tools.jobFlowSankey.tooltip.link.pathCount": "{count, plural, one {# työpaikka} other {# työpaikkaa}} tällä polulla",
  "tools.jobFlowSankey.tooltip.link.pctFrom": "{pct} % virtauksesta poistuu kohteesta {fromName}",
  "tools.jobFlowSankey.tooltip.link.pctTo": "{pct} % virtauksesta tulee kohteeseen {toName}",
  "tools.jobFlowSankey.tooltip.link.splitBrowsedApplied": "{direct} suoraan selaamisesta ilman tallennusta · {external} muualta",
  "tools.jobFlowSankey.tooltip.node.beyondBrowse": "Sisältää hakemukset, joita ei ole laskettu selaamisiin (esim. sivuston ulkopuolella).",
  "tools.jobFlowSankey.tooltip.node.jobCount": "{count, plural, one {# työpaikka} other {# työpaikkaa}}",
  "tools.jobFlowSankey.tooltip.node.pctApplied": "{pct} % hakemuksistasi",
  "tools.jobFlowSankey.tooltip.node.pctBrowsed": "{pct} % selaamistasi ilmoituksista",
  "tools.jobFlowSankey.viewed": "Katsotut",
  "tools.kanban.addExternalApplication": "Lisää ulkopuolinen hakemus",
  "tools.kanban.cancelSelectMode": "Peruuta",
  "tools.kanban.chip.appliedAgo": "Haettu {relativeAge}",
  "tools.kanban.column.applied": "Haettu",
  "tools.kanban.column.collapse": "Pienennä sarake {column}",
  "tools.kanban.column.expand": "Laajenna sarake {column}",
  "tools.kanban.column.hired": "Palkattu",
  "tools.kanban.column.interviewing": "Haastattelut",
  "tools.kanban.column.offer": "Tarjous",
  "tools.kanban.column.rejected": "Hylätty",
  "tools.kanban.column.saved": "Tallennetut",
  "tools.kanban.companyFilterAll": "Kaikki yritykset",
  "tools.kanban.companyFilterLabel": "Suodata yrityksen mukaan",
  "tools.kanban.confirmRemove.appliedBody": "”{jobTitle}” poistetaan haku-taulultasi. Voit hakea paikkaa uudelleen haun kautta myöhemmin.",
  "tools.kanban.confirmRemove.appliedTitle": "Poistetaanko hakemuksista?",
  "tools.kanban.confirmRemove.cancel": "Peruuta",
  "tools.kanban.confirmRemove.close": "Sulje",
  "tools.kanban.confirmRemove.confirm": "Poista",
  "tools.kanban.confirmRemove.savedBody": "”{jobTitle}” poistetaan tallennetuista työpaikoista.",
  "tools.kanban.confirmRemove.savedTitle": "Poistetaanko tallennetuista?",
  "tools.kanban.confirmRemove.working": "Poistetaan…",
  "tools.kanban.deadlineChip": "Sulkeutuu {days, plural, one {# päivässä} other {# päivässä}}",
  "tools.kanban.dragHandle": "Raahaa siirtääksesi toiseen sarakkeeseen tai kohtaan",
  "tools.kanban.emptyBoard": "Ei vielä tallennettuja tai haettuja työpaikkoja. Lisää ulkoinen hakemus yllä olevalla painikkeella tai tallenna ja hae työpaikkoja haun kautta.",
  "tools.kanban.emptyColumn": "Ei vielä yhtään",
  "tools.kanban.groupMixedHeading": "{count} hakemusta",
  "tools.kanban.groupMixedSavedHeading": "{count} tallennettua",
  "tools.kanban.hideInactive": "Piilota ei enää aktiiviset työpaikat",
  "tools.kanban.keepLooking": "Jatka etsimistä →",
  "tools.kanban.mobile.cancel": "Peruuta",
  "tools.kanban.mobile.close": "Sulje",
  "tools.kanban.mobile.companyFilterAll": "Kaikki yritykset",
  "tools.kanban.mobile.companyFilterLabel": "Suodata yrityksen mukaan",
  "tools.kanban.mobile.emptyTab": "Ei hakemuksia vaiheessa {stage}.",
  "tools.kanban.mobile.move": "Siirrä",
  "tools.kanban.mobile.moveTo": "Siirrä vaiheeseen",
  "tools.kanban.mobile.searchPlaceholder": "Hae yritystä tai roolia",
  "tools.kanban.mobile.searchToggle": "Hae hakemuksia",
  "tools.kanban.mobile.sortCompanyAsc": "Yritys (A–Z)",
  "tools.kanban.mobile.sortDateAsc": "Vanhimmat ensin",
  "tools.kanban.mobile.sortDateDesc": "Uusimmat ensin",
  "tools.kanban.mobile.sortLabel": "Lajitteleperuste",
  "tools.kanban.mobile.sortTitleAsc": "Työnimike (A–Z)",
  "tools.kanban.mobile.tabAll": "Kaikki",
  "tools.kanban.mobile.viewJob": "Näytä työpaikkailmoitus",
  "tools.kanban.moveSelectedTo": "Siirrä kohteeseen…",
  "tools.kanban.removeFailed": "Päivitys epäonnistui. Yritä uudelleen.",
  "tools.kanban.removeIcon.applied": "Poista hakemuksista",
  "tools.kanban.removeIcon.saved": "Poista tallennetuista työpaikoista",
  "tools.kanban.removeSelected": "Poista",
  "tools.kanban.savedJob.expired": "Ei enää voimassa",
  "tools.kanban.savedJob.findSimilar": "Etsi vastaavia →",
  "tools.kanban.searchLabel": "Hae",
  "tools.kanban.searchPlaceholder": "Hae yritystä tai roolia",
  "tools.kanban.selectCard": "Valitse {title}",
  "tools.kanban.selectMode": "Valitse",
  "tools.kanban.selectedCount": "{count, plural, one {# valittu} other {# valittua}}",
  "tools.kanban.sortCompanyAsc": "Yritys (A–Z)",
  "tools.kanban.sortDateAsc": "Vanhimmat ensin",
  "tools.kanban.sortDateDesc": "Uusimmat ensin",
  "tools.kanban.sortLabel": "Lajittele mukaan",
  "tools.kanban.sortTitleAsc": "Työnimike (A–Z)",
  "tools.kanban.staleChip": "Seuraava askel? {days, plural, one {# päivä} other {# päivää}} hakemisesta",
  "tools.kanban.title": "Hakemukset vaiheittain",
  "tools.savedJobs.tailorCvAction": "Räätälöi CV",
  "tooltip.allFilters": "Avaa kaikki suodattimet tarkentaaksesi työnhakuasi sijainnin, palkan, työtavan ja muiden kriteerien mukaan",
  "tooltip.view.list": "Vaihda luettelonäkymään nähdäksesi työpaikat tiiviissä luettelomuodossa",
  "tooltip.view.map": "Vaihda karttanäkymään nähdäksesi työpaikkojen sijainnit kartalla",
  "usermenu.account": "Tili",
  "usermenu.blog": "Oppaat ja blogi",
  "usermenu.blog.link": "Oppaat",
  "usermenu.installPwa": "Asenna sovellus",
  "usermenu.login": "Kirjaudu sisään",
  "usermenu.logout": "Kirjaudu ulos",
  "usermenu.myJobs.withCount": "Omat työpaikat ({count})",
  "usermenu.profile": "Oma profiili",
  "usermenu.profileCv.avatarGuestInitials": "Sinä",
  "usermenu.profileCv.caption": "CV",
  "usermenu.profileCv.placeholderEmail": "sinä@esimerkki.fi",
  "usermenu.profileCv.placeholderHint": "Kirjaudu sisään tallentaaksesi työpaikkoja, seurataksesi hakemuksia ja pitääksesi CV:si tallessa JobCrawlsissa.",
  "usermenu.profileCv.placeholderName": "Nimesi",
  "usermenu.profileCv.region": "Profiilisi yhteenveto",
  "usermenu.profileCv.regionGuest": "Esikatsele profiilia — kirjaudu sisään täyttääksesi tietosi",
  "usermenu.profileCv.session": "Istunto",
  "usermenu.profileCv.signInSection": "Aloita",
  "usermenu.theme": "Teema",
  "view.list": "Luettelonäkymä",
  "view.map": "Karttanäkymä",
  "watchlist.company.dataUnavailable": "Yritystiedot eivät ole juuri nyt saatavilla.",
  "watchlist.company.employerScore": "työnantajapisteet",
  "watchlist.company.hiringTrend.declining": "Laskussa",
  "watchlist.company.hiringTrend.growing": "Kasvussa",
  "watchlist.company.hiringTrend.stable": "Vakaa",
  "watchlist.company.openRoles": "avointa paikkaa",
  "watchlist.empty.body": "Seuraa yritystä sen profiilisivulta nähdäksesi täällä uudet paikat, työnantajapisteet ja rekrytointitrendin.",
  "watchlist.empty.browse": "Selaa parhaita yrityksiä →",
  "watchlist.empty.title": "Et seuraa vielä yhtään yritystä.",
  "watchlist.filter.all": "Kaikki",
  "watchlist.filter.noMatches": "Yhdelläkään seuratulla yrityksellä ei ole vielä tätä tagia.",
  "watchlist.relationshipTag.inConversation": "Keskustelussa",
  "watchlist.relationshipTag.interested": "Kiinnostunut",
  "watchlist.relationshipTag.reachedOut": "Otettu yhteyttä",
  "translation.test": "Käännöstesti: Suomi"
};

export const messages = {
  en: messages_en,
  sv: messages_sv,
  fi: messages_fi,
};

// Option 1: Hardcode the list of locales
export const supportedLocales = ['en', 'fi', 'sv'];

// Option 2: Dynamically derive from messages keys
// (uncomment if you prefer dynamic retrieval)
// export const supportedLocales = Object.keys(messages);

export const defaultLocale = 'en';
